export const ChatPromptExamples = [
    {
        question: "How many years of overtime income are needed to count it towards income?",
        answer: "The standard requirement for including overtime income as qualifying income for a mortgage loan is a history of receiving overtime income for at least two years. This allows lenders to have confidence in the consistency and stability of the additional income."
    },
    {
        question: "How long does a borrower need to rent a property to count as rental income?",
        answer: "Typically, a borrower needs to have a history of receiving rental income for at least one to two years in order for it to be counted as qualifying rental income. Lenders usually require documentation such as lease agreements, bank statements, and tax returns to verify the rental income. However, it's important to note that different lenders may have their own requirements, so it's essential to consult with a mortgage loan officer for specific guidelines."
    }

]

export const DocPromptExamples = [
    {
        question: 'What are acceptable flood insurance coverage policies?',
        InitialChatTitle: 'Flood Coverage Essentials',
        Answer: "Based on the Fannie Mae Guidelines, here is the answer:\n\nThe flood insurance policy must be one of these two options:\n\n1. A standard policy issued under the National Flood Insurance Program (NFIP), or\n\n2. A policy issued by a private insurer, provided that:\n- The terms and amount of coverage are at least equal to that provided under an NFIP policy (this must be verified through a review of the full policy issued by the private insurer)\n- The insurer meets Fannie Mae's rating requirements as specified in B7-3-01\n\nImportant notes:\n- A Policy Declaration page is acceptable evidence of flood insurance\n- During an NFIP lapse, lenders can sell loans to Fannie Mae without an active flood insurance policy if specific requirements are met\n- While private flood insurance policies are accepted, they are not required as an alternative during an NFIP lapse\n\nReference: B7-3-06, Flood Insurance Requirements for All Property Types (02/07/2024)",
        QuoteLocations: [
            [
                '860',
                [
                    [
                        [0.07042062282562256, 0.6075205206871033],
                        [0.9059396386146545, 0.6068397164344788],
                        [0.9059568643569946, 0.6194055080413818],
                        [0.0704340934753418, 0.6200858950614929],
                    ],
                    [
                        [0.07134974002838135, 0.6240741610527039],
                        [0.8994748592376709, 0.6233999133110046],
                        [0.8994922637939453, 0.6361382603645325],
                        [0.07136339694261551, 0.6368120312690735],
                    ],
                    [
                        [0.07152945548295975, 0.6405484080314636],
                        [0.9023569822311401, 0.6398726105690002],
                        [0.9023737907409668, 0.6521310806274414],
                        [0.07154259830713272, 0.6528064608573914],
                    ],
                    [
                        [0.07214166969060898, 0.6574968695640564],
                        [0.17585058510303497, 0.657412588596344],
                        [0.17586372792720795, 0.6692477464675903],
                        [0.07215436547994614, 0.669331967830658],
                    ],
                    [
                        [0.07248972356319427, 0.7480916380882263],
                        [0.8806456923484802, 0.7474380135536194],
                        [0.8806721568107605, 0.766872227191925],
                        [0.07251057028770447, 0.7675251960754395],
                    ],
                    [
                        [0.07032414525747299, 0.7764682769775391],
                        [0.3068937063217163, 0.7762771844863892],
                        [0.30691540241241455, 0.7950175404548645],
                        [0.0703442320227623, 0.7952083945274353],
                    ],
                    [
                        [0.07028935104608536, 0.8566675782203674],
                        [0.7568665146827698, 0.8561155200004578],
                        [0.7568831443786621, 0.8687723875045776],
                        [0.07030291855335236, 0.8693241477012634],
                    ],
                    [
                        [0.0718952938914299, 0.9402895569801331],
                        [0.2668684720993042, 0.9401335120201111],
                        [0.2668788731098175, 0.9492281079292297],
                        [0.07190504670143127, 0.9493841528892517],
                    ],
                ],
            ],
            [
                '879',
                [
                    [
                        [0.17169027030467987, 0.07485368102788925],
                        [0.8600567579269409, 0.07461818307638168],
                        [0.8600639700889587, 0.08686798810958862],
                        [0.17169588804244995, 0.08710074424743652],
                    ],
                    [
                        [0.17153072357177734, 0.09141935408115387],
                        [0.8657684326171875, 0.09118557721376419],
                        [0.8657756447792053, 0.10338353365659714],
                        [0.17153632640838623, 0.10361455380916595],
                    ],
                    [
                        [0.07062758505344391, 0.12131864577531815],
                        [0.5867792963981628, 0.12114985287189484],
                        [0.5867858529090881, 0.1332995593547821],
                        [0.0706329345703125, 0.13346631824970245],
                    ],
                    [
                        [0.07233063131570816, 0.16497080028057098],
                        [0.5590834617614746, 0.16481852531433105],
                        [0.5590924024581909, 0.18162833154201508],
                        [0.0723380297422409, 0.1817779392004013],
                    ],
                    [
                        [0.07060346007347107, 0.207246795296669],
                        [0.826792299747467, 0.2070206254720688],
                        [0.8267995119094849, 0.21937264502048492],
                        [0.07060889154672623, 0.2195957899093628],
                    ],
                    [
                        [0.12245591729879379, 0.23716367781162262],
                        [0.5636357665061951, 0.23703601956367493],
                        [0.5636423230171204, 0.24934059381484985],
                        [0.12246144562959671, 0.24946649372577667],
                    ],
                    [
                        [0.12128163874149323, 0.253769189119339],
                        [0.5420383214950562, 0.2536497116088867],
                        [0.5420448184013367, 0.2658955156803131],
                        [0.12128713726997375, 0.26601335406303406],
                    ],
                    [
                        [0.12130429595708847, 0.2707076072692871],
                        [0.7999048829078674, 0.2705186605453491],
                        [0.7999118566513062, 0.2826516926288605],
                        [0.12130974978208542, 0.28283798694610596],
                    ],
                    [
                        [0.07145366072654724, 0.30069291591644287],
                        [0.9041743874549866, 0.30046913027763367],
                        [0.904181718826294, 0.3127092719078064],
                        [0.07145904004573822, 0.31292974948883057],
                    ],
                    [
                        [0.07207010686397552, 0.31717565655708313],
                        [0.3831419050693512, 0.31709372997283936],
                        [0.3831480145454407, 0.32935911417007446],
                        [0.0720755085349083, 0.32943978905677795],
                    ],
                    [
                        [0.07141487300395966, 0.34710070490837097],
                        [0.918104887008667, 0.34688594937324524],
                        [0.9181122183799744, 0.3590974509716034],
                        [0.07142024487257004, 0.3593088686466217],
                    ],
                    [
                        [0.07211391627788544, 0.3636453151702881],
                        [0.9214052557945251, 0.36343446373939514],
                        [0.9214126467704773, 0.37579503655433655],
                        [0.07211935520172119, 0.3760024905204773],
                    ],
                ],
            ],
            [
                '883',
                [
                    [
                        [0.0712098628282547, 0.07494021207094193],
                        [0.8299171924591064, 0.0742434412240982],
                        [0.82993084192276, 0.08680765330791473],
                        [0.0712202936410904, 0.08750442415475845],
                    ],
                    [
                        [0.07171239703893661, 0.10448674112558365],
                        [0.8825822472572327, 0.1037420928478241],
                        [0.8825961351394653, 0.11633305251598358],
                        [0.0717228576540947, 0.11707768589258194],
                    ],
                    [
                        [0.0715290904045105, 0.12126694619655609],
                        [0.7665148973464966, 0.1206287369132042],
                        [0.766528308391571, 0.1332448124885559],
                        [0.07153956592082977, 0.1338830143213272],
                    ],
                    [
                        [0.07176584005355835, 0.15118324756622314],
                        [0.9065358638763428, 0.15041671693325043],
                        [0.9065500497817993, 0.1631404012441635],
                        [0.07177641242742538, 0.16390691697597504],
                    ],
                    [
                        [0.07174582034349442, 0.1679445058107376],
                        [0.9253717064857483, 0.16716068983078003],
                        [0.9253861308097839, 0.18009504675865173],
                        [0.07175655663013458, 0.18087886273860931],
                    ],
                    [
                        [0.07125897705554962, 0.18463625013828278],
                        [0.08943413943052292, 0.18461956083774567],
                        [0.0894421935081482, 0.19425132870674133],
                        [0.07126697897911072, 0.19426801800727844],
                    ],
                    [
                        [0.12166145443916321, 0.21454854309558868],
                        [0.8472156524658203, 0.21388235688209534],
                        [0.8472293615341187, 0.22645626962184906],
                        [0.12167210131883621, 0.2271224409341812],
                    ],
                    [
                        [0.1214635893702507, 0.23107706010341644],
                        [0.6288063526153564, 0.23061124980449677],
                        [0.6288189888000488, 0.24297678470611572],
                        [0.12147406488656998, 0.2434425950050354],
                    ],
                    [
                        [0.12122396379709244, 0.24772298336029053],
                        [0.8744663000106812, 0.24703143537044525],
                        [0.8744806051254272, 0.25998425483703613],
                        [0.1212349385023117, 0.2606757879257202],
                    ],
                    [
                        [0.07048491388559341, 0.2776189148426056],
                        [0.8975363373756409, 0.2768596410751343],
                        [0.8975508213043213, 0.28992992639541626],
                        [0.07049576193094254, 0.2906892001628876],
                    ],
                ],
            ],
            [
                '863',
                [
                    [
                        [0.12182875722646713, 0.07481007277965546],
                        [0.9059627652168274, 0.07461030781269073],
                        [0.9059706330299377, 0.08690259605646133],
                        [0.12183364480733871, 0.08710072934627533],
                    ],
                    [
                        [0.12199883162975311, 0.09136863797903061],
                        [0.3410409092903137, 0.0913134440779686],
                        [0.34104642271995544, 0.10320580750703812],
                        [0.12200355529785156, 0.10326055437326431],
                    ],
                    [
                        [0.12167045474052429, 0.11507201194763184],
                        [0.6449607610702515, 0.114942267537117],
                        [0.6449673175811768, 0.12676715850830078],
                        [0.12167514860630035, 0.12689585983753204],
                    ],
                    [
                        [0.07185991108417511, 0.14535053074359894],
                        [0.31436794996261597, 0.14529164135456085],
                        [0.31437236070632935, 0.15500061213970184],
                        [0.07186362147331238, 0.1550590991973877],
                    ],
                    [
                        [0.07052754610776901, 0.1751023530960083],
                        [0.836917519569397, 0.17492012679576874],
                        [0.8369250893592834, 0.18721643090248108],
                        [0.07053223997354507, 0.1873970627784729],
                    ],
                    [
                        [0.21933768689632416, 0.2173902690410614],
                        [0.35655468702316284, 0.21735863387584686],
                        [0.35655906796455383, 0.22673283517360687],
                        [0.2193416804075241, 0.2267642617225647],
                    ],
                    [
                        [0.6721711158752441, 0.217044860124588],
                        [0.7612259984016418, 0.2170243263244629],
                        [0.7612317800521851, 0.22674374282360077],
                        [0.6721765995025635, 0.22676414251327515],
                    ],
                    [
                        [0.08820906281471252, 0.2580808699131012],
                        [0.30448251962661743, 0.25803250074386597],
                        [0.3044869005680084, 0.26774653792381287],
                        [0.08821281790733337, 0.26779457926750183],
                    ],
                    [
                        [0.5232611298561096, 0.25782686471939087],
                        [0.6723435521125793, 0.25779351592063904],
                        [0.6723498702049255, 0.26901817321777344],
                        [0.5232669711112976, 0.2690512239933014],
                    ],
                    [
                        [0.08811493217945099, 0.3017193078994751],
                        [0.3043498396873474, 0.3016725182533264],
                        [0.3043544292449951, 0.3117818832397461],
                        [0.08811884373426437, 0.31182828545570374],
                    ],
                    [
                        [0.5234101414680481, 0.30158767104148865],
                        [0.6720095872879028, 0.3015555143356323],
                        [0.6720158457756042, 0.31265789270401],
                        [0.5234159231185913, 0.31268975138664246],
                    ],
                    [
                        [0.07371802628040314, 0.4164822995662689],
                        [0.8392579555511475, 0.41633155941963196],
                        [0.839269757270813, 0.43552425503730774],
                        [0.0737253725528717, 0.43567249178886414],
                    ],
                    [
                        [0.0715191438794136, 0.44475510716438293],
                        [0.3583810031414032, 0.4447000026702881],
                        [0.35839003324508667, 0.46392902731895447],
                        [0.07152649015188217, 0.4639831781387329],
                    ],
                    [
                        [0.07169491052627563, 0.5084438920021057],
                        [0.16212867200374603, 0.5084275007247925],
                        [0.16213271021842957, 0.5182775855064392],
                        [0.07169867306947708, 0.5182937979698181],
                    ],
                    [
                        [0.07075580954551697, 0.5247617959976196],
                        [0.9021848440170288, 0.5246133804321289],
                        [0.9021928906440735, 0.5372563600540161],
                        [0.07076063752174377, 0.5374030470848083],
                    ],
                    [
                        [0.07170381397008896, 0.6437773704528809],
                        [0.3270735442638397, 0.6437369585037231],
                        [0.3270812928676605, 0.6605852246284485],
                        [0.0717102512717247, 0.6606249809265137],
                    ],
                    [
                        [0.12201958894729614, 0.5680894255638123],
                        [0.45997998118400574, 0.5680315494537354],
                        [0.4599860906600952, 0.58025723695755],
                        [0.12202444672584534, 0.5803143978118896],
                    ],
                    [
                        [0.12227822095155716, 0.5849236845970154],
                        [0.31358107924461365, 0.5848914384841919],
                        [0.3135865330696106, 0.5968503952026367],
                        [0.122282974421978, 0.5968822240829468],
                    ],
                    [
                        [0.07184010744094849, 0.6864044070243835],
                        [0.9043006896972656, 0.6862785816192627],
                        [0.904308557510376, 0.6986067295074463],
                        [0.07184481620788574, 0.6987308263778687],
                    ],
                    [
                        [0.07111606001853943, 0.702809751033783],
                        [0.9237518906593323, 0.7026832103729248],
                        [0.9237598776817322, 0.7150961756706238],
                        [0.07112079858779907, 0.7152209281921387],
                    ],
                    [
                        [0.07078255712985992, 0.7196580171585083],
                        [0.21533021330833435, 0.7196369767189026],
                        [0.21533547341823578, 0.7319943308830261],
                        [0.07078727334737778, 0.732015073299408],
                    ],
                ],
            ],
            [
                '870',
                [
                    [
                        [0.4604192078113556, 0.08626644313335419],
                        [0.5888899564743042, 0.08627860248088837],
                        [0.5888922810554504, 0.09826557338237762],
                        [0.4604211449623108, 0.09825318306684494],
                    ],
                    [
                        [0.13960449397563934, 0.12717163562774658],
                        [0.2467595636844635, 0.12718243896961212],
                        [0.2467608004808426, 0.13932453095912933],
                        [0.13960540294647217, 0.13931354880332947],
                    ],
                    [
                        [0.1386515349149704, 0.1705932915210724],
                        [0.34748968482017517, 0.17061568796634674],
                        [0.34749123454093933, 0.18270988762378693],
                        [0.13865242898464203, 0.18268711864948273],
                    ],
                    [
                        [0.13859562575817108, 0.21394188702106476],
                        [0.25009265542030334, 0.21395456790924072],
                        [0.25009390711784363, 0.2261219620704651],
                        [0.1385965198278427, 0.2261090725660324],
                    ],
                    [
                        [0.07177519798278809, 0.2575828433036804],
                        [0.9190046191215515, 0.2576846778392792],
                        [0.9190080761909485, 0.27013254165649414],
                        [0.0717758983373642, 0.27002912759780884],
                    ],
                    [
                        [0.0714343786239624, 0.27419334650039673],
                        [0.9266529083251953, 0.2742982804775238],
                        [0.9266564249992371, 0.2866847515106201],
                        [0.07143507152795792, 0.2865782380104065],
                    ],
                    [
                        [0.07114648073911667, 0.29061487317085266],
                        [0.8999423980712891, 0.29071858525276184],
                        [0.8999457955360413, 0.30296432971954346],
                        [0.07114716619253159, 0.3028590977191925],
                    ],
                    [
                        [0.07141157984733582, 0.32077756524086],
                        [0.922818124294281, 0.320887953042984],
                        [0.9228215217590332, 0.333034873008728],
                        [0.07141225785017014, 0.33292296528816223],
                    ],
                    [
                        [0.07141193747520447, 0.33751416206359863],
                        [0.5787456035614014, 0.33758118748664856],
                        [0.5787479281425476, 0.34978872537612915],
                        [0.07141261547803879, 0.3497207760810852],
                    ],
                    [
                        [0.0725785568356514, 0.3811406195163727],
                        [0.5448279976844788, 0.38120612502098083],
                        [0.5448309779167175, 0.39756613969802856],
                        [0.07257947325706482, 0.3974995017051697],
                    ],
                    [
                        [0.07046470791101456, 0.4232901930809021],
                        [0.9212036728858948, 0.4234135150909424],
                        [0.9212071299552917, 0.4358239471912384],
                        [0.07046539336442947, 0.43569907546043396],
                    ],
                    [
                        [0.0717194601893425, 0.44018229842185974],
                        [0.9194926023483276, 0.4403073191642761],
                        [0.9194961190223694, 0.45264410972595215],
                        [0.07172015309333801, 0.4525175392627716],
                    ],
                    [
                        [0.0712994784116745, 0.4565160572528839],
                        [0.48600080609321594, 0.45657822489738464],
                        [0.4860028922557831, 0.4690157175064087],
                        [0.07130017131567001, 0.46895280480384827],
                    ],
                ],
            ],
            [
                '878',
                [
                    [
                        [0.07098404318094254, 0.5951998233795166],
                        [0.9060328602790833, 0.5947681665420532],
                        [0.906046450138092, 0.6072099804878235],
                        [0.07099395245313644, 0.6076398491859436],
                    ],
                    [
                        [0.07167362421751022, 0.6117820143699646],
                        [0.2594742774963379, 0.6116855144500732],
                        [0.2594846189022064, 0.6236513257026672],
                        [0.07168316096067429, 0.6237474679946899],
                    ],
                    [
                        [0.0717831403017044, 0.6417384147644043],
                        [0.8833521008491516, 0.6413252353668213],
                        [0.8833654522895813, 0.653630793094635],
                        [0.07179294526576996, 0.6540423035621643],
                    ],
                    [
                        [0.07197367399930954, 0.6583160758018494],
                        [0.3849644362926483, 0.6581576466560364],
                        [0.3849734961986542, 0.6681390404701233],
                        [0.07198163121938705, 0.6682969927787781],
                    ],
                    [
                        [0.07190729677677155, 0.688393771648407],
                        [0.9217666387557983, 0.6879677772521973],
                        [0.9217807650566101, 0.7008830904960632],
                        [0.0719175860285759, 0.7013072371482849],
                    ],
                    [
                        [0.07136121392250061, 0.7050997018814087],
                        [0.5235432386398315, 0.7048743367195129],
                        [0.5235547423362732, 0.7168976068496704],
                        [0.07137080281972885, 0.7171221375465393],
                    ],
                    [
                        [0.07076942175626755, 0.7483225464820862],
                        [0.4486704170703888, 0.7481369376182556],
                        [0.44868555665016174, 0.7644078731536865],
                        [0.0707823857665062, 0.7645924687385559],
                    ],
                    [
                        [0.0705757811665535, 0.7911046147346497],
                        [0.4945499897003174, 0.790899395942688],
                        [0.4945616126060486, 0.8031716346740723],
                        [0.07058555632829666, 0.8033759593963623],
                    ],
                    [
                        [0.12177519500255585, 0.8208616971969604],
                        [0.4474901854991913, 0.8207056522369385],
                        [0.44750145077705383, 0.8328173160552979],
                        [0.12178505957126617, 0.8329726457595825],
                    ],
                    [
                        [0.12178102880716324, 0.8376049399375916],
                        [0.4622710347175598, 0.8374427556991577],
                        [0.4622824490070343, 0.8496463894844055],
                        [0.12179097533226013, 0.849807858467102],
                    ],
                    [
                        [0.1717500388622284, 0.8540474772453308],
                        [0.911056399345398, 0.8536974191665649],
                        [0.9110700488090515, 0.8661602735519409],
                        [0.1717604100704193, 0.8665087819099426],
                    ],
                    [
                        [0.1721976101398468, 0.8702332973480225],
                        [0.6301870942115784, 0.8700176477432251],
                        [0.6301996111869812, 0.8826348185539246],
                        [0.17220811545848846, 0.8828494548797607],
                    ],
                    [
                        [0.07202421128749847, 0.940443217754364],
                        [0.26698148250579834, 0.9403537511825562],
                        [0.2669890522956848, 0.9491021037101746],
                        [0.0720311850309372, 0.9491912722587585],
                    ],
                ],
            ],
            [
                '884',
                [
                    [
                        [0.07092243432998657, 0.31427472829818726],
                        [0.920272707939148, 0.31310129165649414],
                        [0.920287013053894, 0.3261885643005371],
                        [0.07093321532011032, 0.3273618519306183],
                    ],
                    [
                        [0.07154232263565063, 0.3309544324874878],
                        [0.9254430532455444, 0.3297748863697052],
                        [0.925457239151001, 0.342700719833374],
                        [0.07155296951532364, 0.3438801169395447],
                    ],
                    [
                        [0.07049637287855148, 0.3608492314815521],
                        [0.9224148392677307, 0.35967278480529785],
                        [0.9224291443824768, 0.37274980545043945],
                        [0.07050714641809464, 0.3739261031150818],
                    ],
                    [
                        [0.0716460719704628, 0.3774166703224182],
                        [0.8949403762817383, 0.37627995014190674],
                        [0.8949543237686157, 0.38911548256874084],
                        [0.07165664434432983, 0.39025208353996277],
                    ],
                    [
                        [0.0717196837067604, 0.3941378593444824],
                        [0.11915910989046097, 0.39407238364219666],
                        [0.1191694438457489, 0.40638968348503113],
                        [0.07172983139753342, 0.4064551591873169],
                    ],
                    [
                        [0.09373998641967773, 0.4241788387298584],
                        [0.8624158501625061, 0.4231180250644684],
                        [0.8624297380447388, 0.4360203742980957],
                        [0.09375070780515671, 0.43708106875419617],
                    ],
                    [
                        [0.09281942993402481, 0.4408465027809143],
                        [0.8709065318107605, 0.4397728741168976],
                        [0.8709200620651245, 0.45232054591178894],
                        [0.09282985329627991, 0.4533940255641937],
                    ],
                    [
                        [0.09352491050958633, 0.4571325182914734],
                        [0.35046684741973877, 0.45677804946899414],
                        [0.35047805309295654, 0.4690665602684021],
                        [0.09353511780500412, 0.46942099928855896],
                    ],
                    [
                        [0.07189519703388214, 0.48727595806121826],
                        [0.31407666206359863, 0.48694196343421936],
                        [0.31408563256263733, 0.49689459800720215],
                        [0.07190340012311935, 0.49722856283187866],
                    ],
                    [
                        [0.07054555416107178, 0.517072856426239],
                        [0.8364493250846863, 0.5160168409347534],
                        [0.8364630937576294, 0.52887362241745],
                        [0.0705561414361, 0.529929518699646],
                    ],
                    [
                        [0.2220461666584015, 0.5589959025382996],
                        [0.35893213748931885, 0.5588072538375854],
                        [0.358940988779068, 0.5684689283370972],
                        [0.222054585814476, 0.5686575770378113],
                    ],
                    [
                        [0.674762487411499, 0.5588522553443909],
                        [0.763545572757721, 0.558729887008667],
                        [0.7635555863380432, 0.568362295627594],
                        [0.6747722625732422, 0.5684846639633179],
                    ],
                    [
                        [0.08848169445991516, 0.6005531549453735],
                        [0.3042697012424469, 0.6002558469772339],
                        [0.30427807569503784, 0.6095786690711975],
                        [0.08848942816257477, 0.6098759174346924],
                    ],
                    [
                        [0.5279991030693054, 0.6002455353736877],
                        [0.6670510172843933, 0.6000539660453796],
                        [0.6670631766319275, 0.6120553612709045],
                        [0.5280107259750366, 0.6122468709945679],
                    ],
                    [
                        [0.08838710188865662, 0.6440679430961609],
                        [0.3055836260318756, 0.643768846988678],
                        [0.3055921792984009, 0.6532860994338989],
                        [0.08839499205350876, 0.6535851359367371],
                    ],
                    [
                        [0.5280293822288513, 0.64376300573349],
                        [0.6770331859588623, 0.6435578465461731],
                        [0.6770443916320801, 0.6545530557632446],
                        [0.5280400514602661, 0.6547582149505615],
                    ],
                    [
                        [0.08881662786006927, 0.6877591609954834],
                        [0.30388692021369934, 0.6874631643295288],
                        [0.3038954734802246, 0.6970033049583435],
                        [0.08882454037666321, 0.6972993016242981],
                    ],
                    [
                        [0.5280649662017822, 0.6874883770942688],
                        [0.6768220067024231, 0.6872836351394653],
                        [0.6768330931663513, 0.69818514585495],
                        [0.5280755758285522, 0.6983898282051086],
                    ],
                ],
            ],
            [
                '888',
                [
                    [
                        [0.11396213620901108, 0.49300673604011536],
                        [0.2267099767923355, 0.49298495054244995],
                        [0.22671568393707275, 0.5043273568153381],
                        [0.1139674261212349, 0.5043489933013916],
                    ],
                    [
                        [0.4685928523540497, 0.08579939603805542],
                        [0.7326889634132385, 0.08573316037654877],
                        [0.7326967716217041, 0.09740189462900162],
                        [0.4685996472835541, 0.09746769815683365],
                    ],
                    [
                        [0.29063671827316284, 0.12473694980144501],
                        [0.8905681371688843, 0.12458977103233337],
                        [0.8905767798423767, 0.13661248981952667],
                        [0.29064303636550903, 0.13675865530967712],
                    ],
                    [
                        [0.2903776466846466, 0.1425313800573349],
                        [0.8732103109359741, 0.14238984882831573],
                        [0.8732188940048218, 0.15445753931999207],
                        [0.2903839945793152, 0.15459807217121124],
                    ],
                    [
                        [0.2904556393623352, 0.16098414361476898],
                        [0.8696688413619995, 0.16084501147270203],
                        [0.8696773052215576, 0.17264647781848907],
                        [0.29046183824539185, 0.17278465628623962],
                    ],
                    [
                        [0.28982824087142944, 0.17891952395439148],
                        [0.8844535946846008, 0.17877818644046783],
                        [0.8844620585441589, 0.19055747985839844],
                        [0.2898344099521637, 0.1906978189945221],
                    ],
                    [
                        [0.29079821705818176, 0.19721877574920654],
                        [0.8935179710388184, 0.19707706570625305],
                        [0.8935264348983765, 0.20881476998329163],
                        [0.29080435633659363, 0.20895546674728394],
                    ],
                    [
                        [0.08862994611263275, 0.21520482003688812],
                        [0.20341403782367706, 0.21517811715602875],
                        [0.20341983437538147, 0.22687596082687378],
                        [0.08863531053066254, 0.22690246999263763],
                    ],
                    [
                        [0.290248304605484, 0.21507762372493744],
                        [0.41711148619651794, 0.21504811942577362],
                        [0.41711685061454773, 0.22457323968410492],
                        [0.29025331139564514, 0.2246025800704956],
                    ],
                    [
                        [0.08836593478918076, 0.23309436440467834],
                        [0.18309149146080017, 0.23307256400585175],
                        [0.18309712409973145, 0.2446022480726242],
                        [0.08837121725082397, 0.24462388455867767],
                    ],
                    [
                        [0.290685772895813, 0.23297904431819916],
                        [0.91051185131073, 0.23283645510673523],
                        [0.9105205535888672, 0.24483256042003632],
                        [0.2906920611858368, 0.24497410655021667],
                    ],
                    [
                        [0.2896572947502136, 0.2513868808746338],
                        [0.8731227517127991, 0.2512541711330414],
                        [0.8731311559677124, 0.26293182373046875],
                        [0.2896634042263031, 0.26306357979774475],
                    ],
                    [
                        [0.28942516446113586, 0.2693041265010834],
                        [0.8117785453796387, 0.2691866457462311],
                        [0.8117868304252625, 0.28110194206237793],
                        [0.2894314229488373, 0.281218558549881],
                    ],
                    [
                        [0.2891472578048706, 0.28735190629959106],
                        [0.9113790392875671, 0.287213534116745],
                        [0.91138756275177, 0.29890555143356323],
                        [0.28915339708328247, 0.2990429103374481],
                    ],
                    [
                        [0.2902231514453888, 0.3055366575717926],
                        [0.8581169843673706, 0.30541181564331055],
                        [0.8581253290176392, 0.31720224022865295],
                        [0.29022935032844543, 0.3173261284828186],
                    ],
                    [
                        [0.2902761995792389, 0.32338717579841614],
                        [0.6072170734405518, 0.3233183026313782],
                        [0.6072245240211487, 0.33520010113716125],
                        [0.2902824282646179, 0.33526843786239624],
                    ],
                ],
            ],
            [
                '880',
                [
                    [
                        [0.13091744482517242, 0.0858321264386177],
                        [0.2345423400402069, 0.0857694149017334],
                        [0.2345462441444397, 0.09792089462280273],
                        [0.1309208869934082, 0.09798359125852585],
                    ],
                    [
                        [0.511268675327301, 0.0859418734908104],
                        [0.7096405625343323, 0.08582181483507156],
                        [0.709646463394165, 0.0976630449295044],
                        [0.5112736821174622, 0.09778305888175964],
                    ],
                    [
                        [0.30973881483078003, 0.1259486824274063],
                        [0.849580705165863, 0.12562234699726105],
                        [0.8495873808860779, 0.13776999711990356],
                        [0.30974307656288147, 0.13809624314308167],
                    ],
                    [
                        [0.31103959679603577, 0.14422373473644257],
                        [0.8730666041374207, 0.14388415217399597],
                        [0.8730734586715698, 0.156173437833786],
                        [0.3110438883304596, 0.15651290118694305],
                    ],
                    [
                        [0.3111365735530853, 0.16272848844528198],
                        [0.872948169708252, 0.16238921880722046],
                        [0.8729550242424011, 0.1746300458908081],
                        [0.31114086508750916, 0.17496921122074127],
                    ],
                    [
                        [0.31060922145843506, 0.18117301166057587],
                        [0.8641083240509033, 0.1808389276266098],
                        [0.8641151189804077, 0.1930365264415741],
                        [0.3106134831905365, 0.1933705061674118],
                    ],
                    [
                        [0.3112620413303375, 0.19974710047245026],
                        [0.8664565086364746, 0.19941216707229614],
                        [0.866463303565979, 0.21164947748184204],
                        [0.31126633286476135, 0.2119842916727066],
                    ],
                    [
                        [0.31109315156936646, 0.21800640225410461],
                        [0.9049076437950134, 0.21764835715293884],
                        [0.9049147963523865, 0.23023103177547455],
                        [0.31109756231307983, 0.23058894276618958],
                    ],
                    [
                        [0.31106531620025635, 0.23666828870773315],
                        [0.9031527638435364, 0.23631146550178528],
                        [0.9031596779823303, 0.24852950870990753],
                        [0.3110696077346802, 0.24888621270656586],
                    ],
                    [
                        [0.3104560971260071, 0.2557757496833801],
                        [0.3551620543003082, 0.25574883818626404],
                        [0.3551662266254425, 0.26710084080696106],
                        [0.31046006083488464, 0.26712775230407715],
                    ],
                    [
                        [0.3244493007659912, 0.2731686234474182],
                        [0.5089957118034363, 0.2730575203895569],
                        [0.509000837802887, 0.2851693630218506],
                        [0.32445359230041504, 0.2852804362773895],
                    ],
                    [
                        [0.3242902457714081, 0.29199546575546265],
                        [0.6080484390258789, 0.29182472825050354],
                        [0.6080539226531982, 0.3038046360015869],
                        [0.3242945075035095, 0.30397531390190125],
                    ],
                    [
                        [0.3241676986217499, 0.3104654550552368],
                        [0.5258178114891052, 0.3103441894054413],
                        [0.5258229970932007, 0.3224641978740692],
                        [0.3241719901561737, 0.32258540391921997],
                    ],
                    [
                        [0.3099171221256256, 0.3288162350654602],
                        [0.9102131128311157, 0.3284554183483124],
                        [0.9102202653884888, 0.3409455418586731],
                        [0.3099214732646942, 0.34130623936653137],
                    ],
                    [
                        [0.31101447343826294, 0.3473389148712158],
                        [0.3507029116153717, 0.34731507301330566],
                        [0.3507064878940582, 0.35708802938461304],
                        [0.31101787090301514, 0.3571118414402008],
                    ],
                    [
                        [0.3241455852985382, 0.3656928241252899],
                        [0.4674395024776459, 0.36560675501823425],
                        [0.4674444794654846, 0.37782880663871765],
                        [0.3241499364376068, 0.37791481614112854],
                    ],
                    [
                        [0.3242955803871155, 0.38417133688926697],
                        [0.904932975769043, 0.38382288813591003],
                        [0.9049400687217712, 0.3962978720664978],
                        [0.32430002093315125, 0.3966462314128876],
                    ],
                    [
                        [0.31048262119293213, 0.40243223309516907],
                        [0.5184186697006226, 0.40230751037597656],
                        [0.518423855304718, 0.4144729971885681],
                        [0.31048688292503357, 0.41459769010543823],
                    ],
                    [
                        [0.30980971455574036, 0.4210626780986786],
                        [0.8745124340057373, 0.42072412371635437],
                        [0.8745192885398865, 0.4329439401626587],
                        [0.3098139762878418, 0.43328237533569336],
                    ],
                ],
            ],
            [
                '647',
                [
                    [
                        [0.07171465456485748, 0.7958092093467712],
                        [0.9190541505813599, 0.7957239151000977],
                        [0.9190637469291687, 0.8079923391342163],
                        [0.07172089070081711, 0.8080756664276123],
                    ],
                    [
                        [0.07137541472911835, 0.8125507831573486],
                        [0.9129413366317749, 0.8124688267707825],
                        [0.9129509925842285, 0.8248892426490784],
                        [0.07138172537088394, 0.8249691724777222],
                    ],
                    [
                        [0.07140325754880905, 0.8290529847145081],
                        [0.8905540108680725, 0.8289757966995239],
                        [0.8905636072158813, 0.8414380550384521],
                        [0.07140959054231644, 0.8415133357048035],
                    ],
                    [
                        [0.07187367230653763, 0.8456870913505554],
                        [0.889633059501648, 0.845612645149231],
                        [0.8896426558494568, 0.8580408692359924],
                        [0.07187999039888382, 0.8581133484840393],
                    ],
                    [
                        [0.07180722802877426, 0.8625417947769165],
                        [0.8815058469772339, 0.8624706864356995],
                        [0.8815152645111084, 0.8747330904006958],
                        [0.07181346416473389, 0.87480229139328],
                    ],
                    [
                        [0.07137326151132584, 0.8785887956619263],
                        [0.8932225704193115, 0.8785191774368286],
                        [0.8932324647903442, 0.891383945941925],
                        [0.07137980312108994, 0.8914515376091003],
                    ],
                    [
                        [0.07185453921556473, 0.9403367638587952],
                        [0.2668699622154236, 0.9403225779533386],
                        [0.2668750584125519, 0.9492132067680359],
                        [0.07185906171798706, 0.9492270350456238],
                    ],
                ],
            ],
            [
                '883',
                [
                    [
                        [0.20353612303733826, 0.6067802309989929],
                        [0.35638126730918884, 0.6066399812698364],
                        [0.3563905954360962, 0.6167266368865967],
                        [0.20354494452476501, 0.6168668866157532],
                    ],
                    [
                        [0.6312383413314819, 0.6069220304489136],
                        [0.7680941820144653, 0.6067964434623718],
                        [0.7681047320365906, 0.6167433261871338],
                        [0.6312484741210938, 0.6168689131736755],
                    ],
                    [
                        [0.08949700742959976, 0.6480582356452942],
                        [0.4836506247520447, 0.6476965546607971],
                        [0.48366281390190125, 0.6602792739868164],
                        [0.08950752764940262, 0.6606408953666687],
                    ],
                    [
                        [0.5238862633705139, 0.6573994159698486],
                        [0.8803931474685669, 0.6570723056793213],
                        [0.8804070949554443, 0.6697342991828918],
                        [0.523898720741272, 0.6700614094734192],
                    ],
                    [
                        [0.08871245384216309, 0.6669176816940308],
                        [0.48339706659317017, 0.6665555834770203],
                        [0.48340904712677, 0.678920328617096],
                        [0.08872278779745102, 0.6792824268341064],
                    ],
                    [
                        [0.5235874652862549, 0.6762886047363281],
                        [0.6811578273773193, 0.6761440634727478],
                        [0.6811721324920654, 0.6899798512458801],
                        [0.5236010551452637, 0.6901243925094604],
                    ],
                    [
                        [0.08858383446931839, 0.6863464713096619],
                        [0.19562500715255737, 0.686248242855072],
                        [0.19563362002372742, 0.6961120963096619],
                        [0.08859208226203918, 0.6962103247642517],
                    ],
                    [
                        [0.0894380509853363, 0.7294557690620422],
                        [0.47880786657333374, 0.7290985584259033],
                        [0.478820264339447, 0.7419412136077881],
                        [0.08944878727197647, 0.7422983646392822],
                    ],
                    [
                        [0.5236468315124512, 0.7296324372291565],
                        [0.8323129415512085, 0.7293493151664734],
                        [0.8323264718055725, 0.7417949438095093],
                        [0.5236590504646301, 0.7420781254768372],
                    ],
                    [
                        [0.08957523852586746, 0.7487406134605408],
                        [0.3629472851753235, 0.7484898567199707],
                        [0.3629586398601532, 0.760703444480896],
                        [0.08958544582128525, 0.7609542012214661],
                    ],
                    [
                        [0.5233765244483948, 0.7487402558326721],
                        [0.7948631644248962, 0.7484911680221558],
                        [0.7948765158653259, 0.7609240412712097],
                        [0.5233887434005737, 0.7611730694770813],
                    ],
                    [
                        [0.5239363312721252, 0.7924911975860596],
                        [0.8305023908615112, 0.7922099828720093],
                        [0.8305155038833618, 0.8042744994163513],
                        [0.5239481329917908, 0.8045557141304016],
                    ],
                    [
                        [0.5237368941307068, 0.811349093914032],
                        [0.8569397926330566, 0.8110434412956238],
                        [0.8569532632827759, 0.8233650326728821],
                        [0.5237489938735962, 0.8236706852912903],
                    ],
                    [
                        [0.08944230526685715, 0.8211125135421753],
                        [0.47867098450660706, 0.8207555413246155],
                        [0.47868284583091736, 0.8330168724060059],
                        [0.08945255726575851, 0.8333738446235657],
                    ],
                    [
                        [0.5231947898864746, 0.8304282426834106],
                        [0.8920409679412842, 0.8300899267196655],
                        [0.8920544981956482, 0.8423159122467041],
                        [0.5232067704200745, 0.8426542282104492],
                    ],
                    [
                        [0.5236997008323669, 0.8495633602142334],
                        [0.6672925353050232, 0.8494316339492798],
                        [0.667305052280426, 0.8615725040435791],
                        [0.523711621761322, 0.8617042303085327],
                    ],
                    [
                        [0.07186726480722427, 0.9402386546134949],
                        [0.26679399609565735, 0.9400599002838135],
                        [0.26680225133895874, 0.9492875933647156],
                        [0.07187492400407791, 0.949466347694397],
                    ],
                ],
            ],
            [
                '877',
                [
                    [
                        [0.07257784903049469, 0.08713246881961823],
                        [0.8196975588798523, 0.08699582517147064],
                        [0.8197118043899536, 0.1064101904630661],
                        [0.07258690893650055, 0.10654403269290924],
                    ],
                    [
                        [0.07284551113843918, 0.11557652056217194],
                        [0.2276485115289688, 0.11554905772209167],
                        [0.22765785455703735, 0.13343241810798645],
                        [0.07285385578870773, 0.13345934450626373],
                    ],
                    [
                        [0.07178350538015366, 0.17950618267059326],
                        [0.1623786836862564, 0.17949122190475464],
                        [0.16238349676132202, 0.18915903568267822],
                        [0.0717880129814148, 0.18917381763458252],
                    ],
                    [
                        [0.07051374018192291, 0.19589750468730927],
                        [0.7434167265892029, 0.19578856229782104],
                        [0.7434254884719849, 0.20812153816223145],
                        [0.07051948457956314, 0.20822888612747192],
                    ],
                    [
                        [0.07226618379354477, 0.41379672288894653],
                        [0.613601565361023, 0.4137318432331085],
                        [0.6136130690574646, 0.43123742938041687],
                        [0.0722743421792984, 0.43130049109458923],
                    ],
                    [
                        [0.07237371802330017, 0.7505393624305725],
                        [0.7618116736412048, 0.7505015134811401],
                        [0.7618237137794495, 0.7674334049224854],
                        [0.07238161563873291, 0.7674689292907715],
                    ],
                    [
                        [0.12180159240961075, 0.255636990070343],
                        [0.282134473323822, 0.25561287999153137],
                        [0.2821410298347473, 0.267691433429718],
                        [0.12180744111537933, 0.2677151560783386],
                    ],
                    [
                        [0.12103334814310074, 0.2724350094795227],
                        [0.3914388120174408, 0.27239522337913513],
                        [0.39144575595855713, 0.28433841466903687],
                        [0.12103912234306335, 0.2843775749206543],
                    ],
                    [
                        [0.12246973812580109, 0.28879135847091675],
                        [0.470246821641922, 0.28874126076698303],
                        [0.47025415301322937, 0.3007723093032837],
                        [0.12247556447982788, 0.30082157254219055],
                    ],
                    [
                        [0.12200311571359634, 0.30535537004470825],
                        [0.42426806688308716, 0.3053128123283386],
                        [0.42427530884742737, 0.3175342082977295],
                        [0.1220090314745903, 0.3175760507583618],
                    ],
                    [
                        [0.12203104794025421, 0.3221970498561859],
                        [0.31343287229537964, 0.3221707344055176],
                        [0.3134395480155945, 0.3342665135860443],
                        [0.1220369040966034, 0.3342924118041992],
                    ],
                    [
                        [0.12203843891620636, 0.3389222323894501],
                        [0.29458287358283997, 0.33889904618263245],
                        [0.29458945989608765, 0.35096633434295654],
                        [0.12204428762197495, 0.35098910331726074],
                    ],
                    [
                        [0.12231319397687912, 0.3554982841014862],
                        [0.6075459122657776, 0.35543468594551086],
                        [0.6075538396835327, 0.367428183555603],
                        [0.12231900542974472, 0.36749067902565],
                    ],
                    [
                        [0.07044174522161484, 0.45708581805229187],
                        [0.9190730452537537, 0.45699119567871094],
                        [0.919082522392273, 0.4692544937133789],
                        [0.07044745981693268, 0.46934711933135986],
                    ],
                    [
                        [0.07143984735012054, 0.473538339138031],
                        [0.78952956199646, 0.4734605550765991],
                        [0.789538562297821, 0.4859277307987213],
                        [0.07144565135240555, 0.4860037863254547],
                    ],
                    [
                        [0.12170563638210297, 0.5068690180778503],
                        [0.41598281264305115, 0.5068390369415283],
                        [0.41599005460739136, 0.5191166400909424],
                        [0.12171158194541931, 0.5191459059715271],
                    ],
                    [
                        [0.12167415767908096, 0.5310510993003845],
                        [0.7214528322219849, 0.5309928059577942],
                        [0.7214612364768982, 0.5430261492729187],
                        [0.12167998403310776, 0.5430830717086792],
                    ],
                ],
            ],
            [
                '881',
                [
                    [
                        [0.1310841590166092, 0.08596043288707733],
                        [0.23441237211227417, 0.08586211502552032],
                        [0.2344229370355606, 0.09779298305511475],
                        [0.1310943067073822, 0.09789133816957474],
                    ],
                    [
                        [0.511446475982666, 0.08593711256980896],
                        [0.7094751596450806, 0.08574868738651276],
                        [0.7094875574111938, 0.0975893959403038],
                        [0.5114580988883972, 0.09777788072824478],
                    ],
                    [
                        [0.3099019527435303, 0.12608593702316284],
                        [0.8608188033103943, 0.12556111812591553],
                        [0.860832691192627, 0.13819077610969543],
                        [0.3099134564399719, 0.13871578872203827],
                    ],
                    [
                        [0.31109803915023804, 0.14424805343151093],
                        [0.8999873399734497, 0.14368675649166107],
                        [0.9000011682510376, 0.15609726309776306],
                        [0.311109334230423, 0.15665876865386963],
                    ],
                    [
                        [0.310907781124115, 0.16278976202011108],
                        [0.65739905834198, 0.1624593287706375],
                        [0.6574113965034485, 0.1744743436574936],
                        [0.3109187185764313, 0.1748048961162567],
                    ],
                    [
                        [0.31000927090644836, 0.18134693801403046],
                        [0.875216007232666, 0.18080762028694153],
                        [0.8752294182777405, 0.1929914355278015],
                        [0.310020387172699, 0.19353094696998596],
                    ],
                    [
                        [0.311029851436615, 0.2000136822462082],
                        [0.48262155055999756, 0.19984985888004303],
                        [0.48263299465179443, 0.2116462141275406],
                        [0.31104061007499695, 0.21181008219718933],
                    ],
                    [
                        [0.08869591355323792, 0.2184259444475174],
                        [0.13104751706123352, 0.2183854877948761],
                        [0.13105721771717072, 0.22979067265987396],
                        [0.08870545029640198, 0.22983114421367645],
                    ],
                    [
                        [0.32430073618888855, 0.21800312399864197],
                        [0.4669455587863922, 0.21786686778068542],
                        [0.4669572114944458, 0.22995126247406006],
                        [0.3243118226528168, 0.23008756339550018],
                    ],
                    [
                        [0.32440659403800964, 0.23665951192378998],
                        [0.9049496650695801, 0.23610465228557587],
                        [0.9049634337425232, 0.24844160676002502],
                        [0.3244178891181946, 0.24899667501449585],
                    ],
                    [
                        [0.3103509843349457, 0.25520357489585876],
                        [0.5184263586997986, 0.2550045847892761],
                        [0.5184383392333984, 0.26718267798423767],
                        [0.3103620707988739, 0.2673817276954651],
                    ],
                    [
                        [0.3098905384540558, 0.2734149396419525],
                        [0.8744060397148132, 0.2728748321533203],
                        [0.8744195103645325, 0.28511878848075867],
                        [0.30990171432495117, 0.2856591045856476],
                    ],
                    [
                        [0.324981153011322, 0.29188594222068787],
                        [0.6155897378921509, 0.29160773754119873],
                        [0.6156019568443298, 0.30363526940345764],
                        [0.32499217987060547, 0.30391359329223633],
                    ],
                    [
                        [0.3237181603908539, 0.3106292486190796],
                        [0.6507471799850464, 0.3103160262107849],
                        [0.6507594585418701, 0.32227757573127747],
                        [0.32372912764549255, 0.3225909173488617],
                    ],
                    [
                        [0.31014004349708557, 0.3529551923274994],
                        [0.885590672492981, 0.35240331292152405],
                        [0.8856041431427002, 0.36460110545158386],
                        [0.3101511597633362, 0.3651531934738159],
                    ],
                    [
                        [0.3113154172897339, 0.3714119493961334],
                        [0.8988966941833496, 0.370848149061203],
                        [0.8989102244377136, 0.3830321431159973],
                        [0.3113265335559845, 0.38359618186950684],
                    ],
                    [
                        [0.0890764370560646, 0.3902426064014435],
                        [0.11881944537162781, 0.39021405577659607],
                        [0.11882707476615906, 0.3992352783679962],
                        [0.08908398449420929, 0.39926382899284363],
                    ],
                    [
                        [0.3112119138240814, 0.38991838693618774],
                        [0.5347077250480652, 0.38970381021499634],
                        [0.5347196459770203, 0.40179893374443054],
                        [0.31122294068336487, 0.4020135998725891],
                    ],
                    [
                        [0.3110237419605255, 0.4082896113395691],
                        [0.8512691259384155, 0.40777063369750977],
                        [0.8512825965881348, 0.4200705587863922],
                        [0.3110349774360657, 0.42058971524238586],
                    ],
                ],
            ],
            [
                '873',
                [
                    [
                        [0.07164766639471054, 0.07483723014593124],
                        [0.6803783178329468, 0.07469573616981506],
                        [0.6803864240646362, 0.08689388632774353],
                        [0.07165320217609406, 0.08703406155109406],
                    ],
                    [
                        [0.07067200541496277, 0.10465103387832642],
                        [0.922307550907135, 0.10445759445428848],
                        [0.9223169088363647, 0.11687194555997849],
                        [0.07067763060331345, 0.117063507437706],
                    ],
                    [
                        [0.07139885425567627, 0.12116184085607529],
                        [0.920708954334259, 0.1209714263677597],
                        [0.9207181334495544, 0.13322699069976807],
                        [0.07140441238880157, 0.13341554999351501],
                    ],
                    [
                        [0.07151977717876434, 0.13766475021839142],
                        [0.18325887620449066, 0.13764002919197083],
                        [0.18326406180858612, 0.1481604427099228],
                        [0.07152454555034637, 0.14818495512008667],
                    ],
                    [
                        [0.07192967087030411, 0.16803117096424103],
                        [0.3140375316143036, 0.1679789125919342],
                        [0.31404292583465576, 0.17801105976104736],
                        [0.07193422317504883, 0.17806290090084076],
                    ],
                    [
                        [0.07050454616546631, 0.19786760210990906],
                        [0.8364843130111694, 0.19770632684230804],
                        [0.8364932537078857, 0.2100902497768402],
                        [0.07051015645265579, 0.2102498561143875],
                    ],
                    [
                        [0.20682846009731293, 0.23952876031398773],
                        [0.34395644068717957, 0.23950091004371643],
                        [0.3439616858959198, 0.24905462563037872],
                        [0.20683324337005615, 0.24908225238323212],
                    ],
                    [
                        [0.6348555684089661, 0.2396981567144394],
                        [0.7251135110855103, 0.23967982828617096],
                        [0.7251200675964355, 0.2493353635072708],
                        [0.6348618268966675, 0.2493535429239273],
                    ],
                    [
                        [0.08833858370780945, 0.28096508979797363],
                        [0.30362722277641296, 0.28092294931411743],
                        [0.30363237857818604, 0.29056793451309204],
                        [0.08834300935268402, 0.2906097173690796],
                    ],
                    [
                        [0.4980623126029968, 0.28082919120788574],
                        [0.6370536088943481, 0.2808019518852234],
                        [0.6370614171028137, 0.29275453090667725],
                        [0.49806949496269226, 0.2927814722061157],
                    ],
                    [
                        [0.0885511040687561, 0.3245987296104431],
                        [0.3045966327190399, 0.3245581090450287],
                        [0.30460166931152344, 0.3339765965938568],
                        [0.08855543285608292, 0.3340168595314026],
                    ],
                    [
                        [0.4981270134449005, 0.32421958446502686],
                        [0.6471613645553589, 0.3241915702819824],
                        [0.647168755531311, 0.33547377586364746],
                        [0.4981338083744049, 0.335501492023468],
                    ],
                    [
                        [0.07287188619375229, 0.39603644609451294],
                        [0.8857767581939697, 0.395893931388855],
                        [0.8857907652854919, 0.4149301052093506],
                        [0.07288052886724472, 0.4150698482990265],
                    ],
                    [
                        [0.0726354718208313, 0.42420652508735657],
                        [0.48894137144088745, 0.42413562536239624],
                        [0.4889529049396515, 0.4433766007423401],
                        [0.0726442039012909, 0.4434460699558258],
                    ],
                    [
                        [0.07181908935308456, 0.4879884421825409],
                        [0.16237953305244446, 0.48797404766082764],
                        [0.1623843014240265, 0.4977993965148926],
                        [0.07182354480028152, 0.4978136420249939],
                    ],
                    [
                        [0.07080180943012238, 0.5042040348052979],
                        [0.9223372936248779, 0.5040711164474487],
                        [0.922346830368042, 0.5168013572692871],
                        [0.0708075761795044, 0.5169323682785034],
                    ],
                    [
                        [0.07176826894283295, 0.6567915081977844],
                        [0.16996106505393982, 0.6567788124084473],
                        [0.16996769607067108, 0.6703674793243408],
                        [0.0717744305729866, 0.6703798770904541],
                    ],
                    [
                        [0.12201403826475143, 0.5473505854606628],
                        [0.8881114721298218, 0.5472369194030762],
                        [0.8881205916404724, 0.5595534443855286],
                        [0.12201983481645584, 0.5596654415130615],
                    ],
                    [
                        [0.1215437799692154, 0.5644620656967163],
                        [0.30472204089164734, 0.5644354820251465],
                        [0.304728627204895, 0.5767271518707275],
                        [0.1215495690703392, 0.5767533779144287],
                    ],
                    [
                        [0.12198546528816223, 0.5809706449508667],
                        [0.4599854350090027, 0.5809224843978882],
                        [0.4599926173686981, 0.5931046605110168],
                        [0.12199120223522186, 0.5931521058082581],
                    ],
                ],
            ],
            [
                '874',
                [
                    [
                        [0.07200425863265991, 0.08824609965085983],
                        [0.3269486129283905, 0.08827445656061172],
                        [0.32695165276527405, 0.10508120805025101],
                        [0.07200618833303452, 0.10505246371030807],
                    ],
                    [
                        [0.07147558778524399, 0.13085666298866272],
                        [0.9080207943916321, 0.13095296919345856],
                        [0.908024787902832, 0.14315663278102875],
                        [0.07147698849439621, 0.1430594027042389],
                    ],
                    [
                        [0.07078485935926437, 0.1472383588552475],
                        [0.8722018599510193, 0.1473318189382553],
                        [0.8722057938575745, 0.15970797836780548],
                        [0.07078627496957779, 0.15961360931396484],
                    ],
                    [
                        [0.07136954367160797, 0.5888473987579346],
                        [0.1742224097251892, 0.5888635516166687],
                        [0.1742241084575653, 0.600955605506897],
                        [0.071370929479599, 0.6009393334388733],
                    ],
                    [
                        [0.07135329395532608, 0.1936345398426056],
                        [0.891711950302124, 0.19373367726802826],
                        [0.8917160034179688, 0.2061917632818222],
                        [0.07135472446680069, 0.20609168708324432],
                    ],
                    [
                        [0.07131610065698624, 0.21070599555969238],
                        [0.5543878078460693, 0.21076512336730957],
                        [0.5543906688690186, 0.22299163043498993],
                        [0.07131750136613846, 0.22293196618556976],
                    ],
                    [
                        [0.07232963293790817, 0.25412529706954956],
                        [0.5449057221412659, 0.2541849911212921],
                        [0.5449095964431763, 0.2708452045917511],
                        [0.07233154028654099, 0.27078476548194885],
                    ],
                    [
                        [0.07024522125720978, 0.2963096499443054],
                        [0.8988747000694275, 0.29641756415367126],
                        [0.8988786935806274, 0.30879393219947815],
                        [0.0702466368675232, 0.3086850941181183],
                    ],
                    [
                        [0.07184834033250809, 0.3131304681301117],
                        [0.7533385157585144, 0.3132202625274658],
                        [0.7533422708511353, 0.3262151777744293],
                        [0.07184983789920807, 0.3261245787143707],
                    ],
                    [
                        [0.07034795731306076, 0.3429211676120758],
                        [0.9204431176185608, 0.3430354595184326],
                        [0.9204471111297607, 0.3551846444606781],
                        [0.07034934312105179, 0.3550693988800049],
                    ],
                    [
                        [0.07168515771627426, 0.36001718044281006],
                        [0.15263469517230988, 0.3600281774997711],
                        [0.15263605117797852, 0.3700718283653259],
                        [0.07168631255626678, 0.3700607419013977],
                    ],
                    [
                        [0.0714033991098404, 0.38964614272117615],
                        [0.8800932168960571, 0.38975831866264343],
                        [0.8800972104072571, 0.40210404992103577],
                        [0.07140481472015381, 0.40199095010757446],
                    ],
                ],
            ],
        ],
    },
    {
        question: 'How to use rental income to qualify for a loan?',
        InitialChatTitle: 'Rental Income for Loan Qualification',
        Answer: "Based on the Fannie Mae Guidelines, here is the answer:\n\nTo use rental income for loan qualification, several key requirements must be met:\n\n1. Eligible Properties:\n- Rental income must be likely to continue\n- For subject properties, must be either a 2-4 unit primary residence or investment property\n- One-unit primary residences and second homes generally cannot use rental income (with some exceptions for boarder income and accessory units)\n\n2. Documentation Requirements:\nFor properties with rental history:\n- Most recent year's federal tax returns including Schedule 1 and Schedule E\n- Form 1007 (Single-Family Comparable Rent Schedule) for one-unit properties\n- Form 1025 (Small Residential Income Property Appraisal Report) for 2-4 unit properties\n\nFor properties without rental history:\n- Current signed lease agreement\n- Form 1007 or Form 1025 as applicable\n- Evidence that lease terms have gone into effect (e.g., bank statements showing rental payments or security deposit/first month's rent checks)\n\n3. Calculating Qualifying Income:\n- For investment properties: Calculate net rental income using PITIA\n- For 2-4 unit primary residences: Calculate net rental income without subtracting PITIA\n- Positive rental income can be added to qualifying income\n- Negative rental income must be treated as a liability in DTI calculations\n\n4. Property Management Experience:\nThe borrower must demonstrate property management experience through:\n- Tax returns showing rental income with 365 Fair Rental Days\n- Current lease agreement if property owned for a year but less than 365 Fair Rental Days on Schedule E\n- Documentation of at least one year of property management experience\n\nReferences: B3-3.1-08, B3-3.5-02, B3-6-06",
        QuoteLocations: [
            [
                '340',
                [
                    [
                        [0.12190455943346024, 0.07461019605398178],
                        [0.536056399345398, 0.07490307092666626],
                        [0.5360568165779114, 0.08708766847848892],
                        [0.12190250307321548, 0.08679424971342087],
                    ],
                    [
                        [0.12223245203495026, 0.0913873091340065],
                        [0.4652550518512726, 0.09163050353527069],
                        [0.4652550220489502, 0.10335537791252136],
                        [0.12223047018051147, 0.10311175882816315],
                    ],
                    [
                        [0.12089435756206512, 0.10796818882226944],
                        [0.3795328736305237, 0.10815200954675674],
                        [0.3795323669910431, 0.11949464678764343],
                        [0.12089243531227112, 0.11931051313877106],
                    ],
                    [
                        [0.12195946276187897, 0.12439312040805817],
                        [0.8966777920722961, 0.12494508177042007],
                        [0.8966803550720215, 0.13717207312583923],
                        [0.12195739895105362, 0.13661910593509674],
                    ],
                    [
                        [0.1222294345498085, 0.14110563695430756],
                        [0.4129859507083893, 0.1413133144378662],
                        [0.4129856824874878, 0.15119682252407074],
                        [0.12222776561975479, 0.1509888470172882],
                    ],
                    [
                        [0.12209556251764297, 0.15787075459957123],
                        [0.3682616353034973, 0.15804702043533325],
                        [0.3682610094547272, 0.1703222393989563],
                        [0.12209348380565643, 0.1701456606388092],
                    ],
                    [
                        [0.07060334086418152, 0.2168090045452118],
                        [0.2709190845489502, 0.21695369482040405],
                        [0.27091777324676514, 0.2306911200284958],
                        [0.07060067355632782, 0.23054614663124084],
                    ],
                    [
                        [0.0720285028219223, 0.2588970363140106],
                        [0.9239633679389954, 0.2595162093639374],
                        [0.923966109752655, 0.27209874987602234],
                        [0.0720260739326477, 0.27147844433784485],
                    ],
                    [
                        [0.07184918224811554, 0.2759324014186859],
                        [0.25253427028656006, 0.27606403827667236],
                        [0.2525329887866974, 0.28813436627388],
                        [0.0718468502163887, 0.28800249099731445],
                    ],
                    [
                        [0.12224321067333221, 0.30960938334465027],
                        [0.586628258228302, 0.3099493980407715],
                        [0.5866289138793945, 0.3219224810600281],
                        [0.12224118411540985, 0.3215819001197815],
                    ],
                    [
                        [0.12200514227151871, 0.33296969532966614],
                        [0.5956672430038452, 0.33331766724586487],
                        [0.5956679582595825, 0.3456580936908722],
                        [0.12200305610895157, 0.3453094959259033],
                    ],
                    [
                        [0.12215101718902588, 0.3569742739200592],
                        [0.47421184182167053, 0.35723382234573364],
                        [0.4742118716239929, 0.36907586455345154],
                        [0.1221490129828453, 0.36881589889526367],
                    ],
                    [
                        [0.12205944955348969, 0.3808515965938568],
                        [0.49008381366729736, 0.3811238408088684],
                        [0.4900839328765869, 0.393159419298172],
                        [0.12205741554498672, 0.3928866982460022],
                    ],
                    [
                        [0.12225209921598434, 0.40452641248703003],
                        [0.5433565378189087, 0.4048389792442322],
                        [0.5433570146560669, 0.4171505868434906],
                        [0.1222500205039978, 0.4168374836444855],
                    ],
                    [
                        [0.07255745679140091, 0.4480723738670349],
                        [0.2613618075847626, 0.4482133984565735],
                        [0.2613601088523865, 0.4649551510810852],
                        [0.07255422323942184, 0.46481379866600037],
                    ],
                    [
                        [0.07179109007120132, 0.4902593493461609],
                        [0.8767784237861633, 0.49086418747901917],
                        [0.8767808675765991, 0.5032528638839722],
                        [0.07178869098424911, 0.5026469230651855],
                    ],
                ],
            ],
            [
                '341',
                [
                    [
                        [0.12208291888237, 0.4130493700504303],
                        [0.9052346348762512, 0.4124586284160614],
                        [0.9052462577819824, 0.42498156428337097],
                        [0.1220959946513176, 0.42558008432388306],
                    ],
                    [
                        [0.12142642587423325, 0.4294092059135437],
                        [0.4223601222038269, 0.42917829751968384],
                        [0.422372430562973, 0.4414845407009125],
                        [0.12143927812576294, 0.44171836972236633],
                    ],
                    [
                        [0.12206205725669861, 0.45314928889274597],
                        [0.8593554496765137, 0.4525696933269501],
                        [0.8593672513961792, 0.4651377499103546],
                        [0.12207518517971039, 0.4657246768474579],
                    ],
                    [
                        [0.09359374642372131, 0.48702922463417053],
                        [0.7964078187942505, 0.4864579141139984],
                        [0.7964192032814026, 0.49847692251205444],
                        [0.09360635280609131, 0.4990549683570862],
                    ],
                    [
                        [0.09304679185152054, 0.5034210085868835],
                        [0.16857700049877167, 0.5033586025238037],
                        [0.1685895174741745, 0.5154306888580322],
                        [0.09305944293737411, 0.5154938101768494],
                    ],
                    [
                        [0.07243932783603668, 0.5470359325408936],
                        [0.6119067668914795, 0.5465717315673828],
                        [0.6119232177734375, 0.5634766817092896],
                        [0.07245710492134094, 0.5639480948448181],
                    ],
                    [
                        [0.07064948976039886, 0.5893298983573914],
                        [0.8637368083000183, 0.5886209011077881],
                        [0.863749086856842, 0.601710855960846],
                        [0.07066325843334198, 0.6024280190467834],
                    ],
                    [
                        [0.07160524278879166, 0.6061645746231079],
                        [0.862155556678772, 0.6054473519325256],
                        [0.8621673583984375, 0.6180660724639893],
                        [0.07161851972341537, 0.6187912225723267],
                    ],
                    [
                        [0.07195544987916946, 0.6225835680961609],
                        [0.591122567653656, 0.6221057772636414],
                        [0.5911345481872559, 0.6343830227851868],
                        [0.07196836173534393, 0.6348658204078674],
                    ],
                    [
                        [0.07203157991170883, 0.9402976632118225],
                        [0.26681825518608093, 0.9400693774223328],
                        [0.26682770252227783, 0.9492937922477722],
                        [0.07204128056764603, 0.9495235085487366],
                    ],
                ],
            ],
            [
                '344',
                [
                    [
                        [0.23365670442581177, 0.08562538772821426],
                        [0.24534764885902405, 0.08562030643224716],
                        [0.24535508453845978, 0.09663226455450058],
                        [0.23366408050060272, 0.09663733094930649],
                    ],
                    [
                        [0.6459030508995056, 0.08659663051366806],
                        [0.6876427531242371, 0.08657850325107574],
                        [0.6876510381698608, 0.09635750949382782],
                        [0.6459111571311951, 0.09637558460235596],
                    ],
                    [
                        [0.08884429931640625, 0.12750500440597534],
                        [0.3847600817680359, 0.12737806141376495],
                        [0.38476744294166565, 0.13746073842048645],
                        [0.08885051310062408, 0.1375872790813446],
                    ],
                    [
                        [0.4465457797050476, 0.13720932602882385],
                        [0.8908014893531799, 0.1370193362236023],
                        [0.890812873840332, 0.14944705367088318],
                        [0.44655510783195496, 0.14963631331920624],
                    ],
                    [
                        [0.08908284455537796, 0.14672760665416718],
                        [0.39417764544487, 0.1465975046157837],
                        [0.394186407327652, 0.158585324883461],
                        [0.08909022808074951, 0.15871493518352509],
                    ],
                    [
                        [0.44656863808631897, 0.15589088201522827],
                        [0.5401279330253601, 0.1558511108160019],
                        [0.5401358604431152, 0.16589407622814178],
                        [0.44657617807388306, 0.1659337282180786],
                    ],
                    [
                        [0.08979559689760208, 0.16578780114650726],
                        [0.22114236652851105, 0.16573213040828705],
                        [0.22115039825439453, 0.17778408527374268],
                        [0.08980302512645721, 0.17783954739570618],
                    ],
                    [
                        [0.07182006537914276, 0.20968922972679138],
                        [0.9164776802062988, 0.20933614671230316],
                        [0.9164892435073853, 0.2217765748500824],
                        [0.07182765007019043, 0.2221282571554184],
                    ],
                    [
                        [0.0715324878692627, 0.226240873336792],
                        [0.7587473392486572, 0.22595511376857758],
                        [0.758758008480072, 0.2381572723388672],
                        [0.07153993099927902, 0.23844191431999207],
                    ],
                    [
                        [0.07149947434663773, 0.2694009840488434],
                        [0.6517187356948853, 0.2691630423069],
                        [0.651732861995697, 0.2862326204776764],
                        [0.07150988280773163, 0.2864692211151123],
                    ],
                    [
                        [0.07171540707349777, 0.3122728765010834],
                        [0.9147518277168274, 0.3119319975376129],
                        [0.914763331413269, 0.32435861229896545],
                        [0.07172297686338425, 0.3246980905532837],
                    ],
                    [
                        [0.070900559425354, 0.3287101686000824],
                        [0.8346244096755981, 0.3284030258655548],
                        [0.8346357941627502, 0.3410607576370239],
                        [0.07090827077627182, 0.34136661887168884],
                    ],
                    [
                        [0.1574886292219162, 0.36692699790000916],
                        [0.2582458257675171, 0.36688700318336487],
                        [0.25825121998786926, 0.37479066848754883],
                        [0.1574937105178833, 0.37483054399490356],
                    ],
                    [
                        [0.3929268419742584, 0.366915762424469],
                        [0.5910418629646301, 0.36683711409568787],
                        [0.5910483002662659, 0.37483346462249756],
                        [0.3929327130317688, 0.374911904335022],
                    ],
                    [
                        [0.6812520027160645, 0.36679619550704956],
                        [0.8738508224487305, 0.3667197525501251],
                        [0.8738600611686707, 0.3768358826637268],
                        [0.6812604665756226, 0.37691208720207214],
                    ],
                    [
                        [0.0954957827925682, 0.6695517301559448],
                        [0.3307328522205353, 0.6694678068161011],
                        [0.3307397961616516, 0.6792930960655212],
                        [0.0955018624663353, 0.6793767213821411],
                    ],
                    [
                        [0.08551976829767227, 0.6846805214881897],
                        [0.3014928996562958, 0.6846039295196533],
                        [0.30149954557418823, 0.6941632628440857],
                        [0.08552564680576324, 0.694239616394043],
                    ],
                    [
                        [0.0960054025053978, 0.4288017153739929],
                        [0.29206010699272156, 0.4287254810333252],
                        [0.2920668423175812, 0.4384554624557495],
                        [0.09601142257452011, 0.43853142857551575],
                    ],
                    [
                        [0.37049955129623413, 0.4363316297531128],
                        [0.6105730533599854, 0.43623852729797363],
                        [0.6105810403823853, 0.44605252146720886],
                        [0.3705066442489624, 0.44614529609680176],
                    ],
                    [
                        [0.08524250984191895, 0.44365188479423523],
                        [0.31416764855384827, 0.4435633420944214],
                        [0.3141744136810303, 0.4531959593296051],
                        [0.0852484256029129, 0.45328423380851746],
                    ],
                    [
                        [0.08509407192468643, 0.4583781957626343],
                        [0.3420571982860565, 0.4582793116569519],
                        [0.34206423163414, 0.46816375851631165],
                        [0.08510014414787292, 0.46826231479644775],
                    ],
                    [
                        [0.6552748680114746, 0.468096524477005],
                        [0.9050343632698059, 0.46800073981285095],
                        [0.9050419926643372, 0.4762129485607147],
                        [0.6552817225456238, 0.4763084650039673],
                    ],
                ],
            ],
            [
                '347',
                [
                    [
                        [0.07134777307510376, 0.5976690053939819],
                        [0.3115624487400055, 0.5976682305335999],
                        [0.3115696907043457, 0.6096845269203186],
                        [0.07135388255119324, 0.6096847057342529],
                    ],
                    [
                        [0.12199477106332779, 0.6306337714195251],
                        [0.7512645721435547, 0.6306359171867371],
                        [0.7512742280960083, 0.6432417035102844],
                        [0.12200142443180084, 0.6432380080223083],
                    ],
                    [
                        [0.12199737131595612, 0.654996395111084],
                        [0.8925634026527405, 0.655002772808075],
                        [0.8925735950469971, 0.6673716306686401],
                        [0.12200389802455902, 0.6673633456230164],
                    ],
                    [
                        [0.12213951349258423, 0.6715066432952881],
                        [0.21910598874092102, 0.6715077757835388],
                        [0.21911247074604034, 0.6829854846000671],
                        [0.12214557826519012, 0.6829841136932373],
                    ],
                    [
                        [0.1219799742102623, 0.6952394247055054],
                        [0.9022330641746521, 0.6952521800994873],
                        [0.9022433161735535, 0.7076261639595032],
                        [0.1219865083694458, 0.7076115012168884],
                    ],
                    [
                        [0.1221352219581604, 0.7116053104400635],
                        [0.26304712891578674, 0.7116081118583679],
                        [0.26305386424064636, 0.7231726050376892],
                        [0.12214132398366928, 0.7231695055961609],
                    ],
                    [
                        [0.12202703207731247, 0.7356084585189819],
                        [0.836510956287384, 0.7356259226799011],
                        [0.8365208506584167, 0.7479248046875],
                        [0.12203352153301239, 0.7479055523872375],
                    ],
                    [
                        [0.07260900735855103, 0.7790004014968872],
                        [0.4169275462627411, 0.7790117859840393],
                        [0.4169384837150574, 0.7960839867591858],
                        [0.07261769473552704, 0.7960713505744934],
                    ],
                    [
                        [0.07147320359945297, 0.8214214444160461],
                        [0.9116313457489014, 0.8214564919471741],
                        [0.9116418361663818, 0.834048867225647],
                        [0.07147960364818573, 0.8340116739273071],
                    ],
                    [
                        [0.07117993384599686, 0.8381301760673523],
                        [0.9221070408821106, 0.8381685614585876],
                        [0.9221174716949463, 0.8506308794021606],
                        [0.07118626683950424, 0.8505904078483582],
                    ],
                ],
            ],
            [
                '340',
                [
                    [
                        [0.07215804606676102, 0.6914342641830444],
                        [0.2805625796318054, 0.6915953159332275],
                        [0.28056105971336365, 0.7079757452011108],
                        [0.07215488702058792, 0.7078143358230591],
                    ],
                    [
                        [0.07136501371860504, 0.7334553599357605],
                        [0.9116525053977966, 0.7341084480285645],
                        [0.9116551876068115, 0.7466732859611511],
                        [0.07136257737874985, 0.7460190653800964],
                    ],
                    [
                        [0.07192588597536087, 0.7500152587890625],
                        [0.8913394808769226, 0.7506536245346069],
                        [0.891342043876648, 0.7631317973136902],
                        [0.07192347943782806, 0.7624923586845398],
                    ],
                    [
                        [0.07179820537567139, 0.7667795419692993],
                        [0.8676563501358032, 0.7674009799957275],
                        [0.8676587343215942, 0.7797871232032776],
                        [0.07179580628871918, 0.7791646718978882],
                    ],
                    [
                        [0.07147162407636642, 0.7834446430206299],
                        [0.8700363636016846, 0.7840695381164551],
                        [0.8700388073921204, 0.796606719493866],
                        [0.07146919518709183, 0.79598069190979],
                    ],
                    [
                        [0.07226241379976273, 0.8000175952911377],
                        [0.8713934421539307, 0.8006443977355957],
                        [0.8713958859443665, 0.8131848573684692],
                        [0.07225999236106873, 0.8125569820404053],
                    ],
                    [
                        [0.0715748593211174, 0.8434576392173767],
                        [0.8501061797142029, 0.8440718054771423],
                        [0.8501092791557312, 0.861092746257782],
                        [0.07157156616449356, 0.8604771494865417],
                    ],
                    [
                        [0.07184907048940659, 0.86287522315979],
                        [0.2539933919906616, 0.8630192875862122],
                        [0.25399166345596313, 0.8795113563537598],
                        [0.0718458816409111, 0.879366934299469],
                    ],
                    [
                        [0.0719442069530487, 0.9403231739997864],
                        [0.26688775420188904, 0.9404789805412292],
                        [0.2668869197368622, 0.9492151141166687],
                        [0.0719425156712532, 0.9490590691566467],
                    ],
                ],
            ],
            [
                '343',
                [
                    [
                        [0.07147492468357086, 0.07471860945224762],
                        [0.5729072690010071, 0.07428372651338577],
                        [0.5729207396507263, 0.08697150647640228],
                        [0.07148613780736923, 0.08740624040365219],
                    ],
                    [
                        [0.07192064821720123, 0.11801980435848236],
                        [0.6545708179473877, 0.11751508712768555],
                        [0.6545896530151367, 0.13481812179088593],
                        [0.07193594425916672, 0.13532260060310364],
                    ],
                    [
                        [0.07169973105192184, 0.16079318523406982],
                        [0.8895947337150574, 0.1600855141878128],
                        [0.8896095156669617, 0.17270395159721375],
                        [0.07171088457107544, 0.17341138422489166],
                    ],
                    [
                        [0.07150974124670029, 0.17735673487186432],
                        [0.8686242699623108, 0.17666734755039215],
                        [0.8686391711235046, 0.18946263194084167],
                        [0.07152105122804642, 0.19015178084373474],
                    ],
                    [
                        [0.07159547507762909, 0.19366489350795746],
                        [0.9167351722717285, 0.1929343044757843],
                        [0.9167507290840149, 0.2060687094926834],
                        [0.0716070830821991, 0.20679904520511627],
                    ],
                    [
                        [0.07129640877246857, 0.21079233288764954],
                        [0.8951205611228943, 0.21008050441741943],
                        [0.8951358199119568, 0.22306008636951447],
                        [0.07130788266658783, 0.22377166152000427],
                    ],
                    [
                        [0.07051388174295425, 0.22725845873355865],
                        [0.9132060408592224, 0.22653065621852875],
                        [0.9132212996482849, 0.23940938711166382],
                        [0.07052525877952576, 0.24013693630695343],
                    ],
                    [
                        [0.07150885462760925, 0.24380359053611755],
                        [0.143199160695076, 0.2437417060136795],
                        [0.14320816099643707, 0.25364813208580017],
                        [0.07151761651039124, 0.253710001707077],
                    ],
                    [
                        [0.07147663086652756, 0.2735811173915863],
                        [0.92697674036026, 0.2728431820869446],
                        [0.9269922971725464, 0.2859380543231964],
                        [0.07148820161819458, 0.28667572140693665],
                    ],
                    [
                        [0.0706537514925003, 0.2906676232814789],
                        [0.8783461451530457, 0.289971262216568],
                        [0.8783612847328186, 0.3029100298881531],
                        [0.07066518068313599, 0.3036061227321625],
                    ],
                ],
            ],
            [
                '407',
                [
                    [
                        [0.07191655784845352, 0.07489828020334244],
                        [0.9197043180465698, 0.07375171035528183],
                        [0.9197289347648621, 0.08689280599355698],
                        [0.07193657010793686, 0.08803918212652206],
                    ],
                    [
                        [0.07164986431598663, 0.09139112383127213],
                        [0.9259496331214905, 0.09023600071668625],
                        [0.9259740114212036, 0.10323026776313782],
                        [0.07166965305805206, 0.10438520461320877],
                    ],
                    [
                        [0.07173424959182739, 0.12162550538778305],
                        [0.24721693992614746, 0.12138832360506058],
                        [0.2472362071275711, 0.1334678828716278],
                        [0.0717526525259018, 0.1337050199508667],
                    ],
                    [
                        [0.07092484086751938, 0.15133608877658844],
                        [0.5705950856208801, 0.15066100656986237],
                        [0.570617139339447, 0.16341723501682281],
                        [0.07094426453113556, 0.16409221291542053],
                    ],
                    [
                        [0.12090085446834564, 0.18481065332889557],
                        [0.9256287217140198, 0.18372391164302826],
                        [0.9256530404090881, 0.19668850302696228],
                        [0.12092086672782898, 0.19777506589889526],
                    ],
                    [
                        [0.12205454707145691, 0.2012990117073059],
                        [0.6343386173248291, 0.20060734450817108],
                        [0.6343600153923035, 0.21279124915599823],
                        [0.12207335978746414, 0.2134828120470047],
                    ],
                    [
                        [0.1220666840672493, 0.22499068081378937],
                        [0.9018762707710266, 0.22393815219402313],
                        [0.9018991589546204, 0.23621916770935059],
                        [0.12208563834428787, 0.2372715324163437],
                    ],
                    [
                        [0.1220373660326004, 0.47060078382492065],
                        [0.8331629633903503, 0.46964409947395325],
                        [0.8331865072250366, 0.48247817158699036],
                        [0.12205716967582703, 0.48343467712402344],
                    ],
                    [
                        [0.12233392894268036, 0.2691349387168884],
                        [0.658967912197113, 0.2684110701084137],
                        [0.658990740776062, 0.2813458740711212],
                        [0.12235389649868011, 0.2820696234703064],
                    ],
                    [
                        [0.12074534595012665, 0.29260382056236267],
                        [0.9040156602859497, 0.291547566652298],
                        [0.9040403366088867, 0.3047676682472229],
                        [0.12076574563980103, 0.30582374334335327],
                    ],
                    [
                        [0.9095202684402466, 0.29297834634780884],
                        [0.9223574995994568, 0.2929610311985016],
                        [0.9223757386207581, 0.3027116060256958],
                        [0.9095385074615479, 0.30272889137268066],
                    ],
                    [
                        [0.07048645615577698, 0.3264178931713104],
                        [0.387491375207901, 0.32599061727523804],
                        [0.38751134276390076, 0.3380686044692993],
                        [0.07050484418869019, 0.33849582076072693],
                    ],
                ],
            ],
            [
                '346',
                [
                    [
                        [0.07089608907699585, 0.07481882721185684],
                        [0.7085664868354797, 0.07474936544895172],
                        [0.7085740566253662, 0.08691879361867905],
                        [0.0709007978439331, 0.0869869515299797],
                    ],
                    [
                        [0.12212446331977844, 0.10475587844848633],
                        [0.4453386962413788, 0.10472229868173599],
                        [0.4453449249267578, 0.1166054904460907],
                        [0.12212928384542465, 0.1166384294629097],
                    ],
                    [
                        [0.12188626080751419, 0.12123207002878189],
                        [0.708249032497406, 0.12117276340723038],
                        [0.7082566022872925, 0.13335645198822021],
                        [0.12189120054244995, 0.13341456651687622],
                    ],
                    [
                        [0.17161668837070465, 0.13794228434562683],
                        [0.8990343809127808, 0.13787074387073517],
                        [0.8990429639816284, 0.15025052428245544],
                        [0.17162193357944489, 0.15032054483890533],
                    ],
                    [
                        [0.17234918475151062, 0.15458422899246216],
                        [0.3332659900188446, 0.1545688509941101],
                        [0.3332718014717102, 0.16661052405834198],
                        [0.17235428094863892, 0.16662557423114777],
                    ],
                    [
                        [0.1720612347126007, 0.17102687060832977],
                        [0.9240480065345764, 0.17095710337162018],
                        [0.9240565299987793, 0.18322019279003143],
                        [0.17206642031669617, 0.18328842520713806],
                    ],
                    [
                        [0.1723145991563797, 0.18864665925502777],
                        [0.2661797106266022, 0.18863822519779205],
                        [0.2661849856376648, 0.20011836290359497],
                        [0.1723194718360901, 0.20012661814689636],
                    ],
                    [
                        [0.0712788924574852, 0.2177375853061676],
                        [0.5922293663024902, 0.21769332885742188],
                        [0.5922361016273499, 0.2294447124004364],
                        [0.07128344476222992, 0.22948792576789856],
                    ],
                    [
                        [0.07070165872573853, 0.26116421818733215],
                        [0.43247494101524353, 0.26113614439964294],
                        [0.43248307704925537, 0.2767871022224426],
                        [0.07070771604776382, 0.27681422233581543],
                    ],
                    [
                        [0.07049967348575592, 0.3035505712032318],
                        [0.860899806022644, 0.3034948408603668],
                        [0.8609082698822021, 0.31606271862983704],
                        [0.07050453126430511, 0.3161168098449707],
                    ],
                    [
                        [0.07106634974479675, 0.32043859362602234],
                        [0.9184048771858215, 0.320381224155426],
                        [0.9184134602546692, 0.3327574133872986],
                        [0.07107114046812057, 0.332813024520874],
                    ],
                    [
                        [0.07121240347623825, 0.33706432580947876],
                        [0.7788338661193848, 0.3370184004306793],
                        [0.7788416743278503, 0.3492107391357422],
                        [0.0712171196937561, 0.349255234003067],
                    ],
                    [
                        [0.07162345200777054, 0.3669256567955017],
                        [0.564441442489624, 0.3668961226940155],
                        [0.564448356628418, 0.3791187107563019],
                        [0.07162819057703018, 0.3791472017765045],
                    ],
                ],
            ],
            [
                '345',
                [
                    [
                        [0.15754976868629456, 0.08272582292556763],
                        [0.25791171193122864, 0.08268596231937408],
                        [0.2579173743724823, 0.09096617251634598],
                        [0.15755510330200195, 0.09100590646266937],
                    ],
                    [
                        [0.3929680287837982, 0.08294537663459778],
                        [0.5911257266998291, 0.08286668360233307],
                        [0.5911322832107544, 0.0908965989947319],
                        [0.392973929643631, 0.09097505360841751],
                    ],
                    [
                        [0.681280791759491, 0.08288968354463577],
                        [0.8731128573417664, 0.08281350135803223],
                        [0.873121976852417, 0.09273115545511246],
                        [0.6812891960144043, 0.09280705451965332],
                    ],
                    [
                        [0.6559534072875977, 0.11534664779901505],
                        [0.8925959467887878, 0.11525381356477737],
                        [0.8926049470901489, 0.12496446818113327],
                        [0.6559615135192871, 0.12505696713924408],
                    ],
                    [
                        [0.3701340854167938, 0.12251187860965729],
                        [0.467264860868454, 0.12247387319803238],
                        [0.46727243065834045, 0.13236697018146515],
                        [0.37014126777648926, 0.13240483403205872],
                    ],
                    [
                        [0.6558276414871216, 0.1302127093076706],
                        [0.7495221495628357, 0.13017615675926208],
                        [0.7495287656784058, 0.13780440390110016],
                        [0.6558340191841125, 0.1378408521413803],
                    ],
                    [
                        [0.09592471271753311, 0.13996265828609467],
                        [0.3310680091381073, 0.1398712694644928],
                        [0.3310745656490326, 0.14909805357456207],
                        [0.09593044221401215, 0.14918912947177887],
                    ],
                    [
                        [0.0959184393286705, 0.15438899397850037],
                        [0.3409803509712219, 0.15429426729679108],
                        [0.3409874439239502, 0.16420522332191467],
                        [0.09592459350824356, 0.1642995923757553],
                    ],
                    [
                        [0.37078073620796204, 0.1643635481595993],
                        [0.6234955191612244, 0.16426624357700348],
                        [0.6235034465789795, 0.17390350997447968],
                        [0.37078773975372314, 0.17400045692920685],
                    ],
                    [
                        [0.6559680104255676, 0.16424870491027832],
                        [0.9089354872703552, 0.16415129601955414],
                        [0.9089446067810059, 0.17390459775924683],
                        [0.6559761762619019, 0.17400163412094116],
                    ],
                    [
                        [0.37049615383148193, 0.179122656583786],
                        [0.5291081666946411, 0.17906193435192108],
                        [0.5291156768798828, 0.18861956894397736],
                        [0.37050309777259827, 0.18868006765842438],
                    ],
                    [
                        [0.6555525660514832, 0.17929062247276306],
                        [0.6866612434387207, 0.17927871644496918],
                        [0.6866677403450012, 0.18698740005493164],
                        [0.6555590033531189, 0.18699927628040314],
                    ],
                    [
                        [0.07056388258934021, 0.21705839037895203],
                        [0.8807221055030823, 0.21675275266170502],
                        [0.8807334899902344, 0.2290782332420349],
                        [0.0705714151263237, 0.22938239574432373],
                    ],
                    [
                        [0.12090424448251724, 0.2504861354827881],
                        [0.9010745882987976, 0.2501956820487976],
                        [0.9010859727859497, 0.2624557316303253],
                        [0.12091197818517685, 0.2627447545528412],
                    ],
                    [
                        [0.12161128968000412, 0.2669714391231537],
                        [0.7520105838775635, 0.26673829555511475],
                        [0.7520212531089783, 0.27893880009651184],
                        [0.12161898612976074, 0.27917081117630005],
                    ],
                    [
                        [0.12206084281206131, 0.29090389609336853],
                        [0.8866807818412781, 0.29062381386756897],
                        [0.8866921663284302, 0.3028911352157593],
                        [0.12206857651472092, 0.3031698167324066],
                    ],
                    [
                        [0.12170755118131638, 0.30741533637046814],
                        [0.9212946891784668, 0.30712440609931946],
                        [0.9213061928749084, 0.31942886114120483],
                        [0.12171531468629837, 0.3197183310985565],
                    ],
                    [
                        [0.1216515600681305, 0.3264196515083313],
                        [0.13736911118030548, 0.32641398906707764],
                        [0.13737361133098602, 0.33347946405410767],
                        [0.12165601551532745, 0.33348512649536133],
                    ],
                ],
            ],
            [
                '342',
                [
                    [
                        [0.09717916697263718, 0.08658391237258911],
                        [0.3194121718406677, 0.08639530092477798],
                        [0.31942445039749146, 0.09640386700630188],
                        [0.09719052910804749, 0.09659258276224136],
                    ],
                    [
                        [0.36334100365638733, 0.08640706539154053],
                        [0.5108893513679504, 0.08628183603286743],
                        [0.510905385017395, 0.09851538389921188],
                        [0.36335626244544983, 0.09864069521427155],
                    ],
                    [
                        [0.6020962595939636, 0.08657068759202957],
                        [0.8559943437576294, 0.08635520190000534],
                        [0.8560119867324829, 0.09846948087215424],
                        [0.6021125912666321, 0.098685123026371],
                    ],
                    [
                        [0.09267466515302658, 0.10050910711288452],
                        [0.32377952337265015, 0.10031281411647797],
                        [0.323794960975647, 0.11284264922142029],
                        [0.09268885850906372, 0.11303908377885818],
                    ],
                    [
                        [0.10210051387548447, 0.11495142430067062],
                        [0.3152703046798706, 0.11477021127939224],
                        [0.31528541445732117, 0.12708547711372375],
                        [0.10211451351642609, 0.12726682424545288],
                    ],
                    [
                        [0.16694287955760956, 0.12939925491809845],
                        [0.24929001927375793, 0.12932918965816498],
                        [0.24930453300476074, 0.14143414795398712],
                        [0.16695697605609894, 0.14150425791740417],
                    ],
                    [
                        [0.5482304096221924, 0.6189561486244202],
                        [0.8834999203681946, 0.6186628937721252],
                        [0.8835178017616272, 0.6308205127716064],
                        [0.5482465624809265, 0.6311139464378357],
                    ],
                    [
                        [0.5478487014770508, 0.18940047919750214],
                        [0.5925602316856384, 0.1893623024225235],
                        [0.5925734043121338, 0.1991569697856903],
                        [0.5478616952896118, 0.19919516146183014],
                    ],
                    [
                        [0.5612772703170776, 0.20839577913284302],
                        [0.8802953958511353, 0.208123117685318],
                        [0.8803138732910156, 0.2207253873348236],
                        [0.5612940192222595, 0.22099824249744415],
                    ],
                    [
                        [0.5472884774208069, 0.22703437507152557],
                        [0.9016910791397095, 0.22673115134239197],
                        [0.9017099142074585, 0.23945634067058563],
                        [0.5473053455352783, 0.23975977301597595],
                    ],
                    [
                        [0.19472503662109375, 0.24648043513298035],
                        [0.2213624268770218, 0.24645762145519257],
                        [0.22137434780597687, 0.25649312138557434],
                        [0.19473683834075928, 0.2565159499645233],
                    ],
                    [
                        [0.39995571970939636, 0.6279847025871277],
                        [0.4753124713897705, 0.6279187202453613],
                        [0.47532594203948975, 0.6383137702941895],
                        [0.39996883273124695, 0.6383797526359558],
                    ],
                    [
                        [0.5487815737724304, 0.24634340405464172],
                        [0.7047896385192871, 0.2462097853422165],
                        [0.7048052549362183, 0.25744113326072693],
                        [0.5487964749336243, 0.2575748562812805],
                    ],
                    [
                        [0.5478792190551758, 0.3848882019519806],
                        [0.8727116584777832, 0.38460779190063477],
                        [0.8727295994758606, 0.3968650996685028],
                        [0.5478954911231995, 0.39714571833610535],
                    ],
                    [
                        [0.5474071502685547, 0.28429242968559265],
                        [0.8514800667762756, 0.2840314209461212],
                        [0.8514984846115112, 0.29669705033302307],
                        [0.5474239587783813, 0.29695823788642883],
                    ],
                    [
                        [0.5477455258369446, 0.3032644987106323],
                        [0.9038694500923157, 0.30295848846435547],
                        [0.9038880467414856, 0.31554654240608215],
                        [0.5477622151374817, 0.3158527612686157],
                    ],
                    [
                        [0.5475293397903442, 0.3225022554397583],
                        [0.7801554799079895, 0.3223021328449249],
                        [0.7801729440689087, 0.33456695079803467],
                        [0.5475456118583679, 0.33476722240448],
                    ],
                    [
                        [0.5472674369812012, 0.40399283170700073],
                        [0.7592884302139282, 0.4038096070289612],
                        [0.7593026757240295, 0.41388073563575745],
                        [0.5472807884216309, 0.41406404972076416],
                    ],
                    [
                        [0.548470675945282, 0.422936350107193],
                        [0.895197331905365, 0.42263638973236084],
                        [0.8952161073684692, 0.4353817105293274],
                        [0.5484875440597534, 0.43568190932273865],
                    ],
                    [
                        [0.5479761362075806, 0.4419889748096466],
                        [0.8843866586685181, 0.4416976273059845],
                        [0.8844047784805298, 0.45404160022735596],
                        [0.5479925274848938, 0.4543331563472748],
                    ],
                    [
                        [0.5482240915298462, 0.46115174889564514],
                        [0.8601742386817932, 0.4608812928199768],
                        [0.8601923584938049, 0.4732878804206848],
                        [0.5482405424118042, 0.4735585153102875],
                    ],
                    [
                        [0.19870853424072266, 0.6283586621284485],
                        [0.21816033124923706, 0.6283416748046875],
                        [0.2181718498468399, 0.6380540728569031],
                        [0.19871996343135834, 0.6380711197853088],
                    ],
                    [
                        [0.40368905663490295, 0.4706481695175171],
                        [0.4723091423511505, 0.47058865427970886],
                        [0.47232186794281006, 0.48043158650398254],
                        [0.4037014842033386, 0.48049116134643555],
                    ],
                    [
                        [0.5481446385383606, 0.48007842898368835],
                        [0.9002560973167419, 0.4797728359699249],
                        [0.9002748131752014, 0.4924516975879669],
                        [0.5481614470481873, 0.49275752902030945],
                    ],
                    [
                        [0.5479258298873901, 0.4990542232990265],
                        [0.5879822373390198, 0.49901944398880005],
                        [0.5879956483840942, 0.5090084671974182],
                        [0.5479390621185303, 0.509043276309967],
                    ],
                    [
                        [0.5482636094093323, 0.5179409980773926],
                        [0.900283932685852, 0.5176348090171814],
                        [0.9003027677536011, 0.5304176807403564],
                        [0.5482805371284485, 0.530724048614502],
                    ],
                    [
                        [0.5473930835723877, 0.5371263027191162],
                        [0.8743391036987305, 0.536841630935669],
                        [0.874356210231781, 0.548536479473114],
                        [0.5474085807800293, 0.5488213300704956],
                    ],
                    [
                        [0.548534631729126, 0.5558129549026489],
                        [0.8931880593299866, 0.555512547492981],
                        [0.8932065963745117, 0.5680968165397644],
                        [0.5485513210296631, 0.5683974623680115],
                    ],
                    [
                        [0.548097550868988, 0.575219988822937],
                        [0.8864733576774597, 0.5749247670173645],
                        [0.8864908814430237, 0.5868694186210632],
                        [0.5481134057044983, 0.5871648788452148],
                    ],
                ],
            ],
            [
                '348',
                [
                    [
                        [0.07122962921857834, 0.07477620244026184],
                        [0.23266997933387756, 0.07468331605195999],
                        [0.23268035054206848, 0.08453403413295746],
                        [0.0712393969297409, 0.08462653309106827],
                    ],
                    [
                        [0.07171890884637833, 0.1046290174126625],
                        [0.9124628901481628, 0.1041514128446579],
                        [0.9124793410301208, 0.11675643175840378],
                        [0.07173141092061996, 0.11723145097494125],
                    ],
                    [
                        [0.07129015773534775, 0.12120763957500458],
                        [0.9027054309844971, 0.1207386925816536],
                        [0.9027213454246521, 0.1329764872789383],
                        [0.07130230218172073, 0.1334429532289505],
                    ],
                    [
                        [0.07160326093435287, 0.13798174262046814],
                        [0.6159455180168152, 0.13767693936824799],
                        [0.6159602999687195, 0.15007779002189636],
                        [0.0716155618429184, 0.150380939245224],
                    ],
                    [
                        [0.12129442393779755, 0.17128796875476837],
                        [0.8890267610549927, 0.17086432874202728],
                        [0.8890432715415955, 0.183603897690773],
                        [0.12130729854106903, 0.18402515351772308],
                    ],
                    [
                        [0.1214430183172226, 0.1878976821899414],
                        [0.8814472556114197, 0.18748138844966888],
                        [0.881463885307312, 0.20035821199417114],
                        [0.12145603448152542, 0.20077210664749146],
                    ],
                    [
                        [0.12171844393014908, 0.20476134121418],
                        [0.5360251665115356, 0.20453611016273499],
                        [0.5360392928123474, 0.21667659282684326],
                        [0.12173071503639221, 0.21690060198307037],
                    ],
                    [
                        [0.12195128947496414, 0.22818681597709656],
                        [0.8975648283958435, 0.2277696132659912],
                        [0.8975815176963806, 0.24066254496574402],
                        [0.12196432054042816, 0.24107730388641357],
                    ],
                    [
                        [0.12129460275173187, 0.24557051062583923],
                        [0.2187524288892746, 0.2455185055732727],
                        [0.21876507997512817, 0.2576026916503906],
                        [0.12130681425333023, 0.25765442848205566],
                    ],
                    [
                        [0.12192101776599884, 0.2687820494174957],
                        [0.9159558415412903, 0.268362820148468],
                        [0.9159725308418274, 0.28113606572151184],
                        [0.12193392962217331, 0.28155282139778137],
                    ],
                    [
                        [0.12204998731613159, 0.28544703125953674],
                        [0.898764967918396, 0.28504008054733276],
                        [0.8987812399864197, 0.29754894971847534],
                        [0.12206263095140457, 0.2979535460472107],
                    ],
                ],
            ],
            [
                '408',
                [
                    [
                        [0.07191108912229538, 0.07488514482975006],
                        [0.8978518843650818, 0.07418212294578552],
                        [0.8978678584098816, 0.08691825717687607],
                        [0.07192310690879822, 0.08762012422084808],
                    ],
                    [
                        [0.07114579528570175, 0.09124010056257248],
                        [0.19918279349803925, 0.09113135188817978],
                        [0.1991949826478958, 0.10341870784759521],
                        [0.07115738838911057, 0.10352728515863419],
                    ],
                    [
                        [0.07161545008420944, 0.12138758599758148],
                        [0.874144971370697, 0.12070860713720322],
                        [0.8741603493690491, 0.13308683037757874],
                        [0.07162712514400482, 0.13376472890377045],
                    ],
                    [
                        [0.07083523273468018, 0.13798968493938446],
                        [0.9126362800598145, 0.13727901875972748],
                        [0.9126524925231934, 0.1501612663269043],
                        [0.07084738463163376, 0.15087074041366577],
                    ],
                    [
                        [0.07112360000610352, 0.15459281206130981],
                        [0.9134876728057861, 0.1538832187652588],
                        [0.9135038256645203, 0.16671161353588104],
                        [0.07113569974899292, 0.16742001473903656],
                    ],
                    [
                        [0.07128392159938812, 0.17116771638393402],
                        [0.48167186975479126, 0.17082275450229645],
                        [0.48168525099754333, 0.18301908671855927],
                        [0.07129542529582977, 0.18336348235607147],
                    ],
                    [
                        [0.0702836811542511, 0.2011319398880005],
                        [0.8903375267982483, 0.20044535398483276],
                        [0.8903535008430481, 0.21321234107017517],
                        [0.07029572129249573, 0.21389779448509216],
                    ],
                    [
                        [0.07161270827054977, 0.21782931685447693],
                        [0.8896887898445129, 0.2171458899974823],
                        [0.8897045850753784, 0.22980496287345886],
                        [0.07162465155124664, 0.23048725724220276],
                    ],
                    [
                        [0.07154671847820282, 0.2345113903284073],
                        [0.10943251103162766, 0.23447981476783752],
                        [0.109441839158535, 0.24422159790992737],
                        [0.07155591249465942, 0.24425312876701355],
                    ],
                    [
                        [0.07195021957159042, 0.26436498761177063],
                        [0.3183201551437378, 0.2641604244709015],
                        [0.3183329701423645, 0.27653878927230835],
                        [0.0719619020819664, 0.27674299478530884],
                    ],
                    [
                        [0.07175032049417496, 0.2940864562988281],
                        [0.578336238861084, 0.2936674952507019],
                        [0.5783506631851196, 0.30640605092048645],
                        [0.0717623382806778, 0.30682429671287537],
                    ],
                ],
            ],
            [
                '521',
                [
                    [
                        [0.07118555903434753, 0.0748816654086113],
                        [0.6088129878044128, 0.07461098581552505],
                        [0.6088234782218933, 0.08685293793678284],
                        [0.0711936354637146, 0.08712261915206909],
                    ],
                    [
                        [0.12116862833499908, 0.10831376910209656],
                        [0.3691045343875885, 0.10819020867347717],
                        [0.3691138029098511, 0.12024649977684021],
                        [0.12117680162191391, 0.12036960572004318],
                    ],
                    [
                        [0.12118128687143326, 0.13206028938293457],
                        [0.45283767580986023, 0.1318962126970291],
                        [0.4528474509716034, 0.14411133527755737],
                        [0.12118956446647644, 0.1442747861146927],
                    ],
                    [
                        [0.07038773596286774, 0.16536399722099304],
                        [0.7958886027336121, 0.1650087684392929],
                        [0.795900285243988, 0.17766046524047852],
                        [0.0703960731625557, 0.17801427841186523],
                    ],
                    [
                        [0.12151434272527695, 0.19904837012290955],
                        [0.570319414138794, 0.19883094727993011],
                        [0.5703299045562744, 0.21129466593265533],
                        [0.12152279168367386, 0.21151123940944672],
                    ],
                    [
                        [0.1212501972913742, 0.22276543080806732],
                        [0.9026404619216919, 0.22238971292972565],
                        [0.9026525020599365, 0.2349194586277008],
                        [0.1212586909532547, 0.2352936863899231],
                    ],
                    [
                        [0.12178946286439896, 0.24637140333652496],
                        [0.7353633046150208, 0.24607859551906586],
                        [0.7353743314743042, 0.25831136107444763],
                        [0.12179775536060333, 0.2586030066013336],
                    ],
                    [
                        [0.12171605974435806, 0.27036386728286743],
                        [0.8824983239173889, 0.27000361680984497],
                        [0.8825103044509888, 0.28251177072525024],
                        [0.12172453850507736, 0.2828705608844757],
                    ],
                    [
                        [0.1222965270280838, 0.2869686484336853],
                        [0.5538766980171204, 0.28676536679267883],
                        [0.5538869500160217, 0.2990093529224396],
                        [0.12230483442544937, 0.2992118299007416],
                    ],
                    [
                        [0.09364725649356842, 0.3207511305809021],
                        [0.867986261844635, 0.32039040327072144],
                        [0.8679978847503662, 0.3325875997543335],
                        [0.09365539997816086, 0.33294686675071716],
                    ],
                    [
                        [0.09364398568868637, 0.33710768818855286],
                        [0.5845906138420105, 0.33688023686408997],
                        [0.5846010446548462, 0.34920138120651245],
                        [0.09365221112966537, 0.3494279086589813],
                    ],
                    [
                        [0.07230845838785172, 0.3807229697704315],
                        [0.43500834703445435, 0.3805573582649231],
                        [0.43502143025398254, 0.39708393812179565],
                        [0.07231936603784561, 0.39724862575531006],
                    ],
                ],
            ],
            [
                '341',
                [
                    [
                        [0.12120668590068817, 0.23164206743240356],
                        [0.24286000430583954, 0.23156778514385223],
                        [0.24287262558937073, 0.24386164546012878],
                        [0.12121952325105667, 0.24393711984157562],
                    ],
                    [
                        [0.12199453264474869, 0.25556647777557373],
                        [0.8914657235145569, 0.25508207082748413],
                        [0.8914774656295776, 0.26764482259750366],
                        [0.12200765311717987, 0.2681368887424469],
                    ],
                    [
                        [0.12140069901943207, 0.2721131145954132],
                        [0.9245702624320984, 0.2715969383716583],
                        [0.9245818853378296, 0.28413885831832886],
                        [0.12141379714012146, 0.28466299176216125],
                    ],
                    [
                        [0.12134797126054764, 0.28876185417175293],
                        [0.4804830253124237, 0.288526326417923],
                        [0.4804953336715698, 0.30095022916793823],
                        [0.12136094272136688, 0.3011893033981323],
                    ],
                    [
                        [0.12106307595968246, 0.31267884373664856],
                        [0.9257283210754395, 0.31213587522506714],
                        [0.9257398843765259, 0.3246033489704132],
                        [0.12107609957456589, 0.32515427470207214],
                    ],
                    [
                        [0.12174765020608902, 0.32877716422080994],
                        [0.832229495048523, 0.3282886743545532],
                        [0.8322417736053467, 0.3413084149360657],
                        [0.1217612475156784, 0.34180423617362976],
                    ],
                    [
                        [0.07093822211027145, 0.3627663254737854],
                        [0.8574888110160828, 0.362204372882843],
                        [0.8575006723403931, 0.3749202787876129],
                        [0.07095160335302353, 0.37549012899398804],
                    ],
                    [
                        [0.07091539353132248, 0.37908393144607544],
                        [0.8173081278800964, 0.3785410225391388],
                        [0.8173204660415649, 0.39160293340682983],
                        [0.0709291398525238, 0.3921535909175873],
                    ],
                    [
                        [0.12208291888237, 0.4130493700504303],
                        [0.9052346348762512, 0.4124586284160614],
                        [0.9052462577819824, 0.42498156428337097],
                        [0.1220959946513176, 0.42558008432388306],
                    ],
                ],
            ],
        ],
    },
]

export const FHADocPromptExamples = [
    {
        question: 'Summarize this document.',
        InitialChatTitle: 'FHA Lender Requirements Overview',
        Answer: "This is the FHA Single Family Housing Policy Handbook (4000.1), which outlines key requirements and guidelines for FHA-approved lenders. Here's a summary of the main components:\n\n1. Lender/Mortgagee Approval Requirements:\n- Different types of approved mortgagees (Supervised, Nonsupervised, Government, and Investing)\n- Application and eligibility requirements\n- Personnel licensing requirements\n- Financial requirements including adjusted net worth standards\n\n2. Quality Control (QC) Requirements:\n- Mandatory QC program implementation\n- Requirements for loan file reviews\n- Documentation retention requirements\n- Servicing quality control requirements\n\n3. Direct Endorsement Authority:\n- Eligibility requirements for DE authority\n- Experience requirements (5 years in Single Family mortgages)\n- Personnel requirements (permanent underwriter on staff)\n- Test case phase requirements\n\n4. DELRAP (Direct Endorsement Lender Review and Approval Process) Authority:\n- Requirements for condominium project approval authority\n- Experience requirements\n- Personnel requirements\n- Quality control requirements specific to DELRAP\n\nThe handbook serves as the comprehensive guide for FHA-approved lenders, providing detailed requirements for participating in FHA programs and maintaining FHA approval.\n\nReference: This summary is based on sections from FHA Handbook 4000.1, particularly sections I.A.3 (Application and Eligibility Requirements), I.A.5 (Supplemental Mortgagee Authorities), and V.A (Quality Control Requirements).",
        QuoteLocations: [
            [
                '45',
                [
                    [
                        [0.11658141762018204, 0.06223421171307564],
                        [0.44790926575660706, 0.0620386116206646],
                        [0.4479183554649353, 0.07446581870317459],
                        [0.11658921092748642, 0.07466091960668564],
                    ],
                    [
                        [0.11714127659797668, 0.07649105042219162],
                        [0.5293891429901123, 0.07624839246273041],
                        [0.529399037361145, 0.08930132538080215],
                        [0.1171494647860527, 0.08954332768917084],
                    ],
                    [
                        [0.20601598918437958, 0.1083890050649643],
                        [0.393341988325119, 0.10827947407960892],
                        [0.3933524787425995, 0.12292865663766861],
                        [0.20602558553218842, 0.12303785234689713],
                    ],
                    [
                        [0.235319584608078, 0.14077246189117432],
                        [0.34262168407440186, 0.14071014523506165],
                        [0.34263136982917786, 0.15458567440509796],
                        [0.235328808426857, 0.1546477973461151],
                    ],
                    [
                        [0.2343527227640152, 0.17327572405338287],
                        [0.8749678134918213, 0.17290623486042023],
                        [0.8749809265136719, 0.188048854470253],
                        [0.23436279594898224, 0.18841716647148132],
                    ],
                    [
                        [0.23452211916446686, 0.19097761809825897],
                        [0.8449656367301941, 0.190626859664917],
                        [0.8449784517288208, 0.20556606352329254],
                        [0.23453204333782196, 0.20591570436954498],
                    ],
                    [
                        [0.23486845195293427, 0.20838890969753265],
                        [0.8077108263969421, 0.20806096494197845],
                        [0.8077235221862793, 0.22311191260814667],
                        [0.23487845063209534, 0.2234387993812561],
                    ],
                    [
                        [0.23512446880340576, 0.2259151190519333],
                        [0.6803366541862488, 0.22566120326519012],
                        [0.6803486347198486, 0.24056869745254517],
                        [0.23513437807559967, 0.24082180857658386],
                    ],
                    [
                        [0.2355009913444519, 0.25814637541770935],
                        [0.4761125445365906, 0.2580100893974304],
                        [0.47612351179122925, 0.2728099226951599],
                        [0.23551084101200104, 0.272945761680603],
                    ],
                    [
                        [0.23451457917690277, 0.29100164771080017],
                        [0.8489523530006409, 0.29065608978271484],
                        [0.8489652872085571, 0.30566585063934326],
                        [0.23452456295490265, 0.30601027607917786],
                    ],
                    [
                        [0.23500478267669678, 0.3086419701576233],
                        [0.3263446092605591, 0.3085907995700836],
                        [0.32635459303855896, 0.32298964262008667],
                        [0.23501434922218323, 0.3230406641960144],
                    ],
                    [
                        [0.17614395916461945, 0.34079039096832275],
                        [0.4065423309803009, 0.3406622111797333],
                        [0.4065530300140381, 0.35554635524749756],
                        [0.17615357041358948, 0.3556741178035736],
                    ],
                    [
                        [0.20593774318695068, 0.3733579218387604],
                        [0.3131787180900574, 0.37329867482185364],
                        [0.3131890296936035, 0.38826459646224976],
                        [0.20594754815101624, 0.3883236348628998],
                    ],
                    [
                        [0.20533853769302368, 0.4062216877937317],
                        [0.8298571705818176, 0.40587925910949707],
                        [0.8298701047897339, 0.4209730923175812],
                        [0.2053484320640564, 0.4213143587112427],
                    ],
                    [
                        [0.20518910884857178, 0.4232785701751709],
                        [0.6575915217399597, 0.42303144931793213],
                        [0.6576036810874939, 0.43824315071105957],
                        [0.20519907772541046, 0.4384894073009491],
                    ],
                    [
                        [0.23508216440677643, 0.4560687839984894],
                        [0.4355909824371338, 0.45596006512641907],
                        [0.4356015622615814, 0.4704568386077881],
                        [0.23509180545806885, 0.47056519985198975],
                    ],
                    [
                        [0.23439879715442657, 0.48879849910736084],
                        [0.8734561204910278, 0.48845458030700684],
                        [0.8734690546989441, 0.5033254623413086],
                        [0.2344086766242981, 0.5036682486534119],
                    ],
                    [
                        [0.23494388163089752, 0.5062119960784912],
                        [0.8772555589675903, 0.5058676600456238],
                        [0.8772682547569275, 0.5204662680625916],
                        [0.23495358228683472, 0.5208094716072083],
                    ],
                ],
            ],
            [
                '30',
                [
                    [
                        [0.1466042399406433, 0.4732431471347809],
                        [0.8611374497413635, 0.473147451877594],
                        [0.861142635345459, 0.4880520701408386],
                        [0.1466074436903, 0.48814624547958374],
                    ],
                    [
                        [0.14674974977970123, 0.4910741448402405],
                        [0.8630329966545105, 0.4909800589084625],
                        [0.8630381226539612, 0.5055867433547974],
                        [0.14675287902355194, 0.5056793093681335],
                    ],
                    [
                        [0.14644554257392883, 0.5084914565086365],
                        [0.2873723804950714, 0.50847327709198],
                        [0.28737589716911316, 0.5230456590652466],
                        [0.14644865691661835, 0.5230635404586792],
                    ],
                    [
                        [0.17593379318714142, 0.5410735011100769],
                        [0.4103560447692871, 0.5410444140434265],
                        [0.41035982966423035, 0.5554070472717285],
                        [0.17593695223331451, 0.5554356575012207],
                    ],
                    [
                        [0.20595183968544006, 0.5735445022583008],
                        [0.31266218423843384, 0.5735317468643188],
                        [0.31266579031944275, 0.588217556476593],
                        [0.2059551477432251, 0.5882300734519958],
                    ],
                    [
                        [0.20497025549411774, 0.6062309741973877],
                        [0.806045651435852, 0.6061620712280273],
                        [0.8060505986213684, 0.6207593083381653],
                        [0.20497353374958038, 0.6208269596099854],
                    ],
                    [
                        [0.2055779993534088, 0.6237649917602539],
                        [0.4419946074485779, 0.6237384676933289],
                        [0.4419984817504883, 0.6381953358650208],
                        [0.20558124780654907, 0.6382213234901428],
                    ],
                    [
                        [0.2644176781177521, 0.6423495411872864],
                        [0.8240007162094116, 0.6422882676124573],
                        [0.8240057229995728, 0.6568043231964111],
                        [0.26442110538482666, 0.6568644046783447],
                    ],
                    [
                        [0.263963907957077, 0.6595286726951599],
                        [0.8472219109535217, 0.6594663262367249],
                        [0.8472269177436829, 0.6738578081130981],
                        [0.2639673054218292, 0.6739189624786377],
                    ],
                    [
                        [0.26402878761291504, 0.6769906878471375],
                        [0.7956331968307495, 0.6769351959228516],
                        [0.7956380844116211, 0.6914913654327393],
                        [0.264032244682312, 0.6915457248687744],
                    ],
                    [
                        [0.2641749978065491, 0.6957356333732605],
                        [0.8632424473762512, 0.6956747174263],
                        [0.8632474541664124, 0.7099592089653015],
                        [0.26417839527130127, 0.7100189328193665],
                    ],
                    [
                        [0.2640719413757324, 0.71291184425354],
                        [0.4117317199707031, 0.7128971815109253],
                        [0.41173550486564636, 0.7272083759307861],
                        [0.26407530903816223, 0.7272226810455322],
                    ],
                    [
                        [0.2644275426864624, 0.7312871217727661],
                        [0.8403006196022034, 0.7312315106391907],
                        [0.8403056859970093, 0.7459664940834045],
                        [0.26443102955818176, 0.7460207939147949],
                    ],
                    [
                        [0.2644244134426117, 0.7488323450088501],
                        [0.320583701133728, 0.7488270401954651],
                        [0.3205870985984802, 0.7625569701194763],
                        [0.26442766189575195, 0.7625621557235718],
                    ],
                    [
                        [0.2637285888195038, 0.7672460079193115],
                        [0.8002504110336304, 0.7671970129013062],
                        [0.8002554774284363, 0.7823667526245117],
                        [0.2637321650981903, 0.7824145555496216],
                    ],
                ],
            ],
            [
                '13',
                [
                    [
                        [0.11700957268476486, 0.062310732901096344],
                        [0.24148935079574585, 0.06222963705658913],
                        [0.24149806797504425, 0.07216157764196396],
                        [0.11701793223619461, 0.07224246114492416],
                    ],
                    [
                        [0.11674433201551437, 0.0940587967634201],
                        [0.1314641386270523, 0.09404928982257843],
                        [0.13147389888763428, 0.10557454824447632],
                        [0.11675402522087097, 0.1055840328335762],
                    ],
                    [
                        [0.14675094187259674, 0.09412409365177155],
                        [0.7573539018630981, 0.0937296524643898],
                        [0.7573687434196472, 0.10826005041599274],
                        [0.14676329493522644, 0.10865295678377151],
                    ],
                    [
                        [0.853969931602478, 0.11137393862009048],
                        [0.8810027241706848, 0.11135655641555786],
                        [0.8810149431228638, 0.12290827184915543],
                        [0.8539820909500122, 0.12292559444904327],
                    ],
                    [
                        [0.14671652019023895, 0.11149019747972488],
                        [0.7171550393104553, 0.11112341284751892],
                        [0.7171698808670044, 0.12577763199806213],
                        [0.146728977560997, 0.1261429637670517],
                    ],
                    [
                        [0.1465608775615692, 0.1289098709821701],
                        [0.5277178883552551, 0.128665953874588],
                        [0.5277320146560669, 0.14339607954025269],
                        [0.14657339453697205, 0.14363902807235718],
                    ],
                    [
                        [0.8520876169204712, 0.1293245255947113],
                        [0.8811911344528198, 0.1293059140443802],
                        [0.8812026381492615, 0.14018619060516357],
                        [0.8520990610122681, 0.1402047574520111],
                    ],
                    [
                        [0.1466158628463745, 0.14653079211711884],
                        [0.5377822518348694, 0.1462816596031189],
                        [0.5377959609031677, 0.16050417721271515],
                        [0.14662794768810272, 0.16075235605239868],
                    ],
                    [
                        [0.8517813682556152, 0.14629176259040833],
                        [0.8795097470283508, 0.14627410471439362],
                        [0.8795215487480164, 0.15739917755126953],
                        [0.8517930507659912, 0.15741679072380066],
                    ],
                    [
                        [0.1466047167778015, 0.16381296515464783],
                        [0.5223880410194397, 0.16357474029064178],
                        [0.5224019885063171, 0.17817173898220062],
                        [0.1466171145439148, 0.17840901017189026],
                    ],
                    [
                        [0.8521380424499512, 0.1641770452260971],
                        [0.8794483542442322, 0.16415973007678986],
                        [0.8794599771499634, 0.17515341937541962],
                        [0.8521496057510376, 0.1751706749200821],
                    ],
                    [
                        [0.14647170901298523, 0.18116390705108643],
                        [0.5900540947914124, 0.18088404834270477],
                        [0.5900681614875793, 0.1953296661376953],
                        [0.14648397266864777, 0.19560842216014862],
                    ],
                    [
                        [0.8518456816673279, 0.18137256801128387],
                        [0.8810575604438782, 0.18135413527488708],
                        [0.8810691833496094, 0.19234342873096466],
                        [0.8518571853637695, 0.19236180186271667],
                    ],
                    [
                        [0.11745329946279526, 0.19864723086357117],
                        [0.44764843583106995, 0.19843991100788116],
                        [0.4476621150970459, 0.21305808424949646],
                        [0.11746560037136078, 0.2132645696401596],
                    ],
                    [
                        [0.8518791198730469, 0.2161664217710495],
                        [0.8812214136123657, 0.21614809334278107],
                        [0.8812331557273865, 0.22728395462036133],
                        [0.8518908619880676, 0.22730222344398499],
                    ],
                    [
                        [0.14674463868141174, 0.2160511016845703],
                        [0.5234389901161194, 0.2158157229423523],
                        [0.5234528183937073, 0.23027199506759644],
                        [0.14675691723823547, 0.23050643503665924],
                    ],
                    [
                        [0.14667358994483948, 0.23355625569820404],
                        [0.5334368348121643, 0.23331575095653534],
                        [0.5334509611129761, 0.24798540771007538],
                        [0.14668604731559753, 0.24822492897510529],
                    ],
                    [
                        [0.8525967597961426, 0.23367106914520264],
                        [0.8804939985275269, 0.233653724193573],
                        [0.8805059194564819, 0.24491049349308014],
                        [0.8526086211204529, 0.2449277937412262],
                    ],
                    [
                        [0.14656469225883484, 0.25078919529914856],
                        [0.5175725221633911, 0.25055959820747375],
                        [0.5175865888595581, 0.26523590087890625],
                        [0.14657717943191528, 0.26546454429626465],
                    ],
                    [
                        [0.8525059819221497, 0.25098955631256104],
                        [0.8805307745933533, 0.2509722113609314],
                        [0.8805425763130188, 0.262106329202652],
                        [0.8525176644325256, 0.26212361454963684],
                    ],
                    [
                        [0.1465667337179184, 0.26825809478759766],
                        [0.5860466957092285, 0.267987459897995],
                        [0.5860609412193298, 0.2826114892959595],
                        [0.14657916128635406, 0.2828810214996338],
                    ],
                    [
                        [0.8525023460388184, 0.2685503363609314],
                        [0.8808264136314392, 0.2685329020023346],
                        [0.8808382153511047, 0.2796822190284729],
                        [0.8525140881538391, 0.2796995937824249],
                    ],
                    [
                        [0.11767520755529404, 0.2855840027332306],
                        [0.20736901462078094, 0.2855290472507477],
                        [0.20738106966018677, 0.29942959547042847],
                        [0.11768690496683121, 0.29948434233665466],
                    ],
                    [
                        [0.8524970412254333, 0.3034100830554962],
                        [0.8805370926856995, 0.3033929765224457],
                        [0.8805489540100098, 0.3145534098148346],
                        [0.8525087833404541, 0.31457042694091797],
                    ],
                    [
                        [0.1467820405960083, 0.3031892478466034],
                        [0.5474209189414978, 0.30294492840766907],
                        [0.54743492603302, 0.317476749420166],
                        [0.1467943787574768, 0.3177200257778168],
                    ],
                    [
                        [0.14677837491035461, 0.32077938318252563],
                        [0.43482279777526855, 0.3206046223640442],
                        [0.4348357915878296, 0.3345699906349182],
                        [0.14679023623466492, 0.33474403619766235],
                    ],
                    [
                        [0.8524031639099121, 0.32070884108543396],
                        [0.8809584975242615, 0.3206915259361267],
                        [0.8809704184532166, 0.3319506347179413],
                        [0.8524149656295776, 0.33196792006492615],
                    ],
                    [
                        [0.14664027094841003, 0.3376639485359192],
                        [0.569241464138031, 0.33740881085395813],
                        [0.5692553520202637, 0.3517625331878662],
                        [0.1466524749994278, 0.3520166575908661],
                    ],
                    [
                        [0.8525678515434265, 0.3381349742412567],
                        [0.8813103437423706, 0.3381176292896271],
                        [0.8813222646713257, 0.3493506908416748],
                        [0.852579653263092, 0.34936800599098206],
                    ],
                    [
                        [0.11758346110582352, 0.35568782687187195],
                        [0.38553696870803833, 0.355526864528656],
                        [0.38555026054382324, 0.37002304196357727],
                        [0.11759565770626068, 0.3701833188533783],
                    ],
                    [
                        [0.8523253202438354, 0.39042577147483826],
                        [0.8792730569839478, 0.3904097378253937],
                        [0.8792849779129028, 0.40170761942863464],
                        [0.8523372411727905, 0.40172356367111206],
                    ],
                    [
                        [0.14687258005142212, 0.3729424476623535],
                        [0.48022565245628357, 0.3727432191371918],
                        [0.48023873567581177, 0.386606901884079],
                        [0.14688436686992645, 0.38680532574653625],
                    ],
                    [
                        [0.14659781754016876, 0.39022380113601685],
                        [0.6842235326766968, 0.38990408182144165],
                        [0.6842381358146667, 0.4044632315635681],
                        [0.14661018550395966, 0.4047815799713135],
                    ],
                ],
            ],
            [
                '10',
                [
                    [
                        [0.11689354479312897, 0.062289752066135406],
                        [0.24141663312911987, 0.06216103583574295],
                        [0.24142760038375854, 0.0721464604139328],
                        [0.1169041246175766, 0.07227490097284317],
                    ],
                    [
                        [0.37622013688087463, 0.11501159518957138],
                        [0.622463047504425, 0.11475995182991028],
                        [0.6224794983863831, 0.12826885282993317],
                        [0.3762355446815491, 0.12851975858211517],
                    ],
                    [
                        [0.11757611483335495, 0.15076802670955658],
                        [0.13149796426296234, 0.1507539004087448],
                        [0.13151147961616516, 0.16345128417015076],
                        [0.1175895631313324, 0.16346536576747894],
                    ],
                    [
                        [0.17622719705104828, 0.1506178081035614],
                        [0.4940733313560486, 0.15029548108577728],
                        [0.4940887987613678, 0.16342894732952118],
                        [0.17624135315418243, 0.16375033557415009],
                    ],
                    [
                        [0.8730339407920837, 0.22053980827331543],
                        [0.878974974155426, 0.22053387761116028],
                        [0.878989040851593, 0.2313620150089264],
                        [0.8730480074882507, 0.23136793076992035],
                    ],
                    [
                        [0.11673710495233536, 0.17770570516586304],
                        [0.5873152613639832, 0.1772313117980957],
                        [0.5873328447341919, 0.19184863567352295],
                        [0.11675258725881577, 0.19232149422168732],
                    ],
                    [
                        [0.11806927621364594, 0.2026757299900055],
                        [0.37411949038505554, 0.20241901278495789],
                        [0.37413614988327026, 0.21704284846782684],
                        [0.11808476597070694, 0.2172987312078476],
                    ],
                    [
                        [0.14674749970436096, 0.22044774889945984],
                        [0.33077603578567505, 0.2202639877796173],
                        [0.3307912051677704, 0.23372715711593628],
                        [0.14676187932491302, 0.23391038179397583],
                    ],
                    [
                        [0.14665380120277405, 0.23738612234592438],
                        [0.3372974097728729, 0.23719646036624908],
                        [0.33731311559677124, 0.25112295150756836],
                        [0.1466686725616455, 0.2513120472431183],
                    ],
                    [
                        [0.8715798258781433, 0.27253520488739014],
                        [0.8809414505958557, 0.27252596616744995],
                        [0.8809553980827332, 0.2833009362220764],
                        [0.8715937733650208, 0.2833101451396942],
                    ],
                    [
                        [0.11718866229057312, 0.25514960289001465],
                        [0.39616334438323975, 0.2548731565475464],
                        [0.39618003368377686, 0.2694336473941803],
                        [0.11720408499240875, 0.26970919966697693],
                    ],
                    [
                        [0.1468757838010788, 0.272138386964798],
                        [0.4600287079811096, 0.2718292772769928],
                        [0.4600459039211273, 0.2865701913833618],
                        [0.1468915343284607, 0.2868782877922058],
                    ],
                    [
                        [0.14663295447826385, 0.2898784875869751],
                        [0.48948442935943604, 0.2895413637161255],
                        [0.48950138688087463, 0.3039766252040863],
                        [0.1466483771800995, 0.30431264638900757],
                    ],
                    [
                        [0.8719685077667236, 0.2901303768157959],
                        [0.8805086016654968, 0.29012197256088257],
                        [0.8805227279663086, 0.30102962255477905],
                        [0.8719826340675354, 0.30103799700737],
                    ],
                    [
                        [0.14652076363563538, 0.3072446584701538],
                        [0.4706719219684601, 0.3069272041320801],
                        [0.47068890929222107, 0.3214561939239502],
                        [0.14653627574443817, 0.32177263498306274],
                    ],
                    [
                        [0.8711714148521423, 0.3250936269760132],
                        [0.8811930418014526, 0.32508385181427],
                        [0.8812068104743958, 0.33570173382759094],
                        [0.8711851239204407, 0.3357114791870117],
                    ],
                    [
                        [0.14655940234661102, 0.32490989565849304],
                        [0.4453417658805847, 0.3246184289455414],
                        [0.4453582763671875, 0.33883732557296753],
                        [0.14657460153102875, 0.3391278386116028],
                    ],
                    [
                        [0.11729642003774643, 0.3420436978340149],
                        [0.5766127705574036, 0.34159737825393677],
                        [0.5766306519508362, 0.3564941883087158],
                        [0.11731220036745071, 0.3569389879703522],
                    ],
                    [
                        [0.8717983365058899, 0.37720492482185364],
                        [0.8806803226470947, 0.37719637155532837],
                        [0.8806943297386169, 0.38797321915626526],
                        [0.8718122839927673, 0.38798174262046814],
                    ],
                    [
                        [0.14687617123126984, 0.35983574390411377],
                        [0.601467490196228, 0.359395831823349],
                        [0.6014848947525024, 0.3737744688987732],
                        [0.1468915343284607, 0.37421295046806335],
                    ],
                    [
                        [0.14663058519363403, 0.37697914242744446],
                        [0.4334826171398163, 0.3767026364803314],
                        [0.43349939584732056, 0.39118099212646484],
                        [0.14664605259895325, 0.39145657420158386],
                    ],
                    [
                        [0.14653143286705017, 0.3944009840488434],
                        [0.4761558175086975, 0.39408454298973083],
                        [0.4761728346347809, 0.4086170494556427],
                        [0.14654695987701416, 0.4089324474334717],
                    ],
                    [
                        [0.8718245029449463, 0.3947424590587616],
                        [0.8807581663131714, 0.39473387598991394],
                        [0.8807724118232727, 0.4057426452636719],
                        [0.8718387484550476, 0.40575119853019714],
                    ],
                    [
                        [0.14658869802951813, 0.41169750690460205],
                        [0.49360349774360657, 0.41136568784713745],
                        [0.4936206340789795, 0.4259384274482727],
                        [0.1466042697429657, 0.4262691140174866],
                    ],
                    [
                        [0.8615584969520569, 0.44682225584983826],
                        [0.8804925084114075, 0.4468042850494385],
                        [0.8805068731307983, 0.45785239338874817],
                        [0.8615727424621582, 0.4578703045845032],
                    ],
                    [
                        [0.14659300446510315, 0.4293833374977112],
                        [0.45420902967453003, 0.42909038066864014],
                        [0.45422595739364624, 0.44361796975135803],
                        [0.14660851657390594, 0.4439099431037903],
                    ],
                    [
                        [0.14613811671733856, 0.4466625452041626],
                        [0.43231359124183655, 0.44639110565185547],
                        [0.43233048915863037, 0.460991233587265],
                        [0.14615370333194733, 0.46126171946525574],
                    ],
                    [
                        [0.11684000492095947, 0.46399423480033875],
                        [0.2650009095668793, 0.46385428309440613],
                        [0.2650136351585388, 0.4753892421722412],
                        [0.11685222387313843, 0.4755288362503052],
                    ],
                    [
                        [0.8615866303443909, 0.5166171193122864],
                        [0.8811693787574768, 0.5165988802909851],
                        [0.8811836838722229, 0.5276047587394714],
                        [0.8616008162498474, 0.5276229381561279],
                    ],
                    [
                        [0.14678508043289185, 0.48141056299209595],
                        [0.3787200450897217, 0.48119238018989563],
                        [0.3787364363670349, 0.49556583166122437],
                        [0.1468004435300827, 0.495783269405365],
                    ],
                    [
                        [0.14659492671489716, 0.4990197420120239],
                        [0.5058046579360962, 0.49868321418762207],
                        [0.5058218240737915, 0.513210654258728],
                        [0.14661045372486115, 0.5135460495948792],
                    ],
                    [
                        [0.14660035073757172, 0.5162678360939026],
                        [0.3604547083377838, 0.5160682797431946],
                        [0.3604709506034851, 0.5303757190704346],
                        [0.1466156244277954, 0.53057461977005],
                    ],
                    [
                        [0.14636383950710297, 0.5338619947433472],
                        [0.49065807461738586, 0.5335420370101929],
                        [0.4906749427318573, 0.5478922724723816],
                        [0.14637917280197144, 0.5482110977172852],
                    ],
                    [
                        [0.861675500869751, 0.5689865946769714],
                        [0.8806532025337219, 0.5689691305160522],
                        [0.8806672692298889, 0.5798483490943909],
                        [0.861689567565918, 0.5798658132553101],
                    ],
                    [
                        [0.11697258800268173, 0.5511983633041382],
                        [0.4368615448474884, 0.5509023666381836],
                        [0.4368784427642822, 0.5655087828636169],
                        [0.11698805540800095, 0.5658037066459656],
                    ],
                ],
            ],
            [
                '26',
                [
                    [
                        [0.11734485626220703, 0.33115875720977783],
                        [0.865574061870575, 0.3306603729724884],
                        [0.8655931949615479, 0.3453930616378784],
                        [0.11736052483320236, 0.34589022397994995],
                    ],
                    [
                        [0.11737697571516037, 0.3485972285270691],
                        [0.6260614991188049, 0.3482593595981598],
                        [0.6260799765586853, 0.36336806416511536],
                        [0.11739304661750793, 0.3637050688266754],
                    ],
                    [
                        [0.11709917336702347, 0.3812444806098938],
                        [0.877817690372467, 0.38074198365211487],
                        [0.8778367638587952, 0.3954034149646759],
                        [0.11711475998163223, 0.39590469002723694],
                    ],
                    [
                        [0.11752235889434814, 0.39837631583213806],
                        [0.8092892169952393, 0.3979206681251526],
                        [0.8093090653419495, 0.41339388489723206],
                        [0.11753880977630615, 0.4138483703136444],
                    ],
                    [
                        [0.11704427003860474, 0.41600102186203003],
                        [0.8163430094718933, 0.41554176807403564],
                        [0.8163620233535767, 0.43033578991889954],
                        [0.11705999821424484, 0.4307939112186432],
                    ],
                    [
                        [0.11728540062904358, 0.4333747923374176],
                        [0.8096873760223389, 0.4329213798046112],
                        [0.8097067475318909, 0.4480544626712799],
                        [0.11730149388313293, 0.44850674271583557],
                    ],
                    [
                        [0.11737892776727676, 0.4509001672267914],
                        [0.8162801265716553, 0.4504438638687134],
                        [0.8162990212440491, 0.46515968441963196],
                        [0.1173945739865303, 0.46561485528945923],
                    ],
                    [
                        [0.11766616255044937, 0.4683420956134796],
                        [0.8591389060020447, 0.4678593873977661],
                        [0.8591578006744385, 0.4824354946613312],
                        [0.11768165975809097, 0.48291701078414917],
                    ],
                    [
                        [0.11704251170158386, 0.5335434675216675],
                        [0.8687558174133301, 0.5330594778060913],
                        [0.8687751889228821, 0.5479479432106018],
                        [0.11705833673477173, 0.5484306812286377],
                    ],
                ],
            ],
            [
                '1713',
                [
                    [
                        [0.17614291608333588, 0.4259873926639557],
                        [0.5613231062889099, 0.42601919174194336],
                        [0.5613275170326233, 0.440528929233551],
                        [0.17614540457725525, 0.44049662351608276],
                    ],
                    [
                        [0.14685797691345215, 0.4580965042114258],
                        [0.3614863157272339, 0.4581148326396942],
                        [0.36148980259895325, 0.4729347825050354],
                        [0.14686037600040436, 0.4729161262512207],
                    ],
                    [
                        [0.14629516005516052, 0.4910215139389038],
                        [0.8191391825675964, 0.4910810887813568],
                        [0.8191449046134949, 0.5056259036064148],
                        [0.14629749953746796, 0.5055654048919678],
                    ],
                    [
                        [0.1463569551706314, 0.5083671808242798],
                        [0.8789124488830566, 0.5084331631660461],
                        [0.8789185881614685, 0.5233210325241089],
                        [0.14635935425758362, 0.5232539772987366],
                    ],
                    [
                        [0.14631721377372742, 0.5259419679641724],
                        [0.8734642863273621, 0.526008665561676],
                        [0.8734702467918396, 0.5404433012008667],
                        [0.14631952345371246, 0.5403756499290466],
                    ],
                    [
                        [0.14700238406658173, 0.5432683825492859],
                        [0.8000093698501587, 0.5433293581008911],
                        [0.8000150322914124, 0.5579648017883301],
                        [0.14700475335121155, 0.5579029321670532],
                    ],
                    [
                        [0.146793395280838, 0.5608641505241394],
                        [0.6211154460906982, 0.5609092116355896],
                        [0.6211200952529907, 0.5753037929534912],
                        [0.14679571986198425, 0.5752581357955933],
                    ],
                    [
                        [0.14625397324562073, 0.5930317640304565],
                        [0.7927644848823547, 0.593095064163208],
                        [0.7927701473236084, 0.607833981513977],
                        [0.14625634253025055, 0.607769787311554],
                    ],
                    [
                        [0.14671194553375244, 0.6108025312423706],
                        [0.8611178398132324, 0.6108736395835876],
                        [0.8611236810684204, 0.6251652836799622],
                        [0.1467142403125763, 0.6250932812690735],
                    ],
                    [
                        [0.14662595093250275, 0.6284184455871582],
                        [0.28874292969703674, 0.6284328103065491],
                        [0.2887459099292755, 0.6426334381103516],
                        [0.1466282308101654, 0.6426188945770264],
                    ],
                    [
                        [0.14633817970752716, 0.6605145335197449],
                        [0.8004212975502014, 0.6605826020240784],
                        [0.8004269599914551, 0.675152599811554],
                        [0.1463405191898346, 0.6750836968421936],
                    ],
                    [
                        [0.14660757780075073, 0.6781390905380249],
                        [0.8610466718673706, 0.6782146096229553],
                        [0.8610526323318481, 0.6928107738494873],
                        [0.14660991728305817, 0.6927343010902405],
                    ],
                ],
            ],
            [
                '1732',
                [
                    [
                        [0.17613857984542847, 0.4410479664802551],
                        [0.6834125518798828, 0.44077208638191223],
                        [0.683427095413208, 0.4554961621761322],
                        [0.17615137994289398, 0.4557706117630005],
                    ],
                    [
                        [0.14667533338069916, 0.47356852889060974],
                        [0.6182416677474976, 0.47331503033638],
                        [0.6182562112808228, 0.4882301688194275],
                        [0.14668819308280945, 0.4884822964668274],
                    ],
                    [
                        [0.17599236965179443, 0.5062716007232666],
                        [0.41164639592170715, 0.5061464309692383],
                        [0.4116596281528473, 0.5204719305038452],
                        [0.1760048270225525, 0.5205965042114258],
                    ],
                    [
                        [0.17593225836753845, 0.5388897657394409],
                        [0.8598542213439941, 0.5385307669639587],
                        [0.8598695397377014, 0.5534154176712036],
                        [0.1759451925754547, 0.5537724494934082],
                    ],
                    [
                        [0.17634496092796326, 0.5564314723014832],
                        [0.8167891502380371, 0.5560974478721619],
                        [0.8168043494224548, 0.5709797143936157],
                        [0.1763579100370407, 0.571311891078949],
                    ],
                    [
                        [0.17627449333667755, 0.5739192366600037],
                        [0.8478133678436279, 0.5735713243484497],
                        [0.8478283286094666, 0.5881320834159851],
                        [0.17628715932369232, 0.588478147983551],
                    ],
                    [
                        [0.17626550793647766, 0.5910768508911133],
                        [0.8723661303520203, 0.5907185077667236],
                        [0.8723811507225037, 0.6052497625350952],
                        [0.17627812922000885, 0.6056061387062073],
                    ],
                    [
                        [0.17596301436424255, 0.6085198521614075],
                        [0.8772044777870178, 0.608161211013794],
                        [0.877219557762146, 0.6227483749389648],
                        [0.17597569525241852, 0.6231050491333008],
                    ],
                    [
                        [0.17614229023456573, 0.626097559928894],
                        [0.2712581753730774, 0.6260492205619812],
                        [0.2712705731391907, 0.6399444937705994],
                        [0.17615437507629395, 0.6399925351142883],
                    ],
                    [
                        [0.6877334117889404, 0.659151554107666],
                        [0.747708797454834, 0.6591214537620544],
                        [0.7477202415466309, 0.670540988445282],
                        [0.687744677066803, 0.670570969581604],
                    ],
                    [
                        [0.7995820641517639, 0.6592070460319519],
                        [0.8521770238876343, 0.6591806411743164],
                        [0.8521888256072998, 0.6706171035766602],
                        [0.7995937466621399, 0.6706433296203613],
                    ],
                    [
                        [0.3691236078739166, 0.6675684452056885],
                        [0.4795219898223877, 0.6675132513046265],
                        [0.47953563928604126, 0.6820023059844971],
                        [0.36913684010505676, 0.6820572018623352],
                    ],
                    [
                        [0.7954121828079224, 0.6764300465583801],
                        [0.8559463024139404, 0.6763998866081238],
                        [0.8559579849243164, 0.6877787113189697],
                        [0.7954237461090088, 0.6878086924552917],
                    ],
                    [
                        [0.19416815042495728, 0.6946686506271362],
                        [0.33801448345184326, 0.6945974826812744],
                        [0.3380275070667267, 0.7089471817016602],
                        [0.1941806823015213, 0.7090179324150085],
                    ],
                    [
                        [0.19415515661239624, 0.7144891619682312],
                        [0.4719998240470886, 0.7143527269363403],
                        [0.4720131456851959, 0.7285141944885254],
                        [0.19416752457618713, 0.7286497950553894],
                    ],
                    [
                        [0.19442078471183777, 0.7331846952438354],
                        [0.40739136934280396, 0.7330809235572815],
                        [0.4074019491672516, 0.7445315718650818],
                        [0.19443079829216003, 0.7446349263191223],
                    ],
                    [
                        [0.19413594901561737, 0.75211501121521],
                        [0.6120553612709045, 0.7519128918647766],
                        [0.6120695471763611, 0.766465425491333],
                        [0.19414865970611572, 0.7666663527488708],
                    ],
                    [
                        [0.19472083449363708, 0.7735947370529175],
                        [0.23053482174873352, 0.7735775709152222],
                        [0.23054520785808563, 0.7853540182113647],
                        [0.19473111629486084, 0.7853710651397705],
                    ],
                    [
                        [0.19416216015815735, 0.7953550815582275],
                        [0.5631240010261536, 0.7951796650886536],
                        [0.5631377696990967, 0.8095226287841797],
                        [0.19417467713356018, 0.8096969723701477],
                    ],
                    [
                        [0.19434139132499695, 0.8168684244155884],
                        [0.6093217134475708, 0.8166729211807251],
                        [0.6093359589576721, 0.8313329219818115],
                        [0.19435419142246246, 0.8315272331237793],
                    ],
                    [
                        [0.19387704133987427, 0.8381853699684143],
                        [0.40408986806869507, 0.8380871415138245],
                        [0.4041033983230591, 0.8527479767799377],
                        [0.19388985633850098, 0.8528455495834351],
                    ],
                    [
                        [0.1944412738084793, 0.8600282073020935],
                        [0.4060419201850891, 0.8599302768707275],
                        [0.4060523211956024, 0.8711929321289062],
                        [0.19445110857486725, 0.871290385723114],
                    ],
                ],
            ],
            [
                '70',
                [
                    [
                        [0.1166621744632721, 0.06216756999492645],
                        [0.44750916957855225, 0.06222279742360115],
                        [0.44750621914863586, 0.07457713782787323],
                        [0.1166580319404602, 0.07452142238616943],
                    ],
                    [
                        [0.11704174429178238, 0.07696538418531418],
                        [0.12927567958831787, 0.07696744799613953],
                        [0.1292724460363388, 0.08670172840356827],
                        [0.11703848093748093, 0.08669964969158173],
                    ],
                    [
                        [0.14599858224391937, 0.07673586905002594],
                        [0.40488654375076294, 0.07677953690290451],
                        [0.4048834443092346, 0.08916060626506805],
                        [0.14599454402923584, 0.08911654353141785],
                    ],
                    [
                        [0.2354147583246231, 0.108426533639431],
                        [0.5560155510902405, 0.10848184674978256],
                        [0.5560125708580017, 0.1227501705288887],
                        [0.23541046679019928, 0.12269430607557297],
                    ],
                    [
                        [0.23490425944328308, 0.1408700942993164],
                        [0.8280840516090393, 0.140974760055542],
                        [0.8280822038650513, 0.1556241661310196],
                        [0.2348998486995697, 0.15551845729351044],
                    ],
                    [
                        [0.2346666157245636, 0.15842600166797638],
                        [0.8245222568511963, 0.1585313230752945],
                        [0.8245203495025635, 0.1733168661594391],
                        [0.23466217517852783, 0.1732104867696762],
                    ],
                    [
                        [0.23489020764827728, 0.17545509338378906],
                        [0.8688945770263672, 0.17556960880756378],
                        [0.8688928484916687, 0.19049979746341705],
                        [0.23488572239875793, 0.1903841346502304],
                    ],
                    [
                        [0.2346792072057724, 0.1931835114955902],
                        [0.7696226835250854, 0.19328127801418304],
                        [0.7696205377578735, 0.20808619260787964],
                        [0.23467475175857544, 0.2079874575138092],
                    ],
                    [
                        [0.2056792825460434, 0.22583355009555817],
                        [0.3127628266811371, 0.2258535474538803],
                        [0.31275877356529236, 0.24042442440986633],
                        [0.20567476749420166, 0.24040423333644867],
                    ],
                    [
                        [0.20451709628105164, 0.25848817825317383],
                        [0.8271370530128479, 0.258606880903244],
                        [0.8271352052688599, 0.2731499969959259],
                        [0.2045125812292099, 0.273030161857605],
                    ],
                    [
                        [0.20544777810573578, 0.27577337622642517],
                        [0.8042152523994446, 0.2758888006210327],
                        [0.804213285446167, 0.2906011641025543],
                        [0.20544321835041046, 0.2904846966266632],
                    ],
                    [
                        [0.20513497292995453, 0.29313433170318604],
                        [0.8045334815979004, 0.2932511270046234],
                        [0.804531455039978, 0.3081892728805542],
                        [0.20513035356998444, 0.3080713748931885],
                    ],
                    [
                        [0.20575618743896484, 0.3107760548591614],
                        [0.39107367396354675, 0.3108125627040863],
                        [0.3910699188709259, 0.3255120515823364],
                        [0.20575162768363953, 0.32547521591186523],
                    ],
                    [
                        [0.175859272480011, 0.34323155879974365],
                        [0.4110798239707947, 0.34327882528305054],
                        [0.41107621788978577, 0.3576816916465759],
                        [0.17585469782352448, 0.357634037733078],
                    ],
                    [
                        [0.20586751401424408, 0.3758449852466583],
                        [0.31285831332206726, 0.3758668899536133],
                        [0.31285426020622253, 0.39044347405433655],
                        [0.20586301386356354, 0.3904213607311249],
                    ],
                    [
                        [0.20485100150108337, 0.40834009647369385],
                        [0.8659879565238953, 0.40847814083099365],
                        [0.8659862279891968, 0.42336514592170715],
                        [0.20484638214111328, 0.42322593927383423],
                    ],
                    [
                        [0.20546795427799225, 0.4259148836135864],
                        [0.34406647086143494, 0.42594411969184875],
                        [0.3440634310245514, 0.4373007118701935],
                        [0.2054644376039505, 0.4372712969779968],
                    ],
                    [
                        [0.23554939031600952, 0.45827826857566833],
                        [0.6285750865936279, 0.4583626985549927],
                        [0.6285723447799683, 0.47301986813545227],
                        [0.23554499447345734, 0.4729347229003906],
                    ],
                    [
                        [0.2347133457660675, 0.4910324513912201],
                        [0.8072090148925781, 0.4911577105522156],
                        [0.8072070479393005, 0.5057828426361084],
                        [0.23470894992351532, 0.5056565999984741],
                    ],
                    [
                        [0.23463279008865356, 0.5084773898124695],
                        [0.4319841265678406, 0.5085210204124451],
                        [0.43198055028915405, 0.523215115070343],
                        [0.23462837934494019, 0.5231711268424988],
                    ],
                ],
            ],
            [
                '1178',
                [
                    [
                        [0.20545998215675354, 0.726589024066925],
                        [0.8786039352416992, 0.7263291478157043],
                        [0.8786208629608154, 0.7410869002342224],
                        [0.205473393201828, 0.7413449287414551],
                    ],
                    [
                        [0.20536699891090393, 0.7439895272254944],
                        [0.878389298915863, 0.7437318563461304],
                        [0.8784059286117554, 0.7582589983940125],
                        [0.20538020133972168, 0.7585148811340332],
                    ],
                    [
                        [0.20552270114421844, 0.7614862322807312],
                        [0.8466783761978149, 0.7612427473068237],
                        [0.8466947674751282, 0.7757171988487244],
                        [0.20553584396839142, 0.7759589552879333],
                    ],
                    [
                        [0.20517730712890625, 0.7940564751625061],
                        [0.8455637097358704, 0.7938171029090881],
                        [0.8455803990364075, 0.8084973096847534],
                        [0.20519065856933594, 0.8087350130081177],
                    ],
                    [
                        [0.20576606690883636, 0.8114351630210876],
                        [0.8752137422561646, 0.8111870288848877],
                        [0.8752305507659912, 0.8258705139160156],
                        [0.20577941834926605, 0.8261168599128723],
                    ],
                    [
                        [0.20566517114639282, 0.8288369178771973],
                        [0.39674362540245056, 0.8287667036056519],
                        [0.3967577815055847, 0.8432570099830627],
                        [0.20567834377288818, 0.84332674741745],
                    ],
                    [
                        [0.11710670590400696, 0.9279251098632812],
                        [0.23237332701683044, 0.9278848171234131],
                        [0.2323821634054184, 0.9375106692314148],
                        [0.11711516231298447, 0.9375507235527039],
                    ],
                    [
                        [0.8508904576301575, 0.9280351996421814],
                        [0.881729245185852, 0.928024411201477],
                        [0.8817402720451355, 0.9376605749130249],
                        [0.8509013652801514, 0.9376713037490845],
                    ],
                ],
            ],
            [
                '1732',
                [
                    [
                        [0.11655603349208832, 0.062356285750865936],
                        [0.45312854647636414, 0.062148597091436386],
                        [0.45314016938209534, 0.07457584142684937],
                        [0.11656666547060013, 0.07478272169828415],
                    ],
                    [
                        [0.11720003932714462, 0.07692643254995346],
                        [0.509071946144104, 0.07668572664260864],
                        [0.5090836882591248, 0.08909323066473007],
                        [0.11721065640449524, 0.08933299779891968],
                    ],
                    [
                        [0.23496903479099274, 0.10862922668457031],
                        [0.8643276691436768, 0.10824651271104813],
                        [0.8643397092819214, 0.11991449445486069],
                        [0.23497934639453888, 0.12029579281806946],
                    ],
                    [
                        [0.2348826825618744, 0.1261356621980667],
                        [0.42492949962615967, 0.12602074444293976],
                        [0.4249427020549774, 0.14024312794208527],
                        [0.2348952442407608, 0.14035752415657043],
                    ],
                    [
                        [0.23583689332008362, 0.1585351675748825],
                        [0.4759142994880676, 0.15839149057865143],
                        [0.47592777013778687, 0.17270709574222565],
                        [0.235849529504776, 0.172850102186203],
                    ],
                    [
                        [0.2346322238445282, 0.19120554625988007],
                        [0.7975630164146423, 0.1908722221851349],
                        [0.797577977180481, 0.20555411279201508],
                        [0.23464520275592804, 0.2058858424425125],
                    ],
                    [
                        [0.23511946201324463, 0.2084461748600006],
                        [0.6050705313682556, 0.20822834968566895],
                        [0.6050844788551331, 0.22264090180397034],
                        [0.23513220250606537, 0.22285769879817963],
                    ],
                    [
                        [0.14665043354034424, 0.2408670336008072],
                        [0.7844097018241882, 0.24049551784992218],
                        [0.7844250798225403, 0.2556558847427368],
                        [0.14666350185871124, 0.2560255229473114],
                    ],
                    [
                        [0.17603732645511627, 0.273531436920166],
                        [0.2838680148124695, 0.27346929907798767],
                        [0.28387847542762756, 0.2851521968841553],
                        [0.17604747414588928, 0.2852140963077545],
                    ],
                    [
                        [0.17643478512763977, 0.30625787377357483],
                        [0.8520171046257019, 0.3058728575706482],
                        [0.852032482624054, 0.3208014965057373],
                        [0.1764477640390396, 0.32118457555770874],
                    ],
                    [
                        [0.176321342587471, 0.3237878680229187],
                        [0.876661479473114, 0.3233911395072937],
                        [0.876676619052887, 0.3380444347858429],
                        [0.17633408308029175, 0.3384391963481903],
                    ],
                    [
                        [0.17601342499256134, 0.3409520089626312],
                        [0.8445735573768616, 0.3405754864215851],
                        [0.8445889949798584, 0.3555948734283447],
                        [0.17602647840976715, 0.35596945881843567],
                    ],
                    [
                        [0.17593726515769958, 0.35862496495246887],
                        [0.29992586374282837, 0.35855555534362793],
                        [0.2999390661716461, 0.3732396364212036],
                        [0.17595002055168152, 0.3733086884021759],
                    ],
                    [
                        [0.17602378129959106, 0.39107760787010193],
                        [0.41712093353271484, 0.39094415307044983],
                        [0.41713425517082214, 0.40532639622688293],
                        [0.1760362833738327, 0.4054591655731201],
                    ],
                    [
                        [0.17565254867076874, 0.42379000782966614],
                        [0.8664887547492981, 0.4234119951725006],
                        [0.8665037155151367, 0.43793240189552307],
                        [0.17566516995429993, 0.4383084774017334],
                    ],
                    [
                        [0.17613857984542847, 0.4410479664802551],
                        [0.6834125518798828, 0.44077208638191223],
                        [0.683427095413208, 0.4554961621761322],
                        [0.17615137994289398, 0.4557706117630005],
                    ],
                    [
                        [0.14667533338069916, 0.47356852889060974],
                        [0.6182416677474976, 0.47331503033638],
                        [0.6182562112808228, 0.4882301688194275],
                        [0.14668819308280945, 0.4884822964668274],
                    ],
                ],
            ],
            [
                '54',
                [
                    [
                        [0.11661756038665771, 0.06223762035369873],
                        [0.4476962983608246, 0.06207684800028801],
                        [0.4477027356624603, 0.07446340471506119],
                        [0.11662278324365616, 0.07462374866008759],
                    ],
                    [
                        [0.11706177145242691, 0.07686950266361237],
                        [0.4049835801124573, 0.07673013210296631],
                        [0.4049898386001587, 0.08907172828912735],
                        [0.11706697940826416, 0.08921073377132416],
                    ],
                    [
                        [0.20579837262630463, 0.10834978520870209],
                        [0.31278568506240845, 0.10829834640026093],
                        [0.31279271841049194, 0.1229657456278801],
                        [0.2058049440383911, 0.12301701307296753],
                    ],
                    [
                        [0.23536208271980286, 0.14035631716251373],
                        [0.4852575361728668, 0.14023703336715698],
                        [0.4852656126022339, 0.15544044971466064],
                        [0.2353690266609192, 0.15555934607982635],
                    ],
                    [
                        [0.23452022671699524, 0.17378713190555573],
                        [0.8822677731513977, 0.17348016798496246],
                        [0.8822773694992065, 0.18820925056934357],
                        [0.23452694714069366, 0.18851520121097565],
                    ],
                    [
                        [0.23453707993030548, 0.19095779955387115],
                        [0.8491567373275757, 0.19066764414310455],
                        [0.8491662740707397, 0.2055259495973587],
                        [0.23454385995864868, 0.2058151513338089],
                    ],
                    [
                        [0.23483535647392273, 0.208716481924057],
                        [0.3062443137168884, 0.20868290960788727],
                        [0.3062511384487152, 0.22297503054141998],
                        [0.23484188318252563, 0.22300849854946136],
                    ],
                    [
                        [0.2347731590270996, 0.24087083339691162],
                        [0.8809465765953064, 0.24056917428970337],
                        [0.8809562921524048, 0.2555846571922302],
                        [0.23478001356124878, 0.2558853030204773],
                    ],
                    [
                        [0.2346130907535553, 0.2585408687591553],
                        [0.46832582354545593, 0.25843217968940735],
                        [0.4683334529399872, 0.27289530634880066],
                        [0.23461970686912537, 0.27300363779067993],
                    ],
                    [
                        [0.23538833856582642, 0.2907632291316986],
                        [0.46069857478141785, 0.29065921902656555],
                        [0.4607064127922058, 0.3055696189403534],
                        [0.2353951632976532, 0.3056732714176178],
                    ],
                    [
                        [0.234325110912323, 0.32374870777130127],
                        [0.44429194927215576, 0.3236525058746338],
                        [0.4442993998527527, 0.3380223512649536],
                        [0.2343316674232483, 0.33811822533607483],
                    ],
                    [
                        [0.2938196063041687, 0.34204643964767456],
                        [0.8176720142364502, 0.34180745482444763],
                        [0.8176815509796143, 0.3569631576538086],
                        [0.2938268184661865, 0.35720133781433105],
                    ],
                    [
                        [0.29310283064842224, 0.35993748903274536],
                        [0.40467607975006104, 0.3598867952823639],
                        [0.4046831727027893, 0.37388041615486145],
                        [0.2931094765663147, 0.3739309310913086],
                    ],
                    [
                        [0.2936764061450958, 0.3777977526187897],
                        [0.8723989725112915, 0.3775359094142914],
                        [0.8724086880683899, 0.3925478756427765],
                        [0.2936835289001465, 0.39280882477760315],
                    ],
                    [
                        [0.29378458857536316, 0.39536944031715393],
                        [0.7996217012405396, 0.39514151215553284],
                        [0.7996311783790588, 0.41031017899513245],
                        [0.293791800737381, 0.4105373024940491],
                    ],
                    [
                        [0.29342228174209595, 0.41278329491615295],
                        [0.8606525659561157, 0.41252875328063965],
                        [0.860662043094635, 0.4272914230823517],
                        [0.29342928528785706, 0.42754510045051575],
                    ],
                    [
                        [0.2351452261209488, 0.44552454352378845],
                        [0.46917423605918884, 0.4454203248023987],
                        [0.4691818654537201, 0.45990949869155884],
                        [0.23515184223651886, 0.46001335978507996],
                    ],
                    [
                        [0.23424240946769714, 0.477711945772171],
                        [0.7389451861381531, 0.4774889051914215],
                        [0.7389543056488037, 0.4925124943256378],
                        [0.2342492789030075, 0.49273476004600525],
                    ],
                    [
                        [0.20555037260055542, 0.5105674266815186],
                        [0.820626437664032, 0.5102977156639099],
                        [0.8206359148025513, 0.5253558158874512],
                        [0.20555712282657623, 0.5256245732307434],
                    ],
                ],
            ],
            [
                '1727',
                [
                    [
                        [0.17569367587566376, 0.4563675820827484],
                        [0.8557551503181458, 0.45624375343322754],
                        [0.8557605743408203, 0.47064724564552307],
                        [0.1756962686777115, 0.470769464969635],
                    ],
                    [
                        [0.17609265446662903, 0.4738246500492096],
                        [0.5397452712059021, 0.4737594723701477],
                        [0.5397493839263916, 0.4881330132484436],
                        [0.17609524726867676, 0.48819729685783386],
                    ],
                    [
                        [0.14670784771442413, 0.5094301700592041],
                        [0.15966951847076416, 0.5094279646873474],
                        [0.15967096388339996, 0.5176252722740173],
                        [0.14670924842357635, 0.517627477645874],
                    ],
                    [
                        [0.17637233436107635, 0.5060681104660034],
                        [0.8156837224960327, 0.5059569478034973],
                        [0.815689206123352, 0.5211085677146912],
                        [0.17637506127357483, 0.5212181210517883],
                    ],
                    [
                        [0.17591607570648193, 0.538762092590332],
                        [0.41191548109054565, 0.5387223362922668],
                        [0.4119190573692322, 0.5530896782875061],
                        [0.17591865360736847, 0.5531288981437683],
                    ],
                    [
                        [0.17568960785865784, 0.5711628794670105],
                        [0.8803787231445312, 0.571047842502594],
                        [0.8803843259811401, 0.5858160853385925],
                        [0.17569227516651154, 0.5859293937683105],
                    ],
                    [
                        [0.17579945921897888, 0.588541567325592],
                        [0.8531201481819153, 0.5884329676628113],
                        [0.8531257510185242, 0.6033405065536499],
                        [0.17580214142799377, 0.603447437286377],
                    ],
                    [
                        [0.17607490718364716, 0.6063317060470581],
                        [0.878955066204071, 0.6062210202217102],
                        [0.8789606094360352, 0.6207185983657837],
                        [0.17607751488685608, 0.6208275556564331],
                    ],
                    [
                        [0.17605189979076385, 0.6237135529518127],
                        [0.5627956986427307, 0.623653769493103],
                        [0.562799870967865, 0.6379021406173706],
                        [0.1760544627904892, 0.6379610300064087],
                    ],
                    [
                        [0.7108600735664368, 0.6566876173019409],
                        [0.7407137155532837, 0.6566831469535828],
                        [0.7407176494598389, 0.6681080460548401],
                        [0.7108638882637024, 0.6681124567985535],
                    ],
                    [
                        [0.5968694686889648, 0.6742503643035889],
                        [0.6322575807571411, 0.6742451786994934],
                        [0.6322611570358276, 0.685842752456665],
                        [0.5968729853630066, 0.6858478784561157],
                    ],
                    [
                        [0.7042048573493958, 0.6745863556861877],
                        [0.7467248439788818, 0.6745801568031311],
                        [0.7467287182807922, 0.6858141422271729],
                        [0.7042086124420166, 0.6858202815055847],
                    ],
                    [
                        [0.8060641884803772, 0.6742339134216309],
                        [0.8584924936294556, 0.6742262244224548],
                        [0.8584967851638794, 0.6857720017433167],
                        [0.8060683608055115, 0.6857795715332031],
                    ],
                    [
                        [0.3177836537361145, 0.6827699542045593],
                        [0.4285183548927307, 0.6827539205551147],
                        [0.4285220503807068, 0.6973330974578857],
                        [0.3177868723869324, 0.6973488330841064],
                    ],
                    [
                        [0.696992814540863, 0.6916406154632568],
                        [0.7550520300865173, 0.6916322708129883],
                        [0.7550570964813232, 0.7062463164329529],
                        [0.6969976425170898, 0.7062544822692871],
                    ],
                    [
                        [0.6953635811805725, 0.7091889977455139],
                        [0.7565313577651978, 0.7091804146766663],
                        [0.7565353512763977, 0.7206665873527527],
                        [0.6953673958778381, 0.7206751108169556],
                    ],
                    [
                        [0.19388970732688904, 0.7271457314491272],
                        [0.26967403292655945, 0.7271353006362915],
                        [0.2696770429611206, 0.7416753768920898],
                        [0.19389240443706512, 0.7416856288909912],
                    ],
                    [
                        [0.1941220909357071, 0.7471534609794617],
                        [0.48625466227531433, 0.7471142411231995],
                        [0.4862586557865143, 0.7619531750679016],
                        [0.19412484765052795, 0.7619916796684265],
                    ],
                    [
                        [0.19398626685142517, 0.765129804611206],
                        [0.3847334384918213, 0.7651047706604004],
                        [0.3847368061542511, 0.7790213823318481],
                        [0.1939888447523117, 0.7790459990501404],
                    ],
                    [
                        [0.1938849836587906, 0.7826744318008423],
                        [0.45690596103668213, 0.7826406359672546],
                        [0.45690980553627014, 0.7973780632019043],
                        [0.19388771057128906, 0.7974112629890442],
                    ],
                    [
                        [0.19404330849647522, 0.8030643463134766],
                        [0.4509177505970001, 0.8030322194099426],
                        [0.45092153549194336, 0.8175750374794006],
                        [0.1940460056066513, 0.8176065683364868],
                    ],
                    [
                        [0.19443732500076294, 0.8246414661407471],
                        [0.45687463879585266, 0.8246095776557922],
                        [0.4568784236907959, 0.8391280770301819],
                        [0.19444000720977783, 0.839159369468689],
                    ],
                    [
                        [0.19401854276657104, 0.8465321660041809],
                        [0.3575505018234253, 0.8465128540992737],
                        [0.3575538098812103, 0.8607937693595886],
                        [0.19402119517326355, 0.8608126640319824],
                    ],
                    [
                        [0.8207206130027771, 0.8468472957611084],
                        [0.8441247940063477, 0.8468445539474487],
                        [0.8441285490989685, 0.856877863407135],
                        [0.8207242488861084, 0.8568806052207947],
                    ],
                    [
                        [0.1942511796951294, 0.8679329752922058],
                        [0.30194684863090515, 0.8679206371307373],
                        [0.30195000767707825, 0.8825007081031799],
                        [0.19425387680530548, 0.8825127482414246],
                    ],
                    [
                        [0.19414904713630676, 0.8895187377929688],
                        [0.42047780752182007, 0.8894936442375183],
                        [0.4204813838005066, 0.9038144946098328],
                        [0.19415169954299927, 0.9038390517234802],
                    ],
                    [
                        [0.11701488494873047, 0.9277384281158447],
                        [0.23263207077980042, 0.9277263283729553],
                        [0.23263400793075562, 0.9375893473625183],
                        [0.11701648682355881, 0.9376012682914734],
                    ],
                    [
                        [0.8504936695098877, 0.9280311465263367],
                        [0.882167398929596, 0.928027868270874],
                        [0.8821711540222168, 0.9377941489219666],
                        [0.850497305393219, 0.9377974271774292],
                    ],
                ],
            ],
            [
                '32',
                [
                    [
                        [0.11672360450029373, 0.06273160874843597],
                        [0.4473258852958679, 0.06053765490651131],
                        [0.44766244292259216, 0.07378184050321579],
                        [0.11706045269966125, 0.0759723037481308],
                    ],
                    [
                        [0.11693215370178223, 0.07701132446527481],
                        [0.5285767316818237, 0.07428424060344696],
                        [0.528946578502655, 0.08884480595588684],
                        [0.11730245500802994, 0.09156711399555206],
                    ],
                    [
                        [0.16413480043411255, 0.2037912905216217],
                        [0.4742794334888458, 0.20176804065704346],
                        [0.47468769550323486, 0.21783605217933655],
                        [0.16454342007637024, 0.21985533833503723],
                    ],
                    [
                        [0.15917128324508667, 0.3165077865123749],
                        [0.32227814197540283, 0.31545838713645935],
                        [0.3226514756679535, 0.3301445245742798],
                        [0.15954481065273285, 0.3311920166015625],
                    ],
                    [
                        [0.8328875303268433, 0.3171253502368927],
                        [0.840923011302948, 0.3170737028121948],
                        [0.841150164604187, 0.3260233700275421],
                        [0.8331146836280823, 0.3260749876499176],
                    ],
                    [
                        [0.17673009634017944, 0.3361780047416687],
                        [0.1798185110092163, 0.3361581861972809],
                        [0.17995940148830414, 0.341697633266449],
                        [0.17687100172042847, 0.3417174220085144],
                    ],
                    [
                        [0.1785789281129837, 0.3360915184020996],
                        [0.8675251603126526, 0.33166980743408203],
                        [0.8679361343383789, 0.34786367416381836],
                        [0.17899058759212494, 0.352276474237442],
                    ],
                    [
                        [0.17625634372234344, 0.3518023192882538],
                        [0.42844390869140625, 0.35018691420555115],
                        [0.42876094579696655, 0.36266157031059265],
                        [0.17657357454299927, 0.3642744719982147],
                    ],
                    [
                        [0.17604853212833405, 0.3646998107433319],
                        [0.6699017882347107, 0.3615414798259735],
                        [0.6703226566314697, 0.3781144917011261],
                        [0.17646992206573486, 0.3812662959098816],
                    ],
                    [
                        [0.1759088933467865, 0.39625030755996704],
                        [0.4383006989955902, 0.39457884430885315],
                        [0.43869563937187195, 0.41012024879455566],
                        [0.17630411684513092, 0.4117884635925293],
                    ],
                    [
                        [0.20633062720298767, 0.4278319180011749],
                        [0.31262755393981934, 0.4271574914455414],
                        [0.3130313456058502, 0.4430406987667084],
                        [0.2067345529794693, 0.4437137842178345],
                    ],
                    [
                        [0.2052772343158722, 0.4617726504802704],
                        [0.8773210644721985, 0.457526832818985],
                        [0.8777795433998108, 0.4755966067314148],
                        [0.20573656260967255, 0.4798327386379242],
                    ],
                    [
                        [0.20564168691635132, 0.478945255279541],
                        [0.8545453548431396, 0.4748544991016388],
                        [0.8549894690513611, 0.49235549569129944],
                        [0.20608656108379364, 0.4964371621608734],
                    ],
                    [
                        [0.20496658980846405, 0.4965471029281616],
                        [0.3116019070148468, 0.49587637186050415],
                        [0.3119627833366394, 0.5100705623626709],
                        [0.20532755553722382, 0.5107401013374329],
                    ],
                    [
                        [0.20632189512252808, 0.5276556015014648],
                        [0.44511646032333374, 0.5261594653129578],
                        [0.4455202519893646, 0.5420495271682739],
                        [0.20672595500946045, 0.5435426235198975],
                    ],
                    [
                        [0.20501935482025146, 0.561704695224762],
                        [0.8092110753059387, 0.5579357147216797],
                        [0.8096579909324646, 0.5755439400672913],
                        [0.20546697080135345, 0.5793044567108154],
                    ],
                    [
                        [0.20547179877758026, 0.5787633657455444],
                        [0.8380279541015625, 0.5748260021209717],
                        [0.8384914398193359, 0.5930898785591125],
                        [0.20593608915805817, 0.5970180630683899],
                    ],
                    [
                        [0.205494686961174, 0.596213161945343],
                        [0.46822109818458557, 0.5945814251899719],
                        [0.4686194360256195, 0.6102577447891235],
                        [0.20589330792427063, 0.6118861436843872],
                    ],
                    [
                        [0.20567649602890015, 0.6283842921257019],
                        [0.38041263818740845, 0.6273035407066345],
                        [0.38080888986587524, 0.6428928375244141],
                        [0.20607292652130127, 0.6439714431762695],
                    ],
                ],
            ],
            [
                '70',
                [
                    [
                        [0.23554939031600952, 0.45827826857566833],
                        [0.6285750865936279, 0.4583626985549927],
                        [0.6285723447799683, 0.47301986813545227],
                        [0.23554499447345734, 0.4729347229003906],
                    ],
                    [
                        [0.2347133457660675, 0.4910324513912201],
                        [0.8072090148925781, 0.4911577105522156],
                        [0.8072070479393005, 0.5057828426361084],
                        [0.23470894992351532, 0.5056565999984741],
                    ],
                    [
                        [0.23463279008865356, 0.5084773898124695],
                        [0.4319841265678406, 0.5085210204124451],
                        [0.43198055028915405, 0.523215115070343],
                        [0.23462837934494019, 0.5231711268424988],
                    ],
                    [
                        [0.2354612797498703, 0.5407246947288513],
                        [0.45298799872398376, 0.5407735705375671],
                        [0.452984482049942, 0.5555898547172546],
                        [0.23545682430267334, 0.5555405616760254],
                    ],
                    [
                        [0.23436734080314636, 0.5734392404556274],
                        [0.8046595454216003, 0.5735697150230408],
                        [0.8046575784683228, 0.5882517099380493],
                        [0.2343629151582718, 0.5881202220916748],
                    ],
                    [
                        [0.23424986004829407, 0.590950071811676],
                        [0.6702060699462891, 0.5910507440567017],
                        [0.6702035665512085, 0.6056082844734192],
                        [0.23424547910690308, 0.6055068373680115],
                    ],
                    [
                        [0.23549562692642212, 0.6234003901481628],
                        [0.46981582045555115, 0.6234554052352905],
                        [0.46981242299079895, 0.6380835175514221],
                        [0.23549121618270874, 0.638028085231781],
                    ],
                    [
                        [0.23435643315315247, 0.656026303768158],
                        [0.8697634935379028, 0.6561779975891113],
                        [0.8697617650032043, 0.670975923538208],
                        [0.2343519777059555, 0.6708230972290039],
                    ],
                    [
                        [0.23485426604747772, 0.6734858751296997],
                        [0.8642681837081909, 0.6736375093460083],
                        [0.8642664551734924, 0.6884474158287048],
                        [0.23484981060028076, 0.6882947087287903],
                    ],
                    [
                        [0.2345353215932846, 0.6910135746002197],
                        [0.8438366651535034, 0.691161572933197],
                        [0.8438348770141602, 0.7056177258491516],
                        [0.234530970454216, 0.7054686546325684],
                    ],
                    [
                        [0.23465675115585327, 0.7081767916679382],
                        [0.7175170183181763, 0.7082951068878174],
                        [0.7175146341323853, 0.7232259511947632],
                        [0.23465226590633392, 0.7231068015098572],
                    ],
                    [
                        [0.29364341497421265, 0.727147102355957],
                        [0.5771960616111755, 0.7272172570228577],
                        [0.5771932005882263, 0.7416063547134399],
                        [0.29363933205604553, 0.7415357232093811],
                    ],
                    [
                        [0.2937162220478058, 0.7454962730407715],
                        [0.8437076807022095, 0.7456335425376892],
                        [0.8437058329582214, 0.7604146003723145],
                        [0.2937120497226715, 0.7602763772010803],
                    ],
                    [
                        [0.23511870205402374, 0.7774865031242371],
                        [0.4407607614994049, 0.7775386571884155],
                        [0.4407571852207184, 0.7924544811248779],
                        [0.2351142168045044, 0.7924019694328308],
                    ],
                    [
                        [0.23445048928260803, 0.8103817105293274],
                        [0.8607951402664185, 0.8105429410934448],
                        [0.86079341173172, 0.8254148960113525],
                        [0.23444600403308868, 0.8252525329589844],
                    ],
                    [
                        [0.23447856307029724, 0.8280863165855408],
                        [0.3152010440826416, 0.8281072378158569],
                        [0.3151979148387909, 0.8393567204475403],
                        [0.23447518050670624, 0.8393356204032898],
                    ],
                    [
                        [0.11694837361574173, 0.9276025891304016],
                        [0.23262545466423035, 0.9276340007781982],
                        [0.232622429728508, 0.9376493692398071],
                        [0.11694501340389252, 0.937617838382721],
                    ],
                    [
                        [0.8651944994926453, 0.9279071092605591],
                        [0.8815867304801941, 0.9279115796089172],
                        [0.8815855979919434, 0.9376891851425171],
                        [0.8651933670043945, 0.9376847147941589],
                    ],
                ],
            ],
            [
                '67',
                [
                    [
                        [0.11675496399402618, 0.06227654218673706],
                        [0.4474884271621704, 0.062233250588178635],
                        [0.4474879801273346, 0.07455863058567047],
                        [0.11675366014242172, 0.0746014267206192],
                    ],
                    [
                        [0.11710059642791748, 0.07702470570802689],
                        [0.12924796342849731, 0.07702314108610153],
                        [0.12924696505069733, 0.08660446107387543],
                        [0.1170995831489563, 0.08660601824522018],
                    ],
                    [
                        [0.14588662981987, 0.07676748931407928],
                        [0.40493112802505493, 0.0767340362071991],
                        [0.40493056178092957, 0.08901581168174744],
                        [0.1458854079246521, 0.08904887735843658],
                    ],
                    [
                        [0.2946773171424866, 0.10827582329511642],
                        [0.5406520962715149, 0.10824499279260635],
                        [0.5406518578529358, 0.12321972846984863],
                        [0.2946763038635254, 0.12325011193752289],
                    ],
                    [
                        [0.2931617796421051, 0.1410137116909027],
                        [0.8786944150924683, 0.14094264805316925],
                        [0.8786951899528503, 0.15553736686706543],
                        [0.2931607663631439, 0.1556074023246765],
                    ],
                    [
                        [0.29362019896507263, 0.1585841327905655],
                        [0.8537206053733826, 0.15851736068725586],
                        [0.8537213206291199, 0.17314361035823822],
                        [0.29361921548843384, 0.17320939898490906],
                    ],
                    [
                        [0.29349908232688904, 0.17570437490940094],
                        [0.8797311782836914, 0.1756356954574585],
                        [0.8797320127487183, 0.1904282420873642],
                        [0.29349806904792786, 0.19049587845802307],
                    ],
                    [
                        [0.2935515344142914, 0.19327618181705475],
                        [0.5555777549743652, 0.1932460516691208],
                        [0.5555775761604309, 0.20798936486244202],
                        [0.2935505211353302, 0.20801903307437897],
                    ],
                    [
                        [0.26446297764778137, 0.2257259488105774],
                        [0.42686545848846436, 0.22570790350437164],
                        [0.4268648624420166, 0.240395650267601],
                        [0.2644619047641754, 0.24041341245174408],
                    ],
                    [
                        [0.2637459933757782, 0.2585013210773468],
                        [0.8614231944084167, 0.25843727588653564],
                        [0.8614237904548645, 0.27006441354751587],
                        [0.26374512910842896, 0.2701275944709778],
                    ],
                    [
                        [0.2643301486968994, 0.2757732570171356],
                        [0.7342289686203003, 0.2757238745689392],
                        [0.734229326248169, 0.2904640734195709],
                        [0.26432904601097107, 0.2905125916004181],
                    ],
                    [
                        [0.26377344131469727, 0.30831509828567505],
                        [0.8331907987594604, 0.3082575500011444],
                        [0.8331913352012634, 0.3199240267276764],
                        [0.263772577047348, 0.31998080015182495],
                    ],
                    [
                        [0.2641375660896301, 0.32587161660194397],
                        [0.48554927110671997, 0.3258496820926666],
                        [0.48554888367652893, 0.34035244584083557],
                        [0.2641364634037018, 0.3403739631175995],
                    ],
                    [
                        [0.26479101181030273, 0.35846617817878723],
                        [0.4488750100135803, 0.35844868421554565],
                        [0.44887447357177734, 0.37318241596221924],
                        [0.2647899091243744, 0.37319958209991455],
                    ],
                    [
                        [0.2951052486896515, 0.39093470573425293],
                        [0.8151957392692566, 0.3908873200416565],
                        [0.8151963353157043, 0.40554746985435486],
                        [0.2951042354106903, 0.4055939316749573],
                    ],
                    [
                        [0.2930702567100525, 0.4236060380935669],
                        [0.8394296765327454, 0.42355841398239136],
                        [0.8394303917884827, 0.43815553188323975],
                        [0.2930692434310913, 0.4382022023200989],
                    ],
                    [
                        [0.2939724624156952, 0.4410897493362427],
                        [0.8496410250663757, 0.4410424828529358],
                        [0.849641740322113, 0.45548057556152344],
                        [0.2939714789390564, 0.45552685856819153],
                    ],
                    [
                        [0.29321014881134033, 0.45864593982696533],
                        [0.3531949818134308, 0.458640992641449],
                        [0.35319435596466064, 0.47002142667770386],
                        [0.29320937395095825, 0.47002631425857544],
                    ],
                    [
                        [0.29324114322662354, 0.491088330745697],
                        [0.8450599908828735, 0.4910447299480438],
                        [0.8450607061386108, 0.5054832100868225],
                        [0.29324012994766235, 0.5055258274078369],
                    ],
                ],
            ],
        ],
    },
    {
        question: 'What is the minimum FICO for qualify for an FHA loan?',
        InitialChatTitle: 'FHA Loan Credit Requirements',
        Answer: "Based on the FHA housing handbook, the answer is:\n\nThe minimum FICO (credit score) requirements for FHA loans are:\n\n1. The minimum decision credit score (MDCS) cannot be less than 500 to be eligible for FHA-insured financing.\n\n2. For cases with multiple borrowers:\n- The lender must determine the MDCS for each borrower and select the lowest MDCS among all borrowers\n- When one or more borrowers don't have a credit score, the lender must use the lowest MDCS of the borrower(s) with credit score(s)\n\nIt's important to note that while 500 is the minimum score allowed by FHA, individual lenders may set their own higher credit score requirements.\n\nReference: This information can be found in the FHA Handbook 4000.1 under the section discussing Borrower eligibility and credit score requirements.",
        QuoteLocations: [
            [
                '481',
                [
                    [
                        [0.2637111246585846, 0.6062799692153931],
                        [0.8232763409614563, 0.6061039566993713],
                        [0.8232928514480591, 0.6211156249046326],
                        [0.2637253999710083, 0.6212906241416931],
                    ],
                    [
                        [0.26476943492889404, 0.623455822467804],
                        [0.8307289481163025, 0.6232789754867554],
                        [0.8307454586029053, 0.6382664442062378],
                        [0.26478368043899536, 0.63844233751297],
                    ],
                    [
                        [0.26443254947662354, 0.6409745216369629],
                        [0.6227321624755859, 0.640863299369812],
                        [0.6227477192878723, 0.6557237505912781],
                        [0.2644466757774353, 0.6558343768119812],
                    ],
                    [
                        [0.26442569494247437, 0.673475980758667],
                        [0.527789294719696, 0.6733952164649963],
                        [0.5278043746948242, 0.68817138671875],
                        [0.26443973183631897, 0.6882516741752625],
                    ],
                    [
                        [0.263863205909729, 0.7061671018600464],
                        [0.8744185566902161, 0.7059822082519531],
                        [0.8744352459907532, 0.7209494709968567],
                        [0.26387742161750793, 0.721133291721344],
                    ],
                    [
                        [0.26417332887649536, 0.7235337495803833],
                        [0.7086923122406006, 0.7234000563621521],
                        [0.708704948425293, 0.7351842522621155],
                        [0.26418450474739075, 0.7353173494338989],
                    ],
                    [
                        [0.26457035541534424, 0.7559801340103149],
                        [0.5060186386108398, 0.7559084296226501],
                        [0.5060338377952576, 0.7708840370178223],
                        [0.26458457112312317, 0.7709552645683289],
                    ],
                    [
                        [0.2639255225658417, 0.7885006070137024],
                        [0.8640100359916687, 0.788324773311615],
                        [0.8640266060829163, 0.8032341003417969],
                        [0.26393967866897583, 0.8034089207649231],
                    ],
                    [
                        [0.2640540301799774, 0.8061344623565674],
                        [0.8776506185531616, 0.8059558868408203],
                        [0.8776673078536987, 0.8209447264671326],
                        [0.26406827569007874, 0.8211221694946289],
                    ],
                    [
                        [0.264667272567749, 0.8232816457748413],
                        [0.4376084506511688, 0.8232316374778748],
                        [0.43762052059173584, 0.8353539705276489],
                        [0.2646787762641907, 0.8354036808013916],
                    ],
                    [
                        [0.2640760838985443, 0.85630863904953],
                        [0.8289237022399902, 0.8561476469039917],
                        [0.8289399147033691, 0.8708620667457581],
                        [0.26409006118774414, 0.87102210521698],
                    ],
                    [
                        [0.26405686140060425, 0.8732739090919495],
                        [0.8778954744338989, 0.8731001019477844],
                        [0.8779120445251465, 0.8879495859146118],
                        [0.26407095789909363, 0.8881222605705261],
                    ],
                    [
                        [0.2644156813621521, 0.8911445140838623],
                        [0.5350213646888733, 0.8910684585571289],
                        [0.5350331664085388, 0.9026086330413818],
                        [0.26442664861679077, 0.9026842713356018],
                    ],
                    [
                        [0.11697042733430862, 0.9277980327606201],
                        [0.2324219048023224, 0.9277661442756653],
                        [0.23243120312690735, 0.9376501441001892],
                        [0.11697942018508911, 0.9376819133758545],
                    ],
                    [
                        [0.857139527797699, 0.927839994430542],
                        [0.882692813873291, 0.9278329610824585],
                        [0.8827040791511536, 0.9379549622535706],
                        [0.8571507930755615, 0.937961995601654],
                    ],
                ],
            ],
            [
                '1264',
                [
                    [
                        [0.32308074831962585, 0.7987527847290039],
                        [0.8351598381996155, 0.798712968826294],
                        [0.8351675271987915, 0.8133912682533264],
                        [0.323085755109787, 0.8134301900863647],
                    ],
                    [
                        [0.32341086864471436, 0.8160101175308228],
                        [0.7256782054901123, 0.8159797191619873],
                        [0.7256852984428406, 0.8305918574333191],
                        [0.3234158754348755, 0.830621600151062],
                    ],
                    [
                        [0.32298266887664795, 0.8346781134605408],
                        [0.7478439807891846, 0.8346469402313232],
                        [0.7478505373001099, 0.8479548096656799],
                        [0.3229871988296509, 0.8479852080345154],
                    ],
                    [
                        [0.3230603337287903, 0.8530548214912415],
                        [0.8555522561073303, 0.8530169725418091],
                        [0.8555598855018616, 0.8674768209457397],
                        [0.32306525111198425, 0.8675137162208557],
                    ],
                    [
                        [0.32323190569877625, 0.8707805871963501],
                        [0.7640807628631592, 0.8707502484321594],
                        [0.7640880346298218, 0.8853892087936401],
                        [0.3232369124889374, 0.8854187726974487],
                    ],
                    [
                        [0.11703401058912277, 0.9275962114334106],
                        [0.23281288146972656, 0.9275890588760376],
                        [0.23281598091125488, 0.9376494884490967],
                        [0.11703670769929886, 0.9376564621925354],
                    ],
                    [
                        [0.8510083556175232, 0.9280460476875305],
                        [0.8821722269058228, 0.9280441403388977],
                        [0.8821775317192078, 0.9379281401634216],
                        [0.8510136008262634, 0.9379299879074097],
                    ],
                ],
            ],
            [
                '48',
                [
                    [
                        [0.1166796013712883, 0.06224731355905533],
                        [0.4477962553501129, 0.06215575337409973],
                        [0.44780048727989197, 0.0744677186012268],
                        [0.11668277531862259, 0.07455848902463913],
                    ],
                    [
                        [0.11714428663253784, 0.07688820362091064],
                        [0.5288785099983215, 0.07677551358938217],
                        [0.5288829803466797, 0.08898273855447769],
                        [0.11714743077754974, 0.08909445255994797],
                    ],
                    [
                        [0.17601566016674042, 0.10831426084041595],
                        [0.35634976625442505, 0.10826600342988968],
                        [0.3563545048236847, 0.12312643229961395],
                        [0.17601971328258514, 0.12317417562007904],
                    ],
                    [
                        [0.20610207319259644, 0.14102748036384583],
                        [0.4622136950492859, 0.14096055924892426],
                        [0.4622188210487366, 0.15571866929531097],
                        [0.20610621571540833, 0.15578486025333405],
                    ],
                    [
                        [0.23524822294712067, 0.610563337802887],
                        [0.34260836243629456, 0.6105450391769409],
                        [0.34261268377304077, 0.6242419481277466],
                        [0.23525217175483704, 0.6242599487304688],
                    ],
                    [
                        [0.23457805812358856, 0.20633701980113983],
                        [0.8411670923233032, 0.2061861902475357],
                        [0.8411735892295837, 0.2207770049571991],
                        [0.23458226025104523, 0.22092613577842712],
                    ],
                    [
                        [0.23503868281841278, 0.2234686315059662],
                        [0.8642160892486572, 0.22331425547599792],
                        [0.8642227649688721, 0.238167867064476],
                        [0.2350429743528366, 0.23832042515277863],
                    ],
                    [
                        [0.23435206711292267, 0.2557666301727295],
                        [0.8546260595321655, 0.25561830401420593],
                        [0.8546328544616699, 0.2706652581691742],
                        [0.23435640335083008, 0.2708117663860321],
                    ],
                    [
                        [0.2348126471042633, 0.2736164629459381],
                        [0.37152841687202454, 0.273584246635437],
                        [0.3715331554412842, 0.28821343183517456],
                        [0.23481686413288116, 0.2882452607154846],
                    ],
                    [
                        [0.23472285270690918, 0.30617353320121765],
                        [0.854288637638092, 0.30603140592575073],
                        [0.8542953133583069, 0.32086995244026184],
                        [0.23472712934017181, 0.3210102617740631],
                    ],
                    [
                        [0.23510518670082092, 0.32319584488868713],
                        [0.8411375284194946, 0.3230588436126709],
                        [0.841144323348999, 0.33826279640197754],
                        [0.23510956764221191, 0.3383980393409729],
                    ],
                    [
                        [0.23539549112319946, 0.3408469259738922],
                        [0.8723029494285583, 0.34070509672164917],
                        [0.872309684753418, 0.3555585741996765],
                        [0.2353997826576233, 0.3556985557079315],
                    ],
                    [
                        [0.23513296246528625, 0.358450323343277],
                        [0.810747504234314, 0.3583241403102875],
                        [0.8107540607452393, 0.3732893168926239],
                        [0.23513728380203247, 0.3734138607978821],
                    ],
                    [
                        [0.23530833423137665, 0.37597304582595825],
                        [0.8607521057128906, 0.375838041305542],
                        [0.8607587218284607, 0.39045193791389465],
                        [0.2353125512599945, 0.39058518409729004],
                    ],
                    [
                        [0.23483961820602417, 0.39315372705459595],
                        [0.8564309477806091, 0.3930216133594513],
                        [0.8564377427101135, 0.4080878794193268],
                        [0.23484396934509277, 0.4082182049751282],
                    ],
                    [
                        [0.23519298434257507, 0.41093745827674866],
                        [0.4260435402393341, 0.41089755296707153],
                        [0.4260484576225281, 0.42543986439704895],
                        [0.23519717156887054, 0.4254792332649231],
                    ],
                    [
                        [0.23535841703414917, 0.710698127746582],
                        [0.4760183095932007, 0.710661768913269],
                        [0.476023405790329, 0.7252001762390137],
                        [0.23536260426044464, 0.7252358794212341],
                    ],
                ],
            ],
            [
                '44',
                [
                    [
                        [0.11672128736972809, 0.06227441504597664],
                        [0.44772183895111084, 0.06217711791396141],
                        [0.4477284550666809, 0.07443340867757797],
                        [0.11672649532556534, 0.07453040033578873],
                    ],
                    [
                        [0.11721456050872803, 0.07689522951841354],
                        [0.5289285778999329, 0.07677466422319412],
                        [0.528935432434082, 0.08892159163951874],
                        [0.1172197237610817, 0.08904178440570831],
                    ],
                    [
                        [0.23493747413158417, 0.1085069328546524],
                        [0.8788825869560242, 0.10831990092992783],
                        [0.8788926601409912, 0.12297191470861435],
                        [0.23494429886341095, 0.12315823137760162],
                    ],
                    [
                        [0.2347344011068344, 0.1259751170873642],
                        [0.7424042820930481, 0.1258283406496048],
                        [0.7424136400222778, 0.14042343199253082],
                        [0.2347411960363388, 0.14056964218616486],
                    ],
                    [
                        [0.23453514277935028, 0.15864057838916779],
                        [0.8424081206321716, 0.15846633911132812],
                        [0.8424180150032043, 0.17314927279949188],
                        [0.23454198241233826, 0.17332284152507782],
                    ],
                    [
                        [0.23502226173877716, 0.17593979835510254],
                        [0.8628361821174622, 0.1757606565952301],
                        [0.8628462553024292, 0.19050171971321106],
                        [0.23502913117408752, 0.1906801462173462],
                    ],
                    [
                        [0.1760537326335907, 0.20828917622566223],
                        [0.44753316044807434, 0.20821237564086914],
                        [0.44754114747047424, 0.2230137437582016],
                        [0.17606033384799957, 0.22309023141860962],
                    ],
                    [
                        [0.17614443600177765, 0.2408067286014557],
                        [0.8761127591133118, 0.24061045050621033],
                        [0.8761230707168579, 0.25558626651763916],
                        [0.1761511117219925, 0.25578176975250244],
                    ],
                    [
                        [0.1759169101715088, 0.2588021457195282],
                        [0.28245416283607483, 0.25877243280410767],
                        [0.2824610471725464, 0.2730730175971985],
                        [0.17592327296733856, 0.27310264110565186],
                    ],
                    [
                        [0.20606882870197296, 0.2908329963684082],
                        [0.5056687593460083, 0.290750116109848],
                        [0.5056771636009216, 0.3058009743690491],
                        [0.20607568323612213, 0.305883526802063],
                    ],
                    [
                        [0.235346257686615, 0.3234405219554901],
                        [0.34257984161376953, 0.32341113686561584],
                        [0.3425869345664978, 0.3374750316143036],
                        [0.2353527992963791, 0.3375043272972107],
                    ],
                    [
                        [0.23454080522060394, 0.35629555583000183],
                        [0.8603805303573608, 0.35612553358078003],
                        [0.8603903651237488, 0.37056300044059753],
                        [0.23454752564430237, 0.3707323372364044],
                    ],
                    [
                        [0.23487718403339386, 0.37372589111328125],
                        [0.8724836111068726, 0.3735535144805908],
                        [0.8724936246871948, 0.38818877935409546],
                        [0.23488399386405945, 0.3883604407310486],
                    ],
                    [
                        [0.23511876165866852, 0.39100056886672974],
                        [0.8557870388031006, 0.3908335864543915],
                        [0.8557970523834229, 0.40557241439819336],
                        [0.23512563109397888, 0.4057387113571167],
                    ],
                    [
                        [0.2348586469888687, 0.4085935354232788],
                        [0.2953479588031769, 0.4085773229598999],
                        [0.295353502035141, 0.419963002204895],
                        [0.23486395180225372, 0.41997915506362915],
                    ],
                ],
            ],
            [
                '174',
                [
                    [
                        [0.2643777132034302, 0.4106579124927521],
                        [0.7554349899291992, 0.41075995564460754],
                        [0.755431056022644, 0.4239545464515686],
                        [0.2643716633319855, 0.42385149002075195],
                    ],
                    [
                        [0.26409628987312317, 0.4430859386920929],
                        [0.8390045166015625, 0.44320833683013916],
                        [0.8390004634857178, 0.4580056369304657],
                        [0.2640894949436188, 0.4578819274902344],
                    ],
                    [
                        [0.2642694413661957, 0.46053317189216614],
                        [0.8565189242362976, 0.460660845041275],
                        [0.8565151691436768, 0.4745107889175415],
                        [0.2642630636692047, 0.47438180446624756],
                    ],
                    [
                        [0.26421406865119934, 0.47800788283348083],
                        [0.8568692803382874, 0.4781372845172882],
                        [0.856865406036377, 0.4926767945289612],
                        [0.2642073929309845, 0.49254605174064636],
                    ],
                    [
                        [0.26475784182548523, 0.49603721499443054],
                        [0.33028337359428406, 0.49605172872543335],
                        [0.33027756214141846, 0.5093153715133667],
                        [0.26475173234939575, 0.509300708770752],
                    ],
                    [
                        [0.26455187797546387, 0.5276747345924377],
                        [0.46000590920448303, 0.5277189612388611],
                        [0.4599999487400055, 0.542779266834259],
                        [0.2645449638366699, 0.5427346229553223],
                    ],
                    [
                        [0.26374784111976624, 0.5601929426193237],
                        [0.8600203990936279, 0.5603307485580444],
                        [0.860016405582428, 0.5751611590385437],
                        [0.26374101638793945, 0.5750219225883484],
                    ],
                    [
                        [0.2640356719493866, 0.5782126188278198],
                        [0.3361192047595978, 0.5782294869422913],
                        [0.3361141085624695, 0.5899078249931335],
                        [0.2640303075313568, 0.5898908376693726],
                    ],
                    [
                        [0.2350788712501526, 0.610489010810852],
                        [0.8511414527893066, 0.610636293888092],
                        [0.8511375188827515, 0.6251548528671265],
                        [0.235072061419487, 0.6250061988830566],
                    ],
                    [
                        [0.23432111740112305, 0.6431082487106323],
                        [0.8489527106285095, 0.6432583332061768],
                        [0.8489486575126648, 0.6581723690032959],
                        [0.23431412875652313, 0.6580208539962769],
                    ],
                    [
                        [0.23482297360897064, 0.6605505347251892],
                        [0.8725285530090332, 0.6607080101966858],
                        [0.8725247383117676, 0.6751444339752197],
                        [0.23481619358062744, 0.6749855875968933],
                    ],
                    [
                        [0.2351730614900589, 0.6779083013534546],
                        [0.8312843441963196, 0.678057074546814],
                        [0.8312802910804749, 0.6928983330726624],
                        [0.23516610264778137, 0.6927481889724731],
                    ],
                    [
                        [0.23490898311138153, 0.7103927135467529],
                        [0.8272502422332764, 0.7105435729026794],
                        [0.8272461295127869, 0.7253511548042297],
                        [0.2349020391702652, 0.7251989245414734],
                    ],
                    [
                        [0.23503798246383667, 0.7276211380958557],
                        [0.8708398938179016, 0.7277847528457642],
                        [0.8708359003067017, 0.7429625391960144],
                        [0.2350308746099472, 0.7427974343299866],
                    ],
                ],
            ],
            [
                '945',
                [
                    [
                        [0.1463405340909958, 0.43487656116485596],
                        [0.8583163619041443, 0.4345969557762146],
                        [0.8583315014839172, 0.449441134929657],
                        [0.14635343849658966, 0.449719101190567],
                    ],
                    [
                        [0.14675749838352203, 0.4523566961288452],
                        [0.4622662663459778, 0.4522336423397064],
                        [0.46227967739105225, 0.4665590822696686],
                        [0.1467699408531189, 0.46668145060539246],
                    ],
                    [
                        [0.14700430631637573, 0.4846208989620209],
                        [0.872968316078186, 0.4843413531780243],
                        [0.8729830384254456, 0.49873557686805725],
                        [0.14701680839061737, 0.4990135133266449],
                    ],
                    [
                        [0.14625698328018188, 0.5020157694816589],
                        [0.8413228988647461, 0.5017499923706055],
                        [0.8413382172584534, 0.516822874546051],
                        [0.14627008140087128, 0.5170869827270508],
                    ],
                    [
                        [0.20556487143039703, 0.5210545063018799],
                        [0.36186251044273376, 0.5209951996803284],
                        [0.36187511682510376, 0.5348138213157654],
                        [0.2055770456790924, 0.5348727703094482],
                    ],
                    [
                        [0.2056424766778946, 0.5391247272491455],
                        [0.2830967605113983, 0.5390955805778503],
                        [0.2831086814403534, 0.5524000525474548],
                        [0.20565420389175415, 0.5524290800094604],
                    ],
                    [
                        [0.20539942383766174, 0.5579312443733215],
                        [0.3749746084213257, 0.5578678250312805],
                        [0.3749876022338867, 0.5720605254173279],
                        [0.20541192591190338, 0.5721235275268555],
                    ],
                    [
                        [0.20532502233982086, 0.5762226581573486],
                        [0.4414655268192291, 0.5761350393295288],
                        [0.4414788782596588, 0.5904796123504639],
                        [0.20533765852451324, 0.5905666947364807],
                    ],
                    [
                        [0.20568929612636566, 0.5949552059173584],
                        [0.3553496301174164, 0.5949001312255859],
                        [0.3553624451160431, 0.608942985534668],
                        [0.20570167899131775, 0.6089977622032166],
                    ],
                    [
                        [0.205556258559227, 0.6132379770278931],
                        [0.31827402114868164, 0.6131967902183533],
                        [0.31828588247299194, 0.6263098120689392],
                        [0.20556780695915222, 0.6263507604598999],
                    ],
                    [
                        [0.20536038279533386, 0.632098913192749],
                        [0.37633657455444336, 0.6320369243621826],
                        [0.37634992599487305, 0.6465944051742554],
                        [0.20537321269512177, 0.6466559767723083],
                    ],
                    [
                        [0.1759856790304184, 0.6646057367324829],
                        [0.18600940704345703, 0.6646021604537964],
                        [0.1860191971063614, 0.6757721900939941],
                        [0.17599545419216156, 0.6757757067680359],
                    ],
                    [
                        [0.20620639622211456, 0.6641080379486084],
                        [0.38260534405708313, 0.664044976234436],
                        [0.38261863589286804, 0.6785463094711304],
                        [0.20621918141841888, 0.6786090135574341],
                    ],
                    [
                        [0.20626284182071686, 0.6967253684997559],
                        [0.48407062888145447, 0.6966274380683899],
                        [0.4840845465660095, 0.7114412188529968],
                        [0.20627589523792267, 0.7115384936332703],
                    ],
                    [
                        [0.20550565421581268, 0.7293855547904968],
                        [0.8186628818511963, 0.7291725873947144],
                        [0.8186777234077454, 0.7438545823097229],
                        [0.20551858842372894, 0.7440661787986755],
                    ],
                    [
                        [0.20519542694091797, 0.7468174695968628],
                        [0.6689082980155945, 0.74665766954422],
                        [0.6689223647117615, 0.7610051035881042],
                        [0.20520807802677155, 0.7611638903617859],
                    ],
                    [
                        [0.20510973036289215, 0.7796957492828369],
                        [0.8205498456954956, 0.7794867157936096],
                        [0.8205646276473999, 0.7940654158592224],
                        [0.20512257516384125, 0.7942730188369751],
                    ],
                    [
                        [0.20528048276901245, 0.7974230647087097],
                        [0.3415081202983856, 0.7973772287368774],
                        [0.34152090549468994, 0.8114311695098877],
                        [0.20529286563396454, 0.8114767670631409],
                    ],
                    [
                        [0.20506934821605682, 0.8296098113059998],
                        [0.8561619520187378, 0.8293936848640442],
                        [0.8561767935752869, 0.8439288139343262],
                        [0.20508214831352234, 0.8441433906555176],
                    ],
                    [
                        [0.2051996886730194, 0.8469653725624084],
                        [0.8110784292221069, 0.8467658758163452],
                        [0.8110933899879456, 0.8615862727165222],
                        [0.20521274209022522, 0.8617843985557556],
                    ],
                    [
                        [0.2057061344385147, 0.8661664128303528],
                        [0.2776554524898529, 0.8661429286003113],
                        [0.2776640057563782, 0.8756809234619141],
                        [0.20571453869342804, 0.8757043480873108],
                    ],
                    [
                        [0.11714179813861847, 0.9279184341430664],
                        [0.2328326553106308, 0.9278818368911743],
                        [0.23284120857715607, 0.9375233054161072],
                        [0.11715011298656464, 0.9375597834587097],
                    ],
                ],
            ],
            [
                '45',
                [
                    [
                        [0.11658141762018204, 0.06223421171307564],
                        [0.44790926575660706, 0.0620386116206646],
                        [0.4479183554649353, 0.07446581870317459],
                        [0.11658921092748642, 0.07466091960668564],
                    ],
                    [
                        [0.11714127659797668, 0.07649105042219162],
                        [0.5293891429901123, 0.07624839246273041],
                        [0.529399037361145, 0.08930132538080215],
                        [0.1171494647860527, 0.08954332768917084],
                    ],
                    [
                        [0.20601598918437958, 0.1083890050649643],
                        [0.393341988325119, 0.10827947407960892],
                        [0.3933524787425995, 0.12292865663766861],
                        [0.20602558553218842, 0.12303785234689713],
                    ],
                    [
                        [0.235319584608078, 0.14077246189117432],
                        [0.34262168407440186, 0.14071014523506165],
                        [0.34263136982917786, 0.15458567440509796],
                        [0.235328808426857, 0.1546477973461151],
                    ],
                    [
                        [0.2343527227640152, 0.17327572405338287],
                        [0.8749678134918213, 0.17290623486042023],
                        [0.8749809265136719, 0.188048854470253],
                        [0.23436279594898224, 0.18841716647148132],
                    ],
                    [
                        [0.23452211916446686, 0.19097761809825897],
                        [0.8449656367301941, 0.190626859664917],
                        [0.8449784517288208, 0.20556606352329254],
                        [0.23453204333782196, 0.20591570436954498],
                    ],
                    [
                        [0.23486845195293427, 0.20838890969753265],
                        [0.8077108263969421, 0.20806096494197845],
                        [0.8077235221862793, 0.22311191260814667],
                        [0.23487845063209534, 0.2234387993812561],
                    ],
                    [
                        [0.23512446880340576, 0.2259151190519333],
                        [0.6803366541862488, 0.22566120326519012],
                        [0.6803486347198486, 0.24056869745254517],
                        [0.23513437807559967, 0.24082180857658386],
                    ],
                    [
                        [0.2355009913444519, 0.25814637541770935],
                        [0.4761125445365906, 0.2580100893974304],
                        [0.47612351179122925, 0.2728099226951599],
                        [0.23551084101200104, 0.272945761680603],
                    ],
                    [
                        [0.23451457917690277, 0.29100164771080017],
                        [0.8489523530006409, 0.29065608978271484],
                        [0.8489652872085571, 0.30566585063934326],
                        [0.23452456295490265, 0.30601027607917786],
                    ],
                    [
                        [0.23500478267669678, 0.3086419701576233],
                        [0.3263446092605591, 0.3085907995700836],
                        [0.32635459303855896, 0.32298964262008667],
                        [0.23501434922218323, 0.3230406641960144],
                    ],
                    [
                        [0.17614395916461945, 0.34079039096832275],
                        [0.4065423309803009, 0.3406622111797333],
                        [0.4065530300140381, 0.35554635524749756],
                        [0.17615357041358948, 0.3556741178035736],
                    ],
                    [
                        [0.20593774318695068, 0.3733579218387604],
                        [0.3131787180900574, 0.37329867482185364],
                        [0.3131890296936035, 0.38826459646224976],
                        [0.20594754815101624, 0.3883236348628998],
                    ],
                    [
                        [0.20533853769302368, 0.4062216877937317],
                        [0.8298571705818176, 0.40587925910949707],
                        [0.8298701047897339, 0.4209730923175812],
                        [0.2053484320640564, 0.4213143587112427],
                    ],
                    [
                        [0.20518910884857178, 0.4232785701751709],
                        [0.6575915217399597, 0.42303144931793213],
                        [0.6576036810874939, 0.43824315071105957],
                        [0.20519907772541046, 0.4384894073009491],
                    ],
                    [
                        [0.23508216440677643, 0.4560687839984894],
                        [0.4355909824371338, 0.45596006512641907],
                        [0.4356015622615814, 0.4704568386077881],
                        [0.23509180545806885, 0.47056519985198975],
                    ],
                    [
                        [0.23439879715442657, 0.48879849910736084],
                        [0.8734561204910278, 0.48845458030700684],
                        [0.8734690546989441, 0.5033254623413086],
                        [0.2344086766242981, 0.5036682486534119],
                    ],
                    [
                        [0.23494388163089752, 0.5062119960784912],
                        [0.8772555589675903, 0.5058676600456238],
                        [0.8772682547569275, 0.5204662680625916],
                        [0.23495358228683472, 0.5208094716072083],
                    ],
                ],
            ],
        ],
    },
]

export const VADocPromptExamples = [
    {
        question:
            'Summarize the guideline and provide a list of key points for VA loans.',
        InitialChatTitle: 'VA Home Financing Essentials',
        Answer: "Based on the VA guidelines, here is the answer:\n\nKey Points for VA Loans:\n\n1. Property Requirements:\n- Must meet VA's Minimum Property Requirements (MPRs)\n- Property must be safe, sound, and sanitary\n- Must be used as the borrower's primary residence\n- Requires VA-approved appraiser inspection\n\n2. Financial Requirements:\n- Minimum working capital requirement of $50,000 for lenders\n- Alternative requirement: $250,000 net worth reported by CPA\n- VA funding fee is required (ranges from 1.4% to 3.6%)\n- Secondary borrowing/second mortgages are allowed with restrictions\n\n3. Underwriting Requirements:\n- Underwriters must have minimum 3 years experience in mortgage loans\n- At least 1 recent year of VA loan underwriting experience\n- Can alternatively hold Accredited Residential Underwriter (ARU) certification\n- Must analyze credit, income, and employment history\n\n4. Lender Requirements:\n- Must maintain quality control system\n- Need to have designated liaison officer\n- Required to have minimum $1 million line of credit\n- Must have two permanent investors\n\n5. Documentation Requirements:\n- Accurate documentation maintenance\n- Proper recording of all documents\n- Financial statements audited by CPA\n- Regular submission of required forms and certifications\n\n6. Eligible Loan Purposes:\n- Home purchase\n- Construction\n- Refinancing\n- Energy-efficient improvements\n- Manufactured home or lot purchase\n\nReference Sections:\n- VA Pamphlet 26-7, Chapter 1: Lender Approval Guidelines\n- VA Pamphlet 26-7, Section 16: Property Requirements\n- VA Pamphlet 26-7, Chapter 4: Credit Underwriting",
        QuoteLocations: [
            [
                '561',
                [
                    [
                        [0.626693606376648, 0.09309254586696625],
                        [0.8742664456367493, 0.0931289866566658],
                        [0.8742803931236267, 0.10568436235189438],
                        [0.626705527305603, 0.10564728826284409],
                    ],
                    [
                        [0.11709411442279816, 0.1368418186903],
                        [0.33966487646102905, 0.13687656819820404],
                        [0.339674174785614, 0.1490362286567688],
                        [0.11710169166326523, 0.14900092780590057],
                    ],
                    [
                        [0.5287263989448547, 0.13684675097465515],
                        [0.6843100786209106, 0.13687103986740112],
                        [0.6843221187591553, 0.14905425906181335],
                        [0.5287371873855591, 0.14902958273887634],
                    ],
                    [
                        [0.11717886477708817, 0.15110844373703003],
                        [0.35931196808815, 0.15114694833755493],
                        [0.3593215346336365, 0.16341029107570648],
                        [0.11718650907278061, 0.16337117552757263],
                    ],
                    [
                        [0.5285695791244507, 0.15099795162677765],
                        [0.8303202986717224, 0.15104591846466064],
                        [0.8303337097167969, 0.16345033049583435],
                        [0.5285805463790894, 0.16340158879756927],
                    ],
                    [
                        [0.11723610758781433, 0.16564035415649414],
                        [0.3049854338169098, 0.16567076742649078],
                        [0.30499467253685, 0.17809070646762848],
                        [0.11724384874105453, 0.17805981636047363],
                    ],
                    [
                        [0.5486145615577698, 0.16579732298851013],
                        [0.6807982921600342, 0.1658187359571457],
                        [0.6808092594146729, 0.1769411712884903],
                        [0.548624575138092, 0.17691946029663086],
                    ],
                    [
                        [0.11708720773458481, 0.18036800622940063],
                        [0.28070899844169617, 0.1803950071334839],
                        [0.2807178795337677, 0.19260871410369873],
                        [0.11709481477737427, 0.19258131086826324],
                    ],
                    [
                        [0.5289038419723511, 0.18031978607177734],
                        [0.7959116101264954, 0.18036383390426636],
                        [0.7959244847297668, 0.19253510236740112],
                        [0.5289146304130554, 0.1924903839826584],
                    ],
                    [
                        [0.11687686294317245, 0.19480490684509277],
                        [0.37128520011901855, 0.19484762847423553],
                        [0.371294766664505, 0.20703347027301788],
                        [0.11688444763422012, 0.2069901078939438],
                    ],
                    [
                        [0.5289971232414246, 0.1947789490222931],
                        [0.8297123312950134, 0.19482944905757904],
                        [0.8297255635261536, 0.20702122151851654],
                        [0.5290079116821289, 0.2069699615240097],
                    ],
                    [
                        [0.11708830296993256, 0.20944759249687195],
                        [0.2363726794719696, 0.20946797728538513],
                        [0.23638120293617249, 0.22164884209632874],
                        [0.11709588766098022, 0.22162814438343048],
                    ],
                    [
                        [0.5289124250411987, 0.2091498225927353],
                        [0.7865625619888306, 0.20919384062290192],
                        [0.7865759134292603, 0.22185659408569336],
                        [0.5289236903190613, 0.221811905503273],
                    ],
                    [
                        [0.11730131506919861, 0.223904088139534],
                        [0.3065522611141205, 0.2239370048046112],
                        [0.3065607249736786, 0.23529554903507233],
                        [0.11730839312076569, 0.2352622002363205],
                    ],
                    [
                        [0.5289015173912048, 0.22368969023227692],
                        [0.8389981389045715, 0.22374360263347626],
                        [0.8390117883682251, 0.2363082617521286],
                        [0.5289126634597778, 0.236253559589386],
                    ],
                    [
                        [0.11717244237661362, 0.23824948072433472],
                        [0.2631523013114929, 0.23827528953552246],
                        [0.2631612718105316, 0.2508144974708557],
                        [0.11718025803565979, 0.25078830122947693],
                    ],
                    [
                        [0.5481510758399963, 0.2383332997560501],
                        [0.643568217754364, 0.23835016787052155],
                        [0.6435789465904236, 0.24952611327171326],
                        [0.5481611490249634, 0.2495090216398239],
                    ],
                    [
                        [0.11708585172891617, 0.2529257833957672],
                        [0.39715883135795593, 0.2529761493206024],
                        [0.39716872572898865, 0.2653045058250427],
                        [0.1170935332775116, 0.2652534544467926],
                    ],
                    [
                        [0.5288596153259277, 0.2529039680957794],
                        [0.6769583225250244, 0.252930611371994],
                        [0.6769698858261108, 0.2646958827972412],
                        [0.5288700461387634, 0.26466888189315796],
                    ],
                    [
                        [0.11735151708126068, 0.2674296200275421],
                        [0.3152278661727905, 0.2674658000469208],
                        [0.3152370750904083, 0.2797272503376007],
                        [0.11735915392637253, 0.27969059348106384],
                    ],
                    [
                        [0.5286939740180969, 0.26739856600761414],
                        [0.7307056784629822, 0.2674354910850525],
                        [0.7307182550430298, 0.2797546982765198],
                        [0.5287048816680908, 0.27971726655960083],
                    ],
                    [
                        [0.11718499660491943, 0.28174757957458496],
                        [0.42004135251045227, 0.28180381655693054],
                        [0.4200515151023865, 0.29420602321624756],
                        [0.11719272285699844, 0.2941490113735199],
                    ],
                    [
                        [0.5286316871643066, 0.28204599022865295],
                        [0.8390864133834839, 0.28210365772247314],
                        [0.8390997052192688, 0.2943333685398102],
                        [0.5286425352096558, 0.2942749261856079],
                    ],
                    [
                        [0.11722638458013535, 0.2965698540210724],
                        [0.44025418162345886, 0.2966307997703552],
                        [0.4402643144130707, 0.30883049964904785],
                        [0.11723398417234421, 0.30876871943473816],
                    ],
                    [
                        [0.5289380550384521, 0.29635322093963623],
                        [0.690209150314331, 0.29638364911079407],
                        [0.6902211308479309, 0.308493047952652],
                        [0.5289488434791565, 0.3084622323513031],
                    ],
                    [
                        [0.11733464151620865, 0.31080079078674316],
                        [0.43114230036735535, 0.31086093187332153],
                        [0.43115246295928955, 0.3231821358203888],
                        [0.11734231561422348, 0.32312121987342834],
                    ],
                    [
                        [0.5291687250137329, 0.31082987785339355],
                        [0.8686556816101074, 0.3108949363231659],
                        [0.8686692118644714, 0.323123961687088],
                        [0.5291796326637268, 0.3230580687522888],
                    ],
                    [
                        [0.11713667213916779, 0.32533150911331177],
                        [0.45739781856536865, 0.3253977298736572],
                        [0.4574081599712372, 0.3376811742782593],
                        [0.11714432388544083, 0.33761411905288696],
                    ],
                ],
            ],
            [
                '603',
                [
                    [
                        [0.5288019776344299, 0.3933623135089874],
                        [0.813259482383728, 0.39312779903411865],
                        [0.8132745027542114, 0.4080343246459961],
                        [0.5288154482841492, 0.4082688093185425],
                    ],
                    [
                        [0.11671754717826843, 0.41110754013061523],
                        [0.34744274616241455, 0.41091734170913696],
                        [0.3474539816379547, 0.42427217960357666],
                        [0.11672769486904144, 0.42446231842041016],
                    ],
                    [
                        [0.548191487789154, 0.41088995337486267],
                        [0.6953366994857788, 0.41076865792274475],
                        [0.6953511238098145, 0.4257538616657257],
                        [0.5482051372528076, 0.42587509751319885],
                    ],
                    [
                        [0.11724770814180374, 0.4283057451248169],
                        [0.41311001777648926, 0.42806196212768555],
                        [0.41312283277511597, 0.44290897250175476],
                        [0.11725898832082748, 0.4431527256965637],
                    ],
                    [
                        [0.5285743474960327, 0.4281996488571167],
                        [0.879686176776886, 0.42791032791137695],
                        [0.8797018527984619, 0.44318893551826477],
                        [0.5285881161689758, 0.44347816705703735],
                    ],
                    [
                        [0.11717662215232849, 0.44577130675315857],
                        [0.38452354073524475, 0.4455510675907135],
                        [0.38453587889671326, 0.4599737226963043],
                        [0.11718758195638657, 0.4601939022541046],
                    ],
                    [
                        [0.5486761331558228, 0.44569069147109985],
                        [0.8481841087341309, 0.4454439580440521],
                        [0.8481992483139038, 0.46033796668052673],
                        [0.5486896634101868, 0.4605846405029297],
                    ],
                    [
                        [0.11739280074834824, 0.46328434348106384],
                        [0.4437768757343292, 0.4630155563354492],
                        [0.4437899589538574, 0.47796836495399475],
                        [0.11740416288375854, 0.478237122297287],
                    ],
                    [
                        [0.528826117515564, 0.46305274963378906],
                        [0.8228406310081482, 0.46281060576438904],
                        [0.8228558301925659, 0.477870911359787],
                        [0.5288397669792175, 0.47811299562454224],
                    ],
                    [
                        [0.11712637543678284, 0.48059460520744324],
                        [0.4073961675167084, 0.4803555905818939],
                        [0.4074084162712097, 0.49457648396492004],
                        [0.11713717877864838, 0.4948154091835022],
                    ],
                    [
                        [0.5484741926193237, 0.4807139039039612],
                        [0.6861377954483032, 0.4806005656719208],
                        [0.6861506700515747, 0.4939801096916199],
                        [0.5484863519668579, 0.4940934181213379],
                    ],
                    [
                        [0.11742845177650452, 0.4978732168674469],
                        [0.44551169872283936, 0.4976031482219696],
                        [0.4455242156982422, 0.5119189023971558],
                        [0.11743932962417603, 0.5121889114379883],
                    ],
                    [
                        [0.5291838049888611, 0.4979912042617798],
                        [0.8772448301315308, 0.49770471453666687],
                        [0.8772604465484619, 0.5129046440124512],
                        [0.5291975736618042, 0.5131910443305969],
                    ],
                    [
                        [0.13863924145698547, 0.5157281160354614],
                        [0.17223113775253296, 0.5157004594802856],
                        [0.17223992943763733, 0.5269850492477417],
                        [0.1386478990316391, 0.5270127058029175],
                    ],
                    [
                        [0.5465580224990845, 0.5152292847633362],
                        [0.5813298225402832, 0.515200674533844],
                        [0.581340491771698, 0.5268094539642334],
                        [0.5465686321258545, 0.5268380641937256],
                    ],
                    [
                        [0.11727301776409149, 0.5328319668769836],
                        [0.3485530912876129, 0.5326416492462158],
                        [0.34856563806533813, 0.5475656986236572],
                        [0.11728435754776001, 0.5477558970451355],
                    ],
                    [
                        [0.5288372039794922, 0.5329232811927795],
                        [0.841554582118988, 0.532666027545929],
                        [0.8415697813034058, 0.5476800799369812],
                        [0.528850793838501, 0.547937273979187],
                    ],
                    [
                        [0.11711449176073074, 0.5503119230270386],
                        [0.359188437461853, 0.5501128435134888],
                        [0.35920077562332153, 0.5647050738334656],
                        [0.11712557822465897, 0.5649040937423706],
                    ],
                    [
                        [0.548812985420227, 0.5504220128059387],
                        [0.7708187699317932, 0.5502394437789917],
                        [0.7708331346511841, 0.5647611021995544],
                        [0.5488262176513672, 0.5649436116218567],
                    ],
                    [
                        [0.13666757941246033, 0.567818284034729],
                        [0.2901529371738434, 0.5676921010017395],
                        [0.29016491770744324, 0.5822749733924866],
                        [0.1366787552833557, 0.5824010968208313],
                    ],
                    [
                        [0.5288788676261902, 0.5678396821022034],
                        [0.7095448970794678, 0.5676911473274231],
                        [0.7095591425895691, 0.5823948979377747],
                        [0.5288921594619751, 0.5825434327125549],
                    ],
                    [
                        [0.1172904372215271, 0.5851229429244995],
                        [0.29146644473075867, 0.584979772567749],
                        [0.29147833585739136, 0.5994608402252197],
                        [0.11730144172906876, 0.5996039509773254],
                    ],
                    [
                        [0.5289654731750488, 0.5852156281471252],
                        [0.8654176592826843, 0.5849390625953674],
                        [0.8654326796531677, 0.5996338129043579],
                        [0.5289787650108337, 0.599910318851471],
                    ],
                    [
                        [0.11738621443510056, 0.6026663780212402],
                        [0.4680918753147125, 0.6023781895637512],
                        [0.46810492873191833, 0.6171497106552124],
                        [0.11739744246006012, 0.6174378991127014],
                    ],
                    [
                        [0.5484737157821655, 0.6026294231414795],
                        [0.6551870107650757, 0.6025417447090149],
                        [0.6552005410194397, 0.6168470978736877],
                        [0.5484867691993713, 0.6169347763061523],
                    ],
                    [
                        [0.13875769078731537, 0.6200168132781982],
                        [0.17148442566394806, 0.6199899315834045],
                        [0.1714935302734375, 0.631689190864563],
                        [0.13876666128635406, 0.6317160725593567],
                    ],
                    [
                        [0.528978168964386, 0.6200922131538391],
                        [0.8598424196243286, 0.6198204159736633],
                        [0.8598572611808777, 0.6343249678611755],
                        [0.5289912819862366, 0.6345967054367065],
                    ],
                    [
                        [0.11728788167238235, 0.6375731825828552],
                        [0.32420969009399414, 0.6374031901359558],
                        [0.32422128319740295, 0.6513302326202393],
                        [0.11729846149682999, 0.6515001654624939],
                    ],
                    [
                        [0.528844952583313, 0.6372896432876587],
                        [0.8009572625160217, 0.637066125869751],
                        [0.8009716868400574, 0.6515135765075684],
                        [0.5288580060005188, 0.6517370343208313],
                    ],
                    [
                        [0.11737754940986633, 0.6546530723571777],
                        [0.34040355682373047, 0.654469907283783],
                        [0.340415894985199, 0.6691709756851196],
                        [0.11738871783018112, 0.6693540215492249],
                    ],
                    [
                        [0.5288815498352051, 0.6548454761505127],
                        [0.8605999946594238, 0.6545731425285339],
                        [0.8606149554252625, 0.6692605018615723],
                        [0.52889484167099, 0.6695327758789062],
                    ],
                    [
                        [0.1173161193728447, 0.6723119020462036],
                        [0.2861950695514679, 0.672173261642456],
                        [0.2862071692943573, 0.6869421601295471],
                        [0.11732733994722366, 0.6870807409286499],
                    ],
                    [
                        [0.5502585768699646, 0.6723960638046265],
                        [0.5820000767707825, 0.6723700165748596],
                        [0.5820106267929077, 0.6838293671607971],
                        [0.5502690076828003, 0.683855414390564],
                    ],
                ],
            ],
            [
                '612',
                [
                    [
                        [0.5484603047370911, 0.29427605867385864],
                        [0.5671259164810181, 0.29426971077919006],
                        [0.5671374797821045, 0.30542755126953125],
                        [0.5484717488288879, 0.30543386936187744],
                    ],
                    [
                        [0.11739953607320786, 0.31127873063087463],
                        [0.3308405578136444, 0.31120696663856506],
                        [0.33085379004478455, 0.3252183198928833],
                        [0.11741165816783905, 0.3252895474433899],
                    ],
                    [
                        [0.5292320251464844, 0.31129544973373413],
                        [0.8363391757011414, 0.31119218468666077],
                        [0.8363558053970337, 0.3258412778377533],
                        [0.529246985912323, 0.3259437084197998],
                    ],
                    [
                        [0.11783845722675323, 0.32865309715270996],
                        [0.4486251771450043, 0.32854291796684265],
                        [0.4486396908760071, 0.3432038128376007],
                        [0.1178511455655098, 0.3433131277561188],
                    ],
                    [
                        [0.548748791217804, 0.32879939675331116],
                        [0.69132399559021, 0.32875192165374756],
                        [0.6913395524024963, 0.3430884778499603],
                        [0.5487635731697083, 0.3431355953216553],
                    ],
                    [
                        [0.13697639107704163, 0.3461417853832245],
                        [0.2917954921722412, 0.346090704202652],
                        [0.2918088436126709, 0.3604159653186798],
                        [0.13698889315128326, 0.3604666292667389],
                    ],
                    [
                        [0.5292794704437256, 0.3461415767669678],
                        [0.7950133681297302, 0.3460538983345032],
                        [0.7950299978256226, 0.3608661890029907],
                        [0.5292946100234985, 0.360953152179718],
                    ],
                    [
                        [0.11700266599655151, 0.3634711503982544],
                        [0.33217093348503113, 0.3634008467197418],
                        [0.33218488097190857, 0.3781508803367615],
                        [0.11701542139053345, 0.3782206177711487],
                    ],
                    [
                        [0.5288878679275513, 0.3635523319244385],
                        [0.8690479397773743, 0.3634411692619324],
                        [0.8690647482872009, 0.3781026303768158],
                        [0.5289028286933899, 0.3782128691673279],
                    ],
                    [
                        [0.1175794005393982, 0.3809092044830322],
                        [0.29484933614730835, 0.3808518350124359],
                        [0.29486218094825745, 0.39462509751319885],
                        [0.11759132146835327, 0.39468201994895935],
                    ],
                    [
                        [0.5486990213394165, 0.3810662627220154],
                        [0.7001944780349731, 0.38101726770401],
                        [0.7002090811729431, 0.3944286108016968],
                        [0.5487127900123596, 0.3944772481918335],
                    ],
                    [
                        [0.11755476146936417, 0.3983459770679474],
                        [0.42326220870018005, 0.39824801683425903],
                        [0.42327672243118286, 0.41303780674934387],
                        [0.11756756156682968, 0.41313493251800537],
                    ],
                    [
                        [0.5288810133934021, 0.3982558846473694],
                        [0.8714772462844849, 0.3981460928916931],
                        [0.8714942932128906, 0.4129539430141449],
                        [0.5288960933685303, 0.41306281089782715],
                    ],
                    [
                        [0.11747193336486816, 0.41591283679008484],
                        [0.39134055376052856, 0.4158259630203247],
                        [0.39135435223579407, 0.4300571084022522],
                        [0.11748424917459488, 0.4301432967185974],
                    ],
                    [
                        [0.5484759211540222, 0.41630372405052185],
                        [0.5678086876869202, 0.41629758477211],
                        [0.5678198337554932, 0.4270649552345276],
                        [0.5484870076179504, 0.4270710349082947],
                    ],
                    [
                        [0.11760229617357254, 0.43317538499832153],
                        [0.4125748872756958, 0.4330827295780182],
                        [0.4125887155532837, 0.44724929332733154],
                        [0.11761455237865448, 0.4473412036895752],
                    ],
                    [
                        [0.5290859937667847, 0.43312397599220276],
                        [0.7220125794410706, 0.4330633580684662],
                        [0.7220286726951599, 0.44775867462158203],
                        [0.5291010141372681, 0.4478187561035156],
                    ],
                    [
                        [0.13695412874221802, 0.45069459080696106],
                        [0.3548091948032379, 0.45062685012817383],
                        [0.3548220992088318, 0.4641289710998535],
                        [0.13696591556072235, 0.46419617533683777],
                    ],
                    [
                        [0.5291265845298767, 0.4506831765174866],
                        [0.7064904570579529, 0.45062804222106934],
                        [0.7065048813819885, 0.4638930857181549],
                        [0.5291401147842407, 0.4639478027820587],
                    ],
                    [
                        [0.11735090613365173, 0.4679478704929352],
                        [0.40484538674354553, 0.4678593575954437],
                        [0.40485960245132446, 0.48247963190078735],
                        [0.11736354976892471, 0.48256734013557434],
                    ],
                    [
                        [0.529015064239502, 0.46802252531051636],
                        [0.8074039220809937, 0.46793684363365173],
                        [0.807420551776886, 0.48271143436431885],
                        [0.5290301442146301, 0.4827963709831238],
                    ],
                    [
                        [0.11743703484535217, 0.4852711856365204],
                        [0.41629648208618164, 0.4851801097393036],
                        [0.41631096601486206, 0.49999570846557617],
                        [0.11744984984397888, 0.5000859498977661],
                    ],
                    [
                        [0.5485330820083618, 0.4856473505496979],
                        [0.667841374874115, 0.4856110215187073],
                        [0.6678557991981506, 0.49906936287879944],
                        [0.5485469102859497, 0.49910542368888855],
                    ],
                    [
                        [0.11741401255130768, 0.5029985308647156],
                        [0.3921779990196228, 0.5029156804084778],
                        [0.3921911418437958, 0.5164812803268433],
                        [0.11742574721574783, 0.5165634155273438],
                    ],
                    [
                        [0.5291287302970886, 0.5029622912406921],
                        [0.7862671613693237, 0.5028848052024841],
                        [0.786283552646637, 0.5175603628158569],
                        [0.5291436910629272, 0.5176371932029724],
                    ],
                    [
                        [0.11764444410800934, 0.5204112529754639],
                        [0.3707835078239441, 0.5203357338905334],
                        [0.37079644203186035, 0.5337838530540466],
                        [0.11765608191490173, 0.5338587164878845],
                    ],
                    [
                        [0.5290819406509399, 0.5205543041229248],
                        [0.7866629958152771, 0.5204774737358093],
                        [0.7866783142089844, 0.5341788530349731],
                        [0.5290959477424622, 0.5342550277709961],
                    ],
                    [
                        [0.11735165864229202, 0.537521481513977],
                        [0.361070841550827, 0.5374495387077332],
                        [0.36108511686325073, 0.5523573756217957],
                        [0.1173645555973053, 0.552428662776947],
                    ],
                    [
                        [0.5292291045188904, 0.5378974080085754],
                        [0.8268585205078125, 0.5378095507621765],
                        [0.8268750905990601, 0.5524308681488037],
                        [0.529244065284729, 0.5525178909301758],
                    ],
                    [
                        [0.11733561009168625, 0.5553855299949646],
                        [0.4282231330871582, 0.5552947521209717],
                        [0.4282371997833252, 0.5695924162864685],
                        [0.11734797805547714, 0.5696823596954346],
                    ],
                    [
                        [0.5489091873168945, 0.5555323958396912],
                        [0.6579434871673584, 0.5555006265640259],
                        [0.6579588651657104, 0.569879949092865],
                        [0.5489239692687988, 0.5699114799499512],
                    ],
                    [
                        [0.11739346385002136, 0.5722740292549133],
                        [0.35950297117233276, 0.572204053401947],
                        [0.35951730608940125, 0.5871737599372864],
                        [0.11740642040967941, 0.5872430205345154],
                    ],
                ],
            ],
            [
                '611',
                [
                    [
                        [0.8341353535652161, 0.049333762377500534],
                        [0.8748556971549988, 0.049347758293151855],
                        [0.8748601078987122, 0.05998111143708229],
                        [0.8341395854949951, 0.059967052191495895],
                    ],
                    [
                        [0.11730948835611343, 0.08493485301733017],
                        [0.31646227836608887, 0.08500436693429947],
                        [0.3164653778076172, 0.09925291687250137],
                        [0.11731155216693878, 0.09918298572301865],
                    ],
                    [
                        [0.5283418893814087, 0.08486701548099518],
                        [0.8733969330787659, 0.08498743176460266],
                        [0.8734028339385986, 0.0993872806429863],
                        [0.5283461213111877, 0.09926611930131912],
                    ],
                    [
                        [0.11754436790943146, 0.10176283866167068],
                        [0.4678739607334137, 0.10188598930835724],
                        [0.46787798404693604, 0.11676937341690063],
                        [0.11754652857780457, 0.116645447909832],
                    ],
                    [
                        [0.5502009391784668, 0.1022486686706543],
                        [0.5675550103187561, 0.10225477069616318],
                        [0.5675584673881531, 0.11356953531503677],
                        [0.550204336643219, 0.1135634034872055],
                    ],
                    [
                        [0.5481369495391846, 0.851859450340271],
                        [0.5672919154167175, 0.8518683314323425],
                        [0.5672953128814697, 0.8630244135856628],
                        [0.5481402277946472, 0.8630155324935913],
                    ],
                    [
                        [0.5284225344657898, 0.11973181366920471],
                        [0.8389109373092651, 0.11984178423881531],
                        [0.8389155268669128, 0.13136284053325653],
                        [0.528425931930542, 0.13125233352184296],
                    ],
                    [
                        [0.11727000027894974, 0.13693402707576752],
                        [0.3704322874546051, 0.13702434301376343],
                        [0.3704354763031006, 0.15063175559043884],
                        [0.11727197468280792, 0.15054091811180115],
                    ],
                    [
                        [0.5483099222183228, 0.1369810700416565],
                        [0.6713528633117676, 0.13702496886253357],
                        [0.6713575720787048, 0.15076903998851776],
                        [0.5483139753341675, 0.1507248878479004],
                    ],
                    [
                        [0.11731875687837601, 0.15434075891971588],
                        [0.33276787400245667, 0.15441817045211792],
                        [0.33277106285095215, 0.16878782212734222],
                        [0.11732084304094315, 0.16870993375778198],
                    ],
                    [
                        [0.5286067128181458, 0.15447428822517395],
                        [0.8411226272583008, 0.15458659827709198],
                        [0.8411285281181335, 0.16928917169570923],
                        [0.5286110043525696, 0.16917617619037628],
                    ],
                    [
                        [0.11734869331121445, 0.17163033783435822],
                        [0.46400681138038635, 0.1717558056116104],
                        [0.4640108048915863, 0.1866660863161087],
                        [0.11735086143016815, 0.18653984367847443],
                    ],
                    [
                        [0.5285969972610474, 0.17167069017887115],
                        [0.7276431322097778, 0.1717427372932434],
                        [0.7276484966278076, 0.18654027581214905],
                        [0.528601348400116, 0.18646779656410217],
                    ],
                    [
                        [0.1173996776342392, 0.1892222762107849],
                        [0.31731095910072327, 0.18929515779018402],
                        [0.31731393933296204, 0.2030324786901474],
                        [0.11740167438983917, 0.20295919477939606],
                    ],
                    [
                        [0.5285493731498718, 0.18927918374538422],
                        [0.7962176203727722, 0.18937677145004272],
                        [0.7962233424186707, 0.20408359169960022],
                        [0.5285536646842957, 0.20398542284965515],
                    ],
                    [
                        [0.11721768230199814, 0.20655883848667145],
                        [0.4414297044277191, 0.2066778838634491],
                        [0.4414336085319519, 0.22168968617916107],
                        [0.11721986532211304, 0.22156992554664612],
                    ],
                    [
                        [0.5283336043357849, 0.20649389922618866],
                        [0.7336137890815735, 0.20656925439834595],
                        [0.733619213104248, 0.22144632041454315],
                        [0.5283379554748535, 0.22137050330638885],
                    ],
                    [
                        [0.11718340963125229, 0.22416526079177856],
                        [0.4546521306037903, 0.22429004311561584],
                        [0.4546559453010559, 0.23870164155960083],
                        [0.11718550324440002, 0.23857611417770386],
                    ],
                    [
                        [0.5285847187042236, 0.22420184314250946],
                        [0.760574221611023, 0.22428762912750244],
                        [0.7605796456336975, 0.23875530064105988],
                        [0.5285888910293579, 0.2386690229177475],
                    ],
                    [
                        [0.5502099394798279, 0.7819739580154419],
                        [0.5675763487815857, 0.7819818258285522],
                        [0.5675796866416931, 0.7930270433425903],
                        [0.5502132177352905, 0.79301917552948],
                    ],
                    [
                        [0.5287665724754333, 0.2414492964744568],
                        [0.8324755430221558, 0.2415623813867569],
                        [0.832481324672699, 0.2561744153499603],
                        [0.5287708044052124, 0.2560606896877289],
                    ],
                    [
                        [0.11731552332639694, 0.25914809107780457],
                        [0.38686326146125793, 0.25924918055534363],
                        [0.3868667483329773, 0.2736753225326538],
                        [0.11731761693954468, 0.2735736668109894],
                    ],
                    [
                        [0.5285224914550781, 0.25837668776512146],
                        [0.819832444190979, 0.25848588347435],
                        [0.819838285446167, 0.2732686400413513],
                        [0.528526782989502, 0.2731587886810303],
                    ],
                    [
                        [0.117284394800663, 0.2762688398361206],
                        [0.4090365469455719, 0.2763789892196655],
                        [0.4090401828289032, 0.29098746180534363],
                        [0.11728651076555252, 0.2908766567707062],
                    ],
                    [
                        [0.5288700461387634, 0.2762502431869507],
                        [0.7814770340919495, 0.2763456106185913],
                        [0.7814826369285583, 0.29110845923423767],
                        [0.528874397277832, 0.2910125255584717],
                    ],
                    [
                        [0.11722174286842346, 0.2938423156738281],
                        [0.3869653642177582, 0.2939448952674866],
                        [0.3869688808917999, 0.30850186944007874],
                        [0.11722385138273239, 0.3083987534046173],
                    ],
                    [
                        [0.5285590291023254, 0.2935402989387512],
                        [0.8711086511611938, 0.29367050528526306],
                        [0.8711149096488953, 0.3087359070777893],
                        [0.5285634398460388, 0.3086049258708954],
                    ],
                    [
                        [0.11733774840831757, 0.311129629611969],
                        [0.34237971901893616, 0.3112157881259918],
                        [0.3423830568790436, 0.32603612542152405],
                        [0.11733989417552948, 0.325949490070343],
                    ],
                    [
                        [0.5483396053314209, 0.31137630343437195],
                        [0.5833972096443176, 0.3113897144794464],
                        [0.5834007263183594, 0.3227638602256775],
                        [0.5483430027961731, 0.32275038957595825],
                    ],
                    [
                        [0.11732819676399231, 0.32831257581710815],
                        [0.4059726595878601, 0.32842379808425903],
                        [0.40597641468048096, 0.34358081221580505],
                        [0.117330402135849, 0.34346893429756165],
                    ],
                    [
                        [0.5287013649940491, 0.3285132944583893],
                        [0.8622080683708191, 0.328641802072525],
                        [0.8622140288352966, 0.3432392477989197],
                        [0.5287055969238281, 0.34311002492904663],
                    ],
                    [
                        [0.11724479496479034, 0.345952570438385],
                        [0.46815237402915955, 0.346088707447052],
                        [0.4681563675403595, 0.3609229624271393],
                        [0.11724694818258286, 0.3607860505580902],
                    ],
                    [
                        [0.550164520740509, 0.3460303843021393],
                        [0.5678519010543823, 0.34603723883628845],
                        [0.5678554177284241, 0.35764503479003906],
                        [0.550167977809906, 0.3576381504535675],
                    ],
                    [
                        [0.13629016280174255, 0.36374738812446594],
                        [0.1465027779340744, 0.3637513816356659],
                        [0.1465045064687729, 0.37489062547683716],
                        [0.13629186153411865, 0.3748866021633148],
                    ],
                ],
            ],
            [
                '16',
                [
                    [
                        [0.25865834951400757, 0.39538687467575073],
                        [0.867745041847229, 0.3957039713859558],
                        [0.8677415251731873, 0.41063567996025085],
                        [0.2586528956890106, 0.4103173315525055],
                    ],
                    [
                        [0.25845012068748474, 0.41278666257858276],
                        [0.8525195717811584, 0.4130973219871521],
                        [0.8525159358978271, 0.4282790720462799],
                        [0.25844454765319824, 0.4279671907424927],
                    ],
                    [
                        [0.258639395236969, 0.42995530366897583],
                        [0.8076174855232239, 0.4302436411380768],
                        [0.807613730430603, 0.4453990161418915],
                        [0.2586338520050049, 0.4451095759868622],
                    ],
                    [
                        [0.2585821747779846, 0.448221355676651],
                        [0.37349241971969604, 0.44828200340270996],
                        [0.3734886050224304, 0.45941776037216187],
                        [0.2585780918598175, 0.4593569338321686],
                    ],
                    [
                        [0.2581893801689148, 0.4822094142436981],
                        [0.8027880787849426, 0.48249927163124084],
                        [0.8027842044830322, 0.49805933237075806],
                        [0.25818368792533875, 0.4977683424949646],
                    ],
                    [
                        [0.25836417078971863, 0.49981415271759033],
                        [0.862753689289093, 0.5001372694969177],
                        [0.8627501130104065, 0.5154175162315369],
                        [0.25835856795310974, 0.515093207359314],
                    ],
                    [
                        [0.25816619396209717, 0.5172508358955383],
                        [0.7922190427780151, 0.5175375938415527],
                        [0.7922152280807495, 0.5328376293182373],
                        [0.2581605911254883, 0.5325497984886169],
                    ],
                    [
                        [0.2585413157939911, 0.534797191619873],
                        [0.8132326602935791, 0.535096287727356],
                        [0.813228964805603, 0.5498083233833313],
                        [0.2585359215736389, 0.5495080947875977],
                    ],
                    [
                        [0.2582751512527466, 0.5522403120994568],
                        [0.8535034656524658, 0.5525626540184021],
                        [0.8534997701644897, 0.5678305625915527],
                        [0.2582695782184601, 0.5675069689750671],
                    ],
                    [
                        [0.258350670337677, 0.5700415968894958],
                        [0.34214067459106445, 0.570087194442749],
                        [0.34213560819625854, 0.5846711993217468],
                        [0.2583453357219696, 0.5846254229545593],
                    ],
                    [
                        [0.11678421497344971, 0.6215866208076477],
                        [0.19948093593120575, 0.6216321587562561],
                        [0.19947569072246552, 0.6354485154151917],
                        [0.11677873879671097, 0.6354027986526489],
                    ],
                    [
                        [0.2581576108932495, 0.6216781139373779],
                        [0.7916433215141296, 0.6219719648361206],
                        [0.791639506816864, 0.6371142268180847],
                        [0.2581520676612854, 0.6368192434310913],
                    ],
                    [
                        [0.25830045342445374, 0.6391258835792542],
                        [0.8319234251976013, 0.6394432187080383],
                        [0.83191978931427, 0.6544579267501831],
                        [0.258294939994812, 0.6541393995285034],
                    ],
                    [
                        [0.25857746601104736, 0.6562539339065552],
                        [0.8652228713035583, 0.6565908789634705],
                        [0.865219235420227, 0.6720134615898132],
                        [0.2585718333721161, 0.6716752052307129],
                    ],
                ],
            ],
            [
                '607',
                [
                    [
                        [0.8341076374053955, 0.04950566589832306],
                        [0.8747017979621887, 0.04947446659207344],
                        [0.8747145533561707, 0.06001976132392883],
                        [0.8341203331947327, 0.06005087494850159],
                    ],
                    [
                        [0.11684777587652206, 0.0848749503493309],
                        [0.391655296087265, 0.08466561138629913],
                        [0.3916676342487335, 0.0962291732430458],
                        [0.11685912311077118, 0.09643788635730743],
                    ],
                    [
                        [0.528802752494812, 0.08504627645015717],
                        [0.8476735949516296, 0.08480340987443924],
                        [0.8476909399032593, 0.09918421506881714],
                        [0.528818666934967, 0.09942618757486343],
                    ],
                    [
                        [0.13698965311050415, 0.1022171676158905],
                        [0.25861358642578125, 0.10212493687868118],
                        [0.2586287558078766, 0.11693748086690903],
                        [0.1370042860507965, 0.11702936142683029],
                    ],
                    [
                        [0.5289585590362549, 0.10186363756656647],
                        [0.841900110244751, 0.10162631422281265],
                        [0.8419169783592224, 0.1156347468495369],
                        [0.5289740562438965, 0.11587121337652206],
                    ],
                    [
                        [0.11683644354343414, 0.11975971609354019],
                        [0.4114542603492737, 0.11953730136156082],
                        [0.4114668369293213, 0.13128149509429932],
                        [0.11684796214103699, 0.13150322437286377],
                    ],
                    [
                        [0.5483786463737488, 0.12038567662239075],
                        [0.5994965434074402, 0.12034709751605988],
                        [0.5995088219642639, 0.13120362162590027],
                        [0.5483907461166382, 0.13124209642410278],
                    ],
                    [
                        [0.13701476156711578, 0.13702796399593353],
                        [0.2594112455844879, 0.1369359791278839],
                        [0.25942614674568176, 0.1514778733253479],
                        [0.13702911138534546, 0.15156951546669006],
                    ],
                    [
                        [0.5288683772087097, 0.13681194186210632],
                        [0.8042880892753601, 0.13660496473312378],
                        [0.8043020963668823, 0.14834167063236237],
                        [0.5288813710212708, 0.14854802191257477],
                    ],
                    [
                        [0.11706425994634628, 0.15462681651115417],
                        [0.28925883769989014, 0.15449801087379456],
                        [0.2892737090587616, 0.1688777357339859],
                        [0.11707836389541626, 0.16900606453418732],
                    ],
                    [
                        [0.5492212176322937, 0.15471531450748444],
                        [0.832770586013794, 0.1545032113790512],
                        [0.8327881693840027, 0.16912652552127838],
                        [0.5492375493049622, 0.16933780908584595],
                    ],
                    [
                        [0.11701343953609467, 0.1716623455286026],
                        [0.2884461283683777, 0.1715346723794937],
                        [0.28846147656440735, 0.1863672137260437],
                        [0.11702799052000046, 0.1864943951368332],
                    ],
                    [
                        [0.529115617275238, 0.17157171666622162],
                        [0.8571137189865112, 0.17132745683193207],
                        [0.8571320176124573, 0.18650171160697937],
                        [0.5291324257850647, 0.18674500286579132],
                    ],
                    [
                        [0.11707699298858643, 0.18938873708248138],
                        [0.43662184476852417, 0.1891518533229828],
                        [0.43663766980171204, 0.2038012146949768],
                        [0.11709136515855789, 0.2040371596813202],
                    ],
                    [
                        [0.5482608675956726, 0.1896515190601349],
                        [0.7471073269844055, 0.18950414657592773],
                        [0.7471228837966919, 0.20275478065013885],
                        [0.5482756495475769, 0.20290164649486542],
                    ],
                    [
                        [0.11700291186571121, 0.20660091936588287],
                        [0.33333009481430054, 0.20644128322601318],
                        [0.33334553241729736, 0.22118762135505676],
                        [0.11701738089323044, 0.2213466316461563],
                    ],
                    [
                        [0.5289604663848877, 0.20666489005088806],
                        [0.8779447078704834, 0.20640739798545837],
                        [0.8779626488685608, 0.22120055556297302],
                        [0.5289768576622009, 0.22145704925060272],
                    ],
                    [
                        [0.11709224432706833, 0.22422300279140472],
                        [0.40995675325393677, 0.22400791943073273],
                        [0.4099723994731903, 0.238612100481987],
                        [0.11710657179355621, 0.23882634937763214],
                    ],
                    [
                        [0.5481463074684143, 0.22447647154331207],
                        [0.5832884907722473, 0.22445066273212433],
                        [0.5833012461662292, 0.23578466475009918],
                        [0.5481589436531067, 0.23581038415431976],
                    ],
                    [
                        [0.1171128898859024, 0.24154731631278992],
                        [0.38460272550582886, 0.24135176837444305],
                        [0.38461798429489136, 0.25570178031921387],
                        [0.11712697148323059, 0.25589656829833984],
                    ],
                    [
                        [0.5285390019416809, 0.24125203490257263],
                        [0.7381218671798706, 0.2410988211631775],
                        [0.7381395697593689, 0.2561747133731842],
                        [0.528555691242218, 0.2563273012638092],
                    ],
                    [
                        [0.11751222610473633, 0.25905007123947144],
                        [0.33153393864631653, 0.25889432430267334],
                        [0.33154839277267456, 0.272705078125],
                        [0.11752577871084213, 0.27286022901535034],
                    ],
                    [
                        [0.5284278988838196, 0.2591264545917511],
                        [0.7117865681648254, 0.2589930593967438],
                        [0.7118026614189148, 0.27281370759010315],
                        [0.5284432172775269, 0.2729465961456299],
                    ],
                    [
                        [0.11697975546121597, 0.2763148844242096],
                        [0.4526592791080475, 0.27607178688049316],
                        [0.4526754319667816, 0.29096096754074097],
                        [0.11699435859918594, 0.291203111410141],
                    ],
                    [
                        [0.5284129977226257, 0.2763480544090271],
                        [0.8522149324417114, 0.2761135697364807],
                        [0.8522317409515381, 0.29001232981681824],
                        [0.5284283757209778, 0.2902459502220154],
                    ],
                    [
                        [0.1388535350561142, 0.29415398836135864],
                        [0.18130949139595032, 0.29412341117858887],
                        [0.18132063746452332, 0.3052676022052765],
                        [0.13886453211307526, 0.3052981197834015],
                    ],
                    [
                        [0.5286356210708618, 0.2940259575843811],
                        [0.6463304758071899, 0.2939411401748657],
                        [0.6463459134101868, 0.30744484066963196],
                        [0.5286505818367004, 0.30752936005592346],
                    ],
                    [
                        [0.11699212342500687, 0.3112276494503021],
                        [0.40343403816223145, 0.31102216243743896],
                        [0.40344980359077454, 0.3257600963115692],
                        [0.1170065775513649, 0.3259647786617279],
                    ],
                    [
                        [0.5287455320358276, 0.3110778033733368],
                        [0.8644229173660278, 0.3108370006084442],
                        [0.8644410371780396, 0.32578983902931213],
                        [0.5287621021270752, 0.3260296583175659],
                    ],
                    [
                        [0.11715570092201233, 0.328623503446579],
                        [0.29888075590133667, 0.32849374413490295],
                        [0.29889506101608276, 0.3423020541667938],
                        [0.11716925352811813, 0.34243133664131165],
                    ],
                    [
                        [0.5501982569694519, 0.32880136370658875],
                        [0.5931203961372375, 0.3287707269191742],
                        [0.5931335091590881, 0.3403632342815399],
                        [0.5502111911773682, 0.3403937816619873],
                    ],
                    [
                        [0.11704261600971222, 0.3460463583469391],
                        [0.46511149406433105, 0.3457990288734436],
                        [0.46512433886528015, 0.3576051592826843],
                        [0.11705419421195984, 0.35785168409347534],
                    ],
                    [
                        [0.5283166766166687, 0.34610801935195923],
                        [0.8153056502342224, 0.3459041118621826],
                        [0.8153233528137207, 0.36070185899734497],
                        [0.5283330678939819, 0.3609049320220947],
                    ],
                    [
                        [0.13675501942634583, 0.36363106966018677],
                        [0.3393580913543701, 0.36348778009414673],
                        [0.3393702507019043, 0.3750822842121124],
                        [0.1367664635181427, 0.37522509694099426],
                    ],
                ],
            ],
            [
                '614',
                [
                    [
                        [0.5287837982177734, 0.7990202307701111],
                        [0.7128459215164185, 0.7989741563796997],
                        [0.7128623127937317, 0.8127047419548035],
                        [0.5287993550300598, 0.8127502202987671],
                    ],
                    [
                        [0.1369658261537552, 0.8166801929473877],
                        [0.2827532887458801, 0.8166442513465881],
                        [0.28276756405830383, 0.8302209973335266],
                        [0.13697947561740875, 0.8302565217018127],
                    ],
                    [
                        [0.5290428996086121, 0.8165921568870544],
                        [0.7715634703636169, 0.8165323734283447],
                        [0.7715803384780884, 0.8304535150527954],
                        [0.5290586352348328, 0.8305126428604126],
                    ],
                    [
                        [0.11705274134874344, 0.8338226675987244],
                        [0.41683825850486755, 0.8337497711181641],
                        [0.4168541729450226, 0.8482898473739624],
                        [0.11706726253032684, 0.8483618497848511],
                    ],
                    [
                        [0.5289520621299744, 0.8338783383369446],
                        [0.7952268123626709, 0.8338136076927185],
                        [0.7952448129653931, 0.8485907316207886],
                        [0.5289687514305115, 0.8486546874046326],
                    ],
                    [
                        [0.13736334443092346, 0.8513391613960266],
                        [0.46655499935150146, 0.8512603044509888],
                        [0.46657171845436096, 0.8662939071655273],
                        [0.13737845420837402, 0.8663718104362488],
                    ],
                    [
                        [0.528770923614502, 0.8513702154159546],
                        [0.82704097032547, 0.8512987494468689],
                        [0.8270592093467712, 0.8661535978317261],
                        [0.5287877321243286, 0.8662242293357849],
                    ],
                    [
                        [0.13684384524822235, 0.8687235116958618],
                        [0.2838359475135803, 0.8686888217926025],
                        [0.28385129570961, 0.883262038230896],
                        [0.1368584930896759, 0.8832963109016418],
                    ],
                    [
                        [0.5486975908279419, 0.8684746026992798],
                        [0.8034294843673706, 0.8684144020080566],
                        [0.8034480810165405, 0.8836352229118347],
                        [0.5487149357795715, 0.883694589138031],
                    ],
                    [
                        [0.11734895408153534, 0.8863391280174255],
                        [0.4663715660572052, 0.8862579464912415],
                        [0.46638673543930054, 0.8999024033546448],
                        [0.11736258119344711, 0.8999826908111572],
                    ],
                    [
                        [0.5485647320747375, 0.8866576552391052],
                        [0.6570736765861511, 0.8866324424743652],
                        [0.6570904850959778, 0.9009303450584412],
                        [0.5485810041427612, 0.9009552597999573],
                    ],
                    [
                        [0.52895188331604, 0.9033801555633545],
                        [0.8602056503295898, 0.9033042192459106],
                        [0.8602241277694702, 0.9182170629501343],
                        [0.5289687514305115, 0.9182920455932617],
                    ],
                ],
            ],
            [
                '522',
                [
                    [
                        [0.595744252204895, 0.07511641830205917],
                        [0.8744735717773438, 0.07509498298168182],
                        [0.874477744102478, 0.08740819990634918],
                        [0.5957474708557129, 0.087429478764534],
                    ],
                    [
                        [0.11786726862192154, 0.08939261734485626],
                        [0.1796269416809082, 0.089387908577919],
                        [0.17962880432605743, 0.10204609483480453],
                        [0.11786892265081406, 0.1020507663488388],
                    ],
                    [
                        [0.11748236417770386, 0.12825319170951843],
                        [0.5043519139289856, 0.12822440266609192],
                        [0.5043557286262512, 0.14423471689224243],
                        [0.117484450340271, 0.14426320791244507],
                    ],
                    [
                        [0.11842048168182373, 0.10522926598787308],
                        [0.7775676846504211, 0.10517951101064682],
                        [0.777573823928833, 0.12493972480297089],
                        [0.11842306703329086, 0.1249888613820076],
                    ],
                    [
                        [0.11685457825660706, 0.1972799152135849],
                        [0.7598163485527039, 0.19723418354988098],
                        [0.7598202228546143, 0.20982876420021057],
                        [0.11685622483491898, 0.20987410843372345],
                    ],
                    [
                        [0.22747181355953217, 0.21156126260757446],
                        [0.8549661636352539, 0.21151705086231232],
                        [0.8549705147743225, 0.22458645701408386],
                        [0.2274739146232605, 0.22463028132915497],
                    ],
                    [
                        [0.2270117551088333, 0.22645409405231476],
                        [0.8759012222290039, 0.22640883922576904],
                        [0.8759053945541382, 0.2388768196105957],
                        [0.2270137518644333, 0.23892170190811157],
                    ],
                    [
                        [0.22770710289478302, 0.2408827692270279],
                        [0.8732986450195312, 0.2408381849527359],
                        [0.8733029365539551, 0.253549188375473],
                        [0.22770914435386658, 0.253593385219574],
                    ],
                    [
                        [0.2275959849357605, 0.25554370880126953],
                        [0.8565458059310913, 0.2555007040500641],
                        [0.8565499782562256, 0.2680078446865082],
                        [0.22759798169136047, 0.26805049180984497],
                    ],
                    [
                        [0.22760125994682312, 0.27010878920555115],
                        [0.3709335923194885, 0.27009907364845276],
                        [0.3709360361099243, 0.2823740839958191],
                        [0.2276032418012619, 0.2823837101459503],
                    ],
                    [
                        [0.1171220913529396, 0.2999719977378845],
                        [0.20202527940273285, 0.29996636509895325],
                        [0.20202729105949402, 0.3131088316440582],
                        [0.1171238049864769, 0.3131144046783447],
                    ],
                    [
                        [0.2579531967639923, 0.29898571968078613],
                        [0.8688451647758484, 0.29894521832466125],
                        [0.868849515914917, 0.3118290901184082],
                        [0.2579553723335266, 0.31186923384666443],
                    ],
                    [
                        [0.1169658899307251, 0.31547456979751587],
                        [0.15341056883335114, 0.31547218561172485],
                        [0.1534120738506317, 0.3261736333370209],
                        [0.11696729063987732, 0.3261760175228119],
                    ],
                    [
                        [0.2583405375480652, 0.3133973479270935],
                        [0.5863584876060486, 0.3133758008480072],
                        [0.5863617062568665, 0.3257220387458801],
                        [0.2583426237106323, 0.3257433772087097],
                    ],
                    [
                        [0.25852954387664795, 0.32780367136001587],
                        [0.5742512941360474, 0.32778316736221313],
                        [0.5742545127868652, 0.34038394689559937],
                        [0.2585316598415375, 0.3404042720794678],
                    ],
                    [
                        [0.2733437418937683, 0.3578830063343048],
                        [0.846301794052124, 0.35784661769866943],
                        [0.8463059067726135, 0.3705071210861206],
                        [0.2733459174633026, 0.3705431818962097],
                    ],
                ],
            ],
            [
                '609',
                [
                    [
                        [0.5291017889976501, 0.537590503692627],
                        [0.8036250472068787, 0.5376003980636597],
                        [0.8036344647407532, 0.5524416565895081],
                        [0.5291098356246948, 0.5524312853813171],
                    ],
                    [
                        [0.1367311179637909, 0.5550975203514099],
                        [0.42436301708221436, 0.5551084280014038],
                        [0.4243703782558441, 0.5696836113929749],
                        [0.13673703372478485, 0.569672167301178],
                    ],
                    [
                        [0.5289247632026672, 0.5551561117172241],
                        [0.8654918074607849, 0.5551689267158508],
                        [0.8654993176460266, 0.5666041374206543],
                        [0.5289309620857239, 0.5665909051895142],
                    ],
                    [
                        [0.13664835691452026, 0.8516075611114502],
                        [0.3889179825782776, 0.8516259789466858],
                        [0.38892513513565063, 0.8661301136016846],
                        [0.13665425777435303, 0.8661112785339355],
                    ],
                    [
                        [0.5482412576675415, 0.5726307034492493],
                        [0.6771198511123657, 0.5726358890533447],
                        [0.6771286725997925, 0.5875320434570312],
                        [0.5482494235038757, 0.5875266194343567],
                    ],
                    [
                        [0.13697877526283264, 0.8685398697853088],
                        [0.3305284380912781, 0.8685543537139893],
                        [0.3305354416370392, 0.8833777904510498],
                        [0.13698481023311615, 0.8833629488945007],
                    ],
                    [
                        [0.529139518737793, 0.5899690985679626],
                        [0.7212896943092346, 0.5899772047996521],
                        [0.7212985157966614, 0.6045372486114502],
                        [0.5291473865509033, 0.6045288443565369],
                    ],
                    [
                        [0.11729679256677628, 0.6072638034820557],
                        [0.45010828971862793, 0.6072785258293152],
                        [0.4501153826713562, 0.6210793852806091],
                        [0.1173023134469986, 0.6210641264915466],
                    ],
                    [
                        [0.5290926098823547, 0.6073576211929321],
                        [0.6806379556655884, 0.6073643565177917],
                        [0.680646538734436, 0.6218339204788208],
                        [0.5291004180908203, 0.6218269467353821],
                    ],
                    [
                        [0.11722571402788162, 0.6247422099113464],
                        [0.36410224437713623, 0.6247536540031433],
                        [0.3641093373298645, 0.6394447684288025],
                        [0.117231585085392, 0.639432966709137],
                    ],
                    [
                        [0.5290716886520386, 0.6244890093803406],
                        [0.7574979066848755, 0.6244995594024658],
                        [0.7575069069862366, 0.6390447616577148],
                        [0.5290795564651489, 0.6390337944030762],
                    ],
                    [
                        [0.1367350071668625, 0.6424604654312134],
                        [0.29129502177238464, 0.6424679160118103],
                        [0.29130175709724426, 0.6571397185325623],
                        [0.13674096763134003, 0.6571320295333862],
                    ],
                    [
                        [0.529080331325531, 0.6422595977783203],
                        [0.8719264268875122, 0.6422761678695679],
                        [0.871936023235321, 0.6568669080734253],
                        [0.5290882587432861, 0.65684974193573],
                    ],
                    [
                        [0.11744192987680435, 0.659741997718811],
                        [0.3312167823314667, 0.6597527861595154],
                        [0.3312236964702606, 0.6743791699409485],
                        [0.11744777858257294, 0.6743680834770203],
                    ],
                    [
                        [0.5290715098381042, 0.6598595380783081],
                        [0.673356831073761, 0.6598668098449707],
                        [0.6733646988868713, 0.6731978058815002],
                        [0.5290787220001221, 0.6731902956962585],
                    ],
                    [
                        [0.11747340112924576, 0.6771173477172852],
                        [0.46507591009140015, 0.6771355867385864],
                        [0.46508359909057617, 0.6919803023338318],
                        [0.1174793392419815, 0.6919614672660828],
                    ],
                    [
                        [0.529166042804718, 0.6771457195281982],
                        [0.8514028787612915, 0.6771626472473145],
                        [0.8514123558998108, 0.6917372345924377],
                        [0.5291739702224731, 0.6917197704315186],
                    ],
                    [
                        [0.11744149029254913, 0.6943546533584595],
                        [0.4470895826816559, 0.6943726539611816],
                        [0.44709712266921997, 0.7090851068496704],
                        [0.1174473688006401, 0.7090665698051453],
                    ],
                    [
                        [0.5290089249610901, 0.6941955089569092],
                        [0.72055584192276, 0.6942059397697449],
                        [0.7205650806427002, 0.7095362544059753],
                        [0.5290172100067139, 0.709525465965271],
                    ],
                    [
                        [0.13691845536231995, 0.7120182514190674],
                        [0.22024211287498474, 0.7120229601860046],
                        [0.22024808824062347, 0.7257513999938965],
                        [0.13692402839660645, 0.7257465124130249],
                    ],
                    [
                        [0.5290922522544861, 0.7119210362434387],
                        [0.8206313252449036, 0.7119375467300415],
                        [0.8206409215927124, 0.726941704750061],
                        [0.5291003584861755, 0.7269247174263],
                    ],
                    [
                        [0.11747431010007858, 0.7292729616165161],
                        [0.33649566769599915, 0.7292858362197876],
                        [0.33650264143943787, 0.7439609169960022],
                        [0.11748018115758896, 0.7439476847648621],
                    ],
                    [
                        [0.5487882494926453, 0.7296819090843201],
                        [0.6768372058868408, 0.7296894192695618],
                        [0.6768450140953064, 0.7428879141807556],
                        [0.5487954616546631, 0.7428802251815796],
                    ],
                    [
                        [0.11727689951658249, 0.7468679547309875],
                        [0.4099022448062897, 0.7468857169151306],
                        [0.4099080264568329, 0.7584537863731384],
                        [0.11728151887655258, 0.7584356665611267],
                    ],
                    [
                        [0.5290282964706421, 0.7469418048858643],
                        [0.7937767505645752, 0.7469578385353088],
                        [0.7937862277030945, 0.7619442343711853],
                        [0.5290364027023315, 0.7619276642799377],
                    ],
                    [
                        [0.13678863644599915, 0.7640299797058105],
                        [0.36135929822921753, 0.7640440464019775],
                        [0.36136654019355774, 0.77900630235672],
                        [0.13679471611976624, 0.7789918184280396],
                    ],
                    [
                        [0.5289238095283508, 0.764071524143219],
                        [0.8779053688049316, 0.7640933394432068],
                        [0.8779150247573853, 0.7786663174629211],
                        [0.5289316773414612, 0.7786438465118408],
                    ],
                    [
                        [0.11737138032913208, 0.7812939882278442],
                        [0.3095238208770752, 0.7813064455986023],
                        [0.30953043699264526, 0.7955321669578552],
                        [0.11737706512212753, 0.7955194115638733],
                    ],
                    [
                        [0.5291100144386292, 0.7817325592041016],
                        [0.8696622252464294, 0.7817546129226685],
                        [0.8696717023849487, 0.7961747050285339],
                        [0.5291178226470947, 0.7961521148681641],
                    ],
                    [
                        [0.11722607910633087, 0.798953115940094],
                        [0.4375298023223877, 0.7989745140075684],
                        [0.4375373125076294, 0.813724935054779],
                        [0.11723197996616364, 0.8137030005455017],
                    ],
                    [
                        [0.5491352081298828, 0.7986217141151428],
                        [0.8009130954742432, 0.7986385226249695],
                        [0.8009206056594849, 0.8105630278587341],
                        [0.5491417050361633, 0.8105458617210388],
                    ],
                ],
            ],
            [
                '613',
                [
                    [
                        [0.11755459755659103, 0.3111637532711029],
                        [0.2840621769428253, 0.31110069155693054],
                        [0.28407663106918335, 0.32578134536743164],
                        [0.11756817996501923, 0.3258439302444458],
                    ],
                    [
                        [0.529325008392334, 0.3111093044281006],
                        [0.834138810634613, 0.31099390983581543],
                        [0.8341565728187561, 0.3261016011238098],
                        [0.5293411612510681, 0.3262161612510681],
                    ],
                    [
                        [0.11757151782512665, 0.32855451107025146],
                        [0.4494800269603729, 0.3284299373626709],
                        [0.4494955539703369, 0.34334275126457214],
                        [0.11758531630039215, 0.3434664011001587],
                    ],
                    [
                        [0.5292944312095642, 0.3285009264945984],
                        [0.874309241771698, 0.32837143540382385],
                        [0.8743259310722351, 0.34237608313560486],
                        [0.5293093919754028, 0.34250468015670776],
                    ],
                    [
                        [0.13658463954925537, 0.3460971713066101],
                        [0.4216293692588806, 0.3459911048412323],
                        [0.42164477705955505, 0.3609236776828766],
                        [0.13659855723381042, 0.3610289394855499],
                    ],
                    [
                        [0.5483188033103943, 0.3463048040866852],
                        [0.5679097771644592, 0.3462975323200226],
                        [0.5679219961166382, 0.3575746715068817],
                        [0.5483309626579285, 0.3575819134712219],
                    ],
                    [
                        [0.13687379658222198, 0.3636283874511719],
                        [0.30096831917762756, 0.36356785893440247],
                        [0.3009798228740692, 0.37520265579223633],
                        [0.1368846446275711, 0.3752627968788147],
                    ],
                    [
                        [0.529457151889801, 0.36348557472229004],
                        [0.8812383413314819, 0.3633558452129364],
                        [0.8812560439109802, 0.3781767189502716],
                        [0.5294730067253113, 0.37830546498298645],
                    ],
                    [
                        [0.1176309809088707, 0.3810279667377472],
                        [0.3558933138847351, 0.38094088435173035],
                        [0.35590803623199463, 0.39553335309028625],
                        [0.11764448136091232, 0.39561977982521057],
                    ],
                    [
                        [0.5504435896873474, 0.3811904489994049],
                        [0.5674283504486084, 0.38118425011634827],
                        [0.5674404501914978, 0.392368346452713],
                        [0.5504556894302368, 0.39237451553344727],
                    ],
                    [
                        [0.11786587536334991, 0.39828917384147644],
                        [0.41545945405960083, 0.39818137884140015],
                        [0.4154748320579529, 0.41312313079833984],
                        [0.1178797036409378, 0.41323012113571167],
                    ],
                    [
                        [0.5297935605049133, 0.3983365595340729],
                        [0.866067111492157, 0.39821475744247437],
                        [0.8660846948623657, 0.41305673122406006],
                        [0.5298094749450684, 0.41317760944366455],
                    ],
                    [
                        [0.11739873886108398, 0.41582462191581726],
                        [0.45444464683532715, 0.4157036542892456],
                        [0.45445987582206726, 0.4303031265735626],
                        [0.11741224676370621, 0.43042320013046265],
                    ],
                    [
                        [0.5488450527191162, 0.4158998727798462],
                        [0.7515048384666443, 0.4158271551132202],
                        [0.7515180110931396, 0.42732110619544983],
                        [0.5488573908805847, 0.4273934066295624],
                    ],
                    [
                        [0.13834726810455322, 0.4335700571537018],
                        [0.15426889061927795, 0.4335643947124481],
                        [0.15427947044372559, 0.44484347105026245],
                        [0.13835777342319489, 0.4448491036891937],
                    ],
                    [
                        [0.5298919677734375, 0.43314307928085327],
                        [0.8611345291137695, 0.4330252408981323],
                        [0.8611519932746887, 0.4477823078632355],
                        [0.529907763004303, 0.4478992223739624],
                    ],
                    [
                        [0.11738703399896622, 0.4506544768810272],
                        [0.4492757320404053, 0.4505375027656555],
                        [0.4492909014225006, 0.46509692072868347],
                        [0.11740050464868546, 0.46521297097206116],
                    ],
                    [
                        [0.5508058071136475, 0.45083507895469666],
                        [0.5844438672065735, 0.45082321763038635],
                        [0.5844561457633972, 0.462081640958786],
                        [0.5508179068565369, 0.46209341287612915],
                    ],
                    [
                        [0.11774258315563202, 0.46812790632247925],
                        [0.325406938791275, 0.46805539727211],
                        [0.32542166113853455, 0.4828208386898041],
                        [0.11775624752044678, 0.4828927516937256],
                    ],
                    [
                        [0.5292248725891113, 0.4681103229522705],
                        [0.8395137786865234, 0.46800199151039124],
                        [0.8395311832427979, 0.48277294635772705],
                        [0.5292406678199768, 0.4828804135322571],
                    ],
                    [
                        [0.11770157516002655, 0.48561692237854004],
                        [0.4581744372844696, 0.48549917340278625],
                        [0.45818954706192017, 0.49996477365493774],
                        [0.11771495640277863, 0.5000815987586975],
                    ],
                    [
                        [0.5293891429901123, 0.4855286180973053],
                        [0.7143511176109314, 0.4854646623134613],
                        [0.7143674492835999, 0.499858021736145],
                        [0.5294045209884644, 0.4999215006828308],
                    ],
                    [
                        [0.13685724139213562, 0.5028280019760132],
                        [0.4624103605747223, 0.5027164816856384],
                        [0.4624258577823639, 0.5175337791442871],
                        [0.13687105476856232, 0.5176444053649902],
                    ],
                    [
                        [0.5293979048728943, 0.502966582775116],
                        [0.8406005501747131, 0.5028599500656128],
                        [0.8406177163124084, 0.5174348950386047],
                        [0.5294135212898254, 0.517540693283081],
                    ],
                    [
                        [0.11770699173212051, 0.520326554775238],
                        [0.41585463285446167, 0.5202254056930542],
                        [0.41586923599243164, 0.5343976020812988],
                        [0.1177201047539711, 0.5344979763031006],
                    ],
                    [
                        [0.5292093753814697, 0.5202618837356567],
                        [0.8715577721595764, 0.5201457142829895],
                        [0.8715754747390747, 0.5350132584571838],
                        [0.5292252898216248, 0.5351284146308899],
                    ],
                    [
                        [0.13686220347881317, 0.5372337698936462],
                        [0.2548272907733917, 0.5371941328048706],
                        [0.25484171509742737, 0.5520147681236267],
                        [0.13687601685523987, 0.5520541071891785],
                    ],
                    [
                        [0.5501658320426941, 0.5378909707069397],
                        [0.594083309173584, 0.5378761887550354],
                        [0.594095766544342, 0.5492879748344421],
                        [0.5501781105995178, 0.5493026375770569],
                    ],
                    [
                        [0.117556631565094, 0.5553150177001953],
                        [0.423762708902359, 0.5552130937576294],
                        [0.4237774908542633, 0.5695220232009888],
                        [0.11756987124681473, 0.5696230530738831],
                    ],
                    [
                        [0.5292254090309143, 0.5552721619606018],
                        [0.7158479690551758, 0.5552100539207458],
                        [0.7158641219139099, 0.5694222450256348],
                        [0.529240608215332, 0.5694838762283325],
                    ],
                    [
                        [0.11772477626800537, 0.5722174644470215],
                        [0.4144144058227539, 0.5721197128295898],
                        [0.4144297242164612, 0.586995005607605],
                        [0.11773854494094849, 0.5870919823646545],
                    ],
                    [
                        [0.529315710067749, 0.5725336670875549],
                        [0.7953438758850098, 0.5724459886550903],
                        [0.7953612804412842, 0.5874032378196716],
                        [0.5293316841125488, 0.5874901413917542],
                    ],
                ],
            ],
            [
                '33',
                [
                    [
                        [0.11788135766983032, 0.06546089053153992],
                        [0.43081027269363403, 0.06524602323770523],
                        [0.4308141767978668, 0.08044469356536865],
                        [0.11788233369588852, 0.08065933734178543],
                    ],
                    [
                        [0.11664498597383499, 0.09441164880990982],
                        [0.8090559840202332, 0.09393718093633652],
                        [0.8090656399726868, 0.11373130232095718],
                        [0.11664625257253647, 0.11420510709285736],
                    ],
                    [
                        [0.11617063730955124, 0.11748767644166946],
                        [0.23364126682281494, 0.11740730702877045],
                        [0.23364396393299103, 0.13733352720737457],
                        [0.11617191135883331, 0.13741376996040344],
                    ],
                    [
                        [0.12590226531028748, 0.18937364220619202],
                        [0.22581307590007782, 0.1893056482076645],
                        [0.22581495344638824, 0.20361319184303284],
                        [0.12590326368808746, 0.2036811262369156],
                    ],
                    [
                        [0.26708218455314636, 0.1900836080312729],
                        [0.4015510380268097, 0.18999210000038147],
                        [0.40155452489852905, 0.20466294884681702],
                        [0.2670844495296478, 0.20475436747074127],
                    ],
                    [
                        [0.32579630613327026, 0.2081386297941208],
                        [0.670566737651825, 0.20790429413318634],
                        [0.6705728769302368, 0.22305189073085785],
                        [0.32579919695854187, 0.223285973072052],
                    ],
                    [
                        [0.12598374485969543, 0.25927627086639404],
                        [0.2310660183429718, 0.2592051327228546],
                        [0.23106749355793, 0.2702321708202362],
                        [0.12598451972007751, 0.27030327916145325],
                    ],
                    [
                        [0.26735422015190125, 0.25962916016578674],
                        [0.8533273935317993, 0.25923237204551697],
                        [0.8533351421356201, 0.2742888033390045],
                        [0.2673565745353699, 0.27468517422676086],
                    ],
                    [
                        [0.1259840428829193, 0.2750793993473053],
                        [0.248965784907341, 0.27499619126319885],
                        [0.24896737933158875, 0.28599295020103455],
                        [0.1259848028421402, 0.28607606887817383],
                    ],
                    [
                        [0.26684170961380005, 0.27688273787498474],
                        [0.872759222984314, 0.27647295594215393],
                        [0.8727670907974243, 0.29145851731300354],
                        [0.2668440341949463, 0.29186785221099854],
                    ],
                    [
                        [0.125880166888237, 0.29112184047698975],
                        [0.22682547569274902, 0.2910536229610443],
                        [0.22682718932628632, 0.30403023958206177],
                        [0.12588106095790863, 0.30409836769104004],
                    ],
                    [
                        [0.2651960253715515, 0.2943105399608612],
                        [0.6899591088294983, 0.29402363300323486],
                        [0.6899653077125549, 0.30901604890823364],
                        [0.26519834995269775, 0.3093026578426361],
                    ],
                    [
                        [0.282025545835495, 0.33014822006225586],
                        [0.7554256319999695, 0.32982927560806274],
                        [0.7554323673248291, 0.34472396969795227],
                        [0.2820280194282532, 0.34504255652427673],
                    ],
                    [
                        [0.2818593680858612, 0.34843719005584717],
                        [0.7353096604347229, 0.34813210368156433],
                        [0.7353165149688721, 0.36369743943214417],
                        [0.28186193108558655, 0.36400219798088074],
                    ],
                    [
                        [0.28198906779289246, 0.3668944239616394],
                        [0.803268551826477, 0.3665441572666168],
                        [0.803276002407074, 0.38190633058547974],
                        [0.2819916009902954, 0.3822561800479889],
                    ],
                    [
                        [0.2821568250656128, 0.3847848176956177],
                        [0.8483203053474426, 0.38440489768981934],
                        [0.8483278751373291, 0.39921829104423523],
                        [0.2821592688560486, 0.39959779381752014],
                    ],
                    [
                        [0.2822835445404053, 0.4018420875072479],
                        [0.674308180809021, 0.401579350233078],
                        [0.6743143200874329, 0.4168129563331604],
                        [0.2822860777378082, 0.41707542538642883],
                    ],
                    [
                        [0.26696208119392395, 0.435825914144516],
                        [0.8661637902259827, 0.4354253113269806],
                        [0.8661723136901855, 0.4517025649547577],
                        [0.2669646143913269, 0.4521026909351349],
                    ],
                    [
                        [0.2671356499195099, 0.45446452498435974],
                        [0.856281042098999, 0.45407119393348694],
                        [0.856288492679596, 0.46847331523895264],
                        [0.26713788509368896, 0.468866229057312],
                    ],
                    [
                        [0.2677096426486969, 0.47134387493133545],
                        [0.5339480042457581, 0.47116634249687195],
                        [0.5339529514312744, 0.48661839962005615],
                        [0.2677120566368103, 0.48679572343826294],
                    ],
                    [
                        [0.6958762407302856, 0.5053593516349792],
                        [0.8825096487998962, 0.5052351951599121],
                        [0.8825178146362305, 0.5205745100975037],
                        [0.6958826184272766, 0.5206984877586365],
                    ],
                ],
            ],
            [
                '614',
                [
                    [
                        [0.13867036998271942, 0.5724408626556396],
                        [0.17225486040115356, 0.5724309682846069],
                        [0.17226652801036835, 0.5839049220085144],
                        [0.13868190348148346, 0.5839147567749023],
                    ],
                    [
                        [0.5288689732551575, 0.5725748538970947],
                        [0.7731495499610901, 0.5725026726722717],
                        [0.7731673717498779, 0.5871996283531189],
                        [0.5288856029510498, 0.5872710943222046],
                    ],
                    [
                        [0.11727103590965271, 0.5900647044181824],
                        [0.38901060819625854, 0.5899853706359863],
                        [0.38902661204338074, 0.6047014594078064],
                        [0.11728573590517044, 0.6047799587249756],
                    ],
                    [
                        [0.5289469957351685, 0.5900838375091553],
                        [0.8505094647407532, 0.5899900197982788],
                        [0.8505262136459351, 0.6035541296005249],
                        [0.5289623141288757, 0.6036471128463745],
                    ],
                    [
                        [0.11704801768064499, 0.6071547269821167],
                        [0.45511239767074585, 0.6070572137832642],
                        [0.45512786507606506, 0.6210023164749146],
                        [0.11706195026636124, 0.6210988759994507],
                    ],
                    [
                        [0.5287196636199951, 0.6073536276817322],
                        [0.8350045680999756, 0.607265293598175],
                        [0.8350228071212769, 0.6220727562904358],
                        [0.528736412525177, 0.6221601963043213],
                    ],
                    [
                        [0.1173635944724083, 0.6248774528503418],
                        [0.3005014657974243, 0.6248252987861633],
                        [0.30051684379577637, 0.6393675208091736],
                        [0.1173781231045723, 0.6394191384315491],
                    ],
                    [
                        [0.5491280555725098, 0.6249839067459106],
                        [0.6362658739089966, 0.6249590516090393],
                        [0.6362816095352173, 0.6384646892547607],
                        [0.5491434335708618, 0.638489305973053],
                    ],
                    [
                        [0.11700324714183807, 0.6422834992408752],
                        [0.4108896255493164, 0.642200767993927],
                        [0.4109059274196625, 0.6571071147918701],
                        [0.11701814085245132, 0.657188892364502],
                    ],
                    [
                        [0.528889536857605, 0.642334520816803],
                        [0.8777217268943787, 0.6422363519668579],
                        [0.8777400851249695, 0.656990647315979],
                        [0.5289062261581421, 0.6570877432823181],
                    ],
                    [
                        [0.11699947714805603, 0.6596972346305847],
                        [0.3591717481613159, 0.6596299409866333],
                        [0.3591868579387665, 0.67363440990448],
                        [0.11701346933841705, 0.6737010478973389],
                    ],
                    [
                        [0.52886563539505, 0.6597008109092712],
                        [0.7424070835113525, 0.659641444683075],
                        [0.7424248456954956, 0.6744452714920044],
                        [0.5288823843002319, 0.6745039820671082],
                    ],
                    [
                        [0.11713634431362152, 0.6773976683616638],
                        [0.3769635260105133, 0.6773263812065125],
                        [0.37697866559028625, 0.6912915706634521],
                        [0.11715029180049896, 0.6913621425628662],
                    ],
                    [
                        [0.5293633937835693, 0.6772060990333557],
                        [0.8761441707611084, 0.6771109104156494],
                        [0.8761628270149231, 0.6920813322067261],
                        [0.5293803811073303, 0.6921754479408264],
                    ],
                    [
                        [0.11702220886945724, 0.6942700147628784],
                        [0.42533811926841736, 0.6941864490509033],
                        [0.425354540348053, 0.7091383934020996],
                        [0.11703714728355408, 0.7092210054397583],
                    ],
                    [
                        [0.5484201908111572, 0.6949811577796936],
                        [0.5582123398780823, 0.6949784755706787],
                        [0.5582249164581299, 0.705998420715332],
                        [0.5484327077865601, 0.7060010433197021],
                    ],
                    [
                        [0.13643307983875275, 0.7118759751319885],
                        [0.2317482829093933, 0.7118505239486694],
                        [0.2317628413438797, 0.7259113788604736],
                        [0.13644720613956451, 0.7259365916252136],
                    ],
                    [
                        [0.5292609333992004, 0.7120824456214905],
                        [0.8434948921203613, 0.7119984030723572],
                        [0.8435118794441223, 0.7257956862449646],
                        [0.5292765498161316, 0.725878894329071],
                    ],
                    [
                        [0.11708491295576096, 0.7291741967201233],
                        [0.3598773181438446, 0.729110062122345],
                        [0.3598931133747101, 0.7437800168991089],
                        [0.1170995682477951, 0.7438434362411499],
                    ],
                    [
                        [0.5287871360778809, 0.7293888330459595],
                        [0.6974561214447021, 0.7293443083763123],
                        [0.6974723935127258, 0.7430928945541382],
                        [0.5288026928901672, 0.7431369423866272],
                    ],
                    [
                        [0.11695339530706406, 0.7469683289527893],
                        [0.39107197523117065, 0.7468969225883484],
                        [0.3910880982875824, 0.7616987824440002],
                        [0.11696817725896835, 0.7617693543434143],
                    ],
                    [
                        [0.5290716886520386, 0.7470825910568237],
                        [0.7474368810653687, 0.747025728225708],
                        [0.7474545240402222, 0.7617131471633911],
                        [0.5290883183479309, 0.7617693543434143],
                    ],
                    [
                        [0.11729523539543152, 0.7640480399131775],
                        [0.37127402424812317, 0.7639827728271484],
                        [0.3712899684906006, 0.7787375450134277],
                        [0.11730997264385223, 0.7788020968437195],
                    ],
                    [
                        [0.5289233326911926, 0.7643318176269531],
                        [0.7968299388885498, 0.7642629146575928],
                        [0.7968474626541138, 0.7786359786987305],
                        [0.5289396047592163, 0.778704047203064],
                    ],
                    [
                        [0.11728136241436005, 0.7816923260688782],
                        [0.35819387435913086, 0.7816312313079834],
                        [0.35820987820625305, 0.796503484249115],
                        [0.11729621887207031, 0.7965638637542725],
                    ],
                    [
                        [0.5291391015052795, 0.7818211913108826],
                        [0.8261411190032959, 0.7817459106445312],
                        [0.8261575698852539, 0.7951371669769287],
                        [0.5291542410850525, 0.795211672782898],
                    ],
                    [
                        [0.11717329174280167, 0.7989785671234131],
                        [0.41489797830581665, 0.7989041209220886],
                        [0.41491401195526123, 0.8135377764701843],
                        [0.11718790978193283, 0.8136113286018372],
                    ],
                    [
                        [0.5287837982177734, 0.7990202307701111],
                        [0.7128459215164185, 0.7989741563796997],
                        [0.7128623127937317, 0.8127047419548035],
                        [0.5287993550300598, 0.8127502202987671],
                    ],
                    [
                        [0.1369658261537552, 0.8166801929473877],
                        [0.2827532887458801, 0.8166442513465881],
                        [0.28276756405830383, 0.8302209973335266],
                        [0.13697947561740875, 0.8302565217018127],
                    ],
                    [
                        [0.5290428996086121, 0.8165921568870544],
                        [0.7715634703636169, 0.8165323734283447],
                        [0.7715803384780884, 0.8304535150527954],
                        [0.5290586352348328, 0.8305126428604126],
                    ],
                    [
                        [0.11705274134874344, 0.8338226675987244],
                        [0.41683825850486755, 0.8337497711181641],
                        [0.4168541729450226, 0.8482898473739624],
                        [0.11706726253032684, 0.8483618497848511],
                    ],
                    [
                        [0.5289520621299744, 0.8338783383369446],
                        [0.7952268123626709, 0.8338136076927185],
                        [0.7952448129653931, 0.8485907316207886],
                        [0.5289687514305115, 0.8486546874046326],
                    ],
                    [
                        [0.13736334443092346, 0.8513391613960266],
                        [0.46655499935150146, 0.8512603044509888],
                        [0.46657171845436096, 0.8662939071655273],
                        [0.13737845420837402, 0.8663718104362488],
                    ],
                ],
            ],
            [
                '70',
                [
                    [
                        [0.5636075735092163, 0.06540993601083755],
                        [0.8817816972732544, 0.06531982868909836],
                        [0.8817946314811707, 0.0807553231716156],
                        [0.5636168718338013, 0.08084537088871002],
                    ],
                    [
                        [0.11808478087186813, 0.09863962978124619],
                        [0.8704808950424194, 0.09842686355113983],
                        [0.8704977035522461, 0.11871365457773209],
                        [0.11809029430150986, 0.11892623454332352],
                    ],
                    [
                        [0.11644358187913895, 0.12211251258850098],
                        [0.4214518666267395, 0.12202634662389755],
                        [0.4214612543582916, 0.1409306824207306],
                        [0.11644869297742844, 0.14101678133010864],
                    ],
                    [
                        [0.12573736906051636, 0.19338855147361755],
                        [0.2205463945865631, 0.19336184859275818],
                        [0.22055092453956604, 0.20640727877616882],
                        [0.12574099004268646, 0.2064339518547058],
                    ],
                    [
                        [0.2935976982116699, 0.19323532283306122],
                        [0.8606044054031372, 0.19307567179203033],
                        [0.8606170415878296, 0.20842768251895905],
                        [0.2936038672924042, 0.20858722925186157],
                    ],
                    [
                        [0.125549778342247, 0.20914462208747864],
                        [0.19718869030475616, 0.20912446081638336],
                        [0.19719228148460388, 0.22001855075359344],
                        [0.12555280327796936, 0.22003869712352753],
                    ],
                    [
                        [0.26682087779045105, 0.21078963577747345],
                        [0.5783786177635193, 0.21070197224617004],
                        [0.578387975692749, 0.2259972244501114],
                        [0.2668267488479614, 0.22608481347560883],
                    ],
                    [
                        [0.28880080580711365, 0.24577349424362183],
                        [0.6839312314987183, 0.24566249549388885],
                        [0.6839417219161987, 0.26083579659461975],
                        [0.28880685567855835, 0.26094672083854675],
                    ],
                    [
                        [0.2891538441181183, 0.28063011169433594],
                        [0.8439702987670898, 0.2804744839668274],
                        [0.8439826369285583, 0.29574647545814514],
                        [0.2891599237918854, 0.29590198397636414],
                    ],
                    [
                        [0.26661810278892517, 0.2980860769748688],
                        [0.4898534119129181, 0.2980234920978546],
                        [0.48986169695854187, 0.3131319284439087],
                        [0.2666238844394684, 0.3131944537162781],
                    ],
                    [
                        [0.2891044020652771, 0.33240368962287903],
                        [0.8838444948196411, 0.33223724365234375],
                        [0.8838578462600708, 0.3481617271900177],
                        [0.2891107499599457, 0.34832802414894104],
                    ],
                    [
                        [0.26671701669692993, 0.35041943192481995],
                        [0.3642961382865906, 0.3503921627998352],
                        [0.36430296301841736, 0.3654349446296692],
                        [0.26672276854515076, 0.36546218395233154],
                    ],
                    [
                        [0.2887747287750244, 0.38470178842544556],
                        [0.540522038936615, 0.384631484746933],
                        [0.5405314564704895, 0.4006720781326294],
                        [0.2887811064720154, 0.4007423222064972],
                    ],
                    [
                        [0.28851041197776794, 0.4196102023124695],
                        [0.8070980310440063, 0.41946566104888916],
                        [0.8071103692054749, 0.4351845681667328],
                        [0.28851667046546936, 0.43532902002334595],
                    ],
                    [
                        [0.2901976406574249, 0.4547511637210846],
                        [0.8149209022521973, 0.4546051621437073],
                        [0.8149331212043762, 0.47012731432914734],
                        [0.29020383954048157, 0.4702732264995575],
                    ],
                    [
                        [0.2899719178676605, 0.4897638261318207],
                        [0.5446824431419373, 0.4896930456161499],
                        [0.544691264629364, 0.504719614982605],
                        [0.28997790813446045, 0.5047903656959534],
                    ],
                ],
            ],
            [
                '615',
                [
                    [
                        [0.8344932198524475, 0.04935233294963837],
                        [0.8751357197761536, 0.049350276589393616],
                        [0.8751435875892639, 0.0599912591278553],
                        [0.8345009684562683, 0.05999326333403587],
                    ],
                    [
                        [0.11723888665437698, 0.08474607020616531],
                        [0.4627075791358948, 0.0847301259636879],
                        [0.46271565556526184, 0.09831268340349197],
                        [0.11724528670310974, 0.09832803905010223],
                    ],
                    [
                        [0.528750479221344, 0.0847478061914444],
                        [0.7445399761199951, 0.08473784476518631],
                        [0.7445501685142517, 0.09942444413900375],
                        [0.5287595391273499, 0.0994340032339096],
                    ],
                    [
                        [0.13666465878486633, 0.2937426269054413],
                        [0.4493728280067444, 0.29373642802238464],
                        [0.4493815004825592, 0.3084472417831421],
                        [0.13667169213294983, 0.308452844619751],
                    ],
                    [
                        [0.5289061665534973, 0.10188861936330795],
                        [0.8294888138771057, 0.10187539458274841],
                        [0.8294997215270996, 0.11689060926437378],
                        [0.5289154648780823, 0.11690326035022736],
                    ],
                    [
                        [0.11725901067256927, 0.11960749328136444],
                        [0.40364596247673035, 0.11959553509950638],
                        [0.4036543071269989, 0.13415825366973877],
                        [0.11726587265729904, 0.13416968286037445],
                    ],
                    [
                        [0.5289078950881958, 0.11957240849733353],
                        [0.787651002407074, 0.11956160515546799],
                        [0.7876614928245544, 0.13427841663360596],
                        [0.5289169549942017, 0.1342887431383133],
                    ],
                    [
                        [0.11741356551647186, 0.1367293745279312],
                        [0.4488092362880707, 0.13671624660491943],
                        [0.4488180875778198, 0.15174396336078644],
                        [0.11742065101861954, 0.15175646543502808],
                    ],
                    [
                        [0.5289572477340698, 0.1369738131761551],
                        [0.8796069622039795, 0.13695994019508362],
                        [0.8796172142028809, 0.1508074253797531],
                        [0.5289658308029175, 0.15082068741321564],
                    ],
                    [
                        [0.11734509468078613, 0.1545831859111786],
                        [0.33710888028144836, 0.15457497537136078],
                        [0.3371163606643677, 0.16816087067127228],
                        [0.11735149472951889, 0.16816869378089905],
                    ],
                    [
                        [0.5287377834320068, 0.15454807877540588],
                        [0.8728215098381042, 0.1545352190732956],
                        [0.8728322982788086, 0.1690606027841568],
                        [0.5287467241287231, 0.16907282173633575],
                    ],
                    [
                        [0.11731181293725967, 0.17162972688674927],
                        [0.40337473154067993, 0.17161966860294342],
                        [0.4033832252025604, 0.1864514797925949],
                        [0.11731880903244019, 0.18646101653575897],
                    ],
                    [
                        [0.5292680263519287, 0.17172326147556305],
                        [0.6771724224090576, 0.1717180609703064],
                        [0.6771817207336426, 0.18557758629322052],
                        [0.5292766094207764, 0.18558253347873688],
                    ],
                    [
                        [0.11724544316530228, 0.18935711681842804],
                        [0.3899684548377991, 0.18934811651706696],
                        [0.3899766802787781, 0.20383630692958832],
                        [0.11725226789712906, 0.2038448005914688],
                    ],
                    [
                        [0.5290648341178894, 0.18951353430747986],
                        [0.7724864482879639, 0.18950551748275757],
                        [0.7724958658218384, 0.2028786838054657],
                        [0.5290731191635132, 0.20288628339767456],
                    ],
                    [
                        [0.13685274124145508, 0.2068253606557846],
                        [0.28967714309692383, 0.20682066679000854],
                        [0.28968489170074463, 0.22135961055755615],
                        [0.1368596851825714, 0.22136402130126953],
                    ],
                    [
                        [0.5292862057685852, 0.20663589239120483],
                        [0.8110342621803284, 0.20662721991539001],
                        [0.8110440969467163, 0.22036895155906677],
                        [0.5292946696281433, 0.2203771322965622],
                    ],
                    [
                        [0.11711536347866058, 0.2240486592054367],
                        [0.4651329219341278, 0.22403870522975922],
                        [0.465141624212265, 0.23868058621883392],
                        [0.11712226271629333, 0.23868988454341888],
                    ],
                    [
                        [0.5288652181625366, 0.22386452555656433],
                        [0.7472479939460754, 0.2238582819700241],
                        [0.7472578883171082, 0.23806652426719666],
                        [0.5288739800453186, 0.23807238042354584],
                    ],
                    [
                        [0.5503398180007935, 0.43326884508132935],
                        [0.5942206978797913, 0.4332687556743622],
                        [0.5942280888557434, 0.44474706053733826],
                        [0.5503469705581665, 0.44474709033966064],
                    ],
                    [
                        [0.528889536857605, 0.24143555760383606],
                        [0.7968610525131226, 0.24142847955226898],
                        [0.7968693971633911, 0.2531355917453766],
                        [0.5288968086242676, 0.25314226746559143],
                    ],
                    [
                        [0.11716922372579575, 0.25893500447273254],
                        [0.3618474006652832, 0.2589291036128998],
                        [0.3618558347225189, 0.2740389108657837],
                        [0.1171763464808464, 0.27404433488845825],
                    ],
                    [
                        [0.5489997267723083, 0.25890877842903137],
                        [0.6826727986335754, 0.2589055299758911],
                        [0.6826819777488708, 0.27252379059791565],
                        [0.5490082502365112, 0.2725268006324768],
                    ],
                    [
                        [0.11725135147571564, 0.27632278203964233],
                        [0.4586365222930908, 0.27631527185440063],
                        [0.4586445391178131, 0.2898206412792206],
                        [0.11725771427154541, 0.2898275554180145],
                    ],
                    [
                        [0.528932511806488, 0.27663522958755493],
                        [0.7323451042175293, 0.2766307592391968],
                        [0.7323541641235352, 0.2897799611091614],
                        [0.5289406180381775, 0.2897840738296509],
                    ],
                    [
                        [0.5288673639297485, 0.2938072085380554],
                        [0.8514214158058167, 0.29380083084106445],
                        [0.8514316082000732, 0.3077298104763031],
                        [0.528876006603241, 0.3077356219291687],
                    ],
                    [
                        [0.11722124367952347, 0.31110474467277527],
                        [0.3739972412586212, 0.3111002445220947],
                        [0.3740054666996002, 0.325756698846817],
                        [0.11722815036773682, 0.32576075196266174],
                    ],
                    [
                        [0.5289462208747864, 0.3110775947570801],
                        [0.8768121004104614, 0.3110714554786682],
                        [0.8768230676651001, 0.32583898305892944],
                        [0.5289553999900818, 0.3258444666862488],
                    ],
                    [
                        [0.11729072779417038, 0.32866573333740234],
                        [0.45859548449516296, 0.3286604583263397],
                        [0.4586041569709778, 0.34326693415641785],
                        [0.11729761213064194, 0.34327155351638794],
                    ],
                    [
                        [0.5485633015632629, 0.3287087082862854],
                        [0.6587052345275879, 0.3287070393562317],
                        [0.6587143540382385, 0.3423791825771332],
                        [0.5485718250274658, 0.34238070249557495],
                    ],
                ],
            ],
            [
                '69',
                [
                    [
                        [0.26703977584838867, 0.5260077714920044],
                        [0.8717601299285889, 0.5261286497116089],
                        [0.8717706799507141, 0.5411226749420166],
                        [0.2670470178127289, 0.5410001873970032],
                    ],
                    [
                        [0.2676240801811218, 0.5434889793395996],
                        [0.8489823937416077, 0.5436069965362549],
                        [0.8489929437637329, 0.5587862730026245],
                        [0.2676313817501068, 0.5586667060852051],
                    ],
                    [
                        [0.26697587966918945, 0.5608462691307068],
                        [0.8750266432762146, 0.5609715580940247],
                        [0.8750372529029846, 0.576117217540741],
                        [0.26698318123817444, 0.5759903192520142],
                    ],
                    [
                        [0.26723480224609375, 0.5782799124717712],
                        [0.8755302429199219, 0.5784071087837219],
                        [0.8755407929420471, 0.593441367149353],
                        [0.26724207401275635, 0.5933125615119934],
                    ],
                    [
                        [0.2671009600162506, 0.5958554148674011],
                        [0.6210827231407166, 0.5959305167198181],
                        [0.621091902256012, 0.6109755635261536],
                        [0.2671082317829132, 0.6108995079994202],
                    ],
                    [
                        [0.26754459738731384, 0.6307599544525146],
                        [0.4758683443069458, 0.6308054327964783],
                        [0.47587674856185913, 0.6458633542060852],
                        [0.26755186915397644, 0.6458173394203186],
                    ],
                    [
                        [0.3259831368923187, 0.6490231156349182],
                        [0.8499438166618347, 0.6491391658782959],
                        [0.8499543070793152, 0.6642292737960815],
                        [0.3259907066822052, 0.6641117930412292],
                    ],
                    [
                        [0.3255418539047241, 0.666700541973114],
                        [0.811178982257843, 0.666809618473053],
                        [0.8111891746520996, 0.68183434009552],
                        [0.3255494236946106, 0.681723952293396],
                    ],
                    [
                        [0.32599228620529175, 0.6838111281394958],
                        [0.8385080099105835, 0.6839278340339661],
                        [0.8385183811187744, 0.6989631652832031],
                        [0.3259998559951782, 0.6988450884819031],
                    ],
                    [
                        [0.3258775770664215, 0.7015447616577148],
                        [0.5720694661140442, 0.7016015648841858],
                        [0.5720783472061157, 0.7165710926055908],
                        [0.3258851170539856, 0.7165136337280273],
                    ],
                    [
                        [0.32570239901542664, 0.7201128602027893],
                        [0.8689274191856384, 0.7202399969100952],
                        [0.8689376711845398, 0.7348994016647339],
                        [0.3257097899913788, 0.7347708344459534],
                    ],
                    [
                        [0.3259936571121216, 0.737871527671814],
                        [0.4230022132396698, 0.7378945350646973],
                        [0.42300835251808167, 0.7492828965187073],
                        [0.3259994089603424, 0.7492596507072449],
                    ],
                    [
                        [0.28922900557518005, 0.772003173828125],
                        [0.5762461423873901, 0.772072970867157],
                        [0.5762553811073303, 0.7875837683677673],
                        [0.2892366051673889, 0.7875131964683533],
                    ],
                    [
                        [0.3258623480796814, 0.7904486060142517],
                        [0.8648964762687683, 0.7905814051628113],
                        [0.8649072647094727, 0.8060498237609863],
                        [0.3258701264858246, 0.8059155344963074],
                    ],
                    [
                        [0.32588139176368713, 0.8088810443878174],
                        [0.818867027759552, 0.8090041279792786],
                        [0.8188775777816772, 0.8244621753692627],
                        [0.32588914036750793, 0.8243377804756165],
                    ],
                    [
                        [0.32631945610046387, 0.8265900015830994],
                        [0.7215654253959656, 0.8266899585723877],
                        [0.7215752601623535, 0.8418741226196289],
                        [0.3263271152973175, 0.8417731523513794],
                    ],
                    [
                        [0.6958563923835754, 0.8605858683586121],
                        [0.8824552297592163, 0.8606341481208801],
                        [0.8824657201766968, 0.8755232691764832],
                        [0.6958658695220947, 0.8754745125770569],
                    ],
                ],
            ],
        ],
    },
    {
        question: 'What fees the veteran can pay for construction home loans?',
        InitialChatTitle: 'VA Construction Loan Costs Explained',
        Answer: 'Based on the VA guidelines, here is the answer:\n\nFor construction home loans, veterans can pay:\n\n1. Standard Allowable Fees:\n- All reasonable and customary itemized fees and charges\n- VA appraisal and compliance inspection fees\n- Title examination and title insurance fees\n- VA funding fee (unless exempt)\n\n2. Special Construction Loan Charges:\n- The lender can charge additional flat charges specifically for construction loans:\n* If the lender supervises construction progress and makes advances exceeding 50% of the loan during construction: up to 2% additional charge (making total maximum of 3% flat charge when combined with standard 1% lender fee)\n* If the lender does not supervise construction or make advances exceeding 50%: up to 1% additional charge (making total maximum of 2% flat charge)\n\nImportant Restrictions:\n- The veteran may not pay any fees that are the builder\'s responsibility\n- The funding fee is due within 15 days of loan closing, regardless of construction timeline\n- All fees must be reasonable and customary for the market area\n\nReferences: \n- Chapter 8, Section 2.e "Construction Loans"\n- Chapter 7, Section 2.e "What Fees the Veteran Can Pay"\n- Chapter 8, Section 2.b "Overview"',
        QuoteLocations: [
            [
                '93',
                [
                    [
                        [0.11760860681533813, 0.06575038284063339],
                        [0.4312584400177002, 0.0654873475432396],
                        [0.4312570095062256, 0.08041520416736603],
                        [0.11759955435991287, 0.08067652583122253],
                    ],
                    [
                        [0.11866192519664764, 0.10114499926567078],
                        [0.7713801860809326, 0.10060607641935349],
                        [0.7713887691497803, 0.11945962905883789],
                        [0.11865052580833435, 0.11999406665563583],
                    ],
                    [
                        [0.11726459115743637, 0.15803532302379608],
                        [0.32692956924438477, 0.15786656737327576],
                        [0.32692593336105347, 0.1715436577796936],
                        [0.1172562912106514, 0.17171135544776917],
                    ],
                    [
                        [0.17008107900619507, 0.19289864599704742],
                        [0.23395657539367676, 0.1928480565547943],
                        [0.2339504361152649, 0.20753973722457886],
                        [0.17007341980934143, 0.2075899839401245],
                    ],
                    [
                        [0.48131629824638367, 0.19290415942668915],
                        [0.5837971568107605, 0.19282300770282745],
                        [0.583799421787262, 0.20763088762760162],
                        [0.48131605982780457, 0.20771150290966034],
                    ],
                    [
                        [0.8111624717712402, 0.1929955929517746],
                        [0.8721838593482971, 0.19294728338718414],
                        [0.8721910715103149, 0.2046252191066742],
                        [0.8111685514450073, 0.20467327535152435],
                    ],
                    [
                        [0.14835643768310547, 0.21145281195640564],
                        [0.24702033400535583, 0.21137534081935883],
                        [0.24701444804668427, 0.2262696921825409],
                        [0.1483481526374817, 0.22634664177894592],
                    ],
                    [
                        [0.27312150597572327, 0.2112305462360382],
                        [0.7919819355010986, 0.21082307398319244],
                        [0.7919893264770508, 0.22592861950397491],
                        [0.27311617136001587, 0.22633323073387146],
                    ],
                    [
                        [0.8264742493629456, 0.21121852099895477],
                        [0.8592665195465088, 0.2111927717924118],
                        [0.8592734932899475, 0.22284282743930817],
                        [0.8264806270599365, 0.2228684425354004],
                    ],
                    [
                        [0.2730827331542969, 0.2286556363105774],
                        [0.4419802129268646, 0.2285240739583969],
                        [0.4419790506362915, 0.24323053658008575],
                        [0.27307751774787903, 0.2433611899614334],
                    ],
                    [
                        [0.8106278777122498, 0.22845172882080078],
                        [0.8733590245246887, 0.22840286791324615],
                        [0.8733679056167603, 0.24262244999408722],
                        [0.8106352686882019, 0.24267098307609558],
                    ],
                    [
                        [0.8368303775787354, 0.4215008020401001],
                        [0.8460038304328918, 0.4214943051338196],
                        [0.8460107445716858, 0.4335046112537384],
                        [0.836837112903595, 0.43351107835769653],
                    ],
                    [
                        [0.28817594051361084, 0.2631906270980835],
                        [0.7435975074768066, 0.2628416419029236],
                        [0.7436037659645081, 0.27814239263534546],
                        [0.2881709039211273, 0.27848881483078003],
                    ],
                    [
                        [0.2886429727077484, 0.28082892298698425],
                        [0.5949094891548157, 0.28059622645378113],
                        [0.5949119925498962, 0.2953706979751587],
                        [0.2886381149291992, 0.2956017553806305],
                    ],
                    [
                        [0.2882311940193176, 0.2981248199939728],
                        [0.7311282157897949, 0.29779109358787537],
                        [0.7311340570449829, 0.31275874376296997],
                        [0.28822624683380127, 0.313090056180954],
                    ],
                    [
                        [0.2885744273662567, 0.3156560957431793],
                        [0.38240858912467957, 0.31558600068092346],
                        [0.38240599632263184, 0.33030593395233154],
                        [0.2885695695877075, 0.3303755521774292],
                    ],
                    [
                        [0.28811115026474, 0.33272019028663635],
                        [0.6996005773544312, 0.3324153423309326],
                        [0.6996057033538818, 0.3475298583507538],
                        [0.28810617327690125, 0.34783244132995605],
                    ],
                    [
                        [0.14852137863636017, 0.3512578308582306],
                        [0.2533222734928131, 0.35118088126182556],
                        [0.25331634283065796, 0.36658668518066406],
                        [0.1485128253698349, 0.36666300892829895],
                    ],
                    [
                        [0.27287358045578003, 0.35145214200019836],
                        [0.7355313897132874, 0.3511125445365906],
                        [0.7355373501777649, 0.3660399913787842],
                        [0.2728683054447174, 0.366377055644989],
                    ],
                    [
                        [0.8241510391235352, 0.3515913784503937],
                        [0.8584358096122742, 0.35156622529029846],
                        [0.8584441542625427, 0.36544692516326904],
                        [0.8241585493087769, 0.3654719293117523],
                    ],
                    [
                        [0.2731790244579315, 0.3686226010322571],
                        [0.7782443761825562, 0.368255078792572],
                        [0.7782514691352844, 0.38345038890838623],
                        [0.27317366003990173, 0.38381510972976685],
                    ],
                    [
                        [0.8199555277824402, 0.36923402547836304],
                        [0.8630269169807434, 0.36920270323753357],
                        [0.8630338907241821, 0.3807200491428375],
                        [0.819961667060852, 0.38075119256973267],
                    ],
                    [
                        [0.83307945728302, 0.3859289586544037],
                        [0.8524676561355591, 0.38591498136520386],
                        [0.8524747490882874, 0.3979989290237427],
                        [0.8330861926078796, 0.39801281690597534],
                    ],
                    [
                        [0.28847333788871765, 0.4036810100078583],
                        [0.7450799942016602, 0.40335458517074585],
                        [0.745086133480072, 0.41826996207237244],
                        [0.2884684205055237, 0.4185938835144043],
                    ],
                    [
                        [0.8128464221954346, 0.4919627904891968],
                        [0.8712818622589111, 0.49192291498184204],
                        [0.8712906241416931, 0.5060883164405823],
                        [0.8128538727760315, 0.5061278939247131],
                    ],
                    [
                        [0.2881982624530792, 0.4210309386253357],
                        [0.4544077217578888, 0.4209131598472595],
                        [0.4544070363044739, 0.43284687399864197],
                        [0.28819432854652405, 0.43296390771865845],
                    ],
                    [
                        [0.2884202003479004, 0.4384404718875885],
                        [0.7732428312301636, 0.43810003995895386],
                        [0.7732497453689575, 0.4530777633190155],
                        [0.2884152829647064, 0.45341551303863525],
                    ],
                    [
                        [0.28797709941864014, 0.45598602294921875],
                        [0.562146782875061, 0.4557952582836151],
                        [0.5621485114097595, 0.47055190801620483],
                        [0.28797224164009094, 0.4707411527633667],
                    ],
                    [
                        [0.14838995039463043, 0.4744870364665985],
                        [0.21369710564613342, 0.4744420349597931],
                        [0.21369069814682007, 0.4886739253997803],
                        [0.1483820378780365, 0.48871856927871704],
                    ],
                    [
                        [0.2731378376483917, 0.4742993414402008],
                        [0.7920575141906738, 0.4739418029785156],
                        [0.7920648455619812, 0.48886528611183167],
                        [0.2731325626373291, 0.4892200231552124],
                    ],
                    [
                        [0.8281518220901489, 0.47459548711776733],
                        [0.859917163848877, 0.47457361221313477],
                        [0.8599240183830261, 0.48601582646369934],
                        [0.8281580805778503, 0.48603755235671997],
                    ],
                    [
                        [0.14828507602214813, 0.49204304814338684],
                        [0.2410745620727539, 0.491979718208313],
                        [0.24106989800930023, 0.5034639835357666],
                        [0.14827868342399597, 0.5035269260406494],
                    ],
                    [
                        [0.27324941754341125, 0.49182695150375366],
                        [0.6199308037757874, 0.49159032106399536],
                        [0.6199339628219604, 0.5065404176712036],
                        [0.27324414253234863, 0.5067752003669739],
                    ],
                    [
                        [0.8363175392150879, 0.5096064209938049],
                        [0.8465219736099243, 0.5095995664596558],
                        [0.8465290069580078, 0.5217001438140869],
                        [0.8363243341445923, 0.5217069387435913],
                    ],
                ],
            ],
            [
                '289',
                [
                    [
                        [0.539419949054718, 0.06553420424461365],
                        [0.8524383902549744, 0.06566594541072845],
                        [0.8524422645568848, 0.08061466366052628],
                        [0.5394224524497986, 0.08048208057880402],
                    ],
                    [
                        [0.6594493985176086, 0.08283617347478867],
                        [0.8529425263404846, 0.0829182118177414],
                        [0.852946400642395, 0.09776124358177185],
                        [0.6594523787498474, 0.09767869114875793],
                    ],
                    [
                        [0.14633934199810028, 0.13920976221561432],
                        [0.7934715747833252, 0.13949070870876312],
                        [0.7934764623641968, 0.15961863100528717],
                        [0.1463402360677719, 0.15933533012866974],
                    ],
                    [
                        [0.14681203663349152, 0.1965300738811493],
                        [0.24627873301506042, 0.19657428562641144],
                        [0.2462797611951828, 0.2103659212589264],
                        [0.14681264758110046, 0.21032147109508514],
                    ],
                    [
                        [0.28727221488952637, 0.19653181731700897],
                        [0.5266973972320557, 0.19663822650909424],
                        [0.5266997814178467, 0.21158240735530853],
                        [0.2872735261917114, 0.21147535741329193],
                    ],
                    [
                        [0.30288270115852356, 0.21376438438892365],
                        [0.805061399936676, 0.21398912370204926],
                        [0.8050650954246521, 0.22898012399673462],
                        [0.3028840720653534, 0.22875404357910156],
                    ],
                    [
                        [0.14663010835647583, 0.2663554251194],
                        [0.195347860455513, 0.26637768745422363],
                        [0.19534850120544434, 0.27706488966941833],
                        [0.14663058519363403, 0.27704253792762756],
                    ],
                    [
                        [0.28742530941963196, 0.26601043343544006],
                        [0.8768704533576965, 0.26627975702285767],
                        [0.876874566078186, 0.28154027462005615],
                        [0.287426620721817, 0.2812693119049072],
                    ],
                    [
                        [0.146662637591362, 0.28218209743499756],
                        [0.23791907727718353, 0.28222405910491943],
                        [0.23792006075382233, 0.29587769508361816],
                        [0.14666324853897095, 0.2958355247974396],
                    ],
                    [
                        [0.2875681519508362, 0.2838858962059021],
                        [0.4437395930290222, 0.28395774960517883],
                        [0.4437415599822998, 0.2983616292476654],
                        [0.28756940364837646, 0.29828935861587524],
                    ],
                    [
                        [0.1467142105102539, 0.33592963218688965],
                        [0.24484090507030487, 0.335975706577301],
                        [0.24484172463417053, 0.3469240665435791],
                        [0.1467147022485733, 0.346877783536911],
                    ],
                    [
                        [0.28756189346313477, 0.3360811471939087],
                        [0.5699306726455688, 0.33621370792388916],
                        [0.5699331760406494, 0.35084131360054016],
                        [0.28756317496299744, 0.3507079780101776],
                    ],
                    [
                        [0.3028290569782257, 0.37047937512397766],
                        [0.891457736492157, 0.37075936794281006],
                        [0.8914617896080017, 0.38566651940345764],
                        [0.30283042788505554, 0.3853849470615387],
                    ],
                    [
                        [0.3029012084007263, 0.3880864977836609],
                        [0.5653178691864014, 0.3882121443748474],
                        [0.5653205513954163, 0.4036490321159363],
                        [0.3029026389122009, 0.40352267026901245],
                    ],
                    [
                        [0.3031133711338043, 0.4055071473121643],
                        [0.6456630825996399, 0.40567222237586975],
                        [0.6456660628318787, 0.4208187162876129],
                        [0.30311477184295654, 0.42065268754959106],
                    ],
                    [
                        [0.30293866991996765, 0.42295917868614197],
                        [0.5152782201766968, 0.42306217551231384],
                        [0.5152806043624878, 0.4379236102104187],
                        [0.3029400408267975, 0.4378200173377991],
                    ],
                    [
                        [0.28688377141952515, 0.4575996994972229],
                        [0.7907465100288391, 0.4578472673892975],
                        [0.7907501459121704, 0.47294625639915466],
                        [0.2868851125240326, 0.47269734740257263],
                    ],
                    [
                        [0.28781431913375854, 0.47531720995903015],
                        [0.5315156579017639, 0.475437730550766],
                        [0.5315180420875549, 0.49027642607688904],
                        [0.2878156006336212, 0.49015527963638306],
                    ],
                    [
                        [0.2871200144290924, 0.5099282264709473],
                        [0.8504623770713806, 0.5102103352546692],
                        [0.850466251373291, 0.5252410769462585],
                        [0.28712135553359985, 0.5249574780464172],
                    ],
                    [
                        [0.28799933195114136, 0.52756667137146],
                        [0.34987330436706543, 0.5275978446006775],
                        [0.349874883890152, 0.5423535108566284],
                        [0.28800061345100403, 0.5423221588134766],
                    ],
                    [
                        [0.14649052917957306, 0.5792224407196045],
                        [0.2349235713481903, 0.5792677998542786],
                        [0.23492440581321716, 0.5910595655441284],
                        [0.14649105072021484, 0.5910139679908752],
                    ],
                    [
                        [0.28757062554359436, 0.579508364200592],
                        [0.8902563452720642, 0.5798177123069763],
                        [0.8902604579925537, 0.5947763323783875],
                        [0.2875719368457794, 0.594465434551239],
                    ],
                    [
                        [0.1466965228319168, 0.5958552956581116],
                        [0.2138189822435379, 0.5958899259567261],
                        [0.213819682598114, 0.6065981984138489],
                        [0.146696999669075, 0.6065633893013],
                    ],
                    [
                        [0.2878861427307129, 0.5969316363334656],
                        [0.6301649212837219, 0.5971083641052246],
                        [0.6301677823066711, 0.6119692325592041],
                        [0.28788742423057556, 0.6117916107177734],
                    ],
                    [
                        [0.14637407660484314, 0.6114354133605957],
                        [0.21133828163146973, 0.6114691495895386],
                        [0.21133919060230255, 0.6254637241363525],
                        [0.14637470245361328, 0.6254298090934753],
                    ],
                    [
                        [0.33331298828125, 0.6463868618011475],
                        [0.39533892273902893, 0.6464194655418396],
                        [0.3953406512737274, 0.6609090566635132],
                        [0.333314448595047, 0.6608763337135315],
                    ],
                    [
                        [0.623796820640564, 0.6464806795120239],
                        [0.72125244140625, 0.646531879901886],
                        [0.7212556004524231, 0.6607676148414612],
                        [0.6237995624542236, 0.66071617603302],
                    ],
                    [
                        [0.29606759548187256, 0.6646263599395752],
                        [0.4057185649871826, 0.6646842956542969],
                        [0.40572038292884827, 0.6792494058609009],
                        [0.2960689067840576, 0.6791911721229553],
                    ],
                    [
                        [0.4648744463920593, 0.6653780341148376],
                        [0.8926049470901489, 0.6656041145324707],
                        [0.8926090598106384, 0.6806148886680603],
                        [0.46487659215927124, 0.6803876161575317],
                    ],
                    [
                        [0.2961544692516327, 0.6818089485168457],
                        [0.3910173773765564, 0.6818593740463257],
                        [0.39101916551589966, 0.6966904997825623],
                        [0.29615581035614014, 0.6966398358345032],
                    ],
                ],
            ],
            [
                '302',
                [
                    [
                        [0.1474544107913971, 0.06567114591598511],
                        [0.4606715142726898, 0.06571830064058304],
                        [0.46067577600479126, 0.08043277263641357],
                        [0.1474572718143463, 0.08039142936468124],
                    ],
                    [
                        [0.14610743522644043, 0.08263431489467621],
                        [0.33978667855262756, 0.08265932649374008],
                        [0.33979055285453796, 0.09790770709514618],
                        [0.146110400557518, 0.09788641333580017],
                    ],
                    [
                        [0.1467658132314682, 0.13944700360298157],
                        [0.8212319016456604, 0.13948577642440796],
                        [0.8212399482727051, 0.15949110686779022],
                        [0.146769717335701, 0.1594693660736084],
                    ],
                    [
                        [0.1461566835641861, 0.1631331592798233],
                        [0.34895896911621094, 0.1631387621164322],
                        [0.3489636182785034, 0.1812138706445694],
                        [0.14616020023822784, 0.1812129020690918],
                    ],
                    [
                        [0.14649924635887146, 0.21999302506446838],
                        [0.2161318063735962, 0.21998995542526245],
                        [0.21613416075706482, 0.2308400422334671],
                        [0.146501362323761, 0.23084406554698944],
                    ],
                    [
                        [0.2874845862388611, 0.21995815634727478],
                        [0.7518373727798462, 0.21993766725063324],
                        [0.7518429756164551, 0.23475976288318634],
                        [0.28748810291290283, 0.2347889393568039],
                    ],
                    [
                        [0.14624696969985962, 0.23590607941150665],
                        [0.2403545081615448, 0.23590004444122314],
                        [0.24035754799842834, 0.24950480461120605],
                        [0.14624960720539093, 0.2495124638080597],
                    ],
                    [
                        [0.1466398388147354, 0.2521074712276459],
                        [0.19352005422115326, 0.2521035075187683],
                        [0.19352225959300995, 0.26266488432884216],
                        [0.14664189517498016, 0.26266947388648987],
                    ],
                    [
                        [0.3029980957508087, 0.2549252212047577],
                        [0.45650190114974976, 0.2549116909503937],
                        [0.4565058648586273, 0.2685917615890503],
                        [0.30300140380859375, 0.2686079740524292],
                    ],
                    [
                        [0.30303794145584106, 0.2721414566040039],
                        [0.5902709364891052, 0.27210989594459534],
                        [0.5902754068374634, 0.2857564687728882],
                        [0.3030412495136261, 0.2857930064201355],
                    ],
                    [
                        [0.3030121326446533, 0.289725124835968],
                        [0.8629881739616394, 0.28965112566947937],
                        [0.8629942536354065, 0.30435818433761597],
                        [0.30301570892333984, 0.3044425845146179],
                    ],
                    [
                        [0.3028302490711212, 0.3071284592151642],
                        [0.5116226673126221, 0.3070962727069855],
                        [0.5116272568702698, 0.3219749629497528],
                        [0.3028338551521301, 0.3220110535621643],
                    ],
                    [
                        [0.2875204384326935, 0.3419681191444397],
                        [0.5263410210609436, 0.3419208228588104],
                        [0.5263455510139465, 0.35651692748069763],
                        [0.28752389550209045, 0.3565686345100403],
                    ],
                    [
                        [0.30307725071907043, 0.37664443254470825],
                        [0.8775664567947388, 0.3765054941177368],
                        [0.877572774887085, 0.3916288912296295],
                        [0.3030809164047241, 0.3917787969112396],
                    ],
                    [
                        [0.30239006876945496, 0.39405474066734314],
                        [0.515025794506073, 0.3939986526966095],
                        [0.5150303840637207, 0.40898075699806213],
                        [0.30239370465278625, 0.4090408682823181],
                    ],
                    [
                        [0.28716346621513367, 0.4288555085659027],
                        [0.8759559392929077, 0.4286743402481079],
                        [0.8759620785713196, 0.4433800280094147],
                        [0.2871669828891754, 0.44357213377952576],
                    ],
                    [
                        [0.287201851606369, 0.44659969210624695],
                        [0.3792406916618347, 0.4465692937374115],
                        [0.37924379110336304, 0.45823583006858826],
                        [0.28720465302467346, 0.45826756954193115],
                    ],
                    [
                        [0.28749221563339233, 0.4814157783985138],
                        [0.692423403263092, 0.4812643229961395],
                        [0.6924276947975159, 0.4930928647518158],
                        [0.28749504685401917, 0.49325037002563477],
                    ],
                    [
                        [0.3029406666755676, 0.5160695910453796],
                        [0.8905280828475952, 0.5158241391181946],
                        [0.8905344605445862, 0.5310320854187012],
                        [0.3029443621635437, 0.5312888622283936],
                    ],
                    [
                        [0.3033718466758728, 0.5333970189094543],
                        [0.8437100648880005, 0.5331594347953796],
                        [0.8437163233757019, 0.5484161972999573],
                        [0.30337557196617126, 0.5486641526222229],
                    ],
                    [
                        [0.3028319180011749, 0.5510737895965576],
                        [0.6314491033554077, 0.5509219765663147],
                        [0.6314542293548584, 0.5659676194190979],
                        [0.3028355836868286, 0.5661256909370422],
                    ],
                    [
                        [0.30282965302467346, 0.5681970715522766],
                        [0.46884089708328247, 0.5681167840957642],
                        [0.46884530782699585, 0.5830768942832947],
                        [0.30283328890800476, 0.5831602811813354],
                    ],
                    [
                        [0.3029538094997406, 0.5859693288803101],
                        [0.6517660021781921, 0.5857928395271301],
                        [0.6517713069915771, 0.6010309457778931],
                        [0.3029575049877167, 0.6012141704559326],
                    ],
                ],
            ],
            [
                '294',
                [
                    [
                        [0.14737001061439514, 0.06561606377363205],
                        [0.460766077041626, 0.06522460281848907],
                        [0.4607625901699066, 0.08047033846378326],
                        [0.14736264944076538, 0.08086052536964417],
                    ],
                    [
                        [0.14611752331256866, 0.08283699303865433],
                        [0.3400096595287323, 0.08259569853544235],
                        [0.34000465273857117, 0.09791209548711777],
                        [0.14611010253429413, 0.09815259277820587],
                    ],
                    [
                        [0.1462215781211853, 0.1393754631280899],
                        [0.7998255491256714, 0.13857199251651764],
                        [0.7998265027999878, 0.15949107706546783],
                        [0.1462114453315735, 0.1602908819913864],
                    ],
                    [
                        [0.14673003554344177, 0.16146966814994812],
                        [0.23579485714435577, 0.1613607108592987],
                        [0.2357897162437439, 0.17383956909179688],
                        [0.14672400057315826, 0.1739482283592224],
                    ],
                    [
                        [0.14665596187114716, 0.21394206583499908],
                        [0.2684248983860016, 0.21379481256008148],
                        [0.2684207260608673, 0.22462725639343262],
                        [0.14665073156356812, 0.22477415204048157],
                    ],
                    [
                        [0.28747469186782837, 0.21411222219467163],
                        [0.8708828091621399, 0.2134067714214325],
                        [0.870884358882904, 0.22845736145973206],
                        [0.28746911883354187, 0.22916045784950256],
                    ],
                    [
                        [0.1463811695575714, 0.23009832203388214],
                        [0.19356459379196167, 0.23004145920276642],
                        [0.19355979561805725, 0.24082405865192413],
                        [0.14637595415115356, 0.24088077247142792],
                    ],
                    [
                        [0.2876467704772949, 0.23156021535396576],
                        [0.5196495056152344, 0.23128077387809753],
                        [0.5196467041969299, 0.24644170701503754],
                        [0.28764116764068604, 0.24672020971775055],
                    ],
                    [
                        [0.28768372535705566, 0.2664068937301636],
                        [0.9006296992301941, 0.26567432284355164],
                        [0.9006316661834717, 0.2810608148574829],
                        [0.2876780331134796, 0.2817908525466919],
                    ],
                    [
                        [0.28778427839279175, 0.283917099237442],
                        [0.8786605596542358, 0.28321370482444763],
                        [0.8786622881889343, 0.29840001463890076],
                        [0.28777867555618286, 0.2991010248661041],
                    ],
                    [
                        [0.2876195013523102, 0.3012436032295227],
                        [0.8618295192718506, 0.30056270956993103],
                        [0.86183100938797, 0.3159414529800415],
                        [0.28761380910873413, 0.31661999225616455],
                    ],
                    [
                        [0.2876763343811035, 0.4755791127681732],
                        [0.892583429813385, 0.4748901426792145],
                        [0.892585277557373, 0.4902079701423645],
                        [0.28767067193984985, 0.49089446663856506],
                    ],
                    [
                        [0.2871036231517792, 0.5105224251747131],
                        [0.8198856115341187, 0.509920597076416],
                        [0.8198865056037903, 0.5245403051376343],
                        [0.2870981991291046, 0.5251400470733643],
                    ],
                    [
                        [0.28759169578552246, 0.3710467517375946],
                        [0.8629691004753113, 0.37037527561187744],
                        [0.8629706501960754, 0.3859787881374359],
                        [0.28758591413497925, 0.38664790987968445],
                    ],
                    [
                        [0.2879686951637268, 0.5453841090202332],
                        [0.4111078083515167, 0.5452461838722229],
                        [0.41110390424728394, 0.5598204135894775],
                        [0.287963330745697, 0.5599579215049744],
                    ],
                    [
                        [0.2876626253128052, 0.4230797588825226],
                        [0.9023378491401672, 0.4223710000514984],
                        [0.9023398160934448, 0.4377342164516449],
                        [0.2876569628715515, 0.4384404718875885],
                    ],
                    [
                        [0.2875284254550934, 0.44084393978118896],
                        [0.8992217779159546, 0.440141499042511],
                        [0.8992236852645874, 0.4552396535873413],
                        [0.2875228524208069, 0.4559395909309387],
                    ],
                ],
            ],
            [
                '293',
                [
                    [
                        [0.539416491985321, 0.06559097021818161],
                        [0.8523826003074646, 0.06566428393125534],
                        [0.8523793816566467, 0.08053651452064514],
                        [0.5394108295440674, 0.0804627537727356],
                    ],
                    [
                        [0.659496009349823, 0.08280880749225616],
                        [0.8527699708938599, 0.08285440504550934],
                        [0.852766752243042, 0.09782163798809052],
                        [0.659491240978241, 0.09777576476335526],
                    ],
                    [
                        [0.14673714339733124, 0.13932690024375916],
                        [0.7995777130126953, 0.1394844949245453],
                        [0.7995728254318237, 0.15948359668254852],
                        [0.14672531187534332, 0.1593247354030609],
                    ],
                    [
                        [0.14719846844673157, 0.16146300733089447],
                        [0.23534953594207764, 0.1614844650030136],
                        [0.2353428453207016, 0.17376385629177094],
                        [0.14719119668006897, 0.17374227941036224],
                    ],
                    [
                        [0.14640963077545166, 0.21410229802131653],
                        [0.23897576332092285, 0.21412532031536102],
                        [0.23896995186805725, 0.2248266190290451],
                        [0.14640329778194427, 0.22480349242687225],
                    ],
                    [
                        [0.28752732276916504, 0.213780015707016],
                        [0.8798187971115112, 0.2139272540807724],
                        [0.8798158168792725, 0.22894597053527832],
                        [0.28751954436302185, 0.22879785299301147],
                    ],
                    [
                        [0.14683857560157776, 0.23018290102481842],
                        [0.2421261966228485, 0.23020674288272858],
                        [0.2421203851699829, 0.2409498244524002],
                        [0.14683221280574799, 0.2409258931875229],
                    ],
                    [
                        [0.2878990173339844, 0.23136185109615326],
                        [0.8750899434089661, 0.23150883615016937],
                        [0.8750869035720825, 0.24630941450595856],
                        [0.2878913879394531, 0.2461615949869156],
                    ],
                    [
                        [0.14669270813465118, 0.24606648087501526],
                        [0.23906263709068298, 0.24608974158763885],
                        [0.23905539512634277, 0.25945165753364563],
                        [0.14668479561805725, 0.2594282627105713],
                    ],
                    [
                        [0.2878095507621765, 0.24877746403217316],
                        [0.5722877383232117, 0.24884915351867676],
                        [0.5722833871841431, 0.26086288690567017],
                        [0.2878033220767975, 0.2607908844947815],
                    ],
                    [
                        [0.14685854315757751, 0.26185011863708496],
                        [0.2294469028711319, 0.2618710398674011],
                        [0.2294396013021469, 0.275210440158844],
                        [0.14685063064098358, 0.2751893997192383],
                    ],
                    [
                        [0.3035912811756134, 0.28371140360832214],
                        [0.4498005509376526, 0.2837487459182739],
                        [0.4497941732406616, 0.29856356978416443],
                        [0.3035837709903717, 0.29852601885795593],
                    ],
                    [
                        [0.3034021854400635, 0.3010985553264618],
                        [0.7284678220748901, 0.3012078106403351],
                        [0.7284635901451111, 0.3161582052707672],
                        [0.3033945858478546, 0.3160483241081238],
                    ],
                    [
                        [0.30337798595428467, 0.31847867369651794],
                        [0.5416545867919922, 0.3185403347015381],
                        [0.5416488647460938, 0.33345621824264526],
                        [0.3033703863620758, 0.33339422941207886],
                    ],
                    [
                        [0.30325931310653687, 0.33596768975257874],
                        [0.5110465884208679, 0.3360218107700348],
                        [0.5110405683517456, 0.35110366344451904],
                        [0.30325162410736084, 0.3510492444038391],
                    ],
                    [
                        [0.3031575679779053, 0.3532896935939789],
                        [0.6447842717170715, 0.3533792495727539],
                        [0.6447793245315552, 0.3684578239917755],
                        [0.30314990878105164, 0.3683677613735199],
                    ],
                    [
                        [0.3034116327762604, 0.37090909481048584],
                        [0.6421809196472168, 0.37099847197532654],
                        [0.64217609167099, 0.38562434911727905],
                        [0.30340421199798584, 0.38553449511528015],
                    ],
                    [
                        [0.3028782606124878, 0.38841092586517334],
                        [0.4002598226070404, 0.38843676447868347],
                        [0.4002530872821808, 0.40314778685569763],
                        [0.3028707802295685, 0.4031217694282532],
                    ],
                    [
                        [0.3033507764339447, 0.4058476388454437],
                        [0.4921153485774994, 0.4058980941772461],
                        [0.49211058020591736, 0.4176117181777954],
                        [0.30334481596946716, 0.41756105422973633],
                    ],
                    [
                        [0.3027689456939697, 0.42304956912994385],
                        [0.8692911863327026, 0.42320188879966736],
                        [0.8692880868911743, 0.43816840648651123],
                        [0.3027613162994385, 0.43801525235176086],
                    ],
                    [
                        [0.3033823072910309, 0.4408976435661316],
                        [0.3751092851161957, 0.440917044878006],
                        [0.3751038908958435, 0.45235997438430786],
                        [0.3033764958381653, 0.4523404836654663],
                    ],
                    [
                        [0.30344855785369873, 0.457806795835495],
                        [0.8478368520736694, 0.457955002784729],
                        [0.8478336334228516, 0.4728991985321045],
                        [0.30344095826148987, 0.4727502167224884],
                    ],
                    [
                        [0.30300408601760864, 0.4752303957939148],
                        [0.4816003143787384, 0.4752793312072754],
                        [0.48159411549568176, 0.4902424216270447],
                        [0.3029964864253998, 0.4901932179927826],
                    ],
                    [
                        [0.3029005229473114, 0.4928700923919678],
                        [0.38982954621315, 0.4928940534591675],
                        [0.3898228108882904, 0.5074476599693298],
                        [0.30289310216903687, 0.5074235796928406],
                    ],
                    [
                        [0.3029450476169586, 0.5102452039718628],
                        [0.85122150182724, 0.5103972554206848],
                        [0.8512182831764221, 0.5250794291496277],
                        [0.3029375672340393, 0.5249266028404236],
                    ],
                    [
                        [0.3029145300388336, 0.5275042057037354],
                        [0.893657922744751, 0.5276690125465393],
                        [0.893655002117157, 0.5428123474121094],
                        [0.3029068112373352, 0.5426466464996338],
                    ],
                    [
                        [0.3030807375907898, 0.5455358028411865],
                        [0.37998977303504944, 0.54555743932724],
                        [0.3799830675125122, 0.5599425435066223],
                        [0.3030734360218048, 0.5599208474159241],
                    ],
                ],
            ],
            [
                '306',
                [
                    [
                        [0.3029806911945343, 0.4230339229106903],
                        [0.8611613512039185, 0.42286965250968933],
                        [0.8611763715744019, 0.43795931339263916],
                        [0.3029896318912506, 0.4381323456764221],
                    ],
                    [
                        [0.30330076813697815, 0.4403515160083771],
                        [0.60878586769104, 0.44025611877441406],
                        [0.6087977886199951, 0.4549218714237213],
                        [0.30330947041511536, 0.4550219178199768],
                    ],
                    [
                        [0.30302369594573975, 0.4578171968460083],
                        [0.840496838092804, 0.4576396048069],
                        [0.8405117392539978, 0.47282132506370544],
                        [0.30303269624710083, 0.4730073809623718],
                    ],
                    [
                        [0.301704078912735, 0.47547945380210876],
                        [0.8927518725395203, 0.47527334094047546],
                        [0.8927672505378723, 0.4903531074523926],
                        [0.3017129898071289, 0.49056845903396606],
                    ],
                    [
                        [0.3171122968196869, 0.49289411306381226],
                        [0.5445184707641602, 0.4928106963634491],
                        [0.544529914855957, 0.5077669620513916],
                        [0.31712132692337036, 0.5078539252281189],
                    ],
                    [
                        [0.30177244544029236, 0.5103945136070251],
                        [0.8382493853569031, 0.5101879835128784],
                        [0.838263988494873, 0.5250620245933533],
                        [0.3017812669277191, 0.525276780128479],
                    ],
                    [
                        [0.3171602785587311, 0.5274637341499329],
                        [0.8679280281066895, 0.5272420048713684],
                        [0.8679435849189758, 0.5427698493003845],
                        [0.3171696364879608, 0.5430004596710205],
                    ],
                    [
                        [0.31709226965904236, 0.5451295375823975],
                        [0.8797960877418518, 0.5448926687240601],
                        [0.8798113465309143, 0.559956431388855],
                        [0.3171013593673706, 0.5602021217346191],
                    ],
                    [
                        [0.31663766503334045, 0.5624916553497314],
                        [0.8854158520698547, 0.5622419714927673],
                        [0.8854314088821411, 0.5775766968727112],
                        [0.31664690375328064, 0.5778354406356812],
                    ],
                    [
                        [0.3030310273170471, 0.5800222158432007],
                        [0.8538399338722229, 0.5797703862190247],
                        [0.8538546562194824, 0.5946207642555237],
                        [0.3030398190021515, 0.594880998134613],
                    ],
                    [
                        [0.30332350730895996, 0.59700608253479],
                        [0.6612381935119629, 0.5968362092971802],
                        [0.6612516045570374, 0.6125890612602234],
                        [0.3033328354358673, 0.612764835357666],
                    ],
                    [
                        [0.6973692774772644, 0.6316351890563965],
                        [0.8533266186714172, 0.6315554976463318],
                        [0.8533392548561096, 0.6443435549736023],
                        [0.6973804831504822, 0.6444253325462341],
                    ],
                ],
            ],
            [
                '266',
                [
                    [
                        [0.11789555847644806, 0.05650382488965988],
                        [0.812187135219574, 0.05642607808113098],
                        [0.8122022747993469, 0.07158719003200531],
                        [0.11790204793214798, 0.071663036942482],
                    ],
                    [
                        [0.11703935265541077, 0.0946582704782486],
                        [0.71017986536026, 0.09459593892097473],
                        [0.7101961374282837, 0.11240877956151962],
                        [0.11704696714878082, 0.11246919631958008],
                    ],
                    [
                        [0.1261753886938095, 0.1507526934146881],
                        [0.23300985991954803, 0.1507425606250763],
                        [0.23301589488983154, 0.16229431331157684],
                        [0.12618041038513184, 0.16230422258377075],
                    ],
                    [
                        [0.2672395408153534, 0.15055926144123077],
                        [0.8581799864768982, 0.15050314366817474],
                        [0.8581953048706055, 0.16530007123947144],
                        [0.26724767684936523, 0.1653546243906021],
                    ],
                    [
                        [0.12591126561164856, 0.16818183660507202],
                        [0.22435054183006287, 0.16817279160022736],
                        [0.22435639798641205, 0.1795302778482437],
                        [0.12591619789600372, 0.17953911423683167],
                    ],
                    [
                        [0.2670876085758209, 0.16778627038002014],
                        [0.6467163562774658, 0.16775138676166534],
                        [0.6467293500900269, 0.18284286558628082],
                        [0.2670959234237671, 0.18287670612335205],
                    ],
                    [
                        [0.12608399987220764, 0.185014545917511],
                        [0.2057138830423355, 0.1850074827671051],
                        [0.20572133362293243, 0.19987498223781586],
                        [0.12609046697616577, 0.19988183677196503],
                    ],
                    [
                        [0.12578491866588593, 0.23749004304409027],
                        [0.2475316822528839, 0.23748038709163666],
                        [0.24753957986831665, 0.25225120782852173],
                        [0.12579134106636047, 0.2522605061531067],
                    ],
                    [
                        [0.2665785551071167, 0.23720666766166687],
                        [0.8777563571929932, 0.23715819418430328],
                        [0.8777722120285034, 0.25227969884872437],
                        [0.26658686995506287, 0.25232648849487305],
                    ],
                    [
                        [0.12601841986179352, 0.2549985647201538],
                        [0.20556361973285675, 0.2549925148487091],
                        [0.2055693417787552, 0.2664342224597931],
                        [0.12602339684963226, 0.26644012331962585],
                    ],
                    [
                        [0.2673356533050537, 0.25481292605400085],
                        [0.8457586169242859, 0.25476890802383423],
                        [0.8457738161087036, 0.2696245312690735],
                        [0.2673438489437103, 0.26966702938079834],
                    ],
                    [
                        [0.12598983943462372, 0.27231165766716003],
                        [0.211459681391716, 0.272305428981781],
                        [0.21146725118160248, 0.28729528188705444],
                        [0.12599635124206543, 0.28730127215385437],
                    ],
                    [
                        [0.267021507024765, 0.2721917927265167],
                        [0.8495851159095764, 0.2721492648124695],
                        [0.8496004939079285, 0.28712522983551025],
                        [0.267029732465744, 0.28716617822647095],
                    ],
                    [
                        [0.26676538586616516, 0.2898057699203491],
                        [0.37321650981903076, 0.2897983193397522],
                        [0.3732258379459381, 0.30441391468048096],
                        [0.26677343249320984, 0.304421067237854],
                    ],
                    [
                        [0.12590141594409943, 0.35773634910583496],
                        [0.18778325617313385, 0.3577328026294708],
                        [0.18779069185256958, 0.37305501103401184],
                        [0.12590807676315308, 0.37305840849876404],
                    ],
                    [
                        [0.26713207364082336, 0.35777783393859863],
                        [0.8634428381919861, 0.3577435314655304],
                        [0.8634588122367859, 0.37312373518943787],
                        [0.26714053750038147, 0.3731563985347748],
                    ],
                    [
                        [0.26704224944114685, 0.37539103627204895],
                        [0.8624658584594727, 0.3753586709499359],
                        [0.8624812364578247, 0.3901900053024292],
                        [0.2670504152774811, 0.3902207612991333],
                    ],
                    [
                        [0.26730313897132874, 0.39273709058761597],
                        [0.7427707314491272, 0.3927127420902252],
                        [0.742784857749939, 0.4077581465244293],
                        [0.2673114240169525, 0.4077812135219574],
                    ],
                    [
                        [0.12603192031383514, 0.46106234192848206],
                        [0.20871613919734955, 0.4610591232776642],
                        [0.2087220549583435, 0.4728177785873413],
                        [0.12603704631328583, 0.47282081842422485],
                    ],
                    [
                        [0.26709863543510437, 0.46091413497924805],
                        [0.8344215154647827, 0.46089205145835876],
                        [0.8344367742538452, 0.47593745589256287],
                        [0.26710692048072815, 0.475957989692688],
                    ],
                    [
                        [0.12615464627742767, 0.4787289798259735],
                        [0.23343516886234283, 0.4787251651287079],
                        [0.2334413230419159, 0.49049779772758484],
                        [0.12615975737571716, 0.49050140380859375],
                    ],
                    [
                        [0.26726076006889343, 0.4785260558128357],
                        [0.8714708685874939, 0.478504478931427],
                        [0.8714864253997803, 0.4934293329715729],
                        [0.26726898550987244, 0.49344930052757263],
                    ],
                ],
            ],
            [
                '287',
                [
                    [
                        [0.5390741229057312, 0.06585285067558289],
                        [0.852019190788269, 0.0656646266579628],
                        [0.8520268797874451, 0.08041587471961975],
                        [0.5390791893005371, 0.08060437440872192],
                    ],
                    [
                        [0.6592462062835693, 0.0827849954366684],
                        [0.8525341749191284, 0.08266854286193848],
                        [0.8525420427322388, 0.09769424051046371],
                        [0.6592524647712708, 0.09781086444854736],
                    ],
                    [
                        [0.18635016679763794, 0.13941837847232819],
                        [0.8137229681015015, 0.1390383094549179],
                        [0.8137330412864685, 0.15916384756565094],
                        [0.18635308742523193, 0.1595446765422821],
                    ],
                    [
                        [0.42274826765060425, 0.16269120573997498],
                        [0.576499342918396, 0.16259784996509552],
                        [0.5765066742897034, 0.18252477049827576],
                        [0.42275384068489075, 0.18261830508708954],
                    ],
                    [
                        [0.14671733975410461, 0.20136289298534393],
                        [0.2633133828639984, 0.20129182934761047],
                        [0.2633163630962372, 0.2170894294977188],
                        [0.14671927690505981, 0.21716061234474182],
                    ],
                    [
                        [0.14628936350345612, 0.2578546702861786],
                        [0.2649589776992798, 0.2577819228172302],
                        [0.2649616301059723, 0.2716618478298187],
                        [0.14629106223583221, 0.27173468470573425],
                    ],
                    [
                        [0.2874220609664917, 0.2583836019039154],
                        [0.620904266834259, 0.2581792175769806],
                        [0.620910108089447, 0.2731087803840637],
                        [0.28742510080337524, 0.2733134627342224],
                    ],
                    [
                        [0.280398964881897, 0.2946908175945282],
                        [0.32846859097480774, 0.2946612536907196],
                        [0.328471839427948, 0.30897992849349976],
                        [0.2804017961025238, 0.30900952219963074],
                    ],
                    [
                        [0.5397607684135437, 0.294694185256958],
                        [0.6422393321990967, 0.29463115334510803],
                        [0.6422450542449951, 0.3088594675064087],
                        [0.5397656559944153, 0.30892255902290344],
                    ],
                    [
                        [0.8604609370231628, 0.2946382462978363],
                        [0.8889469504356384, 0.29462072253227234],
                        [0.8889531493186951, 0.3060150742530823],
                        [0.8604669570922852, 0.30603262782096863],
                    ],
                    [
                        [0.8546659350395203, 0.3119555115699768],
                        [0.8948335647583008, 0.311930775642395],
                        [0.8948413729667664, 0.32619407773017883],
                        [0.8546733856201172, 0.326218843460083],
                    ],
                    [
                        [0.301008015871048, 0.3305074870586395],
                        [0.3069908022880554, 0.33050379157066345],
                        [0.30699312686920166, 0.3413870334625244],
                        [0.3010103106498718, 0.3413907289505005],
                    ],
                    [
                        [0.3434407413005829, 0.33009377121925354],
                        [0.8373304009437561, 0.3297889828681946],
                        [0.8373379111289978, 0.3443855047225952],
                        [0.34344416856765747, 0.3446907103061676],
                    ],
                    [
                        [0.8568372130393982, 0.33060750365257263],
                        [0.8817408084869385, 0.3305921256542206],
                        [0.881746768951416, 0.34165024757385254],
                        [0.8568430542945862, 0.3416656255722046],
                    ],
                    [
                        [0.2991420030593872, 0.34878310561180115],
                        [0.3087159991264343, 0.3487772047519684],
                        [0.30871835350990295, 0.3597574234008789],
                        [0.29914432764053345, 0.35976335406303406],
                    ],
                    [
                        [0.3435152471065521, 0.3485276699066162],
                        [0.7298990488052368, 0.34828880429267883],
                        [0.7299056053161621, 0.3627966642379761],
                        [0.3435186743736267, 0.3630358576774597],
                    ],
                    [
                        [0.8570225834846497, 0.34849047660827637],
                        [0.8816953897476196, 0.34847521781921387],
                        [0.8817015886306763, 0.3599770963191986],
                        [0.857028603553772, 0.3599923551082611],
                    ],
                    [
                        [0.29942965507507324, 0.36717352271080017],
                        [0.3082424998283386, 0.3671680688858032],
                        [0.30824488401412964, 0.3783224821090698],
                        [0.2994319796562195, 0.3783279359340668],
                    ],
                    [
                        [0.34355756640434265, 0.366875559091568],
                        [0.7550269365310669, 0.3666207492351532],
                        [0.7550337314605713, 0.3811015188694],
                        [0.34356096386909485, 0.38135668635368347],
                    ],
                    [
                        [0.8569990992546082, 0.3665803372859955],
                        [0.882327675819397, 0.36656466126441956],
                        [0.8823340535163879, 0.3784233033657074],
                        [0.8570053577423096, 0.3784390091896057],
                    ],
                    [
                        [0.29887276887893677, 0.3854950964450836],
                        [0.3091593384742737, 0.38548871874809265],
                        [0.3091616928577423, 0.396328866481781],
                        [0.29887503385543823, 0.39633527398109436],
                    ],
                    [
                        [0.3437310755252838, 0.3852970004081726],
                        [0.794228196144104, 0.3850175142288208],
                        [0.794235110282898, 0.3990885019302368],
                        [0.34373435378074646, 0.39936837553977966],
                    ],
                    [
                        [0.8571335673332214, 0.38534632325172424],
                        [0.8903072476387024, 0.38532572984695435],
                        [0.8903135061264038, 0.3967677354812622],
                        [0.8571395874023438, 0.3967883288860321],
                    ],
                    [
                        [0.2996341288089752, 0.4038901627063751],
                        [0.30856066942214966, 0.403884619474411],
                        [0.3085630238056183, 0.41495367884635925],
                        [0.29963645339012146, 0.41495922207832336],
                    ],
                    [
                        [0.34382709860801697, 0.4034847915172577],
                        [0.4919011890888214, 0.4033927619457245],
                        [0.4919048845767975, 0.4149894714355469],
                        [0.34382984042167664, 0.41508159041404724],
                    ],
                    [
                        [0.8570616245269775, 0.4035987854003906],
                        [0.8920993804931641, 0.4035769999027252],
                        [0.8921055793762207, 0.4148939847946167],
                        [0.8570675849914551, 0.4149157702922821],
                    ],
                    [
                        [0.29940712451934814, 0.42202550172805786],
                        [0.3091375231742859, 0.42201945185661316],
                        [0.3091399669647217, 0.433319091796875],
                        [0.2994094789028168, 0.4333251416683197],
                    ],
                    [
                        [0.3436928391456604, 0.4219838082790375],
                        [0.8247710466384888, 0.4216843247413635],
                        [0.8247783184051514, 0.4360252916812897],
                        [0.3436962068080902, 0.43632522225379944],
                    ],
                    [
                        [0.8570905923843384, 0.42197027802467346],
                        [0.8924828171730042, 0.42194825410842896],
                        [0.8924890160560608, 0.4332970678806305],
                        [0.8570965528488159, 0.4333191215991974],
                    ],
                    [
                        [0.2994743287563324, 0.4406786859035492],
                        [0.30889901518821716, 0.4406728148460388],
                        [0.3089013695716858, 0.4517258107662201],
                        [0.29947665333747864, 0.45173168182373047],
                    ],
                    [
                        [0.3434886932373047, 0.44028058648109436],
                        [0.8208516240119934, 0.43998289108276367],
                        [0.8208587765693665, 0.4541493356227875],
                        [0.3434920310974121, 0.4544474482536316],
                    ],
                    [
                        [0.8574662208557129, 0.44016215205192566],
                        [0.8928490877151489, 0.4401400685310364],
                        [0.8928552865982056, 0.45142990350723267],
                        [0.8574721813201904, 0.45145198702812195],
                    ],
                    [
                        [0.299786776304245, 0.4587913751602173],
                        [0.30875539779663086, 0.4587857723236084],
                        [0.30875784158706665, 0.4702225923538208],
                        [0.299789160490036, 0.4702281951904297],
                    ],
                    [
                        [0.34341660141944885, 0.45841076970100403],
                        [0.5104895830154419, 0.4583064019680023],
                        [0.5104944705963135, 0.473154753446579],
                        [0.3434200882911682, 0.4732592701911926],
                    ],
                    [
                        [0.8571516275405884, 0.45883387327194214],
                        [0.8920228481292725, 0.45881208777427673],
                        [0.8920291066169739, 0.4701939821243286],
                        [0.8571576476097107, 0.4702157974243164],
                    ],
                ],
            ],
            [
                '291',
                [
                    [
                        [0.5389367341995239, 0.06561268121004105],
                        [0.852226972579956, 0.06579317897558212],
                        [0.852226972579956, 0.0807579830288887],
                        [0.5389354228973389, 0.08057721704244614],
                    ],
                    [
                        [0.6596298217773438, 0.08296588063240051],
                        [0.8528454899787903, 0.08307738602161407],
                        [0.8528454899787903, 0.09772534668445587],
                        [0.6596289873123169, 0.09761367738246918],
                    ],
                    [
                        [0.1468699425458908, 0.13933347165584564],
                        [0.7993249297142029, 0.13971208035945892],
                        [0.799324631690979, 0.15955132246017456],
                        [0.14686602354049683, 0.15917198359966278],
                    ],
                    [
                        [0.14740432798862457, 0.16152827441692352],
                        [0.23587606847286224, 0.16157971322536469],
                        [0.2358739972114563, 0.1735694259405136],
                        [0.14740195870399475, 0.17351792752742767],
                    ],
                    [
                        [0.14684924483299255, 0.21365343034267426],
                        [0.2349870353937149, 0.2137049436569214],
                        [0.23498503863811493, 0.22527408599853516],
                        [0.1468469500541687, 0.22522251307964325],
                    ],
                    [
                        [0.14689284563064575, 0.2302502989768982],
                        [0.21362420916557312, 0.23028936982154846],
                        [0.2136223167181015, 0.24080736935138702],
                        [0.1468907594680786, 0.24076826870441437],
                    ],
                    [
                        [0.14695023000240326, 0.2461978942155838],
                        [0.2104845643043518, 0.24623514711856842],
                        [0.2104821801185608, 0.2594655454158783],
                        [0.14694762229919434, 0.2594282329082489],
                    ],
                    [
                        [0.14694100618362427, 0.2619718909263611],
                        [0.22933587431907654, 0.2620202600955963],
                        [0.22933357954025269, 0.2751334607601166],
                        [0.14693841338157654, 0.2750850319862366],
                    ],
                    [
                        [0.31740862131118774, 0.29680633544921875],
                        [0.3793725371360779, 0.2968428432941437],
                        [0.37937068939208984, 0.3109174072742462],
                        [0.3174065053462982, 0.3108808398246765],
                    ],
                    [
                        [0.6021999716758728, 0.29685479402542114],
                        [0.6991575360298157, 0.29691192507743835],
                        [0.6991569399833679, 0.31104087829589844],
                        [0.6021989583969116, 0.31098368763923645],
                    ],
                    [
                        [0.29383814334869385, 0.31510916352272034],
                        [0.3309994041919708, 0.3151310980319977],
                        [0.3309977650642395, 0.3265148997306824],
                        [0.2938363552093506, 0.32649293541908264],
                    ],
                    [
                        [0.4106018841266632, 0.314758837223053],
                        [0.8520514965057373, 0.3150193393230438],
                        [0.8520514965057373, 0.3295946717262268],
                        [0.41060006618499756, 0.3293337821960449],
                    ],
                    [
                        [0.29390180110931396, 0.33260002732276917],
                        [0.3940638303756714, 0.33265921473503113],
                        [0.3940623998641968, 0.34374380111694336],
                        [0.2939000725746155, 0.34368452429771423],
                    ],
                    [
                        [0.41129499673843384, 0.33208906650543213],
                        [0.5446200966835022, 0.3321678638458252],
                        [0.5446188449859619, 0.3468996286392212],
                        [0.4112931787967682, 0.3468207120895386],
                    ],
                    [
                        [0.29390406608581543, 0.34990718960762024],
                        [0.3640892505645752, 0.3499487340450287],
                        [0.36408767104148865, 0.3613606095314026],
                        [0.29390227794647217, 0.36131900548934937],
                    ],
                    [
                        [0.2938982844352722, 0.36741331219673157],
                        [0.3700850307941437, 0.3674584925174713],
                        [0.3700835108757019, 0.3786868751049042],
                        [0.29389652609825134, 0.37864163517951965],
                    ],
                    [
                        [0.4108584523200989, 0.3667658269405365],
                        [0.8649895787239075, 0.3670351505279541],
                        [0.8649896383285522, 0.38200587034225464],
                        [0.41085660457611084, 0.381736159324646],
                    ],
                    [
                        [0.41083812713623047, 0.3842977285385132],
                        [0.8328681588172913, 0.3845484256744385],
                        [0.8328680396080017, 0.3992104232311249],
                        [0.4108363091945648, 0.39895936846733093],
                    ],
                    [
                        [0.41069459915161133, 0.4018327295780182],
                        [0.7558344602584839, 0.4020380973815918],
                        [0.7558341026306152, 0.4163232147693634],
                        [0.41069284081459045, 0.4161175489425659],
                    ],
                    [
                        [0.29419374465942383, 0.4200443625450134],
                        [0.35143351554870605, 0.42007848620414734],
                        [0.3514314591884613, 0.43468567728996277],
                        [0.2941914498806, 0.4346514940261841],
                    ],
                    [
                        [0.41080647706985474, 0.42014622688293457],
                        [0.8735004663467407, 0.4204220473766327],
                        [0.8735005855560303, 0.4350564777851105],
                        [0.4108046591281891, 0.4347802996635437],
                    ],
                    [
                        [0.29396072030067444, 0.43767914175987244],
                        [0.3965924084186554, 0.4377404451370239],
                        [0.39659056067466736, 0.4523349404335022],
                        [0.2939584255218506, 0.45227357745170593],
                    ],
                    [
                        [0.4109901189804077, 0.43739014863967896],
                        [0.8864373564720154, 0.43767401576042175],
                        [0.8864375352859497, 0.4527648687362671],
                        [0.4109882712364197, 0.45248058438301086],
                    ],
                    [
                        [0.29408159852027893, 0.4553601145744324],
                        [0.31749477982521057, 0.4553741216659546],
                        [0.3174930214881897, 0.4671836495399475],
                        [0.2940797507762909, 0.4671696126461029],
                    ],
                    [
                        [0.41073042154312134, 0.45506376028060913],
                        [0.8639726042747498, 0.4553348124027252],
                        [0.8639726638793945, 0.46993887424468994],
                        [0.4107286334037781, 0.4696674644947052],
                    ],
                    [
                        [0.29402264952659607, 0.4724804759025574],
                        [0.389906108379364, 0.47253790497779846],
                        [0.3899042010307312, 0.487297385931015],
                        [0.2940203547477722, 0.48723986744880676],
                    ],
                    [
                        [0.41085532307624817, 0.47251126170158386],
                        [0.6291132569313049, 0.4726420044898987],
                        [0.6291123628616333, 0.4873841404914856],
                        [0.4108535051345825, 0.48725321888923645],
                    ],
                    [
                        [0.29398924112319946, 0.49043625593185425],
                        [0.34151673316955566, 0.4904647767543793],
                        [0.34151509404182434, 0.5017697811126709],
                        [0.2939874529838562, 0.5017412304878235],
                    ],
                    [
                        [0.2937201261520386, 0.5085222721099854],
                        [0.3924081325531006, 0.5085815787315369],
                        [0.39240631461143494, 0.5228043794631958],
                        [0.2937178909778595, 0.5227449536323547],
                    ],
                    [
                        [0.4109155833721161, 0.5081236958503723],
                        [0.8770992159843445, 0.5084038972854614],
                        [0.877099335193634, 0.5231496095657349],
                        [0.41091376543045044, 0.5228690505027771],
                    ],
                    [
                        [0.2938414514064789, 0.5260705947875977],
                        [0.3221167027950287, 0.5260876417160034],
                        [0.322115033864975, 0.5373265743255615],
                        [0.293839693069458, 0.5373095273971558],
                    ],
                    [
                        [0.29405075311660767, 0.5445879101753235],
                        [0.36987924575805664, 0.5446336269378662],
                        [0.36987733840942383, 0.5587657690048218],
                        [0.294048547744751, 0.5587199926376343],
                    ],
                    [
                        [0.41064608097076416, 0.5440471172332764],
                        [0.8785309791564941, 0.5443292856216431],
                        [0.8785310983657837, 0.5591429471969604],
                        [0.4106442332267761, 0.5588603615760803],
                    ],
                    [
                        [0.2941836714744568, 0.5615484118461609],
                        [0.3744107782840729, 0.5615968704223633],
                        [0.3744092285633087, 0.5733004212379456],
                        [0.29418182373046875, 0.5732519030570984],
                    ],
                    [
                        [0.4108443260192871, 0.5613747835159302],
                        [0.8758774995803833, 0.5616556406021118],
                        [0.8758776187896729, 0.5766284465789795],
                        [0.4108424782752991, 0.5763471722602844],
                    ],
                    [
                        [0.29408299922943115, 0.5790652632713318],
                        [0.39009350538253784, 0.579123318195343],
                        [0.39009159803390503, 0.5937175750732422],
                        [0.2940807342529297, 0.5936594009399414],
                    ],
                ],
            ],
            [
                '295',
                [
                    [
                        [0.28767678141593933, 0.4057973623275757],
                        [0.8781893849372864, 0.4055977463722229],
                        [0.8781957626342773, 0.42054620385169983],
                        [0.28768032789230347, 0.4207455515861511],
                    ],
                    [
                        [0.28751468658447266, 0.44067302346229553],
                        [0.8554316759109497, 0.44048166275024414],
                        [0.8554379940032959, 0.455470472574234],
                        [0.2875182628631592, 0.4556615650653839],
                    ],
                    [
                        [0.28760164976119995, 0.4578647017478943],
                        [0.8940253853797913, 0.4576607048511505],
                        [0.8940319418907166, 0.47284331917762756],
                        [0.28760528564453125, 0.47304701805114746],
                    ],
                    [
                        [0.2874000072479248, 0.4756729304790497],
                        [0.417185515165329, 0.47562935948371887],
                        [0.4171887934207916, 0.48729315400123596],
                        [0.28740277886390686, 0.487336665391922],
                    ],
                    [
                        [0.14625293016433716, 0.5276390314102173],
                        [0.2519814074039459, 0.5276036858558655],
                        [0.2519844174385071, 0.540902853012085],
                        [0.1462555080652237, 0.540938138961792],
                    ],
                    [
                        [0.2874152958393097, 0.5274524092674255],
                        [0.8447495102882385, 0.5272662043571472],
                        [0.8447557687759399, 0.542243242263794],
                        [0.2874188721179962, 0.5424292087554932],
                    ],
                    [
                        [0.14659538865089417, 0.5435431599617004],
                        [0.1803908795118332, 0.5435318946838379],
                        [0.1803930699825287, 0.5542584657669067],
                        [0.1465974599123001, 0.5542697310447693],
                    ],
                    [
                        [0.2872738540172577, 0.5449333190917969],
                        [0.8858066201210022, 0.5447336435317993],
                        [0.8858130574226379, 0.5596334934234619],
                        [0.2872774004936218, 0.5598328709602356],
                    ],
                    [
                        [0.2874104380607605, 0.5624050498008728],
                        [0.764994740486145, 0.5622459650039673],
                        [0.7650007009506226, 0.5775232911109924],
                        [0.2874140739440918, 0.5776820778846741],
                    ],
                    [
                        [0.287387490272522, 0.5971305966377258],
                        [0.8675878047943115, 0.5969380140304565],
                        [0.867594301700592, 0.6121482849121094],
                        [0.2873910963535309, 0.6123405694961548],
                    ],
                    [
                        [0.2872597873210907, 0.6148121356964111],
                        [0.8773112297058105, 0.6146166324615479],
                        [0.8773176074028015, 0.6294777989387512],
                        [0.28726333379745483, 0.6296730637550354],
                    ],
                    [
                        [0.28763720393180847, 0.6319549679756165],
                        [0.872585117816925, 0.6317614912986755],
                        [0.8725916147232056, 0.6469464302062988],
                        [0.2876408100128174, 0.6471396088600159],
                    ],
                    [
                        [0.2878592610359192, 0.6495835185050964],
                        [0.8953027725219727, 0.6493829488754272],
                        [0.8953092098236084, 0.6642723083496094],
                        [0.2878628075122833, 0.6644726395606995],
                    ],
                    [
                        [0.2876411974430084, 0.6668554544448853],
                        [0.8141984939575195, 0.6666818261146545],
                        [0.814204752445221, 0.6819905638694763],
                        [0.2876448631286621, 0.6821638941764832],
                    ],
                    [
                        [0.288031667470932, 0.6844419240951538],
                        [0.6227649450302124, 0.6843317747116089],
                        [0.6227700114250183, 0.6990077495574951],
                        [0.28803518414497375, 0.6991177201271057],
                    ],
                    [
                        [0.6971954703330994, 0.7184225916862488],
                        [0.8530160188674927, 0.7183715105056763],
                        [0.853021502494812, 0.7313910722732544],
                        [0.6972002983093262, 0.7314421534538269],
                    ],
                ],
            ],
            [
                '288',
                [
                    [
                        [0.14750465750694275, 0.06555385887622833],
                        [0.4608724117279053, 0.06555481255054474],
                        [0.46087783575057983, 0.08044562488794327],
                        [0.14750804007053375, 0.08045339584350586],
                    ],
                    [
                        [0.1461615264415741, 0.08269664645195007],
                        [0.3399980366230011, 0.0826910212635994],
                        [0.34000277519226074, 0.09789764881134033],
                        [0.14616496860980988, 0.09790877997875214],
                    ],
                    [
                        [0.14776486158370972, 0.13930867612361908],
                        [0.8271268010139465, 0.13921710848808289],
                        [0.8271373510360718, 0.15937912464141846],
                        [0.14776943624019623, 0.15949632227420807],
                    ],
                    [
                        [0.14769338071346283, 0.1628672331571579],
                        [0.2637040615081787, 0.16284649074077606],
                        [0.2637084722518921, 0.17865926027297974],
                        [0.14769697189331055, 0.17868342995643616],
                    ],
                    [
                        [0.14698413014411926, 0.21985451877117157],
                        [0.2464255839586258, 0.21982614696025848],
                        [0.24642926454544067, 0.2334747016429901],
                        [0.14698722958564758, 0.23350560665130615],
                    ],
                    [
                        [0.2873762547969818, 0.22003783285617828],
                        [0.5266914367675781, 0.21996945142745972],
                        [0.5266971588134766, 0.23457150161266327],
                        [0.2873804569244385, 0.23464640974998474],
                    ],
                    [
                        [0.30259591341018677, 0.2372587025165558],
                        [0.8068644404411316, 0.23709839582443237],
                        [0.8068721890449524, 0.2521567642688751],
                        [0.30260035395622253, 0.25233128666877747],
                    ],
                    [
                        [0.14658229053020477, 0.289526104927063],
                        [0.2164580076932907, 0.2894970774650574],
                        [0.21646146476268768, 0.3029717803001404],
                        [0.1465853452682495, 0.30300256609916687],
                    ],
                    [
                        [0.2876823842525482, 0.2894826829433441],
                        [0.8701229691505432, 0.28924068808555603],
                        [0.8701311349868774, 0.304297536611557],
                        [0.2876867353916168, 0.3045559525489807],
                    ],
                    [
                        [0.28770890831947327, 0.30649372935295105],
                        [0.8705426454544067, 0.3062330484390259],
                        [0.8705512285232544, 0.3219772279262543],
                        [0.2877134382724762, 0.32225510478019714],
                    ],
                    [
                        [0.2878434658050537, 0.3243188261985779],
                        [0.9021205902099609, 0.32402360439300537],
                        [0.9021291136741638, 0.3393116593360901],
                        [0.2878478765487671, 0.33962446451187134],
                    ],
                    [
                        [0.2873710095882416, 0.3419573903083801],
                        [0.41338708996772766, 0.34189268946647644],
                        [0.41339111328125, 0.3535880446434021],
                        [0.2873743772506714, 0.35365551710128784],
                    ],
                    [
                        [0.2877770662307739, 0.37668630480766296],
                        [0.8645073771476746, 0.3763526976108551],
                        [0.8645154237747192, 0.3913172483444214],
                        [0.28778138756752014, 0.39166703820228577],
                    ],
                    [
                        [0.28810036182403564, 0.39412984251976013],
                        [0.544101357460022, 0.3939734101295471],
                        [0.5441073775291443, 0.40907326340675354],
                        [0.28810471296310425, 0.4092369079589844],
                    ],
                    [
                        [0.14645078778266907, 0.4464360475540161],
                        [0.23058921098709106, 0.44637641310691833],
                        [0.2305920422077179, 0.45715367794036865],
                        [0.14645321667194366, 0.45721498131752014],
                    ],
                    [
                        [0.2878035306930542, 0.44636502861976624],
                        [0.9025201201438904, 0.4459293782711029],
                        [0.9025286436080933, 0.46128255128860474],
                        [0.2878079414367676, 0.46173587441444397],
                    ],
                    [
                        [0.14654497802257538, 0.46223101019859314],
                        [0.24345725774765015, 0.4621594548225403],
                        [0.24346095323562622, 0.4758947491645813],
                        [0.1465480923652649, 0.47596877813339233],
                    ],
                    [
                        [0.28759077191352844, 0.46370425820350647],
                        [0.7069220542907715, 0.4633934795856476],
                        [0.7069292068481445, 0.4786386489868164],
                        [0.28759515285491943, 0.47896137833595276],
                    ],
                    [
                        [0.2879240810871124, 0.49861371517181396],
                        [0.887975811958313, 0.49812984466552734],
                        [0.8879842162132263, 0.5133600234985352],
                        [0.2879284620285034, 0.5138610005378723],
                    ],
                    [
                        [0.2875276803970337, 0.5161592960357666],
                        [0.8869205713272095, 0.5156562924385071],
                        [0.8869287967681885, 0.5306439995765686],
                        [0.2875320017337799, 0.53116375207901],
                    ],
                ],
            ],
            [
                '295',
                [
                    [
                        [0.539033055305481, 0.06574272364377975],
                        [0.852068305015564, 0.06563345342874527],
                        [0.8520745038986206, 0.0804327055811882],
                        [0.539037823677063, 0.08054182678461075],
                    ],
                    [
                        [0.6591775417327881, 0.08281771838665009],
                        [0.8525181412696838, 0.0827503427863121],
                        [0.85252445936203, 0.09777643531560898],
                        [0.6591829061508179, 0.0978437215089798],
                    ],
                    [
                        [0.14697617292404175, 0.139318585395813],
                        [0.8338474631309509, 0.1390804499387741],
                        [0.8338558673858643, 0.15929366648197174],
                        [0.14698007702827454, 0.1595313400030136],
                    ],
                    [
                        [0.14669308066368103, 0.1965162605047226],
                        [0.24617484211921692, 0.19648195803165436],
                        [0.24617794156074524, 0.21021902561187744],
                        [0.14669573307037354, 0.2102532982826233],
                    ],
                    [
                        [0.2872035801410675, 0.19668079912662506],
                        [0.5377397537231445, 0.19659440219402313],
                        [0.5377445220947266, 0.21152770519256592],
                        [0.28720712661743164, 0.2116139829158783],
                    ],
                    [
                        [0.30268773436546326, 0.21415437757968903],
                        [0.806306779384613, 0.2139810025691986],
                        [0.8063127994537354, 0.22883197665214539],
                        [0.30269134044647217, 0.2290051132440567],
                    ],
                    [
                        [0.14659886062145233, 0.26635339856147766],
                        [0.23825937509536743, 0.26632198691368103],
                        [0.23826181888580322, 0.27730751037597656],
                        [0.14660099148750305, 0.2773388624191284],
                    ],
                    [
                        [0.28749266266822815, 0.26623034477233887],
                        [0.8459809422492981, 0.26603901386260986],
                        [0.8459872603416443, 0.281223326921463],
                        [0.28749629855155945, 0.2814143896102905],
                    ],
                    [
                        [0.14615380764007568, 0.2819831073284149],
                        [0.23065489530563354, 0.28195422887802124],
                        [0.23065733909606934, 0.2930666208267212],
                        [0.1461559534072876, 0.29309549927711487],
                    ],
                    [
                        [0.2877562344074249, 0.28352147340774536],
                        [0.8973616361618042, 0.28331297636032104],
                        [0.8973681926727295, 0.298394113779068],
                        [0.28775984048843384, 0.2986023426055908],
                    ],
                    [
                        [0.146419495344162, 0.2981879711151123],
                        [0.24118326604366302, 0.29815560579299927],
                        [0.24118566513061523, 0.3088398575782776],
                        [0.14642155170440674, 0.30887219309806824],
                    ],
                    [
                        [0.28765687346458435, 0.30115315318107605],
                        [0.860557496547699, 0.3009575307369232],
                        [0.8605626225471497, 0.3130456507205963],
                        [0.28765976428985596, 0.31324106454849243],
                    ],
                    [
                        [0.14680038392543793, 0.31411537528038025],
                        [0.20387673377990723, 0.3140959143638611],
                        [0.20387963950634003, 0.3278194069862366],
                        [0.14680305123329163, 0.32783883810043335],
                    ],
                    [
                        [0.2878435552120209, 0.31829899549484253],
                        [0.8951819539070129, 0.3180919587612152],
                        [0.895188570022583, 0.3332950472831726],
                        [0.2878471910953522, 0.33350178599357605],
                    ],
                    [
                        [0.2875235378742218, 0.3360525667667389],
                        [0.8503329753875732, 0.3358610272407532],
                        [0.8503391742706299, 0.3506457209587097],
                        [0.28752708435058594, 0.35083699226379395],
                    ],
                    [
                        [0.287692666053772, 0.3533061742782593],
                        [0.8179804682731628, 0.35312601923942566],
                        [0.8179866075515747, 0.3681909441947937],
                        [0.2876962721347809, 0.3683708608150482],
                    ],
                    [
                        [0.28779247403144836, 0.38806384801864624],
                        [0.85870361328125, 0.3878704905509949],
                        [0.8587100505828857, 0.40310460329055786],
                        [0.28779610991477966, 0.40329766273498535],
                    ],
                    [
                        [0.28767678141593933, 0.4057973623275757],
                        [0.8781893849372864, 0.4055977463722229],
                        [0.8781957626342773, 0.42054620385169983],
                        [0.28768032789230347, 0.4207455515861511],
                    ],
                ],
            ],
            [
                '297',
                [
                    [
                        [0.5386052131652832, 0.06537359207868576],
                        [0.8525691628456116, 0.06566179543733597],
                        [0.8525486588478088, 0.08114071935415268],
                        [0.5385820269584656, 0.08085101842880249],
                    ],
                    [
                        [0.6593629121780396, 0.08272149413824081],
                        [0.8529859781265259, 0.0829002633690834],
                        [0.8529661893844604, 0.0978381410241127],
                        [0.6593415141105652, 0.09765848517417908],
                    ],
                    [
                        [0.14590701460838318, 0.13904255628585815],
                        [0.7808009386062622, 0.13963982462882996],
                        [0.7807735800743103, 0.15968908369541168],
                        [0.14587274193763733, 0.1590878814458847],
                    ],
                    [
                        [0.1479397714138031, 0.1629786491394043],
                        [0.263624370098114, 0.16308832168579102],
                        [0.2635987102985382, 0.17867833375930786],
                        [0.1479131430387497, 0.17856809496879578],
                    ],
                    [
                        [0.1468902975320816, 0.21975813806056976],
                        [0.2464350461959839, 0.21985425055027008],
                        [0.24641238152980804, 0.23355451226234436],
                        [0.14686688780784607, 0.23345796763896942],
                    ],
                    [
                        [0.28728535771369934, 0.2197660654783249],
                        [0.5380465984344482, 0.22000817954540253],
                        [0.5380247831344604, 0.23460793495178223],
                        [0.2872615456581116, 0.23436468839645386],
                    ],
                    [
                        [0.30258041620254517, 0.23689082264900208],
                        [0.7760114669799805, 0.23735041916370392],
                        [0.775990903377533, 0.25241804122924805],
                        [0.30255594849586487, 0.2519562244415283],
                    ],
                    [
                        [0.14632822573184967, 0.28955399990081787],
                        [0.21652542054653168, 0.28962329030036926],
                        [0.2165030837059021, 0.30299875140190125],
                        [0.14630535244941711, 0.30292919278144836],
                    ],
                    [
                        [0.2875610589981079, 0.2889498174190521],
                        [0.8650087118148804, 0.28951966762542725],
                        [0.8649886846542358, 0.3046981394290924],
                        [0.28753629326820374, 0.30412557721138],
                    ],
                    [
                        [0.2876010537147522, 0.3066525459289551],
                        [0.6215865015983582, 0.30698394775390625],
                        [0.6215645670890808, 0.32212549448013306],
                        [0.2875763475894928, 0.3217925429344177],
                    ],
                    [
                        [0.2874019742012024, 0.34132158756256104],
                        [0.8855732679367065, 0.34192150831222534],
                        [0.8855530023574829, 0.3574396073818207],
                        [0.28737664222717285, 0.35683682560920715],
                    ],
                    [
                        [0.28765371441841125, 0.3575253188610077],
                        [0.767402172088623, 0.35800889134407043],
                        [0.7673797607421875, 0.37436598539352417],
                        [0.2876270115375519, 0.373879998922348],
                    ],
                    [
                        [0.14658084511756897, 0.4113348424434662],
                        [0.24682429432868958, 0.4114375412464142],
                        [0.24680186808109283, 0.4249960482120514],
                        [0.14655767381191254, 0.42489293217658997],
                    ],
                    [
                        [0.2879370152950287, 0.4110940992832184],
                        [0.6309303641319275, 0.4114454686641693],
                        [0.6309088468551636, 0.4263465702533722],
                        [0.2879126965999603, 0.4259936213493347],
                    ],
                    [
                        [0.2872481346130371, 0.44582533836364746],
                        [0.6094183325767517, 0.4461587965488434],
                        [0.6093957424163818, 0.4616667628288269],
                        [0.28722283244132996, 0.4613317549228668],
                    ],
                ],
            ],
            [
                '232',
                [
                    [
                        [0.11137711256742477, 0.39943477511405945],
                        [0.17946815490722656, 0.39949095249176025],
                        [0.1794636845588684, 0.41023099422454834],
                        [0.11137242615222931, 0.41017478704452515],
                    ],
                    [
                        [0.11147987842559814, 0.4151434898376465],
                        [0.20888808369636536, 0.4152238965034485],
                        [0.20888368785381317, 0.42599913477897644],
                        [0.11147516965866089, 0.42591872811317444],
                    ],
                    [
                        [0.25812357664108276, 0.41953980922698975],
                        [0.8623825907707214, 0.4200385510921478],
                        [0.8623793125152588, 0.43526509404182434],
                        [0.25811758637428284, 0.4347662627696991],
                    ],
                    [
                        [0.25861549377441406, 0.4368625581264496],
                        [0.8738711476325989, 0.4373704791069031],
                        [0.8738679885864258, 0.4523050785064697],
                        [0.2586096227169037, 0.4517970681190491],
                    ],
                    [
                        [0.25808024406433105, 0.4542968273162842],
                        [0.8582656979560852, 0.45479241013526917],
                        [0.8582624793052673, 0.4697539210319519],
                        [0.2580743730068207, 0.46925824880599976],
                    ],
                    [
                        [0.2580609619617462, 0.4720718264579773],
                        [0.4934009313583374, 0.47226619720458984],
                        [0.4933960735797882, 0.4872743785381317],
                        [0.25805506110191345, 0.4870799779891968],
                    ],
                    [
                        [0.25817543268203735, 0.5239151120185852],
                        [0.8353143334388733, 0.5243920683860779],
                        [0.8353109955787659, 0.5392085313796997],
                        [0.25816962122917175, 0.5387315154075623],
                    ],
                    [
                        [0.25771021842956543, 0.5764909982681274],
                        [0.33558401465415955, 0.5765553712844849],
                        [0.33557847142219543, 0.5914878249168396],
                        [0.25770434737205505, 0.5914234519004822],
                    ],
                    [
                        [0.2734828293323517, 0.610686719417572],
                        [0.6263934373855591, 0.6109786629676819],
                        [0.6263889670372009, 0.626579761505127],
                        [0.2734767496585846, 0.6262877583503723],
                    ],
                    [
                        [0.27351754903793335, 0.628017246723175],
                        [0.8646867871284485, 0.6285064220428467],
                        [0.8646833896636963, 0.6442042589187622],
                        [0.27351143956184387, 0.6437150239944458],
                    ],
                    [
                        [0.27368658781051636, 0.6462603807449341],
                        [0.4246842563152313, 0.6463853716850281],
                        [0.4246792793273926, 0.660842776298523],
                        [0.2736809551715851, 0.660717785358429],
                    ],
                    [
                        [0.273909330368042, 0.6628262996673584],
                        [0.7531896829605103, 0.6632230281829834],
                        [0.7531858086585999, 0.6788918375968933],
                        [0.2739032208919525, 0.6784949898719788],
                    ],
                    [
                        [0.2575944662094116, 0.6980077028274536],
                        [0.8701831698417664, 0.698514997959137],
                        [0.8701799511909485, 0.7137523889541626],
                        [0.2575884759426117, 0.7132450342178345],
                    ],
                    [
                        [0.2582509219646454, 0.7153195142745972],
                        [0.594537615776062, 0.7155980467796326],
                        [0.5945330858230591, 0.73079514503479],
                        [0.25824493169784546, 0.7305165529251099],
                    ],
                    [
                        [0.2582506537437439, 0.7502221465110779],
                        [0.8596760630607605, 0.7507205009460449],
                        [0.8596728444099426, 0.7656351923942566],
                        [0.2582447826862335, 0.7651367783546448],
                    ],
                    [
                        [0.2582530081272125, 0.7678946256637573],
                        [0.7957754731178284, 0.7683401107788086],
                        [0.7957720160484314, 0.7832920551300049],
                        [0.25824713706970215, 0.7828464508056641],
                    ],
                    [
                        [0.25977474451065063, 0.7854136824607849],
                        [0.7952079772949219, 0.7858575582504272],
                        [0.7952044606208801, 0.8009229898452759],
                        [0.2597688138484955, 0.8004790544509888],
                    ],
                    [
                        [0.7269331216812134, 0.8197587728500366],
                        [0.8827235102653503, 0.8198879957199097],
                        [0.8827208876609802, 0.8325785398483276],
                        [0.7269298434257507, 0.8324493169784546],
                    ],
                ],
            ],
            [
                '296',
                [
                    [
                        [0.14756262302398682, 0.06568913161754608],
                        [0.4606887996196747, 0.06568124890327454],
                        [0.4606971740722656, 0.08044490963220596],
                        [0.147568017244339, 0.0804527997970581],
                    ],
                    [
                        [0.1461256742477417, 0.08289644122123718],
                        [0.3397350311279297, 0.0828915685415268],
                        [0.3397423326969147, 0.0977935716509819],
                        [0.14613111317157745, 0.09779845178127289],
                    ],
                    [
                        [0.1470399647951126, 0.13935504853725433],
                        [0.8395698070526123, 0.13933756947517395],
                        [0.8395860195159912, 0.15935832262039185],
                        [0.1470472812652588, 0.15937581658363342],
                    ],
                    [
                        [0.14702175557613373, 0.16154202818870544],
                        [0.23582231998443604, 0.16153977811336517],
                        [0.2358274757862091, 0.17374444007873535],
                        [0.1470262110233307, 0.17374669015407562],
                    ],
                    [
                        [0.14663134515285492, 0.2141425609588623],
                        [0.2489912509918213, 0.21413996815681458],
                        [0.2489970326423645, 0.22755002975463867],
                        [0.1466362327337265, 0.2275526225566864],
                    ],
                    [
                        [0.28771093487739563, 0.21404874324798584],
                        [0.876369833946228, 0.214033842086792],
                        [0.876382052898407, 0.22871044278144836],
                        [0.2877176105976105, 0.2287253439426422],
                    ],
                    [
                        [0.14622068405151367, 0.2301858514547348],
                        [0.1798967868089676, 0.23018500208854675],
                        [0.17990101873874664, 0.24115808308124542],
                        [0.14622467756271362, 0.24115894734859467],
                    ],
                    [
                        [0.28753453493118286, 0.23151570558547974],
                        [0.851672351360321, 0.23150143027305603],
                        [0.8516845107078552, 0.2463892698287964],
                        [0.28754130005836487, 0.24640357494354248],
                    ],
                    [
                        [0.2874836325645447, 0.26632317900657654],
                        [0.8817896842956543, 0.26630809903144836],
                        [0.8818022608757019, 0.28137221932411194],
                        [0.28749051690101624, 0.2813872992992401],
                    ],
                    [
                        [0.28729045391082764, 0.2837575078010559],
                        [0.8435636758804321, 0.28374341130256653],
                        [0.8435757160186768, 0.2985265254974365],
                        [0.28729718923568726, 0.2985406517982483],
                    ],
                    [
                        [0.2876872718334198, 0.30107057094573975],
                        [0.8447046875953674, 0.3010564148426056],
                        [0.8447144627571106, 0.31309664249420166],
                        [0.28769275546073914, 0.3131107985973358],
                    ],
                    [
                        [0.287395179271698, 0.3184462785720825],
                        [0.8786141872406006, 0.3184312582015991],
                        [0.8786267042160034, 0.33345547318458557],
                        [0.2874020040035248, 0.33347049355506897],
                    ],
                    [
                        [0.2874355912208557, 0.33602869510650635],
                        [0.8891428112983704, 0.33601340651512146],
                        [0.8891555070877075, 0.3511156439781189],
                        [0.28744247555732727, 0.3511309325695038],
                    ],
                    [
                        [0.2878626585006714, 0.3534010946750641],
                        [0.7654748558998108, 0.3533889353275299],
                        [0.7654862403869629, 0.368315190076828],
                        [0.2878694534301758, 0.3683273196220398],
                    ],
                    [
                        [0.14647679030895233, 0.40586960315704346],
                        [0.26426076889038086, 0.4058665931224823],
                        [0.26426658034324646, 0.41903671622276306],
                        [0.14648160338401794, 0.4190397262573242],
                    ],
                    [
                        [0.28779613971710205, 0.405768483877182],
                        [0.8824322819709778, 0.40575331449508667],
                        [0.8824448585510254, 0.4208277761936188],
                        [0.2878030240535736, 0.4208429157733917],
                    ],
                    [
                        [0.14623403549194336, 0.4216398000717163],
                        [0.21587620675563812, 0.42163801193237305],
                        [0.2158806473016739, 0.4324793219566345],
                        [0.14623799920082092, 0.4324811100959778],
                    ],
                    [
                        [0.28764545917510986, 0.42295128107070923],
                        [0.6646599769592285, 0.422941654920578],
                        [0.6646704077720642, 0.4378853142261505],
                        [0.28765225410461426, 0.43789491057395935],
                    ],
                ],
            ],
        ],
    },
]

export const FreddieDocPromptExamples = [
    {
        question: 'How to use rental income to qualify for a loan?',
        InitialChatTitle: 'Using Rental Earnings for Qualification',
        Answer: "Based on the Freddie Mac guidelines, here is the answer:\n\nRental income can be used for qualification in several ways, depending on the property type:\n\n1. For 2- to 4-unit Primary Residences, subject 1- to 4-unit Investment Properties, and non-subject Investment Properties:\n- Net rental income must be calculated and documented properly\n- The borrower must demonstrate a history of managing rental properties\n- At least one borrower needs a minimum of one year of investment property management experience to use the full amount of net rental income for qualifying\n\n2. For 1-unit Primary Residences:\n- Rental income can be considered from a live-in aide\n- Rental income from an ADU (Accessory Dwelling Unit) may be used for qualification, subject to specific delivery requirements\n\nKey Documentation Requirements:\n- Form 72 or 1000 is required for subject properties\n- Current lease agreements\n- Documentation of rental management experience\n- Market rent analysis may be required\n\nImportant Considerations:\n- If current market rents don't reasonably support the gross rental income, the lender must:\n  * Determine if additional documentation is needed to support income stability\n  * Provide a written analysis explaining any discrepancies\n  * Justify that the rental income used is stable and likely to continue\n\nFor properties purchased or placed in service in the current calendar year, additional documentation requirements may apply.\n\nReference: Freddie Mac Single-Family Seller/Servicer Guide, Sections 5306.4(a), 5306.4(a)(i), and 5306.4(a)(iii)",
        QuoteLocations: [
            [
                '1015',
                [
                    [
                        [0.11806238442659378, 0.12084463238716125],
                        [0.8346046209335327, 0.12093015015125275],
                        [0.8346202969551086, 0.14321355521678925],
                        [0.11806555092334747, 0.14312045276165009],
                    ],
                    [
                        [0.11766649782657623, 0.14698009192943573],
                        [0.873203456401825, 0.14707966148853302],
                        [0.8732197880744934, 0.1693558394908905],
                        [0.11766965687274933, 0.16924826800823212],
                    ],
                    [
                        [0.11776433885097504, 0.1731070876121521],
                        [0.3106235861778259, 0.173134908080101],
                        [0.3106301724910736, 0.19554945826530457],
                        [0.11776752024888992, 0.1955195963382721],
                    ],
                    [
                        [0.11758250743150711, 0.2209891676902771],
                        [0.8742995858192444, 0.22111551463603973],
                        [0.874310314655304, 0.23575450479984283],
                        [0.11758458614349365, 0.23562289774417877],
                    ],
                    [
                        [0.14652690291404724, 0.23840349912643433],
                        [0.6385489702224731, 0.23848973214626312],
                        [0.6385570168495178, 0.2530883848667145],
                        [0.14652930200099945, 0.2529987692832947],
                    ],
                    [
                        [0.14592567086219788, 0.27335456013679504],
                        [0.8784304261207581, 0.2734951078891754],
                        [0.8784411549568176, 0.2879924178123474],
                        [0.1459280401468277, 0.28784680366516113],
                    ],
                    [
                        [0.14654426276683807, 0.2908858358860016],
                        [0.6349416971206665, 0.2909836173057556],
                        [0.6349496245384216, 0.30543771386146545],
                        [0.1465466469526291, 0.305336594581604],
                    ],
                    [
                        [0.14028730988502502, 0.3258596956729889],
                        [0.5386140942573547, 0.32594606280326843],
                        [0.5386208295822144, 0.34026017785072327],
                        [0.14028958976268768, 0.34017109870910645],
                    ],
                    [
                        [0.17567263543605804, 0.36069440841674805],
                        [0.8497058749198914, 0.3608517348766327],
                        [0.8497164249420166, 0.3755921423435211],
                        [0.1756753921508789, 0.3754301071166992],
                    ],
                    [
                        [0.11720821261405945, 0.9276914000511169],
                        [0.4419247806072235, 0.9278547167778015],
                        [0.44192957878112793, 0.9399833679199219],
                        [0.11720992624759674, 0.9398181438446045],
                    ],
                    [
                        [0.7934643626213074, 0.9279463291168213],
                        [0.8821588158607483, 0.9279909133911133],
                        [0.8821675777435303, 0.9399073123931885],
                        [0.7934723496437073, 0.9398621916770935],
                    ],
                    [
                        [0.11730467528104782, 0.9423863887786865],
                        [0.21537551283836365, 0.9424363970756531],
                        [0.21537765860557556, 0.9522826671600342],
                        [0.11730606853961945, 0.9522321820259094],
                    ],
                ],
            ],
            [
                '955',
                [
                    [
                        [0.36048153042793274, 0.7881572246551514],
                        [0.8731032013893127, 0.7887541651725769],
                        [0.8731016516685486, 0.803749680519104],
                        [0.36047717928886414, 0.8031502962112427],
                    ],
                    [
                        [0.3605528175830841, 0.805677592754364],
                        [0.8482481241226196, 0.8062481880187988],
                        [0.8482464551925659, 0.8212016820907593],
                        [0.3605484962463379, 0.8206287622451782],
                    ],
                    [
                        [0.3604866564273834, 0.8235511779785156],
                        [0.47913435101509094, 0.82369065284729],
                        [0.4791315495967865, 0.8351810574531555],
                        [0.360483318567276, 0.8350411057472229],
                    ],
                    [
                        [0.11767042428255081, 0.8660141229629517],
                        [0.5688825249671936, 0.8665506839752197],
                        [0.5688793063163757, 0.8815462589263916],
                        [0.11766475439071655, 0.8810075521469116],
                    ],
                    [
                        [0.11698731034994125, 0.9371417760848999],
                        [0.44229596853256226, 0.9375359416007996],
                        [0.4422927498817444, 0.949877142906189],
                        [0.11698263883590698, 0.949481725692749],
                    ],
                    [
                        [0.7938227653503418, 0.9372965097427368],
                        [0.8821370601654053, 0.9374034404754639],
                        [0.8821358680725098, 0.9497788548469543],
                        [0.7938211560249329, 0.9496715068817139],
                    ],
                    [
                        [0.11717472970485687, 0.9519198536872864],
                        [0.21537446975708008, 0.9520393013954163],
                        [0.2153710126876831, 0.9621031880378723],
                        [0.11717092245817184, 0.9619834423065186],
                    ],
                ],
            ],
            [
                '840',
                [
                    [
                        [0.14642982184886932, 0.7041711211204529],
                        [0.7923533916473389, 0.7047885656356812],
                        [0.792344331741333, 0.7193216681480408],
                        [0.14641918241977692, 0.7187018990516663],
                    ],
                    [
                        [0.1464828997850418, 0.7214048504829407],
                        [0.8032679557800293, 0.7220354080200195],
                        [0.8032586574554443, 0.7370016574859619],
                        [0.14647193253040314, 0.7363686561584473],
                    ],
                    [
                        [0.14643123745918274, 0.7387969493865967],
                        [0.8509410619735718, 0.7394763231277466],
                        [0.8509318828582764, 0.7544220685958862],
                        [0.14642030000686646, 0.7537400722503662],
                    ],
                    [
                        [0.14645126461982727, 0.7566513419151306],
                        [0.2331082820892334, 0.7567353248596191],
                        [0.233100026845932, 0.7682369351387024],
                        [0.14644283056259155, 0.7681527733802795],
                    ],
                    [
                        [0.1461523026227951, 0.7909306287765503],
                        [0.8699713945388794, 0.7916378378868103],
                        [0.8699623346328735, 0.8064026236534119],
                        [0.14614148437976837, 0.8056928515434265],
                    ],
                    [
                        [0.14681750535964966, 0.8088857531547546],
                        [0.4584141671657562, 0.8091915249824524],
                        [0.4584042429924011, 0.8238011598587036],
                        [0.14680680632591248, 0.8234942555427551],
                    ],
                    [
                        [0.17553351819515228, 0.8433411717414856],
                        [0.8708451390266418, 0.8440293669700623],
                        [0.8708360195159912, 0.8589789271354675],
                        [0.17552264034748077, 0.8582881689071655],
                    ],
                    [
                        [0.17597916722297668, 0.8607100248336792],
                        [0.8627092242240906, 0.8613926768302917],
                        [0.8627002239227295, 0.8761035799980164],
                        [0.1759684830904007, 0.8754185438156128],
                    ],
                    [
                        [0.176260307431221, 0.8787338733673096],
                        [0.4011482000350952, 0.8789584040641785],
                        [0.4011383354663849, 0.8932589292526245],
                        [0.1762499064207077, 0.8930336236953735],
                    ],
                    [
                        [0.11707376688718796, 0.9275422692298889],
                        [0.44209766387939453, 0.9278706312179565],
                        [0.4420892894268036, 0.9401106238365173],
                        [0.11706475168466568, 0.9397813081741333],
                    ],
                    [
                        [0.7930968999862671, 0.9278748035430908],
                        [0.8803055882453918, 0.9279628992080688],
                        [0.8802982568740845, 0.9399930238723755],
                        [0.7930893898010254, 0.9399046301841736],
                    ],
                    [
                        [0.11723119765520096, 0.9422624707221985],
                        [0.2152504324913025, 0.9423618316650391],
                        [0.21524325013160706, 0.9523219466209412],
                        [0.11722385883331299, 0.9522223472595215],
                    ],
                ],
            ],
            [
                '594',
                [
                    [
                        [0.11670105904340744, 0.8062623143196106],
                        [0.4724588990211487, 0.8061114549636841],
                        [0.47246789932250977, 0.821107804775238],
                        [0.11670905351638794, 0.8212577104568481],
                    ],
                    [
                        [0.14660942554473877, 0.8410497903823853],
                        [0.5085120797157288, 0.8408986330032349],
                        [0.5085206031799316, 0.854986310005188],
                        [0.14661701023578644, 0.8551365733146667],
                    ],
                    [
                        [0.14681856334209442, 0.8758230209350586],
                        [0.8275817036628723, 0.8755428791046143],
                        [0.8275914788246155, 0.890228807926178],
                        [0.14682649075984955, 0.890507161617279],
                    ],
                    [
                        [0.11711394041776657, 0.9278817176818848],
                        [0.4420038163661957, 0.9277510643005371],
                        [0.4420110583305359, 0.9398952126502991],
                        [0.1171204224228859, 0.9400252103805542],
                    ],
                    [
                        [0.7932603359222412, 0.9277006983757019],
                        [0.8800005316734314, 0.9276657700538635],
                        [0.8800089359283447, 0.9400891065597534],
                        [0.7932685613632202, 0.9401237964630127],
                    ],
                    [
                        [0.11724389344453812, 0.9423531889915466],
                        [0.2154136747121811, 0.9423139691352844],
                        [0.21541918814182281, 0.9522797465324402],
                        [0.11724921315908432, 0.9523187875747681],
                    ],
                ],
            ],
            [
                '999',
                [
                    [
                        [0.17610813677310944, 0.8117858171463013],
                        [0.624189019203186, 0.8117071390151978],
                        [0.6241952180862427, 0.8266230225563049],
                        [0.17611338198184967, 0.8266996145248413],
                    ],
                    [
                        [0.20752350986003876, 0.8467667698860168],
                        [0.41010749340057373, 0.8467333912849426],
                        [0.41011306643486023, 0.8612558245658875],
                        [0.20752866566181183, 0.86128830909729],
                    ],
                    [
                        [0.23475566506385803, 0.8815497756004333],
                        [0.8664247393608093, 0.8814525008201599],
                        [0.8664313554763794, 0.8963199257850647],
                        [0.23476101458072662, 0.8964142799377441],
                    ],
                    [
                        [0.1170690730214119, 0.9277192950248718],
                        [0.4419824779033661, 0.9276739358901978],
                        [0.44198721647262573, 0.9398914575576782],
                        [0.11707326024770737, 0.9399356245994568],
                    ],
                    [
                        [0.7932202816009521, 0.927584171295166],
                        [0.882490336894989, 0.927571713924408],
                        [0.8824959397315979, 0.9400737881660461],
                        [0.7932257056236267, 0.9400858879089355],
                    ],
                    [
                        [0.11720192432403564, 0.9423207640647888],
                        [0.21538060903549194, 0.9423074722290039],
                        [0.21538420021533966, 0.952342689037323],
                        [0.11720536649227142, 0.952355682849884],
                    ],
                ],
            ],
            [
                '1347',
                [
                    [
                        [0.09076259285211563, 0.7600062489509583],
                        [0.7001222372055054, 0.7603985667228699],
                        [0.700124979019165, 0.7892952561378479],
                        [0.09075839817523956, 0.7889000773429871],
                    ],
                    [
                        [0.09113507717847824, 0.8220354914665222],
                        [0.23591427505016327, 0.8221301436424255],
                        [0.23591259121894836, 0.8412759900093079],
                        [0.09113230556249619, 0.8411808013916016],
                    ],
                    [
                        [0.09061633050441742, 0.9063966870307922],
                        [0.3416886329650879, 0.9065644145011902],
                        [0.3416879177093506, 0.9221742749214172],
                        [0.09061406552791595, 0.9220058917999268],
                    ],
                    [
                        [0.8180596828460693, 0.906624972820282],
                        [0.8850340843200684, 0.9066697359085083],
                        [0.8850367069244385, 0.922150194644928],
                        [0.8180618286132812, 0.9221053123474121],
                    ],
                    [
                        [0.09069282561540604, 0.9250645041465759],
                        [0.166285440325737, 0.9251152276992798],
                        [0.16628398001194, 0.9377648234367371],
                        [0.0906909927725792, 0.9377139210700989],
                    ],
                ],
            ],
            [
                '879',
                [
                    [
                        [0.3079547882080078, 0.6017906069755554],
                        [0.8743394017219543, 0.6014800071716309],
                        [0.8743445873260498, 0.6200522184371948],
                        [0.30795639753341675, 0.6203622817993164],
                    ],
                    [
                        [0.30785971879959106, 0.6244844794273376],
                        [0.3878369927406311, 0.6244406700134277],
                        [0.38783910870552063, 0.64305180311203],
                        [0.3078612983226776, 0.6430954933166504],
                    ],
                    [
                        [0.09083928912878036, 0.6869533658027649],
                        [0.7627511024475098, 0.686587929725647],
                        [0.7627556920051575, 0.7055809497833252],
                        [0.09083953499794006, 0.7059456706047058],
                    ],
                    [
                        [0.11332987993955612, 0.732367217540741],
                        [0.8941082954406738, 0.7319444417953491],
                        [0.8941138386726379, 0.7514306306838989],
                        [0.11333027482032776, 0.7518525719642639],
                    ],
                    [
                        [0.11327408254146576, 0.754561185836792],
                        [0.9022015333175659, 0.7541349530220032],
                        [0.9022068977355957, 0.7728989124298096],
                        [0.1132744625210762, 0.7733243703842163],
                    ],
                    [
                        [0.1134527251124382, 0.7773669958114624],
                        [0.6264968514442444, 0.7770904302597046],
                        [0.6265004277229309, 0.7956486940383911],
                        [0.11345310509204865, 0.7959247827529907],
                    ],
                    [
                        [0.09061796218156815, 0.9065881371498108],
                        [0.3416665494441986, 0.9064545631408691],
                        [0.3416680693626404, 0.9219235181808472],
                        [0.09061815589666367, 0.9220569133758545],
                    ],
                    [
                        [0.8181213140487671, 0.9065374135971069],
                        [0.8858696818351746, 0.9065013527870178],
                        [0.8858740925788879, 0.9220884442329407],
                        [0.8181253671646118, 0.922124445438385],
                    ],
                    [
                        [0.09075189381837845, 0.9250870943069458],
                        [0.1663609892129898, 0.925046980381012],
                        [0.1663614809513092, 0.9378497004508972],
                        [0.09075205773115158, 0.937889814376831],
                    ],
                ],
            ],
            [
                '1006',
                [
                    [
                        [0.3267301023006439, 0.5343363881111145],
                        [0.8144630193710327, 0.5342292189598083],
                        [0.814469575881958, 0.5488156080245972],
                        [0.32673415541648865, 0.5489214658737183],
                    ],
                    [
                        [0.32660993933677673, 0.5691666007041931],
                        [0.448731392621994, 0.569140613079071],
                        [0.4487350881099701, 0.580674409866333],
                        [0.3266131579875946, 0.580700159072876],
                    ],
                    [
                        [0.35621169209480286, 0.5936771631240845],
                        [0.8437786102294922, 0.5935755968093872],
                        [0.8437855243682861, 0.6086111068725586],
                        [0.35621604323387146, 0.608711302280426],
                    ],
                    [
                        [0.3562936782836914, 0.6116192936897278],
                        [0.5198574662208557, 0.611585795879364],
                        [0.5198624730110168, 0.6260585188865662],
                        [0.3562978506088257, 0.6260915994644165],
                    ],
                    [
                        [0.3559591472148895, 0.636518657207489],
                        [0.8071334958076477, 0.6364283561706543],
                        [0.8071399927139282, 0.6509741544723511],
                        [0.3559633493423462, 0.6510632038116455],
                    ],
                    [
                        [0.3537938594818115, 0.654066264629364],
                        [0.8098297119140625, 0.6539765000343323],
                        [0.809836208820343, 0.6684261560440063],
                        [0.3537980318069458, 0.6685146689414978],
                    ],
                    [
                        [0.35615965723991394, 0.6714695692062378],
                        [0.8066843152046204, 0.6713823676109314],
                        [0.8066908121109009, 0.6857982277870178],
                        [0.3561638295650482, 0.6858841180801392],
                    ],
                    [
                        [0.35602396726608276, 0.689121425151825],
                        [0.42357394099235535, 0.6891086101531982],
                        [0.4235774278640747, 0.7002135515213013],
                        [0.35602718591690063, 0.7002262473106384],
                    ],
                    [
                        [0.1400146484375, 0.7159890532493591],
                        [0.781248927116394, 0.7158704400062561],
                        [0.7812542915344238, 0.7281308770179749],
                        [0.14001725614070892, 0.7282479405403137],
                    ],
                    [
                        [0.1330290585756302, 0.7480937242507935],
                        [0.48146387934684753, 0.7480314373970032],
                        [0.48146870732307434, 0.7624996900558472],
                        [0.13303211331367493, 0.762561023235321],
                    ],
                    [
                        [0.17567802965641022, 0.783115804195404],
                        [0.8733972311019897, 0.7829957008361816],
                        [0.8734040856361389, 0.7975683212280273],
                        [0.17568132281303406, 0.7976865172386169],
                    ],
                    [
                        [0.17588327825069427, 0.8005899786949158],
                        [0.23465029895305634, 0.8005800247192383],
                        [0.2346537858247757, 0.8147387504577637],
                        [0.17588646709918976, 0.8147485256195068],
                    ],
                    [
                        [0.11720603704452515, 0.9277794361114502],
                        [0.4420369565486908, 0.9277324676513672],
                        [0.4420408308506012, 0.9398442506790161],
                        [0.11720851808786392, 0.9398903846740723],
                    ],
                    [
                        [0.7936283946037292, 0.9276590347290039],
                        [0.8826857209205627, 0.9276462197303772],
                        [0.8826915621757507, 0.9399758577346802],
                        [0.7936338782310486, 0.9399885535240173],
                    ],
                    [
                        [0.11733179539442062, 0.9423742890357971],
                        [0.2153140902519226, 0.9423604011535645],
                        [0.21531647443771362, 0.9522834420204163],
                        [0.11733382940292358, 0.9522971510887146],
                    ],
                ],
            ],
            [
                '1017',
                [
                    [
                        [0.3265148401260376, 0.5342238545417786],
                        [0.8142750263214111, 0.5342574119567871],
                        [0.8142780065536499, 0.5488333106040955],
                        [0.3265157639980316, 0.5487989187240601],
                    ],
                    [
                        [0.32637396454811096, 0.5690683722496033],
                        [0.44861114025115967, 0.5690772533416748],
                        [0.4486123323440552, 0.5807040929794312],
                        [0.32637470960617065, 0.5806950330734253],
                    ],
                    [
                        [0.35616859793663025, 0.5936022400856018],
                        [0.843428909778595, 0.5936391949653625],
                        [0.8434321284294128, 0.6086036562919617],
                        [0.3561697006225586, 0.6085658073425293],
                    ],
                    [
                        [0.35598477721214294, 0.6114404201507568],
                        [0.5197667479515076, 0.6114532351493835],
                        [0.519768476486206, 0.6261219382286072],
                        [0.3559858500957489, 0.6261088848114014],
                    ],
                    [
                        [0.35584667325019836, 0.636463463306427],
                        [0.8069243431091309, 0.6365000605583191],
                        [0.8069274425506592, 0.6515721678733826],
                        [0.3558477759361267, 0.6515347957611084],
                    ],
                    [
                        [0.35388287901878357, 0.6538371443748474],
                        [0.809606671333313, 0.6538749933242798],
                        [0.8096096515655518, 0.6685624718666077],
                        [0.3538839519023895, 0.6685237884521484],
                    ],
                    [
                        [0.35597819089889526, 0.6713764071464539],
                        [0.8065328598022461, 0.671414852142334],
                        [0.8065357804298401, 0.685914933681488],
                        [0.3559792637825012, 0.6858757138252258],
                    ],
                    [
                        [0.35592418909072876, 0.6890923976898193],
                        [0.4236975312232971, 0.6890982985496521],
                        [0.4236985743045807, 0.7002393007278442],
                        [0.3559249937534332, 0.7002332806587219],
                    ],
                    [
                        [0.13985760509967804, 0.7159321904182434],
                        [0.7819029092788696, 0.7159903645515442],
                        [0.7819052934646606, 0.7282006144523621],
                        [0.13985773921012878, 0.7281415462493896],
                    ],
                    [
                        [0.13221684098243713, 0.7479607462882996],
                        [0.4813733696937561, 0.7479937076568604],
                        [0.48137497901916504, 0.7626228928565979],
                        [0.13221697509288788, 0.7625893354415894],
                    ],
                    [
                        [0.17551343142986298, 0.7830299735069275],
                        [0.8732224702835083, 0.7830988168716431],
                        [0.8732256889343262, 0.7977050542831421],
                        [0.17551375925540924, 0.7976349592208862],
                    ],
                    [
                        [0.17617256939411163, 0.8005279302597046],
                        [0.23444274067878723, 0.8005338311195374],
                        [0.2344432920217514, 0.81475430727005],
                        [0.1761728823184967, 0.8147483468055725],
                    ],
                    [
                        [0.11707848310470581, 0.9276284575462341],
                        [0.44182464480400085, 0.927666187286377],
                        [0.44182583689689636, 0.9398819208145142],
                        [0.11707854270935059, 0.9398437142372131],
                    ],
                    [
                        [0.7933603525161743, 0.9277871251106262],
                        [0.8823072910308838, 0.9277974367141724],
                        [0.8823100328445435, 0.9399054050445557],
                        [0.7933627367019653, 0.93989497423172],
                    ],
                    [
                        [0.11726988852024078, 0.9423518776893616],
                        [0.21529191732406616, 0.942363440990448],
                        [0.21529226005077362, 0.9522842764854431],
                        [0.11726993322372437, 0.9522725939750671],
                    ],
                ],
            ],
            [
                '915',
                [
                    [
                        [0.30796918272972107, 0.6019656658172607],
                        [0.8743720054626465, 0.6016688346862793],
                        [0.8743772506713867, 0.620232343673706],
                        [0.307971328496933, 0.6205294132232666],
                    ],
                    [
                        [0.3077503740787506, 0.6246799826622009],
                        [0.38795432448387146, 0.6246379017829895],
                        [0.3879568874835968, 0.6431079506874084],
                        [0.30775249004364014, 0.6431500315666199],
                    ],
                    [
                        [0.09084582328796387, 0.6870439648628235],
                        [0.7627692818641663, 0.6866905093193054],
                        [0.7627740502357483, 0.7059217691421509],
                        [0.09084678441286087, 0.7062755227088928],
                    ],
                    [
                        [0.11347787827253342, 0.7327101826667786],
                        [0.8940869569778442, 0.732298731803894],
                        [0.8940925598144531, 0.7515828013420105],
                        [0.11347898095846176, 0.7519945502281189],
                    ],
                    [
                        [0.11325938254594803, 0.754822850227356],
                        [0.902133047580719, 0.7544066309928894],
                        [0.9021385312080383, 0.7731839418411255],
                        [0.11326044797897339, 0.7736004590988159],
                    ],
                    [
                        [0.11341562122106552, 0.7777026295661926],
                        [0.6265151500701904, 0.7774316668510437],
                        [0.6265191435813904, 0.7961717247962952],
                        [0.11341668665409088, 0.7964429259300232],
                    ],
                    [
                        [0.0905366912484169, 0.9069063067436218],
                        [0.34164029359817505, 0.9067729711532593],
                        [0.34164223074913025, 0.9223084449768066],
                        [0.09053746610879898, 0.922441840171814],
                    ],
                    [
                        [0.8180142045021057, 0.9069186449050903],
                        [0.8858608603477478, 0.906882643699646],
                        [0.885865330696106, 0.9224621653556824],
                        [0.81801837682724, 0.9224982261657715],
                    ],
                    [
                        [0.09062520414590836, 0.9254189133644104],
                        [0.16638615727424622, 0.925378680229187],
                        [0.16638709604740143, 0.9383229613304138],
                        [0.09062585234642029, 0.9383631944656372],
                    ],
                ],
            ],
            [
                '1018',
                [
                    [
                        [0.20185427367687225, 0.11961311846971512],
                        [0.384502112865448, 0.11970916390419006],
                        [0.38451123237609863, 0.13375815749168396],
                        [0.20186325907707214, 0.13366205990314484],
                    ],
                    [
                        [0.2012385129928589, 0.15265269577503204],
                        [0.24993355572223663, 0.15267834067344666],
                        [0.24994295835494995, 0.16733229160308838],
                        [0.20124787092208862, 0.16730663180351257],
                    ],
                    [
                        [0.3496498763561249, 0.1525772511959076],
                        [0.5735178589820862, 0.15269511938095093],
                        [0.5735275745391846, 0.16739362478256226],
                        [0.34965938329696655, 0.16727569699287415],
                    ],
                    [
                        [0.6326932311058044, 0.1524648517370224],
                        [0.8582119345664978, 0.15258359909057617],
                        [0.8582218885421753, 0.16731275618076324],
                        [0.6327030062675476, 0.1671939641237259],
                    ],
                    [
                        [0.34929344058036804, 0.17027543485164642],
                        [0.4443556070327759, 0.17032551765441895],
                        [0.4443630576133728, 0.18174545466899872],
                        [0.3493008315563202, 0.1816953420639038],
                    ],
                    [
                        [0.6329547762870789, 0.17014434933662415],
                        [0.8542554974555969, 0.1702609360218048],
                        [0.8542652130126953, 0.18456369638442993],
                        [0.6329643130302429, 0.1844470500946045],
                    ],
                    [
                        [0.6327002644538879, 0.18843984603881836],
                        [0.7126402258872986, 0.18848198652267456],
                        [0.7126494646072388, 0.20226693153381348],
                        [0.6327094435691833, 0.2022247612476349],
                    ],
                    [
                        [0.6619632840156555, 0.21235935389995575],
                        [0.8712524175643921, 0.21246978640556335],
                        [0.8712602853775024, 0.2240140587091446],
                        [0.6619709730148315, 0.2239035815000534],
                    ],
                    [
                        [0.6626839637756348, 0.2302418053150177],
                        [0.8077698349952698, 0.23031841218471527],
                        [0.8077793121337891, 0.24436725676059723],
                        [0.6626933217048645, 0.24429062008857727],
                    ],
                    [
                        [0.6621271967887878, 0.24719280004501343],
                        [0.8940213918685913, 0.24731531739234924],
                        [0.8940292596817017, 0.2589472532272339],
                        [0.6621349453926086, 0.2588246762752533],
                    ],
                    [
                        [0.6623222231864929, 0.26507413387298584],
                        [0.8570596575737, 0.26517707109451294],
                        [0.8570692539215088, 0.2793305814266205],
                        [0.6623316407203674, 0.2792275846004486],
                    ],
                    [
                        [0.6626293063163757, 0.2823762893676758],
                        [0.7781311869621277, 0.28243741393089294],
                        [0.7781406044960022, 0.2964397072792053],
                        [0.6626386046409607, 0.29637858271598816],
                    ],
                    [
                        [0.11714949458837509, 0.9276468753814697],
                        [0.44189468026161194, 0.9278227090835571],
                        [0.44190260767936707, 0.9399834871292114],
                        [0.11715720593929291, 0.939807653427124],
                    ],
                    [
                        [0.7933676838874817, 0.9279230237007141],
                        [0.8821983933448792, 0.9279711246490479],
                        [0.8822065591812134, 0.9400096535682678],
                        [0.7933757901191711, 0.9399615526199341],
                    ],
                    [
                        [0.11723898351192474, 0.9423092007637024],
                        [0.21553626656532288, 0.9423624277114868],
                        [0.21554262936115265, 0.952326238155365],
                        [0.11724530160427094, 0.9522729516029358],
                    ],
                ],
            ],
            [
                '1007',
                [
                    [
                        [0.20187292993068695, 0.11962739378213882],
                        [0.384500652551651, 0.11970673501491547],
                        [0.38450971245765686, 0.13376931846141815],
                        [0.2018817961215973, 0.13368993997573853],
                    ],
                    [
                        [0.2012261152267456, 0.15265312790870667],
                        [0.249937042593956, 0.15267430245876312],
                        [0.24994632601737976, 0.16732047498226166],
                        [0.2012353539466858, 0.167299285531044],
                    ],
                    [
                        [0.34966132044792175, 0.15257437527179718],
                        [0.5735065340995789, 0.1526716947555542],
                        [0.5735161900520325, 0.1673416942358017],
                        [0.34967073798179626, 0.1672443300485611],
                    ],
                    [
                        [0.6327158808708191, 0.15247738361358643],
                        [0.8582150340080261, 0.15257543325424194],
                        [0.8582249879837036, 0.16728322207927704],
                        [0.6327255964279175, 0.16718512773513794],
                    ],
                    [
                        [0.3493012487888336, 0.17027634382247925],
                        [0.4443493187427521, 0.17031769454479218],
                        [0.4443567097187042, 0.18173331022262573],
                        [0.3493085503578186, 0.1816919445991516],
                    ],
                    [
                        [0.63294917345047, 0.1701655387878418],
                        [0.8542531728744507, 0.17026181519031525],
                        [0.8542628884315491, 0.18456296622753143],
                        [0.6329586505889893, 0.1844666600227356],
                    ],
                    [
                        [0.632698655128479, 0.18845507502555847],
                        [0.7126437425613403, 0.1884898692369461],
                        [0.7126529216766357, 0.20226579904556274],
                        [0.6327077746391296, 0.20223098993301392],
                    ],
                    [
                        [0.6619601249694824, 0.21236392855644226],
                        [0.8712537884712219, 0.21245507895946503],
                        [0.8712616562843323, 0.22399932146072388],
                        [0.6619678139686584, 0.22390815615653992],
                    ],
                    [
                        [0.6626853346824646, 0.2302442193031311],
                        [0.8077698945999146, 0.2303074300289154],
                        [0.8077793717384338, 0.24435700476169586],
                        [0.6626946926116943, 0.24429376423358917],
                    ],
                    [
                        [0.6621289253234863, 0.24719658493995667],
                        [0.8940101265907288, 0.24729764461517334],
                        [0.8940180540084839, 0.25892823934555054],
                        [0.6621366143226624, 0.2588271200656891],
                    ],
                    [
                        [0.6623212099075317, 0.26508069038391113],
                        [0.8570648431777954, 0.2651655972003937],
                        [0.8570744395256042, 0.2793164551258087],
                        [0.6623305678367615, 0.2792315185070038],
                    ],
                    [
                        [0.6626273989677429, 0.2823839783668518],
                        [0.7781283855438232, 0.2824343740940094],
                        [0.7781378030776978, 0.29643675684928894],
                        [0.6626366972923279, 0.29638636112213135],
                    ],
                    [
                        [0.11715888977050781, 0.92766273021698],
                        [0.4419112801551819, 0.9278067946434021],
                        [0.441919207572937, 0.9400337934494019],
                        [0.11716651916503906, 0.9398897290229797],
                    ],
                    [
                        [0.7933255434036255, 0.9278822541236877],
                        [0.8821709156036377, 0.9279216527938843],
                        [0.8821791410446167, 0.9400391578674316],
                        [0.7933337092399597, 0.9399997591972351],
                    ],
                    [
                        [0.11724039912223816, 0.94231778383255],
                        [0.21552464365959167, 0.9423614144325256],
                        [0.21553091704845428, 0.9523172378540039],
                        [0.11724662035703659, 0.9522736072540283],
                    ],
                ],
            ],
            [
                '1004',
                [
                    [
                        [0.14678014814853668, 0.12872257828712463],
                        [0.8731264472007751, 0.12884534895420074],
                        [0.8731424808502197, 0.1435440629720688],
                        [0.1467859297990799, 0.14341841638088226],
                    ],
                    [
                        [0.14659442007541656, 0.1461637169122696],
                        [0.7510742545127869, 0.14626872539520264],
                        [0.7510883212089539, 0.16071154177188873],
                        [0.14660009741783142, 0.16060417890548706],
                    ],
                    [
                        [0.11823001503944397, 0.19472043216228485],
                        [0.8006761074066162, 0.1948479264974594],
                        [0.8006985187530518, 0.21681328117847443],
                        [0.11823805421590805, 0.21668171882629395],
                    ],
                    [
                        [0.11822383850812912, 0.22084252536296844],
                        [0.8349566459655762, 0.22098149359226227],
                        [0.8349801301956177, 0.2432277351617813],
                        [0.11823198199272156, 0.24308446049690247],
                    ],
                    [
                        [0.1178564801812172, 0.24722537398338318],
                        [0.7781531810760498, 0.24735811352729797],
                        [0.7781751155853271, 0.2693372368812561],
                        [0.11786451935768127, 0.2692005932331085],
                    ],
                    [
                        [0.11783317476511002, 0.2947118878364563],
                        [0.8746864795684814, 0.29487374424934387],
                        [0.8747023344039917, 0.30942395329475403],
                        [0.11783849447965622, 0.3092591166496277],
                    ],
                    [
                        [0.14645245671272278, 0.31230294704437256],
                        [0.6387258172035217, 0.3124105632305145],
                        [0.6387383937835693, 0.32698535919189453],
                        [0.14645817875862122, 0.32687580585479736],
                    ],
                    [
                        [0.14616437256336212, 0.34710946679115295],
                        [0.8789447546005249, 0.3472765386104584],
                        [0.878960907459259, 0.3619961738586426],
                        [0.14617015421390533, 0.36182618141174316],
                    ],
                    [
                        [0.1465500444173813, 0.3645229935646057],
                        [0.6350885033607483, 0.36463668942451477],
                        [0.6351009607315063, 0.3791238069534302],
                        [0.14655573666095734, 0.3790082037448883],
                    ],
                    [
                        [0.14055806398391724, 0.399575412273407],
                        [0.5385046601295471, 0.3996717631816864],
                        [0.5385156273841858, 0.4139668345451355],
                        [0.14056360721588135, 0.4138689339160919],
                    ],
                    [
                        [0.175648033618927, 0.4343605637550354],
                        [0.849708080291748, 0.4345301389694214],
                        [0.8497234582901001, 0.44896626472473145],
                        [0.1756541132926941, 0.44879406690597534],
                    ],
                    [
                        [0.1172504872083664, 0.9277644157409668],
                        [0.4420780837535858, 0.9278894066810608],
                        [0.4420861601829529, 0.9398328065872192],
                        [0.1172548457980156, 0.9397067427635193],
                    ],
                    [
                        [0.7937095761299133, 0.9279201030731201],
                        [0.8825033903121948, 0.9279542565345764],
                        [0.8825165033340454, 0.9398952126502991],
                        [0.7937216758728027, 0.9398607611656189],
                    ],
                    [
                        [0.1174221932888031, 0.9424338340759277],
                        [0.21555480360984802, 0.9424720406532288],
                        [0.21555928885936737, 0.9522404670715332],
                        [0.11742576211690903, 0.9522020816802979],
                    ],
                ],
            ],
            [
                '1021',
                [
                    [
                        [0.3792555034160614, 0.6652443408966064],
                        [0.5844014883041382, 0.6644265651702881],
                        [0.584456741809845, 0.6789239645004272],
                        [0.37930920720100403, 0.6797407865524292],
                    ],
                    [
                        [0.37915071845054626, 0.6826947927474976],
                        [0.535865843296051, 0.6820709705352783],
                        [0.5359222292900085, 0.6969691514968872],
                        [0.3792058825492859, 0.6975921988487244],
                    ],
                    [
                        [0.37906867265701294, 0.7007496953010559],
                        [0.5931610465049744, 0.6998987197875977],
                        [0.5932151079177856, 0.7140724062919617],
                        [0.37912115454673767, 0.7149223685264587],
                    ],
                    [
                        [0.3790600895881653, 0.7177395820617676],
                        [0.5648333430290222, 0.7170022130012512],
                        [0.5648899674415588, 0.7318961024284363],
                        [0.3791152536869049, 0.7326325178146362],
                    ],
                    [
                        [0.37929171323776245, 0.7355284094810486],
                        [0.5687151551246643, 0.7347776293754578],
                        [0.568768322467804, 0.7487593293190002],
                        [0.3793434798717499, 0.7495092153549194],
                    ],
                    [
                        [0.3788665235042572, 0.7526395916938782],
                        [0.5914605855941772, 0.7517982125282288],
                        [0.5915153622627258, 0.7661510109901428],
                        [0.37891966104507446, 0.7669914364814758],
                    ],
                    [
                        [0.37915751338005066, 0.7699608206748962],
                        [0.5659427642822266, 0.769222617149353],
                        [0.5659864544868469, 0.7807202935218811],
                        [0.3792000710964203, 0.781457781791687],
                    ],
                    [
                        [0.3791336715221405, 0.7874141335487366],
                        [0.5612789392471313, 0.7866953611373901],
                        [0.5613232851028442, 0.7983618974685669],
                        [0.3791768550872803, 0.7990800142288208],
                    ],
                    [
                        [0.37907788157463074, 0.8044295310974121],
                        [0.46381524205207825, 0.8040956258773804],
                        [0.46387025713920593, 0.8187794089317322],
                        [0.3791322410106659, 0.8191129565238953],
                    ],
                    [
                        [0.19111351668834686, 0.8508265614509583],
                        [0.7682395577430725, 0.8485609889030457],
                        [0.7682914733886719, 0.8618502616882324],
                        [0.1911614090204239, 0.8641132712364197],
                    ],
                    [
                        [0.11703041940927505, 0.9280734062194824],
                        [0.4420831501483917, 0.9268056154251099],
                        [0.44213005900382996, 0.9393593668937683],
                        [0.11707516759634018, 0.940625786781311],
                    ],
                    [
                        [0.7935355305671692, 0.9280064702033997],
                        [0.8820486664772034, 0.9276612997055054],
                        [0.8820968866348267, 0.9398188591003418],
                        [0.7935831546783447, 0.9401636719703674],
                    ],
                    [
                        [0.11724190413951874, 0.9426671862602234],
                        [0.21514467895030975, 0.9422858357429504],
                        [0.21517911553382874, 0.9518051743507385],
                        [0.11727584153413773, 0.9521862268447876],
                    ],
                ],
            ],
            [
                '1010',
                [
                    [
                        [0.3792468011379242, 0.6652516722679138],
                        [0.5843918323516846, 0.6644408702850342],
                        [0.5844460129737854, 0.678918182849884],
                        [0.37929949164390564, 0.679728090763092],
                    ],
                    [
                        [0.3791846036911011, 0.682691752910614],
                        [0.5358795523643494, 0.6820732951164246],
                        [0.5359349846839905, 0.6969777345657349],
                        [0.3792388439178467, 0.697595477104187],
                    ],
                    [
                        [0.3790740370750427, 0.7007483839988708],
                        [0.5931733250617981, 0.6999045610427856],
                        [0.593226432800293, 0.7140754461288452],
                        [0.37912559509277344, 0.714918315410614],
                    ],
                    [
                        [0.37906354665756226, 0.7177379727363586],
                        [0.5648266077041626, 0.7170068025588989],
                        [0.564882218837738, 0.7318979501724243],
                        [0.3791177272796631, 0.7326282858848572],
                    ],
                    [
                        [0.37931087613105774, 0.7355281114578247],
                        [0.5687115788459778, 0.7347837090492249],
                        [0.568763792514801, 0.7487614154815674],
                        [0.37936174869537354, 0.7495050430297852],
                    ],
                    [
                        [0.3788634240627289, 0.7526453733444214],
                        [0.5914797186851501, 0.7518108487129211],
                        [0.5915335416793823, 0.7661713361740112],
                        [0.3789156973361969, 0.7670049667358398],
                    ],
                    [
                        [0.3791634738445282, 0.769957959651947],
                        [0.5659205913543701, 0.7692258954048157],
                        [0.5659635066986084, 0.780718982219696],
                        [0.3792053163051605, 0.7814503908157349],
                    ],
                    [
                        [0.3791336715221405, 0.787406325340271],
                        [0.5612634420394897, 0.7866933941841125],
                        [0.5613069534301758, 0.798356831073761],
                        [0.37917613983154297, 0.7990691065788269],
                    ],
                    [
                        [0.3790731132030487, 0.8044307827949524],
                        [0.46380719542503357, 0.8040995597839355],
                        [0.46386128664016724, 0.8187864422798157],
                        [0.37912654876708984, 0.8191173076629639],
                    ],
                    [
                        [0.19110636413097382, 0.8508362770080566],
                        [0.7678595781326294, 0.8485899567604065],
                        [0.7679104208946228, 0.8618488311767578],
                        [0.19115334749221802, 0.8640928268432617],
                    ],
                    [
                        [0.1170433834195137, 0.9280793070793152],
                        [0.44208645820617676, 0.9268211126327515],
                        [0.44213253259658813, 0.939369797706604],
                        [0.11708738654851913, 0.9406267404556274],
                    ],
                    [
                        [0.7935413122177124, 0.9280099868774414],
                        [0.8820421695709229, 0.927667498588562],
                        [0.8820894956588745, 0.9398229718208313],
                        [0.7935881018638611, 0.9401651620864868],
                    ],
                    [
                        [0.11720560491085052, 0.9426610469818115],
                        [0.2152981162071228, 0.9422817826271057],
                        [0.21533203125, 0.9518139958381653],
                        [0.11723903566598892, 0.9521929621696472],
                    ],
                ],
            ],
        ],
    },
    {
        question:
            'Can you summarize some key points for the Freddie Mac Guidelines?',
        InitialChatTitle: 'Freddie Mac Policy Essentials',
        Answer: "Based on the Freddie Mac guidelines, here are the key points:\n\n1. Loan Types and Property Requirements:\n- Offers various mortgage products including fixed-rate and adjustable-rate mortgages (ARMs)\n- Property types include 1-4 unit primary residences, second homes, and investment properties\n- Maximum LTV ratios vary by property type and loan purpose:\n  * Second homes: up to 90% LTV\n  * Investment Properties: up to 85% for 1-unit, 75% for 2-4 units\n  * Cash-out refinance: 80% for 1-unit primary residence, 70% for 2-4 units\n\n2. Borrower Requirements:\n- Credit score requirements specified in Exhibit 25\n- DTI (Debt-to-Income) ratio calculations must include all monthly housing expenses and liabilities\n- Income must be stable and verifiable\n- For certain programs like Home Possible, borrower's income must not exceed 100% of Area Median Income\n\n3. Special Program Features:\n- Home Possible Mortgages: Designed for low to moderate-income borrowers\n- HomeOne Program: Specifically for First-Time Homebuyers\n- Homeownership education required for:\n  * First-Time Homebuyers in Home Possible purchases\n  * HomeOne purchase transactions\n  * Borrowers using only Noncredit Payment References\n\n4. Documentation Requirements:\n- Complete mortgage application (Form 65)\n- Property appraisal documentation\n- Income and asset verification\n- Credit history documentation\n\nReferences: Chapters 4201, 4203, 4501, 5103, 5401, and 1301 of the Freddie Mac Single-Family Seller/Servicer Guide.",
        QuoteLocations: [
            [
                '357',
                [
                    [
                        [0.17630919814109802, 0.6953147649765015],
                        [0.8649308681488037, 0.6960701942443848],
                        [0.8649166822433472, 0.7115755081176758],
                        [0.1762920767068863, 0.7108176350593567],
                    ],
                    [
                        [0.17622768878936768, 0.7131725549697876],
                        [0.2873324155807495, 0.7132948637008667],
                        [0.28731662034988403, 0.727996289730072],
                        [0.17621144652366638, 0.7278735637664795],
                    ],
                    [
                        [0.17585808038711548, 0.7475929856300354],
                        [0.8799454569816589, 0.748373806476593],
                        [0.8799314498901367, 0.7636590600013733],
                        [0.17584119737148285, 0.7628757357597351],
                    ],
                    [
                        [0.17675107717514038, 0.7650035619735718],
                        [0.8079150319099426, 0.7657060623168945],
                        [0.807900607585907, 0.7811133861541748],
                        [0.176734060049057, 0.7804086208343506],
                    ],
                    [
                        [0.17608380317687988, 0.7830044627189636],
                        [0.3376764953136444, 0.7831850051879883],
                        [0.3376608192920685, 0.7979641556739807],
                        [0.17606748640537262, 0.7977830767631531],
                    ],
                    [
                        [0.1762932389974594, 0.8172354102134705],
                        [0.7897127866744995, 0.8179255127906799],
                        [0.7896983027458191, 0.8333658576011658],
                        [0.17627619206905365, 0.8326736092567444],
                    ],
                    [
                        [0.17641468346118927, 0.8347059488296509],
                        [0.8466788530349731, 0.8354626893997192],
                        [0.8466649055480957, 0.8505567908287048],
                        [0.17639802396297455, 0.8497977256774902],
                    ],
                    [
                        [0.1761893779039383, 0.852340579032898],
                        [0.8159348368644714, 0.8530654311180115],
                        [0.8159209489822388, 0.8679786324501038],
                        [0.1761728972196579, 0.8672515749931335],
                    ],
                    [
                        [0.1761503666639328, 0.8695472478866577],
                        [0.8641705513000488, 0.8703295588493347],
                        [0.8641563653945923, 0.8857546448707581],
                        [0.17613333463668823, 0.88496994972229],
                    ],
                    [
                        [0.11717620491981506, 0.9272878766059875],
                        [0.4422735869884491, 0.9276618361473083],
                        [0.44226065278053284, 0.9401830434799194],
                        [0.11716217547655106, 0.939808189868927],
                    ],
                    [
                        [0.7935838103294373, 0.9273223876953125],
                        [0.8806266784667969, 0.9274225234985352],
                        [0.8806155323982239, 0.9396321177482605],
                        [0.7935724258422852, 0.9395318031311035],
                    ],
                    [
                        [0.11732463538646698, 0.9421926140785217],
                        [0.2152107208967209, 0.9423055648803711],
                        [0.2151997834444046, 0.9523073434829712],
                        [0.11731342226266861, 0.9521942138671875],
                    ],
                ],
            ],
            [
                '594',
                [
                    [
                        [0.11670105904340744, 0.8062623143196106],
                        [0.4724588990211487, 0.8061114549636841],
                        [0.47246789932250977, 0.821107804775238],
                        [0.11670905351638794, 0.8212577104568481],
                    ],
                    [
                        [0.14660942554473877, 0.8410497903823853],
                        [0.5085120797157288, 0.8408986330032349],
                        [0.5085206031799316, 0.854986310005188],
                        [0.14661701023578644, 0.8551365733146667],
                    ],
                    [
                        [0.14681856334209442, 0.8758230209350586],
                        [0.8275817036628723, 0.8755428791046143],
                        [0.8275914788246155, 0.890228807926178],
                        [0.14682649075984955, 0.890507161617279],
                    ],
                    [
                        [0.11711394041776657, 0.9278817176818848],
                        [0.4420038163661957, 0.9277510643005371],
                        [0.4420110583305359, 0.9398952126502991],
                        [0.1171204224228859, 0.9400252103805542],
                    ],
                    [
                        [0.7932603359222412, 0.9277006983757019],
                        [0.8800005316734314, 0.9276657700538635],
                        [0.8800089359283447, 0.9400891065597534],
                        [0.7932685613632202, 0.9401237964630127],
                    ],
                    [
                        [0.11724389344453812, 0.9423531889915466],
                        [0.2154136747121811, 0.9423139691352844],
                        [0.21541918814182281, 0.9522797465324402],
                        [0.11724921315908432, 0.9523187875747681],
                    ],
                ],
            ],
            [
                '2060',
                [
                    [
                        [0.11687050014734268, 0.669434666633606],
                        [0.4081237018108368, 0.6692948937416077],
                        [0.40812644362449646, 0.6841260194778442],
                        [0.11687333881855011, 0.68426513671875],
                    ],
                    [
                        [0.11720939725637436, 0.7044963836669922],
                        [0.8289970755577087, 0.704158365726471],
                        [0.8289996981620789, 0.7190883755683899],
                        [0.11721225827932358, 0.7194247841835022],
                    ],
                    [
                        [0.11731623858213425, 0.7219622135162354],
                        [0.5454845428466797, 0.7217599749565125],
                        [0.5454872250556946, 0.7364599704742432],
                        [0.11731905490159988, 0.7366613149642944],
                    ],
                    [
                        [0.11889846622943878, 0.7568219304084778],
                        [0.7226632833480835, 0.7565398216247559],
                        [0.7226659059524536, 0.7712638974189758],
                        [0.11890128254890442, 0.7715447545051575],
                    ],
                    [
                        [0.11706244200468063, 0.7912722229957581],
                        [0.5601190328598022, 0.7910674214363098],
                        [0.5601217746734619, 0.8060826063156128],
                        [0.11706531792879105, 0.8062864542007446],
                    ],
                    [
                        [0.11721710115671158, 0.8263956904411316],
                        [0.5928835868835449, 0.8261781334877014],
                        [0.5928862690925598, 0.8410061597824097],
                        [0.117219939827919, 0.8412226438522339],
                    ],
                    [
                        [0.1166754886507988, 0.8613454699516296],
                        [0.47783637046813965, 0.8611821532249451],
                        [0.47783851623535156, 0.8728751540184021],
                        [0.11667773127555847, 0.8730378746986389],
                    ],
                    [
                        [0.11709705740213394, 0.9279016256332397],
                        [0.4421248733997345, 0.927757740020752],
                        [0.4421271085739136, 0.9398068189620972],
                        [0.11709935963153839, 0.9399501085281372],
                    ],
                    [
                        [0.7936227321624756, 0.9277637600898743],
                        [0.8800079226493835, 0.9277254939079285],
                        [0.8800100684165955, 0.9398784637451172],
                        [0.7936248779296875, 0.9399165511131287],
                    ],
                    [
                        [0.11728739738464355, 0.9423689842224121],
                        [0.21538478136062622, 0.9423257112503052],
                        [0.21538667380809784, 0.9522523283958435],
                        [0.11728929728269577, 0.9522953629493713],
                    ],
                ],
            ],
            [
                '503',
                [
                    [
                        [0.20538049936294556, 0.5003683567047119],
                        [0.2693818211555481, 0.5002890229225159],
                        [0.26939693093299866, 0.5139140486717224],
                        [0.20539534091949463, 0.5139932036399841],
                    ],
                    [
                        [0.20569682121276855, 0.5352927446365356],
                        [0.7342861890792847, 0.5346415042877197],
                        [0.734303891658783, 0.5489035248756409],
                        [0.20571234822273254, 0.5495530366897583],
                    ],
                    [
                        [0.17639727890491486, 0.5699219703674316],
                        [0.6319465041160583, 0.5693643689155579],
                        [0.6319642663002014, 0.5840514302253723],
                        [0.1764131635427475, 0.5846075415611267],
                    ],
                    [
                        [0.17627939581871033, 0.6047812700271606],
                        [0.8449030518531799, 0.6039681434631348],
                        [0.8449214696884155, 0.618457019329071],
                        [0.17629505693912506, 0.6192678809165955],
                    ],
                    [
                        [0.17573674023151398, 0.6219872236251831],
                        [0.8534428477287292, 0.6211657524108887],
                        [0.8534621000289917, 0.636268675327301],
                        [0.17575305700302124, 0.6370877623558044],
                    ],
                    [
                        [0.17599549889564514, 0.6397296190261841],
                        [0.8617233633995056, 0.6389012336730957],
                        [0.8617420792579651, 0.6535822153091431],
                        [0.1760113686323166, 0.6544082760810852],
                    ],
                    [
                        [0.17595434188842773, 0.6570364236831665],
                        [0.8313981294631958, 0.6562472581863403],
                        [0.8314163684844971, 0.6706131100654602],
                        [0.17596986889839172, 0.6714001297950745],
                    ],
                    [
                        [0.1762920469045639, 0.6742939352989197],
                        [0.6705646514892578, 0.673700749874115],
                        [0.6705824136734009, 0.6882045865058899],
                        [0.17630772292613983, 0.6887961030006409],
                    ],
                    [
                        [0.11770396679639816, 0.7091380953788757],
                        [0.30485668778419495, 0.7089149951934814],
                        [0.3048730492591858, 0.7235729694366455],
                        [0.11771956831216812, 0.7237954139709473],
                    ],
                    [
                        [0.1438833326101303, 0.7441298365592957],
                        [0.6629757285118103, 0.7435152530670166],
                        [0.6629936099052429, 0.7581955194473267],
                        [0.14389905333518982, 0.7588083148002625],
                    ],
                    [
                        [0.17642025649547577, 0.7788553833961487],
                        [0.7969046235084534, 0.7781257629394531],
                        [0.7969239354133606, 0.793460488319397],
                        [0.17643682658672333, 0.7941879630088806],
                    ],
                    [
                        [0.17626626789569855, 0.8137684464454651],
                        [0.48260289430618286, 0.8134106397628784],
                        [0.4826199412345886, 0.8280051946640015],
                        [0.17628204822540283, 0.8283619284629822],
                    ],
                    [
                        [0.11728773266077042, 0.9280314445495605],
                        [0.44198018312454224, 0.9276607632637024],
                        [0.4419941008090973, 0.9396999478340149],
                        [0.11730054765939713, 0.9400697350502014],
                    ],
                    [
                        [0.7936964631080627, 0.9277891516685486],
                        [0.8815866112709045, 0.9276888370513916],
                        [0.8816021680831909, 0.9398426413536072],
                        [0.7937117218971252, 0.9399427175521851],
                    ],
                    [
                        [0.11740464717149734, 0.9424451589584351],
                        [0.2154095470905304, 0.9423335790634155],
                        [0.2154204249382019, 0.9522912502288818],
                        [0.11741524934768677, 0.9524025917053223],
                    ],
                ],
            ],
            [
                '2455',
                [
                    [
                        [0.11790009588003159, 0.7298260927200317],
                        [0.29231125116348267, 0.7298845052719116],
                        [0.29230332374572754, 0.744221568107605],
                        [0.11789175122976303, 0.7441623210906982],
                    ],
                    [
                        [0.14621897041797638, 0.7648321390151978],
                        [0.2947060465812683, 0.7648835182189941],
                        [0.2946998178958893, 0.7761791944503784],
                        [0.14621245861053467, 0.776127278804779],
                    ],
                    [
                        [0.17602767050266266, 0.7993941307067871],
                        [0.8142613768577576, 0.7996219396591187],
                        [0.8142545819282532, 0.8142650723457336],
                        [0.17601928114891052, 0.8140343427658081],
                    ],
                    [
                        [0.17583414912223816, 0.816519021987915],
                        [0.37878134846687317, 0.8165925145149231],
                        [0.37877342104911804, 0.8313232064247131],
                        [0.17582571506500244, 0.8312487602233887],
                    ],
                    [
                        [0.1761496663093567, 0.8514273762702942],
                        [0.8552295565605164, 0.8516808152198792],
                        [0.8552228212356567, 0.8663108944892883],
                        [0.17614129185676575, 0.8660542964935303],
                    ],
                    [
                        [0.11712358146905899, 0.9276919364929199],
                        [0.44204238057136536, 0.9278209805488586],
                        [0.442035973072052, 0.9399630427360535],
                        [0.11711651086807251, 0.9398328065872192],
                    ],
                    [
                        [0.7933179140090942, 0.9279124140739441],
                        [0.8815106153488159, 0.927947461605072],
                        [0.8815052509307861, 0.9398754835128784],
                        [0.7933123707771301, 0.9398401379585266],
                    ],
                    [
                        [0.11731688678264618, 0.9423208236694336],
                        [0.21518297493457794, 0.9423601627349854],
                        [0.21517738699913025, 0.9522334337234497],
                        [0.11731113493442535, 0.9521937966346741],
                    ],
                ],
            ],
            [
                '1040',
                [
                    [
                        [0.1470528095960617, 0.6127750277519226],
                        [0.31536978483200073, 0.6128678917884827],
                        [0.31537142395973206, 0.627460777759552],
                        [0.14705412089824677, 0.6273676753044128],
                    ],
                    [
                        [0.14638139307498932, 0.6474468111991882],
                        [0.7062755227088928, 0.6477578282356262],
                        [0.7062777876853943, 0.6622029542922974],
                        [0.14638268947601318, 0.6618911027908325],
                    ],
                    [
                        [0.1464422047138214, 0.6824061274528503],
                        [0.6181293725967407, 0.6826699376106262],
                        [0.6181315183639526, 0.6972202062606812],
                        [0.14644351601600647, 0.696955680847168],
                    ],
                    [
                        [0.14687080681324005, 0.7173185348510742],
                        [0.31838536262512207, 0.7174151539802551],
                        [0.31838691234588623, 0.7315609455108643],
                        [0.14687207341194153, 0.7314640879631042],
                    ],
                    [
                        [0.11697602272033691, 0.7516508102416992],
                        [0.8501175045967102, 0.7520664930343628],
                        [0.8501201868057251, 0.7672045230865479],
                        [0.11697733402252197, 0.766787588596344],
                    ],
                    [
                        [0.11730515211820602, 0.7688387632369995],
                        [0.8748183250427246, 0.7692697048187256],
                        [0.8748210668563843, 0.7843745350837708],
                        [0.11730645596981049, 0.7839423418045044],
                    ],
                    [
                        [0.11740236729383469, 0.7865070104598999],
                        [0.6128187775611877, 0.7867898344993591],
                        [0.6128209829330444, 0.8016896843910217],
                        [0.11740364879369736, 0.8014060854911804],
                    ],
                    [
                        [0.11763668805360794, 0.8216719627380371],
                        [0.331080824136734, 0.8217946290969849],
                        [0.3310824930667877, 0.8365310430526733],
                        [0.11763796210289001, 0.8364080190658569],
                    ],
                    [
                        [0.14641715586185455, 0.8562138676643372],
                        [0.8704390525817871, 0.8566327691078186],
                        [0.870441734790802, 0.8714368939399719],
                        [0.1464184820652008, 0.8710167407989502],
                    ],
                    [
                        [0.14615710079669952, 0.8736481070518494],
                        [0.8544408082962036, 0.87405925989151],
                        [0.8544434309005737, 0.8887823224067688],
                        [0.14615842700004578, 0.8883699774742126],
                    ],
                    [
                        [0.11720220744609833, 0.9276774525642395],
                        [0.442121684551239, 0.9278680682182312],
                        [0.4421232044696808, 0.939972996711731],
                        [0.1172032579779625, 0.9397819638252258],
                    ],
                    [
                        [0.7937735319137573, 0.9279916882514954],
                        [0.8807289600372314, 0.9280427098274231],
                        [0.8807311058044434, 0.9399464130401611],
                        [0.7937755584716797, 0.9398952722549438],
                    ],
                    [
                        [0.11732526868581772, 0.9423417448997498],
                        [0.21544420719146729, 0.9423994421958923],
                        [0.21544519066810608, 0.9523125290870667],
                        [0.11732612550258636, 0.9522547125816345],
                    ],
                ],
            ],
            [
                '1051',
                [
                    [
                        [0.11742541193962097, 0.8089287281036377],
                        [0.6128495931625366, 0.8088198304176331],
                        [0.6128571629524231, 0.8236572742462158],
                        [0.11743053048849106, 0.8237643241882324],
                    ],
                    [
                        [0.1175677701830864, 0.843662440776825],
                        [0.33145245909690857, 0.8436172604560852],
                        [0.3314586281776428, 0.8584461212158203],
                        [0.11757288873195648, 0.858490526676178],
                    ],
                    [
                        [0.11706967651844025, 0.9277704954147339],
                        [0.4428996741771698, 0.9277083873748779],
                        [0.4429051876068115, 0.9398638606071472],
                        [0.11707387119531631, 0.9399250745773315],
                    ],
                    [
                        [0.7933109998703003, 0.9276890158653259],
                        [0.879782497882843, 0.9276725649833679],
                        [0.8797898292541504, 0.9399449825286865],
                        [0.7933180332183838, 0.9399612545967102],
                    ],
                    [
                        [0.11725542694330215, 0.9423410892486572],
                        [0.21536970138549805, 0.9423227310180664],
                        [0.2153734713792801, 0.952301561832428],
                        [0.11725886911153793, 0.9523196816444397],
                    ],
                ],
            ],
            [
                '465',
                [
                    [
                        [0.11712402105331421, 0.142770454287529],
                        [0.8322760462760925, 0.14239287376403809],
                        [0.8322848677635193, 0.15729281306266785],
                        [0.11713030189275742, 0.1576678603887558],
                    ],
                    [
                        [0.11715824156999588, 0.16027255356311798],
                        [0.3373132646083832, 0.1601572334766388],
                        [0.33731892704963684, 0.17211541533470154],
                        [0.11716328561306, 0.17223010957241058],
                    ],
                    [
                        [0.11751677840948105, 0.1948215812444687],
                        [0.3049178123474121, 0.1947249472141266],
                        [0.3049246370792389, 0.20935779809951782],
                        [0.1175229549407959, 0.2094537764787674],
                    ],
                    [
                        [0.1283436119556427, 0.5864854454994202],
                        [0.14618664979934692, 0.5864778757095337],
                        [0.14619258046150208, 0.600310206413269],
                        [0.12834948301315308, 0.600317656993866],
                    ],
                    [
                        [0.1758972555398941, 0.22998455166816711],
                        [0.7295993566513062, 0.22970366477966309],
                        [0.7296075224876404, 0.24417763948440552],
                        [0.1759035587310791, 0.24445661902427673],
                    ],
                    [
                        [0.1225379928946495, 0.2640949487686157],
                        [0.1470710188150406, 0.2640827000141144],
                        [0.14707723259925842, 0.2785824239253998],
                        [0.12254413217306137, 0.27859458327293396],
                    ],
                    [
                        [0.1758706420660019, 0.2647680640220642],
                        [0.6919976472854614, 0.26451051235198975],
                        [0.6920057535171509, 0.27906718850135803],
                        [0.17587698996067047, 0.2793229818344116],
                    ],
                    [
                        [0.11739460378885269, 0.29959315061569214],
                        [0.14631834626197815, 0.2995789647102356],
                        [0.1463242620229721, 0.31338202953338623],
                        [0.11740042269229889, 0.3133961260318756],
                    ],
                    [
                        [0.1761239469051361, 0.29970014095306396],
                        [0.8676859140396118, 0.2993607521057129],
                        [0.8676947355270386, 0.3140386939048767],
                        [0.17613033950328827, 0.3143756687641144],
                    ],
                    [
                        [0.17587631940841675, 0.317082941532135],
                        [0.3316643536090851, 0.3170071244239807],
                        [0.3316713869571686, 0.3318556547164917],
                        [0.17588278651237488, 0.33193090558052063],
                    ],
                    [
                        [0.11859343945980072, 0.3599160313606262],
                        [0.1463262140750885, 0.3599027991294861],
                        [0.14633207023143768, 0.3735673725605011],
                        [0.11859921365976334, 0.3735804855823517],
                    ],
                    [
                        [0.1758301854133606, 0.3599150478839874],
                        [0.8708077073097229, 0.35958391427993774],
                        [0.8708164095878601, 0.37406596541404724],
                        [0.1758365035057068, 0.3743947148323059],
                    ],
                    [
                        [0.17600037157535553, 0.3772657811641693],
                        [0.8316628932952881, 0.3769560754299164],
                        [0.8316718935966492, 0.392168253660202],
                        [0.1760070025920868, 0.3924756348133087],
                    ],
                    [
                        [0.17617106437683105, 0.3946525454521179],
                        [0.4849283695220947, 0.3945079743862152],
                        [0.4849357306957245, 0.4089660942554474],
                        [0.17617736756801605, 0.40910962224006653],
                    ],
                    [
                        [0.2051934152841568, 0.4294508993625641],
                        [0.603979766368866, 0.4292674660682678],
                        [0.6039876937866211, 0.4439733326435089],
                        [0.2051999270915985, 0.44415539503097534],
                    ],
                    [
                        [0.20525023341178894, 0.46458232402801514],
                        [0.47767412662506104, 0.46445927023887634],
                        [0.47767987847328186, 0.4757978320121765],
                        [0.20525525510311127, 0.475920170545578],
                    ],
                    [
                        [0.11755373328924179, 0.498843789100647],
                        [0.43913042545318604, 0.49870115518569946],
                        [0.43913787603378296, 0.5136639475822449],
                        [0.11756004393100739, 0.5138054490089417],
                    ],
                    [
                        [0.14645151793956757, 0.5340152978897095],
                        [0.8732632994651794, 0.5336989760398865],
                        [0.8732722997665405, 0.5486846566200256],
                        [0.14645794034004211, 0.5489984154701233],
                    ],
                    [
                        [0.14604410529136658, 0.5516226887702942],
                        [0.3594549000263214, 0.551530659198761],
                        [0.3594619631767273, 0.5662948489189148],
                        [0.14605042338371277, 0.5663861036300659],
                    ],
                ],
            ],
            [
                '1671',
                [
                    [
                        [0.14650610089302063, 0.61184161901474],
                        [0.8463979363441467, 0.6116898059844971],
                        [0.8463969826698303, 0.6265249252319336],
                        [0.14650468528270721, 0.626674473285675],
                    ],
                    [
                        [0.14666558802127838, 0.6293382048606873],
                        [0.868890106678009, 0.629184365272522],
                        [0.8688892126083374, 0.643838107585907],
                        [0.14666418731212616, 0.6439895033836365],
                    ],
                    [
                        [0.14625035226345062, 0.6471244096755981],
                        [0.21063277125358582, 0.6471109390258789],
                        [0.21063145995140076, 0.6612147092819214],
                        [0.14624901115894318, 0.6612279415130615],
                    ],
                    [
                        [0.11743170022964478, 0.6814208030700684],
                        [0.3637339770793915, 0.6813712120056152],
                        [0.3637327551841736, 0.6958655118942261],
                        [0.11743029206991196, 0.6959142684936523],
                    ],
                    [
                        [0.146238312125206, 0.7164454460144043],
                        [0.8628920912742615, 0.7163068652153015],
                        [0.8628911972045898, 0.7310065627098083],
                        [0.14623691141605377, 0.7311426997184753],
                    ],
                    [
                        [0.14626960456371307, 0.7340286374092102],
                        [0.2000426948070526, 0.7340185046195984],
                        [0.20004162192344666, 0.7454939484596252],
                        [0.14626850187778473, 0.7455040216445923],
                    ],
                    [
                        [0.2942807376384735, 0.7722311019897461],
                        [0.6863018870353699, 0.7721602320671082],
                        [0.6863009929656982, 0.7845563888549805],
                        [0.29427963495254517, 0.7846261858940125],
                    ],
                    [
                        [0.15620887279510498, 0.8163170218467712],
                        [0.2728445827960968, 0.8162971138954163],
                        [0.27284348011016846, 0.8284856081008911],
                        [0.15620771050453186, 0.8285052180290222],
                    ],
                    [
                        [0.1761578917503357, 0.8383470177650452],
                        [0.2986880838871002, 0.8383267521858215],
                        [0.298687219619751, 0.8481720089912415],
                        [0.17615696787834167, 0.8481920957565308],
                    ],
                    [
                        [0.3225470185279846, 0.8383137583732605],
                        [0.40806254744529724, 0.838299572467804],
                        [0.4080617129802704, 0.8482152223587036],
                        [0.3225461542606354, 0.8482292294502258],
                    ],
                    [
                        [0.1724194586277008, 0.8607118129730225],
                        [0.19694899022579193, 0.8607078790664673],
                        [0.19694815576076508, 0.8696971535682678],
                        [0.17241860926151276, 0.8697010278701782],
                    ],
                    [
                        [0.2228964865207672, 0.8604586124420166],
                        [0.4229552745819092, 0.8604264855384827],
                        [0.4229542911052704, 0.8722310662269592],
                        [0.22289539873600006, 0.872262716293335],
                    ],
                    [
                        [0.6300652623176575, 0.8605925440788269],
                        [0.7981196045875549, 0.8605654835700989],
                        [0.7981190085411072, 0.8700248003005981],
                        [0.6300646066665649, 0.8700514435768127],
                    ],
                    [
                        [0.11713312566280365, 0.9277251362800598],
                        [0.44235959649086, 0.9276778101921082],
                        [0.4423586130142212, 0.9399023056030273],
                        [0.11713194102048874, 0.9399487376213074],
                    ],
                    [
                        [0.7937769889831543, 0.9277841448783875],
                        [0.8821171522140503, 0.927771270275116],
                        [0.882116436958313, 0.9400321841239929],
                        [0.7937762141227722, 0.9400448203086853],
                    ],
                    [
                        [0.1173207089304924, 0.9423074126243591],
                        [0.2154080718755722, 0.9422934651374817],
                        [0.21540714800357819, 0.9522423148155212],
                        [0.1173197403550148, 0.9522560834884644],
                    ],
                ],
            ],
            [
                '81',
                [
                    [
                        [0.42103031277656555, 0.4437316060066223],
                        [0.6464543342590332, 0.44360116124153137],
                        [0.6464552879333496, 0.4580633044242859],
                        [0.4210304617881775, 0.4581928253173828],
                    ],
                    [
                        [0.4212907552719116, 0.46106454730033875],
                        [0.7474685907363892, 0.4608774185180664],
                        [0.7474699020385742, 0.4755280315876007],
                        [0.42129090428352356, 0.47571372985839844],
                    ],
                    [
                        [0.42103904485702515, 0.47862672805786133],
                        [0.49969545006752014, 0.4785820245742798],
                        [0.49969586730003357, 0.49308350682258606],
                        [0.4210391938686371, 0.49312788248062134],
                    ],
                    [
                        [0.1944665163755417, 0.4967930018901825],
                        [0.2982514500617981, 0.49673452973365784],
                        [0.298251211643219, 0.5113127827644348],
                        [0.19446590542793274, 0.5113707780838013],
                    ],
                    [
                        [0.3918379545211792, 0.6031940579414368],
                        [0.791155219078064, 0.602981686592102],
                        [0.7911563515663147, 0.614427924156189],
                        [0.3918379843235016, 0.6146389245986938],
                    ],
                    [
                        [0.3917697072029114, 0.5126203894615173],
                        [0.706266462802887, 0.5124447345733643],
                        [0.7062677145004272, 0.5283318161964417],
                        [0.39176976680755615, 0.5285059809684753],
                    ],
                    [
                        [0.19434817135334015, 0.5322149991989136],
                        [0.30013221502304077, 0.5321565270423889],
                        [0.30013197660446167, 0.5467854738235474],
                        [0.1943475604057312, 0.5468435287475586],
                    ],
                    [
                        [0.3916306495666504, 0.532387912273407],
                        [0.7759897112846375, 0.5321754813194275],
                        [0.7759907841682434, 0.5436239838600159],
                        [0.39163070917129517, 0.5438351035118103],
                    ],
                    [
                        [0.39170315861701965, 0.5476473569869995],
                        [0.630272388458252, 0.5475165843963623],
                        [0.6302733421325684, 0.563614010810852],
                        [0.3917032480239868, 0.5637437105178833],
                    ],
                    [
                        [0.19445404410362244, 0.5676294565200806],
                        [0.2994900941848755, 0.5675724744796753],
                        [0.2994898557662964, 0.5821089744567871],
                        [0.1944534331560135, 0.5821654796600342],
                    ],
                    [
                        [0.3918653726577759, 0.5831992626190186],
                        [0.5941073894500732, 0.5830904841423035],
                        [0.5941082239151001, 0.598976731300354],
                        [0.39186546206474304, 0.5990845561027527],
                    ],
                    [
                        [0.19439740478992462, 0.603151261806488],
                        [0.30022427439689636, 0.6030949950218201],
                        [0.30022403597831726, 0.6176714301109314],
                        [0.19439679384231567, 0.6177272796630859],
                    ],
                    [
                        [0.3922135829925537, 0.6185846924781799],
                        [0.6299780607223511, 0.6184593439102173],
                        [0.6299790740013123, 0.6346929669380188],
                        [0.3922136723995209, 0.6348172426223755],
                    ],
                    [
                        [0.19441893696784973, 0.6385359168052673],
                        [0.2996112108230591, 0.6384810209274292],
                        [0.2996109426021576, 0.6529918909072876],
                        [0.19441832602024078, 0.6530463099479675],
                    ],
                    [
                        [0.3857959508895874, 0.638739287853241],
                        [0.7612780332565308, 0.6385434865951538],
                        [0.7612793445587158, 0.6528700590133667],
                        [0.3857960104942322, 0.6530642509460449],
                    ],
                    [
                        [0.3858258128166199, 0.654997706413269],
                        [0.5226673483848572, 0.6549270153045654],
                        [0.5226677656173706, 0.66730797290802],
                        [0.38582587242126465, 0.6673781871795654],
                    ],
                    [
                        [0.11748392134904861, 0.6911956071853638],
                        [0.3048422932624817, 0.6911008358001709],
                        [0.3048420548439026, 0.7057119011878967],
                        [0.11748304218053818, 0.7058058977127075],
                    ],
                    [
                        [0.14635393023490906, 0.7263083457946777],
                        [0.8480522036552429, 0.7259605526924133],
                        [0.8480538129806519, 0.7407680153846741],
                        [0.14635314047336578, 0.7411128282546997],
                    ],
                    [
                        [0.14661376178264618, 0.7437663674354553],
                        [0.8195265531539917, 0.7434362769126892],
                        [0.8195281028747559, 0.7581355571746826],
                        [0.1466129720211029, 0.7584627866744995],
                    ],
                    [
                        [0.14604751765727997, 0.7613393664360046],
                        [0.2533636689186096, 0.761287271976471],
                        [0.2533632814884186, 0.7753620743751526],
                        [0.14604675769805908, 0.7754136919975281],
                    ],
                    [
                        [0.17564435303211212, 0.7960970997810364],
                        [0.8085364699363708, 0.7957963943481445],
                        [0.8085379600524902, 0.8103242516517639],
                        [0.1756436675786972, 0.8106222748756409],
                    ],
                    [
                        [0.17582467198371887, 0.8309630751609802],
                        [0.8774805068969727, 0.8306368589401245],
                        [0.8774821758270264, 0.8447490930557251],
                        [0.17582401633262634, 0.8450723886489868],
                    ],
                    [
                        [0.1759457290172577, 0.8484784364700317],
                        [0.3138390779495239, 0.8484150171279907],
                        [0.3138388693332672, 0.8626822829246521],
                        [0.17594505846500397, 0.8627451062202454],
                    ],
                    [
                        [0.117163747549057, 0.9279115796089172],
                        [0.4419800341129303, 0.9277697801589966],
                        [0.4419802129268646, 0.9398465156555176],
                        [0.11716301739215851, 0.9399871230125427],
                    ],
                    [
                        [0.7936406135559082, 0.9277743101119995],
                        [0.8795362710952759, 0.9277368187904358],
                        [0.8795377016067505, 0.9399954080581665],
                        [0.7936418652534485, 0.9400325417518616],
                    ],
                    [
                        [0.11729877442121506, 0.9423463344573975],
                        [0.21536120772361755, 0.9423039555549622],
                        [0.2153608351945877, 0.9521541595458984],
                        [0.1172981783747673, 0.9521963000297546],
                    ],
                ],
            ],
            [
                '486',
                [
                    [
                        [0.12528175115585327, 0.3995314836502075],
                        [0.3254717290401459, 0.39935681223869324],
                        [0.32548147439956665, 0.41308826208114624],
                        [0.12529081106185913, 0.41326260566711426],
                    ],
                    [
                        [0.12479318678379059, 0.44348227977752686],
                        [0.24711865186691284, 0.44337618350982666],
                        [0.2471286654472351, 0.45787927508354187],
                        [0.12480275332927704, 0.45798513293266296],
                    ],
                    [
                        [0.3906421959400177, 0.44343557953834534],
                        [0.7011258006095886, 0.4431663155555725],
                        [0.7011350989341736, 0.4547988772392273],
                        [0.3906506299972534, 0.4550676941871643],
                    ],
                    [
                        [0.12508948147296906, 0.5755495429039001],
                        [0.2305622547864914, 0.5754597783088684],
                        [0.23056989908218384, 0.5866082906723022],
                        [0.12509682774543762, 0.5866979360580444],
                    ],
                    [
                        [0.3909064531326294, 0.2137065827846527],
                        [0.4249612092971802, 0.2136761099100113],
                        [0.42496949434280396, 0.22497694194316864],
                        [0.390914648771286, 0.22500737011432648],
                    ],
                    [
                        [0.12656119465827942, 0.6192752718925476],
                        [0.33547601103782654, 0.6190985441207886],
                        [0.33548635244369507, 0.6336249113082886],
                        [0.12657079100608826, 0.633801281452179],
                    ],
                    [
                        [0.39139050245285034, 0.2574364244937897],
                        [0.42491719126701355, 0.2574065923690796],
                        [0.4249255657196045, 0.2688535451889038],
                        [0.3913988173007965, 0.2688833177089691],
                    ],
                    [
                        [0.12494438141584396, 0.6631402969360352],
                        [0.3052196204662323, 0.6629887223243713],
                        [0.30522772669792175, 0.6744954586029053],
                        [0.12495197355747223, 0.67464679479599],
                    ],
                    [
                        [0.390951544046402, 0.6197006106376648],
                        [0.4249919056892395, 0.6196718215942383],
                        [0.42500007152557373, 0.6307989954948425],
                        [0.39095962047576904, 0.630827784538269],
                    ],
                    [
                        [0.12482953816652298, 0.6806747913360596],
                        [0.19161929190158844, 0.6806188225746155],
                        [0.19162890315055847, 0.6948293447494507],
                        [0.12483891099691391, 0.69488525390625],
                    ],
                    [
                        [0.1254078894853592, 0.3818410038948059],
                        [0.48399898409843445, 0.3815273642539978],
                        [0.4840078353881836, 0.39336061477661133],
                        [0.12541569769382477, 0.39367374777793884],
                    ],
                    [
                        [0.12647634744644165, 0.48745864629745483],
                        [0.324707955121994, 0.4872877895832062],
                        [0.32471808791160583, 0.5015943646430969],
                        [0.12648579478263855, 0.5017648935317993],
                    ],
                    [
                        [0.3913881778717041, 0.4875281751155853],
                        [0.424856573343277, 0.4874993562698364],
                        [0.4248649477958679, 0.4988926351070404],
                        [0.3913964331150055, 0.4989214241504669],
                    ],
                    [
                        [0.12490822374820709, 0.5312101244926453],
                        [0.3660408556461334, 0.5310035347938538],
                        [0.3660513162612915, 0.5455308556556702],
                        [0.12491780519485474, 0.5457370281219482],
                    ],
                    [
                        [0.39110836386680603, 0.6634998917579651],
                        [0.4248993694782257, 0.663471519947052],
                        [0.42490750551223755, 0.6745559573173523],
                        [0.3911164104938507, 0.6745843291282654],
                    ],
                    [
                        [0.11700577288866043, 0.7124626636505127],
                        [0.8435412049293518, 0.7118561863899231],
                        [0.843553364276886, 0.726410448551178],
                        [0.11701534688472748, 0.7270156741142273],
                    ],
                    [
                        [0.11728009581565857, 0.7295675873756409],
                        [0.7552163600921631, 0.7290363311767578],
                        [0.7552282810211182, 0.7436891794204712],
                        [0.11728973686695099, 0.7442193031311035],
                    ],
                    [
                        [0.11739075183868408, 0.7472265362739563],
                        [0.22995278239250183, 0.7471330165863037],
                        [0.22996270656585693, 0.7616031765937805],
                        [0.11740027368068695, 0.761696457862854],
                    ],
                    [
                        [0.11735564470291138, 0.9280428290367126],
                        [0.44174420833587646, 0.9277804493904114],
                        [0.4417530596256256, 0.9397901296615601],
                        [0.11736354231834412, 0.9400520324707031],
                    ],
                    [
                        [0.7717148065567017, 0.9279317855834961],
                        [0.8594368100166321, 0.9278608560562134],
                        [0.8594468832015991, 0.9398643374443054],
                        [0.7717246413230896, 0.9399351477622986],
                    ],
                    [
                        [0.11742937564849854, 0.9425572752952576],
                        [0.21532303094863892, 0.9424782395362854],
                        [0.21532969176769257, 0.9522503614425659],
                        [0.11743580549955368, 0.9523292183876038],
                    ],
                ],
            ],
            [
                '463',
                [
                    [
                        [0.14658093452453613, 0.6860834360122681],
                        [0.8194726705551147, 0.686480700969696],
                        [0.8194718956947327, 0.7014079093933105],
                        [0.1465788334608078, 0.7010078430175781],
                    ],
                    [
                        [0.14650116860866547, 0.7037858963012695],
                        [0.21466155350208282, 0.7038264870643616],
                        [0.2146596908569336, 0.718041718006134],
                        [0.1464991718530655, 0.7180008292198181],
                    ],
                    [
                        [0.11754752695560455, 0.7381937503814697],
                        [0.439609169960022, 0.7383886575698853],
                        [0.4396076798439026, 0.7531596422195435],
                        [0.11754539608955383, 0.7529633641242981],
                    ],
                    [
                        [0.1464156210422516, 0.7730206251144409],
                        [0.681817889213562, 0.7733498811721802],
                        [0.6818168759346008, 0.788124144077301],
                        [0.14641353487968445, 0.7877926230430603],
                    ],
                    [
                        [0.15046142041683197, 0.8078280687332153],
                        [0.8493306040763855, 0.8082647919654846],
                        [0.8493298888206482, 0.8230219483375549],
                        [0.15045936405658722, 0.8225823044776917],
                    ],
                    [
                        [0.1761225014925003, 0.8257448077201843],
                        [0.7317073345184326, 0.8260948061943054],
                        [0.731706440448761, 0.8405104279518127],
                        [0.17612051963806152, 0.8401581645011902],
                    ],
                    [
                        [0.1376303881406784, 0.8605257272720337],
                        [0.8790953159332275, 0.8610001802444458],
                        [0.8790947198867798, 0.8753817677497864],
                        [0.13762834668159485, 0.8749043345451355],
                    ],
                    [
                        [0.1759164184331894, 0.8776481747627258],
                        [0.8268969655036926, 0.8780678510665894],
                        [0.8268962502479553, 0.8927055597305298],
                        [0.17591442167758942, 0.8922832012176514],
                    ],
                    [
                        [0.11712218075990677, 0.9276342391967773],
                        [0.44196850061416626, 0.9278482794761658],
                        [0.44196727871894836, 0.9400240778923035],
                        [0.1171204224228859, 0.9398089051246643],
                    ],
                    [
                        [0.7932921648025513, 0.9279245734214783],
                        [0.8802813291549683, 0.9279818534851074],
                        [0.8802808523178101, 0.9400244355201721],
                        [0.7932915091514587, 0.9399667978286743],
                    ],
                    [
                        [0.11721090972423553, 0.9423195123672485],
                        [0.2153504490852356, 0.9423845410346985],
                        [0.21534913778305054, 0.9523383378982544],
                        [0.11720947176218033, 0.9522730112075806],
                    ],
                ],
            ],
            [
                '533',
                [
                    [
                        [0.38433924317359924, 0.10146219283342361],
                        [0.8460049629211426, 0.10201612859964371],
                        [0.8459990620613098, 0.11722489446401596],
                        [0.3843306303024292, 0.11666887998580933],
                    ],
                    [
                        [0.3148627281188965, 0.1271628886461258],
                        [0.9194477796554565, 0.12789292633533478],
                        [0.9194422960281372, 0.14308181405067444],
                        [0.3148537278175354, 0.14234904944896698],
                    ],
                    [
                        [0.3152816891670227, 0.14468644559383392],
                        [0.8645723462104797, 0.1453525722026825],
                        [0.8645665049552917, 0.1606699526309967],
                        [0.31527262926101685, 0.16000133752822876],
                    ],
                    [
                        [0.11683377623558044, 0.21724209189414978],
                        [0.6343775391578674, 0.21788088977336884],
                        [0.6343667507171631, 0.2408076822757721],
                        [0.11681844294071198, 0.2401653677225113],
                    ],
                    [
                        [0.11673024296760559, 0.2646728754043579],
                        [0.7777600288391113, 0.2654980719089508],
                        [0.7777533531188965, 0.2815377414226532],
                        [0.11671952158212662, 0.2807093858718872],
                    ],
                    [
                        [0.1172804981470108, 0.28363922238349915],
                        [0.20567677915096283, 0.28375008702278137],
                        [0.20566771924495697, 0.2980301082134247],
                        [0.11727095395326614, 0.2979188859462738],
                    ],
                    [
                        [0.4626287519931793, 0.32615381479263306],
                        [0.7457415461540222, 0.3265123665332794],
                        [0.7457352876663208, 0.34113529324531555],
                        [0.46262091398239136, 0.3407755196094513],
                    ],
                    [
                        [0.10865847766399384, 0.3593314290046692],
                        [0.25628238916397095, 0.3595198690891266],
                        [0.25627461075782776, 0.3721690773963928],
                        [0.10864998400211334, 0.37198010087013245],
                    ],
                    [
                        [0.3150694966316223, 0.3589642643928528],
                        [0.8889902830123901, 0.35969671607017517],
                        [0.8889846801757812, 0.37487170100212097],
                        [0.3150605261325836, 0.37413665652275085],
                    ],
                    [
                        [0.315175324678421, 0.3763023614883423],
                        [0.9081130027770996, 0.3770621418952942],
                        [0.9081076383590698, 0.39170435070991516],
                        [0.3151666522026062, 0.3909419775009155],
                    ],
                    [
                        [0.31500041484832764, 0.3945997655391693],
                        [0.3861466944217682, 0.3946913182735443],
                        [0.3861401081085205, 0.40633150935173035],
                        [0.3149935305118561, 0.40623971819877625],
                    ],
                    [
                        [0.3147674798965454, 0.4183729290962219],
                        [0.9160749912261963, 0.4191509485244751],
                        [0.9160699248313904, 0.4331655502319336],
                        [0.31475916504859924, 0.43238502740859985],
                    ],
                    [
                        [0.31534457206726074, 0.43646159768104553],
                        [0.7360565066337585, 0.43700820207595825],
                        [0.736050009727478, 0.45213955640792847],
                        [0.31533560156822205, 0.45159104466438293],
                    ],
                    [
                        [0.3149757385253906, 0.4610735774040222],
                        [0.8898749947547913, 0.4618246853351593],
                        [0.8898692727088928, 0.47715866565704346],
                        [0.31496667861938477, 0.47640493512153625],
                    ],
                    [
                        [0.3151545226573944, 0.4786553978919983],
                        [0.8880977034568787, 0.4794069528579712],
                        [0.888092041015625, 0.4945277273654938],
                        [0.3151455819606781, 0.49377360939979553],
                    ],
                    [
                        [0.31508883833885193, 0.496346116065979],
                        [0.5856598019599915, 0.4967024326324463],
                        [0.5856525301933289, 0.5116156339645386],
                        [0.31508001685142517, 0.5112581253051758],
                    ],
                    [
                        [0.3150857985019684, 0.5210505127906799],
                        [0.8867658972740173, 0.5218076109886169],
                        [0.8867602348327637, 0.5368975400924683],
                        [0.3150768578052521, 0.5361378788948059],
                    ],
                ],
            ],
            [
                '590',
                [
                    [
                        [0.11699432879686356, 0.5999020934104919],
                        [0.34929630160331726, 0.5998071432113647],
                        [0.34930557012557983, 0.6146684288978577],
                        [0.11700223386287689, 0.6147633194923401],
                    ],
                    [
                        [0.11687543243169785, 0.6483951210975647],
                        [0.8484613299369812, 0.6480965614318848],
                        [0.848480224609375, 0.6710297465324402],
                        [0.11688762158155441, 0.6713281273841858],
                    ],
                    [
                        [0.11685410141944885, 0.6733719706535339],
                        [0.6881304383277893, 0.6731389760971069],
                        [0.6881489157676697, 0.6974846720695496],
                        [0.11686704307794571, 0.6977174878120422],
                    ],
                    [
                        [0.11679259687662125, 0.7227926254272461],
                        [0.4730122983455658, 0.7226475477218628],
                        [0.47302234172821045, 0.7375802397727966],
                        [0.11680053174495697, 0.7377252578735352],
                    ],
                    [
                        [0.14586389064788818, 0.7574236989021301],
                        [0.28018248081207275, 0.7573690414428711],
                        [0.28019142150878906, 0.7723536491394043],
                        [0.14587202668190002, 0.7724082469940186],
                    ],
                    [
                        [0.14659084379673004, 0.7925962209701538],
                        [0.32976290583610535, 0.7925217747688293],
                        [0.32977184653282166, 0.8070533871650696],
                        [0.1465987265110016, 0.807127833366394],
                    ],
                    [
                        [0.11770898848772049, 0.8271029591560364],
                        [0.2898224890232086, 0.8270330429077148],
                        [0.28983163833618164, 0.84229975938797],
                        [0.11771710962057114, 0.8423696160316467],
                    ],
                    [
                        [0.11719563603401184, 0.9279002547264099],
                        [0.4422633647918701, 0.9277685880661011],
                        [0.4422713816165924, 0.9398860335350037],
                        [0.11720208078622818, 0.9400176405906677],
                    ],
                    [
                        [0.793744683265686, 0.9277714490890503],
                        [0.880948543548584, 0.9277361631393433],
                        [0.8809587955474854, 0.9399491548538208],
                        [0.793754518032074, 0.9399844408035278],
                    ],
                    [
                        [0.11740300804376602, 0.9423520565032959],
                        [0.2152857780456543, 0.942312479019165],
                        [0.21529150009155273, 0.9523259997367859],
                        [0.11740832775831223, 0.9523655772209167],
                    ],
                ],
            ],
            [
                '787',
                [
                    [
                        [0.11680340766906738, 0.14273883402347565],
                        [0.47284311056137085, 0.14264710247516632],
                        [0.4728327989578247, 0.1574684977531433],
                        [0.11679177731275558, 0.15756075084209442],
                    ],
                    [
                        [0.1469321846961975, 0.17762035131454468],
                        [0.3157897889614105, 0.17757625877857208],
                        [0.3157789409160614, 0.1923581063747406],
                        [0.14692069590091705, 0.1924024522304535],
                    ],
                    [
                        [0.14640459418296814, 0.21234093606472015],
                        [0.5271102786064148, 0.21224018931388855],
                        [0.5271002054214478, 0.22706592082977295],
                        [0.1463930606842041, 0.2271672487258911],
                    ],
                    [
                        [0.14675933122634888, 0.24755904078483582],
                        [0.26720336079597473, 0.24752673506736755],
                        [0.26719486713409424, 0.2589000165462494],
                        [0.14675049483776093, 0.2589324712753296],
                    ],
                    [
                        [0.14655961096286774, 0.2849607467651367],
                        [0.32208430767059326, 0.28491300344467163],
                        [0.32207366824150085, 0.2994508147239685],
                        [0.1465483158826828, 0.2994988262653351],
                    ],
                    [
                        [0.11756682395935059, 0.31933289766311646],
                        [0.33112412691116333, 0.31927406787872314],
                        [0.33111321926116943, 0.3342016935348511],
                        [0.11755511909723282, 0.33426085114479065],
                    ],
                    [
                        [0.14664067327976227, 0.35449478030204773],
                        [0.8514032959938049, 0.3542981743812561],
                        [0.8513944149017334, 0.3691220283508301],
                        [0.14662915468215942, 0.36931970715522766],
                    ],
                    [
                        [0.1465636044740677, 0.3718571066856384],
                        [0.8561281561851501, 0.3716579079627991],
                        [0.8561192750930786, 0.38651782274246216],
                        [0.14655205607414246, 0.38671809434890747],
                    ],
                    [
                        [0.1463679075241089, 0.389235258102417],
                        [0.6041507720947266, 0.3891059458255768],
                        [0.6041408777236938, 0.40407824516296387],
                        [0.1463562697172165, 0.404208242893219],
                    ],
                    [
                        [0.17593030631542206, 0.42245209217071533],
                        [0.8803234100341797, 0.42225074768066406],
                        [0.880313515663147, 0.4389817416667938],
                        [0.17591741681098938, 0.4391842484474182],
                    ],
                    [
                        [0.17551057040691376, 0.4939594268798828],
                        [0.3273889720439911, 0.493914932012558],
                        [0.3273783326148987, 0.5084575414657593],
                        [0.17549937963485718, 0.5085022449493408],
                    ],
                    [
                        [0.17798829078674316, 0.4741896092891693],
                        [0.8719438910484314, 0.4739876389503479],
                        [0.87193363904953, 0.4912440776824951],
                        [0.17797502875328064, 0.4914472699165344],
                    ],
                    [
                        [0.1759413778781891, 0.5272009372711182],
                        [0.8593633770942688, 0.5269983410835266],
                        [0.8593536019325256, 0.5433400869369507],
                        [0.17592880129814148, 0.5435437560081482],
                    ],
                    [
                        [0.17557843029499054, 0.5462343692779541],
                        [0.3499310612678528, 0.5461823344230652],
                        [0.34992071986198425, 0.5604568123817444],
                        [0.17556743323802948, 0.5605090856552124],
                    ],
                    [
                        [0.17586830258369446, 0.5809707641601562],
                        [0.8483183979988098, 0.580767810344696],
                        [0.8483096361160278, 0.5953913927078247],
                        [0.1758570522069931, 0.5955953001976013],
                    ],
                    [
                        [0.17579622566699982, 0.5981647968292236],
                        [0.41964155435562134, 0.5980907678604126],
                        [0.4196312427520752, 0.6126527786254883],
                        [0.17578501999378204, 0.612727165222168],
                    ],
                    [
                        [0.11703485250473022, 0.9278335571289062],
                        [0.4421391189098358, 0.9277240633964539],
                        [0.44213059544563293, 0.9398859739303589],
                        [0.11702531576156616, 0.9399958252906799],
                    ],
                    [
                        [0.7348451018333435, 0.9277169704437256],
                        [0.8231216073036194, 0.9276872277259827],
                        [0.8231141567230225, 0.9399791955947876],
                        [0.7348373532295227, 0.9400090575218201],
                    ],
                    [
                        [0.11723565310239792, 0.942299485206604],
                        [0.21531207859516144, 0.9422662854194641],
                        [0.215304434299469, 0.9523268938064575],
                        [0.11722776293754578, 0.952360212802887],
                    ],
                ],
            ],
        ],
    },
]

export const UsdaDocPromptExamples = [
    {
        question: 'Summarize the USDA guidelines and give key points.',
        InitialChatTitle: 'USDA Rural Housing Insights',
        Answer: 'Here are some key points:\n\n1. Eligibility and Service Areas:\n- Loans are provided in rural areas\n- Available to eligible low- and very low-income applicants\n- Rural areas include:\n  * Open country\n  * Places with population of 10,000 or less\n  * Under certain conditions, towns/cities between 10,000-20,000 population\n\n2. Loan Purpose Options:\n- Purchase existing housing\n- Purchase and repair existing housing\n- Purchase a building site and construct a dwelling\n- Purchase new housing\n\n3. Property Requirements:\n- Must be in good repair or brought to good repair with loan funds\n- Requires a whole house inspection by qualified inspector for existing properties\n- Inspection costs should be addressed in purchase agreement\n\n4. Equal Opportunity:\n- Equal consideration given regardless of:\n  * Race, color, national origin\n  * Religion, sex, gender identity\n  * Sexual orientation, disability, age\n  * Marital status, family/parental status\n  * Income source from public assistance\n  * Political beliefs\n\n5. Application Process:\nThree ways to apply:\n- Through a loan application packager\n- Online application (requires USDA eAuthentication)\n- Direct submission to Rural Development office\n\n6. Income Considerations:\n- Income limits apply based on area\n- Adjusted annual household income must be within specified limits\n- Applicants exceeding limits have alternative options:\n  * REO property purchase\n  * Transfer/assumption of existing Rural Development loans\n  * Guaranteed Rural Housing loans\n  * Private lending options\n\nReference: HB-1-3550, Handbook Letter 1 (3550), Attachment 3-D',
        QuoteLocations: [
            [
                '724',
                [
                    [
                        [0.7028114199638367, 0.09831266105175018],
                        [0.8832235932350159, 0.09836553782224655],
                        [0.8832314014434814, 0.11169494688510895],
                        [0.7028184533119202, 0.11164181679487228],
                    ],
                    [
                        [0.1165059432387352, 0.1310400664806366],
                        [0.22182047367095947, 0.1310712844133377],
                        [0.221824511885643, 0.14176593720912933],
                        [0.11650962382555008, 0.14173460006713867],
                    ],
                    [
                        [0.2932785153388977, 0.13081414997577667],
                        [0.5255289077758789, 0.13088300824165344],
                        [0.5255352258682251, 0.1442406177520752],
                        [0.2932838797569275, 0.14417144656181335],
                    ],
                    [
                        [0.11695485562086105, 0.16278579831123352],
                        [0.19538480043411255, 0.16280929744243622],
                        [0.19538863003253937, 0.1732027679681778],
                        [0.11695843189954758, 0.17317917943000793],
                    ],
                    [
                        [0.2928643226623535, 0.16262109577655792],
                        [0.48155656456947327, 0.16267766058444977],
                        [0.4815627336502075, 0.17608045041561127],
                        [0.2928696572780609, 0.17602363228797913],
                    ],
                    [
                        [0.5877037048339844, 0.21129167079925537],
                        [0.774867057800293, 0.21134869754314423],
                        [0.7748749256134033, 0.22560253739356995],
                        [0.5877106785774231, 0.2255452275276184],
                    ],
                    [
                        [0.12041663378477097, 0.2594080865383148],
                        [0.5286258459091187, 0.2595345079898834],
                        [0.5286323428153992, 0.27319902181625366],
                        [0.12042135000228882, 0.2730720341205597],
                    ],
                    [
                        [0.11747319251298904, 0.2755885124206543],
                        [0.4495297372341156, 0.2756918966770172],
                        [0.4495358467102051, 0.2893402576446533],
                        [0.1174778938293457, 0.2892363965511322],
                    ],
                    [
                        [0.11758256703615189, 0.29105183482170105],
                        [0.33256545662879944, 0.29111912846565247],
                        [0.33257097005844116, 0.30454403162002563],
                        [0.11758718639612198, 0.30447643995285034],
                    ],
                    [
                        [0.11692347377538681, 0.33962613344192505],
                        [0.4879917800426483, 0.3397441506385803],
                        [0.48799794912338257, 0.3530994653701782],
                        [0.11692807078361511, 0.35298097133636475],
                    ],
                    [
                        [0.11674266308546066, 0.3712032735347748],
                        [0.8722460865974426, 0.3714459538459778],
                        [0.8722540736198425, 0.38520702719688416],
                        [0.1167474016547203, 0.3849632441997528],
                    ],
                    [
                        [0.11657308042049408, 0.3868207633495331],
                        [0.8723547458648682, 0.38706475496292114],
                        [0.8723627924919128, 0.4008454978466034],
                        [0.11657782644033432, 0.4006004333496094],
                    ],
                    [
                        [0.11710666865110397, 0.4026455879211426],
                        [0.8653126358985901, 0.40288835763931274],
                        [0.8653208613395691, 0.41707563400268555],
                        [0.11711155623197556, 0.41683176159858704],
                    ],
                    [
                        [0.11785182356834412, 0.4346621632575989],
                        [0.8095351457595825, 0.4348888695240021],
                        [0.8095429539680481, 0.44875556230545044],
                        [0.11785659939050674, 0.44852787256240845],
                    ],
                    [
                        [0.11701002717018127, 0.450938880443573],
                        [0.8214597105979919, 0.45117098093032837],
                        [0.821467399597168, 0.46477749943733215],
                        [0.11701471358537674, 0.464544415473938],
                    ],
                    [
                        [0.11566989868879318, 0.4666292667388916],
                        [0.8146321177482605, 0.46686068177223206],
                        [0.8146398663520813, 0.4805929660797119],
                        [0.11567462235689163, 0.48036056756973267],
                    ],
                    [
                        [0.11659958213567734, 0.4833764433860779],
                        [0.19051623344421387, 0.48340103030204773],
                        [0.1905209720134735, 0.4962957799434662],
                        [0.1166040226817131, 0.4962711036205292],
                    ],
                    [
                        [0.11660797894001007, 0.5145028233528137],
                        [0.8236442804336548, 0.5147404074668884],
                        [0.8236520290374756, 0.5284076929092407],
                        [0.11661268770694733, 0.5281691551208496],
                    ],
                    [
                        [0.11706717312335968, 0.5306015014648438],
                        [0.8623230457305908, 0.5308531522750854],
                        [0.8623310327529907, 0.5446847081184387],
                        [0.11707193404436111, 0.5444319844245911],
                    ],
                    [
                        [0.11696694791316986, 0.5464773774147034],
                        [0.4508066475391388, 0.5465906858444214],
                        [0.45081281661987305, 0.5603140592575073],
                        [0.11697167903184891, 0.5602002739906311],
                    ],
                    [
                        [0.11692642420530319, 0.5782938003540039],
                        [0.8421384692192078, 0.5785422325134277],
                        [0.8421464562416077, 0.5924524664878845],
                        [0.11693121492862701, 0.5922029614448547],
                    ],
                    [
                        [0.11677895486354828, 0.5944532752037048],
                        [0.670896053314209, 0.5946440100669861],
                        [0.6709031462669373, 0.6083822846412659],
                        [0.11678368598222733, 0.6081907153129578],
                    ],
                    [
                        [0.11640895903110504, 0.6263850331306458],
                        [0.7229964733123779, 0.6265958547592163],
                        [0.7230037450790405, 0.6402116417884827],
                        [0.11641363799571991, 0.6399999856948853],
                    ],
                    [
                        [0.09605146944522858, 0.8761717081069946],
                        [0.2578134834766388, 0.8762320876121521],
                        [0.2578180730342865, 0.8880560994148254],
                        [0.09605546295642853, 0.8879954814910889],
                    ],
                ],
            ],
            [
                '129',
                [
                    [
                        [0.791369616985321, 0.10900885611772537],
                        [0.8967627882957458, 0.10910103470087051],
                        [0.8967634439468384, 0.11889897286891937],
                        [0.7913698554039001, 0.11880677193403244],
                    ],
                    [
                        [0.7911902070045471, 0.12301630526781082],
                        [0.8646883368492126, 0.12308061122894287],
                        [0.8646889925003052, 0.13592484593391418],
                        [0.791190505027771, 0.13586051762104034],
                    ],
                    [
                        [0.41124460101127625, 0.14881405234336853],
                        [0.5872451066970825, 0.1489681452512741],
                        [0.58724445104599, 0.16052863001823425],
                        [0.41124314069747925, 0.1603745073080063],
                    ],
                    [
                        [0.3863247334957123, 0.20517180860042572],
                        [0.6125509738922119, 0.20537014305591583],
                        [0.6125504374504089, 0.2168857753276825],
                        [0.38632315397262573, 0.2166873812675476],
                    ],
                    [
                        [0.36981484293937683, 0.2225324809551239],
                        [0.6253125071525574, 0.22275657951831818],
                        [0.6253119707107544, 0.23428596556186676],
                        [0.3698131740093231, 0.2340618073940277],
                    ],
                    [
                        [0.28182944655418396, 0.24291522800922394],
                        [0.7178681492805481, 0.24329787492752075],
                        [0.7178680896759033, 0.2581314146518707],
                        [0.28182676434516907, 0.2577486038208008],
                    ],
                    [
                        [0.1754463016986847, 0.2742956578731537],
                        [0.8622308969497681, 0.27489882707595825],
                        [0.8622316718101501, 0.28961044549942017],
                        [0.17544303834438324, 0.2890070378780365],
                    ],
                    [
                        [0.11818476021289825, 0.29176971316337585],
                        [0.8285341858863831, 0.29239386320114136],
                        [0.8285347819328308, 0.30755606293678284],
                        [0.11818105727434158, 0.30693167448043823],
                    ],
                    [
                        [0.11701492220163345, 0.3088536262512207],
                        [0.8478559851646423, 0.30949604511260986],
                        [0.8478567004203796, 0.32502835988998413],
                        [0.11701112240552902, 0.32438570261001587],
                    ],
                    [
                        [0.1169060543179512, 0.3264382779598236],
                        [0.8442577719688416, 0.3270778954029083],
                        [0.8442584872245789, 0.3427686095237732],
                        [0.11690220981836319, 0.342128723859787],
                    ],
                    [
                        [0.11669676750898361, 0.34425637125968933],
                        [0.7565706968307495, 0.3448193371295929],
                        [0.7565708160400391, 0.35954880714416504],
                        [0.1166931539773941, 0.35898563265800476],
                    ],
                    [
                        [0.16430799663066864, 0.3772382140159607],
                        [0.6756876111030579, 0.3776884973049164],
                        [0.675687313079834, 0.39246171712875366],
                        [0.16430465877056122, 0.39201125502586365],
                    ],
                    [
                        [0.1073203757405281, 0.39476731419563293],
                        [0.5977551341056824, 0.39519932866096497],
                        [0.5977543592453003, 0.40992799401283264],
                        [0.10731671005487442, 0.4094958007335663],
                    ],
                    [
                        [0.17590533196926117, 0.42711541056632996],
                        [0.8385968804359436, 0.42769965529441833],
                        [0.8385975956916809, 0.4431203007698059],
                        [0.17590191960334778, 0.4425358176231384],
                    ],
                    [
                        [0.1174420714378357, 0.4445446729660034],
                        [0.8449432253837585, 0.4451863467693329],
                        [0.8449438810348511, 0.4603157341480255],
                        [0.11743836849927902, 0.45967382192611694],
                    ],
                    [
                        [0.11739137023687363, 0.46206238865852356],
                        [0.8213456273078918, 0.4626835584640503],
                        [0.8213461637496948, 0.47773995995521545],
                        [0.11738768965005875, 0.4771185517311096],
                    ],
                    [
                        [0.11742778867483139, 0.4798903167247772],
                        [0.46310174465179443, 0.48019546270370483],
                        [0.4631001949310303, 0.4946618974208832],
                        [0.11742424964904785, 0.494356632232666],
                    ],
                    [
                        [0.1761355847120285, 0.5120564699172974],
                        [0.8314175009727478, 0.5126354098320007],
                        [0.8314180970191956, 0.5279998779296875],
                        [0.1761321872472763, 0.527420699596405],
                    ],
                    [
                        [0.11712311208248138, 0.5292403697967529],
                        [0.8491591811180115, 0.5298873782157898],
                        [0.8491598963737488, 0.5453404188156128],
                        [0.11711932718753815, 0.544693112373352],
                    ],
                    [
                        [0.11736032366752625, 0.5467673540115356],
                        [0.8011127710342407, 0.5473719835281372],
                        [0.8011131882667542, 0.5626485347747803],
                        [0.11735658347606659, 0.5620437264442444],
                    ],
                    [
                        [0.11691185086965561, 0.5644991993904114],
                        [0.4246678352355957, 0.5647714734077454],
                        [0.42466601729393005, 0.5796200633049011],
                        [0.11690820753574371, 0.5793476700782776],
                    ],
                    [
                        [0.17567799985408783, 0.5965844392776489],
                        [0.7964414954185486, 0.5971340537071228],
                        [0.7964418530464172, 0.6125068664550781],
                        [0.17567460238933563, 0.6119570136070251],
                    ],
                    [
                        [0.11727451533079147, 0.6140578985214233],
                        [0.8340671062469482, 0.6146928071975708],
                        [0.8340677618980408, 0.6300498843193054],
                        [0.11727075278759003, 0.6294147372245789],
                    ],
                    [
                        [0.11745438724756241, 0.6323447227478027],
                        [0.23211294412612915, 0.6324463486671448],
                        [0.23211005330085754, 0.6469449996948242],
                        [0.11745083332061768, 0.6468433737754822],
                    ],
                    [
                        [0.20547142624855042, 0.6674659252166748],
                        [0.8645445704460144, 0.6680505275726318],
                        [0.8645454049110413, 0.6833767890930176],
                        [0.20546820759773254, 0.6827920079231262],
                    ],
                    [
                        [0.20734351873397827, 0.6852070689201355],
                        [0.7849711179733276, 0.6857196092605591],
                        [0.7849714159965515, 0.7006194591522217],
                        [0.20734040439128876, 0.700106680393219],
                    ],
                    [
                        [0.20548996329307556, 0.7033613324165344],
                        [0.8497635722160339, 0.7039332389831543],
                        [0.8497642874717712, 0.7194285988807678],
                        [0.2054867148399353, 0.7188564538955688],
                    ],
                    [
                        [0.20521287620067596, 0.721106231212616],
                        [0.8129907846450806, 0.7216460108757019],
                        [0.8129912614822388, 0.7368995547294617],
                        [0.2052096724510193, 0.7363595366477966],
                    ],
                    [
                        [0.20538420975208282, 0.7392833232879639],
                        [0.8374342322349548, 0.7398449182510376],
                        [0.8374348878860474, 0.7549142241477966],
                        [0.20538105070590973, 0.7543524503707886],
                    ],
                    [
                        [0.2053149789571762, 0.7568541169166565],
                        [0.8415957093238831, 0.7574197053909302],
                        [0.8415963649749756, 0.7726459503173828],
                        [0.20531179010868073, 0.77208012342453],
                    ],
                ],
            ],
        ],
    },
    {
        question: 'How to use rental income to qualify for a loan?',
        InitialChatTitle: 'Qualifying with Rental Earnings',
        Answer: 'Based on the USDA guidelines, here is the answer:\n\nFor rental income to be considered for loan qualification, it must be evaluated under both annual income and repayment income criteria:\n\n1. For Annual Income:\n- The gross amount of rental income must be included in annual income calculations\n- This applies to income from all household members, not just parties to the note\n\n2. For Repayment Income:\n- Only rental income from parties to the note can be considered\n- The rental income must be determined to be stable and dependable\n- Actual income derived from rental assets is used in calculations\n\nKey Verification Requirements:\n- Documentation of two years of rental income history is typically required\n- Tax returns, W-2s, and other preferred verification sources should be used to evaluate the stability and dependability of the rental income\n- The Loan Originator will compare application information with verification documents to make determinations\n\nImportant Notes:\n- Rental income must meet the "stable and dependable" criteria to be counted for repayment purposes\n- Only parties to the note\'s rental income can be used for repayment qualification\n- The income must be properly documented and verified\n\nReferences: \nHB-1-3550, Chapter 4.2 A.1 (Income Definitions)\nHB-1-3550, Chapter 4.3 A (Income Considered for Annual and Repayment Income)\nHB-1-3550, Chapter 4.4 H (Calculating Repayment Income)',
        QuoteLocations: [
            [
                '69',
                [
                    [
                        [0.11717453598976135, 0.6676156520843506],
                        [0.8710690140724182, 0.6674623489379883],
                        [0.8710849285125732, 0.6825916171073914],
                        [0.11718564480543137, 0.6827442646026611],
                    ],
                    [
                        [0.11712903529405594, 0.685381293296814],
                        [0.7844551801681519, 0.6852461695671082],
                        [0.7844703793525696, 0.7002263069152832],
                        [0.117140032351017, 0.700360894203186],
                    ],
                    [
                        [0.11769794672727585, 0.7027907967567444],
                        [0.8471434712409973, 0.7026437520980835],
                        [0.8471590876579285, 0.717654824256897],
                        [0.1177089735865593, 0.7178013324737549],
                    ],
                    [
                        [0.1174769327044487, 0.7206881046295166],
                        [0.5860984325408936, 0.720594048500061],
                        [0.5861120223999023, 0.735153317451477],
                        [0.11748762428760529, 0.735247015953064],
                    ],
                    [
                        [0.1761489063501358, 0.7533474564552307],
                        [0.8664876222610474, 0.7532100677490234],
                        [0.8665032982826233, 0.7681261897087097],
                        [0.17616023123264313, 0.7682631015777588],
                    ],
                    [
                        [0.11722274124622345, 0.7711049318313599],
                        [0.8576073050498962, 0.7709581851959229],
                        [0.8576228022575378, 0.785778820514679],
                        [0.11723362654447556, 0.785925030708313],
                    ],
                    [
                        [0.11716780811548233, 0.7882310152053833],
                        [0.8503448367118835, 0.7880863547325134],
                        [0.8503603935241699, 0.8030203580856323],
                        [0.117178775370121, 0.803164541721344],
                    ],
                    [
                        [0.11696630716323853, 0.8060433864593506],
                        [0.8286153078079224, 0.8059035539627075],
                        [0.8286306858062744, 0.8207659721374512],
                        [0.11697721481323242, 0.8209052681922913],
                    ],
                    [
                        [0.11697611957788467, 0.8234610557556152],
                        [0.1766529381275177, 0.8234493732452393],
                        [0.17666170001029968, 0.8349903225898743],
                        [0.11698459088802338, 0.8350019454956055],
                    ],
                    [
                        [0.4881436228752136, 0.8699556589126587],
                        [0.5102468729019165, 0.8699513673782349],
                        [0.5102555155754089, 0.8795404434204102],
                        [0.4881521761417389, 0.8795446753501892],
                    ],
                    [
                        [0.11713727563619614, 0.8846573829650879],
                        [0.2872335612773895, 0.8846246004104614],
                        [0.28724297881126404, 0.8962994813919067],
                        [0.1171458512544632, 0.8963321447372437],
                    ],
                ],
            ],
            [
                '96',
                [
                    [
                        [0.7753672003746033, 0.0734303742647171],
                        [0.8790630102157593, 0.07344620674848557],
                        [0.8790669441223145, 0.08285774290561676],
                        [0.7753708362579346, 0.0828418880701065],
                    ],
                    [
                        [0.77496337890625, 0.0885329470038414],
                        [0.8580904006958008, 0.08854565769433975],
                        [0.8580957651138306, 0.10155590623617172],
                        [0.7749683856964111, 0.10154317319393158],
                    ],
                    [
                        [0.11610011756420135, 0.12169511616230011],
                        [0.4568740725517273, 0.12174741178750992],
                        [0.4568782448768616, 0.13639859855175018],
                        [0.1161026805639267, 0.1363462209701538],
                    ],
                    [
                        [0.11773126572370529, 0.14646315574645996],
                        [0.9064777493476868, 0.14658451080322266],
                        [0.9064841866493225, 0.16168750822544098],
                        [0.1177339106798172, 0.16156597435474396],
                    ],
                    [
                        [0.11713536828756332, 0.16389776766300201],
                        [0.907050609588623, 0.16401952505111694],
                        [0.9070569276809692, 0.17889927327632904],
                        [0.11713797599077225, 0.17877735197544098],
                    ],
                    [
                        [0.11768049746751785, 0.18105784058570862],
                        [0.8960508704185486, 0.181178018450737],
                        [0.8960572481155396, 0.19625213742256165],
                        [0.11768313497304916, 0.19613178074359894],
                    ],
                    [
                        [0.11723323911428452, 0.19875362515449524],
                        [0.9048662781715393, 0.19887545704841614],
                        [0.9048726558685303, 0.213845357298851],
                        [0.11723585426807404, 0.21372336149215698],
                    ],
                    [
                        [0.11753010749816895, 0.21602663397789001],
                        [0.8575316071510315, 0.21614128351211548],
                        [0.8575378060340881, 0.23122906684875488],
                        [0.11753274500370026, 0.2311142385005951],
                    ],
                    [
                        [0.11727742850780487, 0.2336505800485611],
                        [0.8736176490783691, 0.23376797139644623],
                        [0.8736238479614258, 0.2486627995967865],
                        [0.1172800362110138, 0.24854522943496704],
                    ],
                    [
                        [0.1174066811800003, 0.2508551776409149],
                        [0.8323498964309692, 0.250966340303421],
                        [0.8323559761047363, 0.2660655975341797],
                        [0.11740932613611221, 0.26595425605773926],
                    ],
                    [
                        [0.11708267033100128, 0.26836922764778137],
                        [0.8765670657157898, 0.26848751306533813],
                        [0.8765732049942017, 0.2832227349281311],
                        [0.11708524823188782, 0.28310427069664],
                    ],
                    [
                        [0.11777348816394806, 0.28585872054100037],
                        [0.8855816721916199, 0.2859785258769989],
                        [0.8855879902839661, 0.3010338544845581],
                        [0.11777612566947937, 0.30091387033462524],
                    ],
                    [
                        [0.11729875952005386, 0.3034714162349701],
                        [0.9058002829551697, 0.3035946488380432],
                        [0.9058066010475159, 0.3183264434337616],
                        [0.1173013374209404, 0.31820300221443176],
                    ],
                    [
                        [0.11847685277462006, 0.32094210386276245],
                        [0.7953235507011414, 0.3210480809211731],
                        [0.7953291535377502, 0.33537057042121887],
                        [0.11847936362028122, 0.3352644443511963],
                    ],
                    [
                        [0.11735713481903076, 0.35277312994003296],
                        [0.8577585816383362, 0.35288941860198975],
                        [0.8577646613121033, 0.3677828311920166],
                        [0.11735974252223969, 0.3676663935184479],
                    ],
                    [
                        [0.11741114407777786, 0.3705485761165619],
                        [0.8204323649406433, 0.370659202337265],
                        [0.8204382658004761, 0.38541337847709656],
                        [0.117413729429245, 0.3853026032447815],
                    ],
                    [
                        [0.11741290986537933, 0.3874002695083618],
                        [0.8408831357955933, 0.38751429319381714],
                        [0.8408892750740051, 0.40260669589042664],
                        [0.11741555482149124, 0.402492493391037],
                    ],
                    [
                        [0.11733980476856232, 0.40528008341789246],
                        [0.8561374545097351, 0.4053967297077179],
                        [0.8561434745788574, 0.42013147473335266],
                        [0.11734238266944885, 0.4200146794319153],
                    ],
                    [
                        [0.11706990003585815, 0.4223995804786682],
                        [0.8437579274177551, 0.42251449823379517],
                        [0.8437641263008118, 0.43763768672943115],
                        [0.11707255244255066, 0.4375225901603699],
                    ],
                    [
                        [0.11734361946582794, 0.4400749206542969],
                        [0.8099489212036133, 0.44018465280532837],
                        [0.809954822063446, 0.45500174164772034],
                        [0.11734621226787567, 0.4548918604850769],
                    ],
                    [
                        [0.11739907413721085, 0.4572273790836334],
                        [0.8077028393745422, 0.4573369026184082],
                        [0.8077087998390198, 0.472493052482605],
                        [0.11740172654390335, 0.4723833203315735],
                    ],
                    [
                        [0.11756166070699692, 0.47492730617523193],
                        [0.8387998342514038, 0.4750419557094574],
                        [0.8388057947158813, 0.48983126878738403],
                        [0.11756425350904465, 0.48971644043922424],
                    ],
                    [
                        [0.11714394390583038, 0.4922194182872772],
                        [0.8575534820556641, 0.49233731627464294],
                        [0.8575596213340759, 0.5071514844894409],
                        [0.11714653670787811, 0.5070334076881409],
                    ],
                ],
            ],
            [
                '166',
                [
                    [
                        [0.1433386206626892, 0.5613511800765991],
                        [0.6343464255332947, 0.5613439083099365],
                        [0.6343548893928528, 0.5760483741760254],
                        [0.1433454155921936, 0.5760554075241089],
                    ],
                    [
                        [0.1758972853422165, 0.591012716293335],
                        [0.8527438044548035, 0.59100341796875],
                        [0.8527531623840332, 0.6059654355049133],
                        [0.1759043186903, 0.6059744358062744],
                    ],
                    [
                        [0.11736273765563965, 0.6082028746604919],
                        [0.8428327441215515, 0.6081933379173279],
                        [0.8428421020507812, 0.6231840252876282],
                        [0.11736956983804703, 0.6231932044029236],
                    ],
                    [
                        [0.11727166175842285, 0.625954270362854],
                        [0.8013155460357666, 0.6259456872940063],
                        [0.801324725151062, 0.6409187912940979],
                        [0.11727848649024963, 0.6409270167350769],
                    ],
                    [
                        [0.17699889838695526, 0.6487597227096558],
                        [0.8103699088096619, 0.6487522721290588],
                        [0.8103792071342468, 0.6637417674064636],
                        [0.17700594663619995, 0.6637488603591919],
                    ],
                    [
                        [0.20572958886623383, 0.666493833065033],
                        [0.8208602070808411, 0.6664869785308838],
                        [0.820869505405426, 0.6814876198768616],
                        [0.20573672652244568, 0.6814941167831421],
                    ],
                    [
                        [0.20546817779541016, 0.6835363507270813],
                        [0.8594089150428772, 0.6835294961929321],
                        [0.8594183325767517, 0.6985180974006653],
                        [0.205475315451622, 0.6985246539115906],
                    ],
                    [
                        [0.20541688799858093, 0.7012592554092407],
                        [0.831074595451355, 0.7012530565261841],
                        [0.8310839533805847, 0.7162148356437683],
                        [0.2054240107536316, 0.7162206768989563],
                    ],
                    [
                        [0.2049405723810196, 0.718457043170929],
                        [0.8535155057907104, 0.7184510231018066],
                        [0.8535248637199402, 0.7333890199661255],
                        [0.20494769513607025, 0.7333946824073792],
                    ],
                    [
                        [0.2056884467601776, 0.7362457513809204],
                        [0.8606869578361511, 0.7362400889396667],
                        [0.8606963157653809, 0.7511787414550781],
                        [0.20569556951522827, 0.7511841058731079],
                    ],
                    [
                        [0.2054707109928131, 0.7531570792198181],
                        [0.8073470592498779, 0.7531521916389465],
                        [0.8073548078536987, 0.76576167345047],
                        [0.20547671616077423, 0.7657662630081177],
                    ],
                    [
                        [0.2054571658372879, 0.7712891697883606],
                        [0.4723134934902191, 0.771287202835083],
                        [0.47232136130332947, 0.785915195941925],
                        [0.20546412467956543, 0.7859170436859131],
                    ],
                    [
                        [0.4865243136882782, 0.8725053071975708],
                        [0.5153775811195374, 0.8725051879882812],
                        [0.5153828859329224, 0.882194459438324],
                        [0.4865295886993408, 0.8821945786476135],
                    ],
                    [
                        [0.12152028828859329, 0.8874619007110596],
                        [0.2857476770877838, 0.8874613642692566],
                        [0.2857535481452942, 0.8992835283279419],
                        [0.12152568995952606, 0.8992840051651001],
                    ],
                ],
            ],
            [
                '156',
                [
                    [
                        [0.056585535407066345, 0.11383538693189621],
                        [0.5047006011009216, 0.11394878476858139],
                        [0.5046995878219604, 0.12667904794216156],
                        [0.05658237636089325, 0.1265651136636734],
                    ],
                    [
                        [0.17608729004859924, 0.14945900440216064],
                        [0.5501044392585754, 0.14955490827560425],
                        [0.5501035451889038, 0.16403336822986603],
                        [0.17608435451984406, 0.16393695771694183],
                    ],
                    [
                        [0.17665457725524902, 0.1820315420627594],
                        [0.3616299629211426, 0.18207953870296478],
                        [0.3616284132003784, 0.1937124878168106],
                        [0.1766522079706192, 0.1936642974615097],
                    ],
                    [
                        [0.2050580531358719, 0.21432507038116455],
                        [0.8610494136810303, 0.21449728310108185],
                        [0.8610501289367676, 0.22797879576683044],
                        [0.20505546033382416, 0.2278057336807251],
                    ],
                    [
                        [0.17572006583213806, 0.2314649522304535],
                        [0.8680955171585083, 0.23164784908294678],
                        [0.8680963516235352, 0.24651359021663666],
                        [0.1757170408964157, 0.24632972478866577],
                    ],
                    [
                        [0.1762702912092209, 0.24900983273983002],
                        [0.8502653241157532, 0.24918898940086365],
                        [0.8502660989761353, 0.26401785016059875],
                        [0.17626728117465973, 0.2638377547264099],
                    ],
                    [
                        [0.17603030800819397, 0.2665489614009857],
                        [0.8440839052200317, 0.26672762632369995],
                        [0.8440845608711243, 0.28151074051856995],
                        [0.1760272979736328, 0.2813311219215393],
                    ],
                    [
                        [0.17575810849666595, 0.283715158700943],
                        [0.8655245900154114, 0.28390076756477356],
                        [0.8655254244804382, 0.2990351617336273],
                        [0.17575503885746002, 0.29884856939315796],
                    ],
                    [
                        [0.175639346241951, 0.30122071504592896],
                        [0.8722233176231384, 0.3014093041419983],
                        [0.8722242116928101, 0.3162742257118225],
                        [0.17563632130622864, 0.3160846531391144],
                    ],
                    [
                        [0.17590628564357758, 0.31873875856399536],
                        [0.8002303242683411, 0.31890881061553955],
                        [0.8002307415008545, 0.33279532194137573],
                        [0.17590346932411194, 0.3326244354248047],
                    ],
                    [
                        [0.17583070695400238, 0.3359738886356354],
                        [0.8254982233047485, 0.3361518979072571],
                        [0.8254988789558411, 0.3511822819709778],
                        [0.17582765221595764, 0.35100334882736206],
                    ],
                    [
                        [0.17643383145332336, 0.3536340594291687],
                        [0.4631030559539795, 0.3537130653858185],
                        [0.46310165524482727, 0.36863261461257935],
                        [0.17643079161643982, 0.36855319142341614],
                    ],
                    [
                        [0.2638819217681885, 0.3872498869895935],
                        [0.8076954483985901, 0.3874015212059021],
                        [0.8076958060264587, 0.39909806847572327],
                        [0.2638799250125885, 0.3989458382129669],
                    ],
                    [
                        [0.2638084590435028, 0.40465492010116577],
                        [0.8756470680236816, 0.4048265218734741],
                        [0.8756479620933533, 0.4195833206176758],
                        [0.26380595564842224, 0.4194108545780182],
                    ],
                    [
                        [0.26391348242759705, 0.42170387506484985],
                        [0.8772595524787903, 0.4218769073486328],
                        [0.8772604465484619, 0.43712350726127625],
                        [0.2639108896255493, 0.43694961071014404],
                    ],
                    [
                        [0.26439595222473145, 0.43938982486724854],
                        [0.8606278896331787, 0.4395590126514435],
                        [0.8606286644935608, 0.4544990062713623],
                        [0.2643933892250061, 0.4543289840221405],
                    ],
                    [
                        [0.2641749083995819, 0.4564840495586395],
                        [0.8767858743667603, 0.45665889978408813],
                        [0.8767867684364319, 0.47193777561187744],
                        [0.2641723155975342, 0.4717620611190796],
                    ],
                    [
                        [0.26408106088638306, 0.47460857033729553],
                        [0.3230052888393402, 0.47462549805641174],
                        [0.32300320267677307, 0.4887090027332306],
                        [0.26407867670059204, 0.4886919856071472],
                    ],
                    [
                        [0.2638608515262604, 0.5076627135276794],
                        [0.8773870468139648, 0.5078408122062683],
                        [0.8773879408836365, 0.5226902961730957],
                        [0.2638583183288574, 0.52251136302948],
                    ],
                    [
                        [0.26444360613822937, 0.5252960324287415],
                        [0.8105589151382446, 0.5254554152488708],
                        [0.8105593919754028, 0.5399940013885498],
                        [0.2644411325454712, 0.5398338437080383],
                    ],
                    [
                        [0.26453498005867004, 0.542701244354248],
                        [0.8419949412345886, 0.5428707599639893],
                        [0.8419956564903259, 0.5577153563499451],
                        [0.2645324468612671, 0.5575450658798218],
                    ],
                    [
                        [0.26473942399024963, 0.576058566570282],
                        [0.8724782466888428, 0.5762388706207275],
                        [0.8724790811538696, 0.5914850234985352],
                        [0.2647368311882019, 0.591303825378418],
                    ],
                    [
                        [0.263957679271698, 0.5931472182273865],
                        [0.8748732805252075, 0.5933294296264648],
                        [0.8748742341995239, 0.6087108254432678],
                        [0.2639550566673279, 0.6085277199745178],
                    ],
                    [
                        [0.2637845277786255, 0.6108037233352661],
                        [0.876046895980835, 0.6109873652458191],
                        [0.8760477900505066, 0.6260753870010376],
                        [0.26378196477890015, 0.6258909106254578],
                    ],
                    [
                        [0.2642990052700043, 0.6282785534858704],
                        [0.8273775577545166, 0.6284483671188354],
                        [0.8273782134056091, 0.6438349485397339],
                        [0.26429638266563416, 0.6436643600463867],
                    ],
                    [
                        [0.2643275558948517, 0.6458584666252136],
                        [0.8404459357261658, 0.6460331678390503],
                        [0.8404465913772583, 0.6606789231300354],
                        [0.2643250524997711, 0.6605034470558167],
                    ],
                    [
                        [0.264460027217865, 0.6633667349815369],
                        [0.5923823118209839, 0.66346675157547],
                        [0.5923815965652466, 0.6781901717185974],
                        [0.2644575238227844, 0.6780897378921509],
                    ],
                    [
                        [0.17604894936084747, 0.6961550116539001],
                        [0.41354912519454956, 0.6962281465530396],
                        [0.4135478138923645, 0.7077919244766235],
                        [0.17604660987854004, 0.7077184915542603],
                    ],
                ],
            ],
            [
                '247',
                [
                    [
                        [0.11671604961156845, 0.7224303483963013],
                        [0.8938820362091064, 0.722544252872467],
                        [0.8938913345336914, 0.7376149892807007],
                        [0.11672138422727585, 0.7374995350837708],
                    ],
                    [
                        [0.11689984798431396, 0.7401948571205139],
                        [0.8914886713027954, 0.7403101921081543],
                        [0.8914976716041565, 0.7549036145210266],
                        [0.11690501123666763, 0.7547867894172668],
                    ],
                    [
                        [0.1171044185757637, 0.7574337720870972],
                        [0.6688069105148315, 0.7575171589851379],
                        [0.6688151359558105, 0.7726377844810486],
                        [0.11710977554321289, 0.7725533246994019],
                    ],
                    [
                        [0.17575636506080627, 0.7866892218589783],
                        [0.7250509858131409, 0.7867743968963623],
                        [0.7250593304634094, 0.8016941547393799],
                        [0.17576193809509277, 0.8016079664230347],
                    ],
                    [
                        [0.12141144275665283, 0.804272472858429],
                        [0.8987025022506714, 0.8043947219848633],
                        [0.898711621761322, 0.8190801739692688],
                        [0.12141666561365128, 0.8189563751220703],
                    ],
                    [
                        [0.1165510043501854, 0.8217447996139526],
                        [0.8720697164535522, 0.8218653798103333],
                        [0.8720787763595581, 0.8367392420768738],
                        [0.11655627191066742, 0.8366171717643738],
                    ],
                    [
                        [0.878020167350769, 0.8219940662384033],
                        [0.8936709761619568, 0.8219965696334839],
                        [0.8936781287193298, 0.8335249423980713],
                        [0.8780272603034973, 0.8335224390029907],
                    ],
                    [
                        [0.5043389201164246, 0.8416804671287537],
                        [0.52367103099823, 0.8416836261749268],
                        [0.5236757397651672, 0.8512743711471558],
                        [0.504343569278717, 0.8512712121009827],
                    ],
                    [
                        [0.10742130130529404, 0.8560882806777954],
                        [0.2712002694606781, 0.8561151027679443],
                        [0.2712051570415497, 0.8681095242500305],
                        [0.1074255108833313, 0.8680824041366577],
                    ],
                ],
            ],
            [
                '5',
                [
                    [
                        [0.7663406133651733, 0.10735923796892166],
                        [0.8820717930793762, 0.10740073770284653],
                        [0.8820780515670776, 0.11712498217821121],
                        [0.7663463950157166, 0.11708348244428635],
                    ],
                    [
                        [0.8387497067451477, 0.12241552025079727],
                        [0.8823559880256653, 0.12243115156888962],
                        [0.8823637962341309, 0.13454602658748627],
                        [0.8387572765350342, 0.13453038036823273],
                    ],
                    [
                        [0.1777580827474594, 0.15131211280822754],
                        [0.3493193984031677, 0.15137363970279694],
                        [0.349324107170105, 0.16268819570541382],
                        [0.1777619868516922, 0.16262665390968323],
                    ],
                    [
                        [0.37176838517189026, 0.15131495893001556],
                        [0.8427826762199402, 0.15148389339447021],
                        [0.8427914977073669, 0.16558346152305603],
                        [0.3717744052410126, 0.165414497256279],
                    ],
                    [
                        [0.37030255794525146, 0.16886091232299805],
                        [0.45257997512817383, 0.16889041662216187],
                        [0.4525851607322693, 0.18012775480747223],
                        [0.3703073263168335, 0.18009823560714722],
                    ],
                    [
                        [0.1777014583349228, 0.18625758588314056],
                        [0.3525330424308777, 0.18632031977176666],
                        [0.35253775119781494, 0.19758960604667664],
                        [0.1777053326368332, 0.19752687215805054],
                    ],
                    [
                        [0.3720143139362335, 0.18617981672286987],
                        [0.7571614384651184, 0.18631799519062042],
                        [0.757168173789978, 0.1976989209651947],
                        [0.3720191717147827, 0.19756072759628296],
                    ],
                    [
                        [0.17569196224212646, 0.20357410609722137],
                        [0.35042497515678406, 0.20363681018352509],
                        [0.3504297733306885, 0.2151654064655304],
                        [0.17569591104984283, 0.21510271728038788],
                    ],
                    [
                        [0.37197500467300415, 0.20366530120372772],
                        [0.6363778710365295, 0.20376017689704895],
                        [0.6363840103149414, 0.21523183584213257],
                        [0.37197989225387573, 0.21513696014881134],
                    ],
                    [
                        [0.17581549286842346, 0.22103948891162872],
                        [0.34239789843559265, 0.22109927237033844],
                        [0.3424026072025299, 0.23243063688278198],
                        [0.17581938207149506, 0.23237085342407227],
                    ],
                    [
                        [0.37210795283317566, 0.22090741991996765],
                        [0.856357991695404, 0.2210812121629715],
                        [0.8563652634620667, 0.23253817856311798],
                        [0.37211284041404724, 0.23236438632011414],
                    ],
                    [
                        [0.371369868516922, 0.23852892220020294],
                        [0.7899885177612305, 0.2386791706085205],
                        [0.7899953126907349, 0.2499767690896988],
                        [0.3713746964931488, 0.24982650578022003],
                    ],
                    [
                        [0.17558598518371582, 0.2559396028518677],
                        [0.34385764598846436, 0.25600001215934753],
                        [0.3438623547554016, 0.2673439383506775],
                        [0.17558987438678741, 0.26728352904319763],
                    ],
                    [
                        [0.3695278465747833, 0.25592562556266785],
                        [0.864201009273529, 0.2561032176017761],
                        [0.8642081618309021, 0.2673414349555969],
                        [0.36953261494636536, 0.26716384291648865],
                    ],
                    [
                        [0.3714020550251007, 0.2733403742313385],
                        [0.6906974911689758, 0.2734549939632416],
                        [0.6907037496566772, 0.2846444845199585],
                        [0.37140682339668274, 0.28452983498573303],
                    ],
                    [
                        [0.11734313517808914, 0.305195152759552],
                        [0.4905681610107422, 0.30532917380332947],
                        [0.4905736446380615, 0.31685903668403625],
                        [0.11734681576490402, 0.3167249858379364],
                    ],
                    [
                        [0.8558889031410217, 0.35745668411254883],
                        [0.879554033279419, 0.3574651777744293],
                        [0.8795613646507263, 0.3688545525074005],
                        [0.8558961153030396, 0.36884602904319763],
                    ],
                    [
                        [0.17744484543800354, 0.3223836123943329],
                        [0.31065329909324646, 0.32243144512176514],
                        [0.31065797805786133, 0.3340511918067932],
                        [0.17744885385036469, 0.3340033292770386],
                    ],
                    [
                        [0.11715475469827652, 0.3399782180786133],
                        [0.5740916728973389, 0.3401423394680023],
                        [0.5740976929664612, 0.3519069254398346],
                        [0.11715850234031677, 0.35174277424812317],
                    ],
                    [
                        [0.17744292318820953, 0.357007771730423],
                        [0.3108883798122406, 0.3570556938648224],
                        [0.31089308857917786, 0.36882030963897705],
                        [0.17744697630405426, 0.36877235770225525],
                    ],
                    [
                        [0.20553746819496155, 0.37481003999710083],
                        [0.5526809692382812, 0.37493476271629333],
                        [0.5526882410049438, 0.3893676698207855],
                        [0.20554260909557343, 0.38924291729927063],
                    ],
                    [
                        [0.2051742672920227, 0.3921619653701782],
                        [0.6982189416885376, 0.39233914017677307],
                        [0.6982272863388062, 0.40710386633872986],
                        [0.20517952740192413, 0.4069266617298126],
                    ],
                    [
                        [0.17768234014511108, 0.4099139869213104],
                        [0.40514665842056274, 0.4099957346916199],
                        [0.4051516652107239, 0.42139336466789246],
                        [0.17768625915050507, 0.421311616897583],
                    ],
                    [
                        [0.20546148717403412, 0.42681995034217834],
                        [0.6619939208030701, 0.4269840717315674],
                        [0.6620021462440491, 0.44197481870651245],
                        [0.2054668366909027, 0.4418106973171234],
                    ],
                    [
                        [0.20522816479206085, 0.4442652761936188],
                        [0.6811709403991699, 0.44443637132644653],
                        [0.6811791658401489, 0.45919227600097656],
                        [0.2052334100008011, 0.4590211510658264],
                    ],
                    [
                        [0.20552054047584534, 0.46165502071380615],
                        [0.7129527926445007, 0.4618374705314636],
                        [0.7129612565040588, 0.47666043043136597],
                        [0.20552581548690796, 0.4764779806137085],
                    ],
                    [
                        [0.20545195043087006, 0.47914111614227295],
                        [0.6758090257644653, 0.4793102443218231],
                        [0.6758155822753906, 0.4911738932132721],
                        [0.20545616745948792, 0.49100473523139954],
                    ],
                    [
                        [0.20530298352241516, 0.49666452407836914],
                        [0.4787444770336151, 0.49676287174224854],
                        [0.4787513017654419, 0.5112702250480652],
                        [0.20530815422534943, 0.5111718773841858],
                    ],
                    [
                        [0.17763587832450867, 0.5138432383537292],
                        [0.6638091206550598, 0.5140181183815002],
                        [0.6638156175613403, 0.5258221626281738],
                        [0.1776399314403534, 0.5256472826004028],
                    ],
                    [
                        [0.20558840036392212, 0.5314626693725586],
                        [0.4430851936340332, 0.5315481424331665],
                        [0.44309186935424805, 0.5461727380752563],
                        [0.20559360086917877, 0.5460872650146484],
                    ],
                    [
                        [0.2050897479057312, 0.548762321472168],
                        [0.5801990628242493, 0.5488973259925842],
                        [0.5802066326141357, 0.5636229515075684],
                        [0.20509499311447144, 0.5634879469871521],
                    ],
                    [
                        [0.2055709809064865, 0.5663012266159058],
                        [0.3981355130672455, 0.5663705468177795],
                        [0.3981419503688812, 0.5810332298278809],
                        [0.20557621121406555, 0.5809639096260071],
                    ],
                    [
                        [0.2053578794002533, 0.5834430456161499],
                        [0.3919179141521454, 0.583510160446167],
                        [0.3919244110584259, 0.5984500050544739],
                        [0.2053631991147995, 0.598382830619812],
                    ],
                    [
                        [0.2052263468503952, 0.6011431813240051],
                        [0.4594789743423462, 0.6012347340583801],
                        [0.45948565006256104, 0.615666925907135],
                        [0.20523148775100708, 0.6155754327774048],
                    ],
                    [
                        [0.20484445989131927, 0.618490993976593],
                        [0.5740973353385925, 0.6186239123344421],
                        [0.5741050839424133, 0.6337137222290039],
                        [0.20484983921051025, 0.6335808038711548],
                    ],
                    [
                        [0.20496833324432373, 0.6357972621917725],
                        [0.7276855707168579, 0.6359854936599731],
                        [0.7276942133903503, 0.6508610248565674],
                        [0.20497362315654755, 0.6506727933883667],
                    ],
                    [
                        [0.20539826154708862, 0.6534239053726196],
                        [0.47593387961387634, 0.6535213589668274],
                        [0.4759408235549927, 0.6682797074317932],
                        [0.20540352165699005, 0.6681822538375854],
                    ],
                    [
                        [0.11725194752216339, 0.6708623170852661],
                        [0.5683672428131104, 0.6710247993469238],
                        [0.5683732032775879, 0.6826751232147217],
                        [0.11725565791130066, 0.682512640953064],
                    ],
                    [
                        [0.8458383679389954, 0.688371479511261],
                        [0.881848931312561, 0.688384473323822],
                        [0.8818563222885132, 0.6998607516288757],
                        [0.8458455801010132, 0.6998478174209595],
                    ],
                    [
                        [0.17736518383026123, 0.6880894899368286],
                        [0.6312962770462036, 0.6882529854774475],
                        [0.631302535533905, 0.6999556422233582],
                        [0.17736920714378357, 0.6997921466827393],
                    ],
                    [
                        [0.20561139285564423, 0.7060677409172058],
                        [0.3613654375076294, 0.7061238288879395],
                        [0.36137160658836365, 0.7207534909248352],
                        [0.20561660826206207, 0.7206974029541016],
                    ],
                    [
                        [0.2052726149559021, 0.7231346368789673],
                        [0.39889076352119446, 0.7232043743133545],
                        [0.39889585971832275, 0.7348736524581909],
                        [0.20527677237987518, 0.7348039150238037],
                    ],
                    [
                        [0.2055155634880066, 0.7405530214309692],
                        [0.5077394247055054, 0.7406619191169739],
                        [0.5077464580535889, 0.7551018595695496],
                        [0.20552071928977966, 0.7549929618835449],
                    ],
                    [
                        [0.20439764857292175, 0.7581657767295837],
                        [0.3704819083213806, 0.7582256197929382],
                        [0.3704867362976074, 0.7695454955101013],
                        [0.2044016718864441, 0.769485592842102],
                    ],
                    [
                        [0.17748036980628967, 0.7754659056663513],
                        [0.4403395354747772, 0.7755606174468994],
                        [0.44034478068351746, 0.7870712876319885],
                        [0.17748433351516724, 0.7869765162467957],
                    ],
                    [
                        [0.11907368898391724, 0.8629262447357178],
                        [0.2846446633338928, 0.8629859685897827],
                        [0.2846492528915405, 0.874783992767334],
                        [0.11907745897769928, 0.8747243285179138],
                    ],
                ],
            ],
            [
                '158',
                [
                    [
                        [0.09904953092336655, 0.11919574439525604],
                        [0.5506002902984619, 0.11915231496095657],
                        [0.5506035089492798, 0.13200396299362183],
                        [0.09905069321393967, 0.13204634189605713],
                    ],
                    [
                        [0.1760435402393341, 0.16162681579589844],
                        [0.32496973872184753, 0.16161364316940308],
                        [0.3249717056751251, 0.17308765649795532],
                        [0.17604489624500275, 0.1731005311012268],
                    ],
                    [
                        [0.2059733271598816, 0.19399835169315338],
                        [0.8611587285995483, 0.19394421577453613],
                        [0.8611640930175781, 0.2087075412273407],
                        [0.2059752196073532, 0.20875991880893707],
                    ],
                    [
                        [0.17638558149337769, 0.21136119961738586],
                        [0.8214252591133118, 0.21130993962287903],
                        [0.8214304447174072, 0.22621332108974457],
                        [0.17638733983039856, 0.22626283764839172],
                    ],
                    [
                        [0.17575262486934662, 0.22879558801651],
                        [0.8703631162643433, 0.2287425845861435],
                        [0.8703685998916626, 0.2436949610710144],
                        [0.1757543981075287, 0.2437460869550705],
                    ],
                    [
                        [0.17626285552978516, 0.24609091877937317],
                        [0.8427714109420776, 0.2460421472787857],
                        [0.8427766561508179, 0.26086118817329407],
                        [0.17626459896564484, 0.2609081566333771],
                    ],
                    [
                        [0.20557399094104767, 0.2788145840167999],
                        [0.8637951612472534, 0.2787703275680542],
                        [0.863800585269928, 0.29375922679901123],
                        [0.20557591319084167, 0.2938017249107361],
                    ],
                    [
                        [0.17618858814239502, 0.29611536860466003],
                        [0.6484388709068298, 0.29608508944511414],
                        [0.648442268371582, 0.30782556533813477],
                        [0.17618997395038605, 0.3078548312187195],
                    ],
                    [
                        [0.26379886269569397, 0.3298950493335724],
                        [0.7930021286010742, 0.32986435294151306],
                        [0.7930071353912354, 0.3445653021335602],
                        [0.26380106806755066, 0.3445945680141449],
                    ],
                    [
                        [0.26398757100105286, 0.34749916195869446],
                        [0.4516933262348175, 0.3474888801574707],
                        [0.4516963064670563, 0.3612331748008728],
                        [0.2639896273612976, 0.36124300956726074],
                    ],
                    [
                        [0.26386353373527527, 0.38069358468055725],
                        [0.8537669777870178, 0.38066479563713074],
                        [0.8537723422050476, 0.3955678939819336],
                        [0.26386576890945435, 0.39559507369995117],
                    ],
                    [
                        [0.2641450762748718, 0.3983124792575836],
                        [0.38498440384864807, 0.3983069956302643],
                        [0.3849870264530182, 0.4118839204311371],
                        [0.2641471028327942, 0.41188913583755493],
                    ],
                    [
                        [0.2638164162635803, 0.43154177069664],
                        [0.8458521366119385, 0.4315187633037567],
                        [0.8458574414253235, 0.4463939666748047],
                        [0.2638186514377594, 0.44641542434692383],
                    ],
                    [
                        [0.264148473739624, 0.44917476177215576],
                        [0.8731544613838196, 0.4491526186466217],
                        [0.8731599450111389, 0.46406838297843933],
                        [0.2641507089138031, 0.46408888697624207],
                    ],
                    [
                        [0.1756449192762375, 0.4817311763763428],
                        [0.6601141095161438, 0.48171642422676086],
                        [0.6601184010505676, 0.49657103419303894],
                        [0.17564667761325836, 0.4965844750404358],
                    ],
                    [
                        [0.20531423389911652, 0.5140831470489502],
                        [0.871440052986145, 0.514066755771637],
                        [0.8714454770088196, 0.5288313031196594],
                        [0.20531614124774933, 0.5288459062576294],
                    ],
                    [
                        [0.17532972991466522, 0.5314802527427673],
                        [0.8133200407028198, 0.531466543674469],
                        [0.8133251667022705, 0.5462881922721863],
                        [0.1753314733505249, 0.5463001132011414],
                    ],
                    [
                        [0.17569608986377716, 0.5487095713615417],
                        [0.8447772264480591, 0.548697292804718],
                        [0.8447826504707336, 0.5640436410903931],
                        [0.17569789290428162, 0.564054012298584],
                    ],
                    [
                        [0.17590977251529694, 0.5666078329086304],
                        [0.8467373251914978, 0.5665977001190186],
                        [0.846742570400238, 0.5813443064689636],
                        [0.17591151595115662, 0.5813525915145874],
                    ],
                    [
                        [0.17574836313724518, 0.583595335483551],
                        [0.8196991682052612, 0.5835875868797302],
                        [0.8197043538093567, 0.5984726548194885],
                        [0.17575012147426605, 0.5984786748886108],
                    ],
                    [
                        [0.17602641880512238, 0.6012845635414124],
                        [0.840149462223053, 0.6012787222862244],
                        [0.8401547074317932, 0.6160958409309387],
                        [0.17602816224098206, 0.6160998940467834],
                    ],
                    [
                        [0.17586997151374817, 0.6184853315353394],
                        [0.8734721541404724, 0.6184813976287842],
                        [0.8734776973724365, 0.6334968209266663],
                        [0.17587174475193024, 0.6334988474845886],
                    ],
                    [
                        [0.17568394541740417, 0.636202871799469],
                        [0.8487929701805115, 0.6362012624740601],
                        [0.8487982153892517, 0.6509302854537964],
                        [0.17568568885326385, 0.6509301066398621],
                    ],
                    [
                        [0.17582792043685913, 0.6532667279243469],
                        [0.6735823750495911, 0.6532670259475708],
                        [0.6735867857933044, 0.6681697368621826],
                        [0.17582967877388, 0.6681680679321289],
                    ],
                    [
                        [0.20489366352558136, 0.6881092190742493],
                        [0.8589618802070618, 0.688113808631897],
                        [0.8589673042297363, 0.7031344771385193],
                        [0.20489560067653656, 0.7031281590461731],
                    ],
                    [
                        [0.1753917932510376, 0.7058308720588684],
                        [0.8455787897109985, 0.7058377265930176],
                        [0.8455842137336731, 0.7209460735321045],
                        [0.17539356648921967, 0.7209374308586121],
                    ],
                    [
                        [0.17604587972164154, 0.7230913043022156],
                        [0.7886723875999451, 0.7230994701385498],
                        [0.7886773943901062, 0.7379899024963379],
                        [0.17604763805866241, 0.7379801273345947],
                    ],
                ],
            ],
            [
                '221',
                [
                    [
                        [0.17998018860816956, 0.1267091929912567],
                        [0.868581235408783, 0.1266452670097351],
                        [0.8685883283615112, 0.14017193019390106],
                        [0.1799849271774292, 0.14023499190807343],
                    ],
                    [
                        [0.11672138422727585, 0.1699243038892746],
                        [0.1497936248779297, 0.16992135345935822],
                        [0.1497974842786789, 0.18118801712989807],
                        [0.1167251467704773, 0.18119092285633087],
                    ],
                    [
                        [0.1756981760263443, 0.16960684955120087],
                        [0.6944993138313293, 0.1695607304573059],
                        [0.6945064067840576, 0.18431702256202698],
                        [0.17570333182811737, 0.18436242640018463],
                    ],
                    [
                        [0.17572976648807526, 0.19288234412670135],
                        [0.9279276132583618, 0.1928171068429947],
                        [0.9279359579086304, 0.20817339420318604],
                        [0.17573513090610504, 0.20823757350444794],
                    ],
                    [
                        [0.11711844801902771, 0.2107466757297516],
                        [0.9213078618049622, 0.21067824959754944],
                        [0.9213159084320068, 0.22558699548244476],
                        [0.11712343245744705, 0.22565430402755737],
                    ],
                    [
                        [0.1173301413655281, 0.22784319519996643],
                        [0.6341495513916016, 0.22780004143714905],
                        [0.6341565847396851, 0.24284464120864868],
                        [0.11733517050743103, 0.24288707971572876],
                    ],
                    [
                        [0.17591330409049988, 0.2606945335865021],
                        [0.5355410575866699, 0.2606655955314636],
                        [0.53554767370224, 0.27562493085861206],
                        [0.17591853439807892, 0.2756533622741699],
                    ],
                    [
                        [0.11710447072982788, 0.2777765393257141],
                        [0.5340030789375305, 0.2777436375617981],
                        [0.5340097546577454, 0.2929215133190155],
                        [0.11710954457521439, 0.29295381903648376],
                    ],
                    [
                        [0.6471120119094849, 0.2751673460006714],
                        [0.7668271660804749, 0.2751578688621521],
                        [0.7668319940567017, 0.2848094403743744],
                        [0.6471165418624878, 0.2848188281059265],
                    ],
                    [
                        [0.11727851629257202, 0.29556941986083984],
                        [0.5222940444946289, 0.29553812742233276],
                        [0.5223006010055542, 0.31060007214546204],
                        [0.11728355288505554, 0.31063079833984375],
                    ],
                    [
                        [0.6042457818984985, 0.29693683981895447],
                        [0.6722291111946106, 0.29693159461021423],
                        [0.6722337603569031, 0.3065934479236603],
                        [0.6042501926422119, 0.30659863352775574],
                    ],
                    [
                        [0.7806056141853333, 0.2968500554561615],
                        [0.8099294304847717, 0.29684779047966003],
                        [0.8099345564842224, 0.30688151717185974],
                        [0.7806106805801392, 0.3068837523460388],
                    ],
                    [
                        [0.1170801892876625, 0.31281378865242004],
                        [0.5096113085746765, 0.3127841055393219],
                        [0.509617805480957, 0.32768839597702026],
                        [0.11708517372608185, 0.3277175724506378],
                    ],
                    [
                        [0.6038322448730469, 0.3155118525028229],
                        [0.664190948009491, 0.31550729274749756],
                        [0.6641954779624939, 0.32506710290908813],
                        [0.6038366556167603, 0.3250716030597687],
                    ],
                    [
                        [0.7801027894020081, 0.31541165709495544],
                        [0.8100060820579529, 0.315409392118454],
                        [0.810011088848114, 0.3252360224723816],
                        [0.7801077365875244, 0.32523825764656067],
                    ],
                    [
                        [0.11693812906742096, 0.33051446080207825],
                        [0.5356757640838623, 0.33048346638679504],
                        [0.5356823205947876, 0.34529733657836914],
                        [0.11694307625293732, 0.345327764749527],
                    ],
                    [
                        [0.11710667610168457, 0.3473448157310486],
                        [0.9022102355957031, 0.3472879230976105],
                        [0.9022184610366821, 0.3627123236656189],
                        [0.11711183190345764, 0.36276811361312866],
                    ],
                    [
                        [0.11667490005493164, 0.3651799261569977],
                        [0.8783262968063354, 0.36512598395347595],
                        [0.8783342838287354, 0.3802427649497986],
                        [0.11667995154857635, 0.38029566407203674],
                    ],
                    [
                        [0.11709918081760406, 0.3822875916957855],
                        [0.4633578062057495, 0.3822636008262634],
                        [0.4633641839027405, 0.3973437249660492],
                        [0.11710421741008759, 0.3973672389984131],
                    ],
                    [
                        [0.615254282951355, 0.4040391743183136],
                        [0.8558076620101929, 0.40402302145957947],
                        [0.8558143377304077, 0.41679003834724426],
                        [0.6152601838111877, 0.4168059527873993],
                    ],
                    [
                        [0.14330226182937622, 0.41528719663619995],
                        [0.29894155263900757, 0.4152768850326538],
                        [0.29894599318504333, 0.42689934372901917],
                        [0.1433062106370926, 0.426909476518631],
                    ],
                    [
                        [0.539341926574707, 0.4256579279899597],
                        [0.5709788799285889, 0.42565587162971497],
                        [0.5709837079048157, 0.43633508682250977],
                        [0.5393466949462891, 0.43633711338043213],
                    ],
                    [
                        [0.5976303219795227, 0.42593449354171753],
                        [0.8008006811141968, 0.4259212613105774],
                        [0.800806999206543, 0.4383244514465332],
                        [0.5976359844207764, 0.4383374750614166],
                    ],
                    [
                        [0.5394847989082336, 0.4693550765514374],
                        [0.5712779760360718, 0.4693531394004822],
                        [0.5712828636169434, 0.4802466630935669],
                        [0.5394896268844604, 0.4802485704421997],
                    ],
                    [
                        [0.5976375937461853, 0.44063031673431396],
                        [0.6363515853881836, 0.4406278431415558],
                        [0.6363560557365417, 0.450189471244812],
                        [0.5976420044898987, 0.4501919150352478],
                    ],
                    [
                        [0.17584183812141418, 0.44745105504989624],
                        [0.4898410141468048, 0.44743120670318604],
                        [0.4898476004600525, 0.462775319814682],
                        [0.17584718763828278, 0.4627947211265564],
                    ],
                    [
                        [0.5392252206802368, 0.4547843337059021],
                        [0.5714237689971924, 0.45478230714797974],
                        [0.5714285969734192, 0.4655779302120209],
                        [0.5392299890518188, 0.46557992696762085],
                    ],
                    [
                        [0.592168927192688, 0.4549863338470459],
                        [0.6959559917449951, 0.4549798369407654],
                        [0.6959607005119324, 0.4646519422531128],
                        [0.5921733379364014, 0.46465831995010376],
                    ],
                    [
                        [0.12438306212425232, 0.4649606943130493],
                        [0.4256244897842407, 0.4649421274662018],
                        [0.4256308078765869, 0.480228990316391],
                        [0.1243881955742836, 0.4802471101284027],
                    ],
                    [
                        [0.5982014536857605, 0.4699328541755676],
                        [0.6600155234336853, 0.4699290692806244],
                        [0.6600198745727539, 0.4791799485683441],
                        [0.5982056856155396, 0.4791836738586426],
                    ],
                    [
                        [0.12482403963804245, 0.4824046492576599],
                        [0.4949955344200134, 0.4823824465274811],
                        [0.4950021207332611, 0.4976137578487396],
                        [0.12482915818691254, 0.49763545393943787],
                    ],
                    [
                        [0.5392787456512451, 0.48365387320518494],
                        [0.5709433555603027, 0.4836519956588745],
                        [0.5709482431411743, 0.4944881498813629],
                        [0.5392835140228271, 0.49448999762535095],
                    ],
                    [
                        [0.597740888595581, 0.4841040074825287],
                        [0.6878299117088318, 0.4840986132621765],
                        [0.687834620475769, 0.4938942790031433],
                        [0.5977453589439392, 0.4938995838165283],
                    ],
                    [
                        [0.12450966238975525, 0.49995702505111694],
                        [0.4945281744003296, 0.4999353885650635],
                        [0.4945344626903534, 0.5145605802536011],
                        [0.12451457977294922, 0.5145816802978516],
                    ],
                    [
                        [0.5396032929420471, 0.5056920647621155],
                        [0.7782858610153198, 0.5056782960891724],
                        [0.7782922983169556, 0.5184912085533142],
                        [0.5396089553833008, 0.5185047388076782],
                    ],
                    [
                        [0.12446688115596771, 0.5172095894813538],
                        [0.4490624666213989, 0.5171911716461182],
                        [0.4490688741207123, 0.5324224233627319],
                        [0.1244719922542572, 0.5324404239654541],
                    ],
                    [
                        [0.5392093658447266, 0.5211179256439209],
                        [0.8878777027130127, 0.521098256111145],
                        [0.8878844380378723, 0.5337837934494019],
                        [0.5392150282859802, 0.5338031053543091],
                    ],
                    [
                        [0.12442640960216522, 0.5347826480865479],
                        [0.4792681932449341, 0.5347630977630615],
                        [0.4792744815349579, 0.5494592189788818],
                        [0.12443134933710098, 0.54947829246521],
                    ],
                    [
                        [0.5783371925354004, 0.5439574122428894],
                        [0.8257625102996826, 0.5439439415931702],
                        [0.8257687091827393, 0.5558928847312927],
                        [0.5783425569534302, 0.5559060573577881],
                    ],
                    [
                        [0.12447539716959, 0.5521700382232666],
                        [0.38623976707458496, 0.5521560311317444],
                        [0.38624587655067444, 0.5673098564147949],
                        [0.12448049336671829, 0.5673235058784485],
                    ],
                    [
                        [0.5778818726539612, 0.5626009702682495],
                        [0.8219663500785828, 0.5625881552696228],
                        [0.821971595287323, 0.5727548599243164],
                        [0.5778864622116089, 0.572767436504364],
                    ],
                    [
                        [0.17580220103263855, 0.588366687297821],
                        [0.9282822012901306, 0.5883288979530334],
                        [0.9282904267311096, 0.6035035252571106],
                        [0.17580749094486237, 0.603540301322937],
                    ],
                    [
                        [0.11730816960334778, 0.6056922078132629],
                        [0.9258120059967041, 0.6056528687477112],
                        [0.9258204102516174, 0.6212273240089417],
                        [0.11731337755918503, 0.6212655305862427],
                    ],
                    [
                        [0.11696546524763107, 0.6234367489814758],
                        [0.41083601117134094, 0.6234229803085327],
                        [0.4108421802520752, 0.6385126113891602],
                        [0.1169705018401146, 0.6385260224342346],
                    ],
                    [
                        [0.1434928923845291, 0.6631156802177429],
                        [0.2860866189002991, 0.6631094813346863],
                        [0.2860910892486572, 0.6749784350395203],
                        [0.14349694550037384, 0.6749844551086426],
                    ],
                    [
                        [0.17372174561023712, 0.6879584789276123],
                        [0.36964261531829834, 0.6879504323005676],
                        [0.3696472942829132, 0.6996929049491882],
                        [0.17372582852840424, 0.6997007131576538],
                    ],
                    [
                        [0.16486866772174835, 0.7127087116241455],
                        [0.9201323986053467, 0.712679386138916],
                        [0.9201399087905884, 0.7266116142272949],
                        [0.16487349569797516, 0.7266399264335632],
                    ],
                    [
                        [0.11355283111333847, 0.7282159924507141],
                        [0.8844887614250183, 0.7281872034072876],
                        [0.8844963312149048, 0.7424413561820984],
                        [0.11355757713317871, 0.7424691319465637],
                    ],
                    [
                        [0.48646143078804016, 0.7590115070343018],
                        [0.5165009498596191, 0.7590104341506958],
                        [0.5165051817893982, 0.7687580585479736],
                        [0.4864656329154968, 0.7687590718269348],
                    ],
                ],
            ],
            [
                '198',
                [
                    [
                        [0.12012434750795364, 0.6943570375442505],
                        [0.4918660819530487, 0.6942353844642639],
                        [0.49187761545181274, 0.7089304327964783],
                        [0.12013442814350128, 0.7090514302253723],
                    ],
                    [
                        [0.1199454590678215, 0.7309589982032776],
                        [0.14376874268054962, 0.7309513092041016],
                        [0.14377674460411072, 0.7425011396408081],
                        [0.11995338648557663, 0.7425088286399841],
                    ],
                    [
                        [0.17969338595867157, 0.7310108542442322],
                        [0.8189269304275513, 0.7308046221733093],
                        [0.8189371228218079, 0.7424674034118652],
                        [0.17970158159732819, 0.7426726818084717],
                    ],
                    [
                        [0.17881040275096893, 0.7561526298522949],
                        [0.8471806049346924, 0.7559390664100647],
                        [0.8471938371658325, 0.7709060311317444],
                        [0.1788209080696106, 0.7711183428764343],
                    ],
                    [
                        [0.12031034380197525, 0.773216724395752],
                        [0.8356271386146545, 0.7729896903038025],
                        [0.835639238357544, 0.7867847084999084],
                        [0.12031980603933334, 0.7870104312896729],
                    ],
                    [
                        [0.11995413899421692, 0.7908985614776611],
                        [0.28676068782806396, 0.7908459901809692],
                        [0.28677135705947876, 0.8054468035697937],
                        [0.11996416002511978, 0.8054990768432617],
                    ],
                    [
                        [0.17865005135536194, 0.8154146671295166],
                        [0.8509277105331421, 0.8152048587799072],
                        [0.850940465927124, 0.8296791911125183],
                        [0.17866021394729614, 0.8298877477645874],
                    ],
                    [
                        [0.12001074105501175, 0.8326764106750488],
                        [0.778449296951294, 0.8324723839759827],
                        [0.7784624695777893, 0.8477259874343872],
                        [0.12002120912075043, 0.8479287624359131],
                    ],
                    [
                        [0.12051131576299667, 0.8502786159515381],
                        [0.842655599117279, 0.8500564098358154],
                        [0.8426684737205505, 0.8647321462631226],
                        [0.12052138894796371, 0.8649530410766602],
                    ],
                    [
                        [0.12055949866771698, 0.8677070736885071],
                        [0.3755978047847748, 0.8676291704177856],
                        [0.37560901045799255, 0.8824889659881592],
                        [0.12056969851255417, 0.8825663924217224],
                    ],
                    [
                        [0.4684390425682068, 0.8969918489456177],
                        [0.4970040023326874, 0.8969832062721252],
                        [0.49701163172721863, 0.9066731333732605],
                        [0.4684465825557709, 0.9066817164421082],
                    ],
                    [
                        [0.10929547250270844, 0.9121986031532288],
                        [0.2737407088279724, 0.9121493101119995],
                        [0.27374935150146484, 0.9240404367446899],
                        [0.10930360108613968, 0.9240894913673401],
                    ],
                ],
            ],
            [
                '322',
                [
                    [
                        [0.17596866190433502, 0.6717548370361328],
                        [0.8509090542793274, 0.6718039512634277],
                        [0.8509112000465393, 0.6869027018547058],
                        [0.17596863210201263, 0.6868528127670288],
                    ],
                    [
                        [0.11728677153587341, 0.6890713572502136],
                        [0.8212853074073792, 0.6891235709190369],
                        [0.8212873339653015, 0.7039579749107361],
                        [0.1172865629196167, 0.7039049863815308],
                    ],
                    [
                        [0.11709540337324142, 0.7067537307739258],
                        [0.8084534406661987, 0.706805944442749],
                        [0.8084554672241211, 0.721670925617218],
                        [0.11709519475698471, 0.7216178774833679],
                    ],
                    [
                        [0.11744672060012817, 0.7241017818450928],
                        [0.7944468259811401, 0.7241538763046265],
                        [0.7944487929344177, 0.7390413284301758],
                        [0.11744651198387146, 0.73898845911026],
                    ],
                    [
                        [0.11720776557922363, 0.7414404153823853],
                        [0.8379507064819336, 0.7414968609809875],
                        [0.8379527926445007, 0.7564877867698669],
                        [0.11720755696296692, 0.7564303874969482],
                    ],
                    [
                        [0.11716938763856888, 0.7589541673660278],
                        [0.8098680377006531, 0.7590094208717346],
                        [0.8098699450492859, 0.7736475467681885],
                        [0.11716917902231216, 0.7735914587974548],
                    ],
                    [
                        [0.11747530847787857, 0.776522159576416],
                        [0.6207910180091858, 0.7765630483627319],
                        [0.6207924485206604, 0.7914820909500122],
                        [0.11747509986162186, 0.7914406061172485],
                    ],
                    [
                        [0.5198661684989929, 0.8093047738075256],
                        [0.5413700938224792, 0.8093065619468689],
                        [0.5413708090782166, 0.8189424276351929],
                        [0.5198668837547302, 0.8189406394958496],
                    ],
                    [
                        [0.09631337225437164, 0.8240170478820801],
                        [0.2656422257423401, 0.824031412601471],
                        [0.2656424343585968, 0.8356866240501404],
                        [0.09631315618753433, 0.8356720209121704],
                    ],
                ],
            ],
        ],
    },
]

export const NewWaveLendingDIPrimeDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "### Summary of Key Features for the A-QM DSCR PRIME Loan Product:\n\n#### Matrix:\n- **Transaction Types**: Purchase, Rate & Term Refinance, Cash Out\n- **Loan Amounts**:\n  - Purchase & R/T Refi: Up to $3,000,000. Cash Out: Up to $2,500,000\n- **Loan-to-Value (LTV)**: Varies: up to 80% for Purchase & R/T Refi with 700 FICO and 1.00 DSCR\n- **Minimum FICO**: 660 to 700 depending on LTV and loan type\n- **Debt Service Coverage Ratio (DSCR)**: Minimum 1.00 - 1.20 depending on the loan specifics\n- **Interest Only & Declining Market**: Reduces max LTV by 5% and 10% respectively\n\n#### Program Guidelines:\n- **Loan Terms**: Fixed 30 years, ARM 5/6, 7/6, and 10/6 with Interest-Only options\n- **Qualifying Rate**: At Note Rate for both Fixed & ARM; Interest-Only qualifies at the interest-only payment\n- **Minimum Loan Amount**: $100,000 for 1-4 unit properties\n- **DSCR Calculation**: Monthly gross rent divided by PITIA (or ITIA for I/O)\n\n#### Eligible Borrowers:\n- **Eligible**: US Citizens, Permanent Residents, Non-permanent Residents with valid visa types, US based LLCs, Partnerships, and Corporations\n- **Ineligible**: First Time Home Buyers, Borrowers with ITIN, Foreign Nationals, Irrevocable Trusts\n\n#### Borrower Experience and Requirements:\n- **Investor Experience**: At least 12 months of owning/managing real estate in the last 24 months\n- **Credit**: Minimum of 2 trade lines per borrower; 4 years since major derogatory credit event\n\n#### Property Requirements:\n- **Eligible**: Single-family, PUD, Condo (warrantable), 2-4 units\n- **Ineligible**: C5/C6 condition properties, manufactured homes, co-ops, condo hotels, non-warrantable condos, rural properties\n\n#### Special Conditions:\n- **Interest-Only Loans**: Available with a reduction of LTV by 5%\n- **Credit Documentation**: Recent 2-month bank statements required, liquid assets must be verified\n\n#### Loan Types:\n- **Purchase**\n- **Rate & Term Refinance**: Includes refinancing of purchase second lien seasoned a minimum of 12 months\n- **Cash-Out Refinance**: Maximum cash-in-hand of $500,000; Specific limitations for non-permanent residents and recent purchases\n\n#### Reserves:\n- **Reserve Requirements**:\n  - <=$1,000,000: 3 months\n  - >$1,000,000 and <=$2,000,000: 6 months\n  - >$2,000,000 and <=$3,000,000: 9 months\n  - Stocks & bonds valued at 70% for reserves\n\nExamples:\n- **New Investor Purchase**: A US citizen looking to purchase a $1.5M property can get up to 75% LTV with a 680 FICO and a DSCR of 1.20      .\n\nThis summary encapsulates the essential features and guidelines of the A-QM DSCR PRIME loan product. For more detailed inquiries, specific scenarios, or exceptions, referring directly to the full guidelines in the product documentation is recommended.",
        "QuoteLocations": {},
        "InitialChatTitle": "Document Summary"
    }
]

export const NewWaveLendingDIDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "### Key Features of A-QM DSCR Investor Loan Program\n\n#### Matrix\n- **Loan Amounts**:\n  - $100,000 (1-4 Unit), $400,000 (5-8 Units or 2-8 Mixed Use), $150,000 (Foreign National)\n- **Maximum LTV**:\n  - Up to 80% for certain loan amounts and FICO scores\n  - Declining based on higher loan amounts and lower FICO scores\n- **FICO**:\n  - Minimum 640, with higher LTV thresholds for higher FICO scores\n\n#### Program Guidelines\n- **Loan Terms**:\n  - Fixed: 30-year, 15-year\n  - ARM: 5/6, 7/6, 10/6 (interest-only options available)\n- **Interest Rates**:\n  - Qualified at note rate, both fixed and interest-only payments\n\n#### Eligible Borrowers and Property Requirements\n- **Borrowers**:\n  - U.S. citizens, permanent residents, non-permanent residents\n  - LLCs, Partnerships, Corporations with additional documentation\n- **Eligible Properties**:\n  - Single-family, PUD, Condo (full HOA cert), Condo Hotel, 2-8 units residential, mixed-use properties, 1 unit with ADU\n\n#### Special Conditions\n- **Interest-Only**:\n  - Available with a minimum FICO of 680\n- **Declining Market**:\n  - 5% LTV reduction applies in designated CBSA restricted areas\n\n#### Credit Requirements\n- **Tradelines**:\n  - At least 3 tradelines reporting for a minimum of 12 months\n- **Derogatory Accounts**:\n  - Must not be more than 30 days delinquent; certain derogatory events must be resolved or seasoned\n\n#### Loan Types\n- **Purchase, Rate & Term, Cash-Out**\n  - Specific LTV limits apply based on DSCR and loan amount\n  - Cash-out proceeds can be used to satisfy reserve requirements with restrictions\n\n#### Borrower Experience and Reserves\n- **Experience**:\n  - Defined as owning and managing commercial or non-owner-occupied residential property for at least one year in the last three years\n- **Reserves**:\n  - Based on property type and loan details\n  \n#### Documentation for Entities\n- **LLCs**:\n  - Articles of Organization, Certificate of Good Standing, Borrowing Certificate\n- **Corporations**:\n  - Filed Certificate/Articles of Incorporation, By-Laws, Good Standing Certificate\n- **Partnerships**:\n  - Partnership Agreement and Good Standing Certificate\n\n#### Examples\n- **Experienced Investor**:\n  - Higher LTV, typically with lower reserve requirements\n- **First-Time Investor**:\n  - Stricter guidelines, higher FICO requirements, more reserves needed\n\nThis comprehensive summary provides an overview of the A-QM DSCR Investor Loan Program's main features, breaking down borrower eligibility, property requirements, and special conditions[0][1][2][3][4][5].",
        "QuoteLocations": [
            "2",
            "4",
            "6",
            "1",
            "3"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewWaveLendingVOEDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "Here is a comprehensive summary of the key features of the mortgage loan product from the New Wave Lending Group documentation:\n\n### Matrix\n- **Loan Amounts:**\n  - Minimum: $100,000\n  - Maximum: $3,000,000 (varies with FICO score and LTV)\n- **LTV/CLTV:**\n  - Different for purchase, rate/term refinance, and cash-out refinance\n  - Maximum 80% for purchase under $1,000,000\n- **FICO Scores:**\n  - Minimum: 680; varies up to above 720\n- **Debt Service Coverage Ratio (DSCR):** Not specified directly\n\n### Program Guidelines\n- **Loan Terms:**\n  - Fixed terms: 30 years, 15 years\n  - ARM terms: 5/6, 7/6, and 10/6 SOFR\n  - Interest-Only options available\n- **Interest Rates:**\n  - Qualify at the greater of note rate or fully indexed rate with amortizing payment for 30 years\n\n### Eligible Borrowers and Property Requirements\n- **Eligible Borrowers:**\n  - U.S. Citizens and permanent residents\n  - Non-permanent residents with valid work eligibility\n- **Ineligible Borrowers:**\n  - Non-occupant co-borrowers, ITIN holders\n- **Property Requirements:**\n  - Eligible: Single-family, PUD, Condo, 2-4 units\n  - Ineligible: C5/C6 rating, Mixed-use, Manufactured homes, Rural properties as defined\n\n### Special Conditions\n- **Interest-Only Loans:**\n  - Available for ARM and fixed options\n  - Specific reserve requirements apply\n- **Declining Market Reduction:**\n  - 5% LTV reduction and loan amount capped at $2MM in declining markets\n- **Housing Event Seasoning:**\n  - BK/FC/SS/DIL/Mod must be >= 36 months\n\n### Credit Requirements\n- **FICO Scores:**\n  - 680 minimum but varies higher\n- **Housing History:**\n  - 1x30x12 history required for higher loan amounts or lower FICO scores\n\n### Loan Types\n- **Purchase:**\n  - Maximum LTV 80% with higher FICO scores\n- **Cash-Out:**\n  - Unlimited cash-out under certain LTV conditions\n- **Rate & Term:**\n  - Maximum cash back limited to $2,000 or 1% of new loan amount\n\n### Borrower Experience and Reserves\n- **Experience:**\n  - 2 years self-employment required for WAVE P&L program\n- **Reserves:**\n  - Policy varies based on occupancy and loan amount\n  - Gift funds and liquid assets can be used for reserves\n\n### Documentation Requirements\n- **WAVE VOE (Wage Earner):**\n  - WVOE with 2 years' history\n- **WAVE P&L (Self-Employed):**\n  - 3rd party prepared P&L, business license, and letter from CPA\n\n### Property and Loan Requirements\n- **Eligible Properties:**\n  - Maximum 20 acres, not meeting rural definitions\n- **Appraisal Requirements:**\n  - Completed appraisal and supporting documentation for rental income verification\n\nThese points encapsulate the primary elements of the mortgage program offered by the New Wave Lending Group, covering the product matrix, program guidelines, borrower requirements, and special conditions[0][1][2][3][4][5][6][7][8][9].",
        "QuoteLocations": [
            "2",
            "4",
            "6",
            "1",
            "5"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewWaveLendingPLDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "Here is a comprehensive summary of the key features of the mortgage loan product from the New Wave Lending Group documentation:\n\n### Matrix\n- **Loan Amounts:**\n  - Minimum: $100,000\n  - Maximum: $3,000,000 (varies with FICO score and LTV)\n- **LTV/CLTV:**\n  - Different for purchase, rate/term refinance, and cash-out refinance\n  - Maximum 80% for purchase under $1,000,000\n- **FICO Scores:**\n  - Minimum: 680; varies up to above 720\n- **Debt Service Coverage Ratio (DSCR):** Not specified directly\n\n### Program Guidelines\n- **Loan Terms:**\n  - Fixed terms: 30 years, 15 years\n  - ARM terms: 5/6, 7/6, and 10/6 SOFR\n  - Interest-Only options available\n- **Interest Rates:**\n  - Qualify at the greater of note rate or fully indexed rate with amortizing payment for 30 years\n\n### Eligible Borrowers and Property Requirements\n- **Eligible Borrowers:**\n  - U.S. Citizens and permanent residents\n  - Non-permanent residents with valid work eligibility\n- **Ineligible Borrowers:**\n  - Non-occupant co-borrowers, ITIN holders\n- **Property Requirements:**\n  - Eligible: Single-family, PUD, Condo, 2-4 units\n  - Ineligible: C5/C6 rating, Mixed-use, Manufactured homes, Rural properties as defined\n\n### Special Conditions\n- **Interest-Only Loans:**\n  - Available for ARM and fixed options\n  - Specific reserve requirements apply\n- **Declining Market Reduction:**\n  - 5% LTV reduction and loan amount capped at $2MM in declining markets\n- **Housing Event Seasoning:**\n  - BK/FC/SS/DIL/Mod must be >= 36 months\n\n### Credit Requirements\n- **FICO Scores:**\n  - 680 minimum but varies higher\n- **Housing History:**\n  - 1x30x12 history required for higher loan amounts or lower FICO scores\n\n### Loan Types\n- **Purchase:**\n  - Maximum LTV 80% with higher FICO scores\n- **Cash-Out:**\n  - Unlimited cash-out under certain LTV conditions\n- **Rate & Term:**\n  - Maximum cash back limited to $2,000 or 1% of new loan amount\n\n### Borrower Experience and Reserves\n- **Experience:**\n  - 2 years self-employment required for WAVE P&L program\n- **Reserves:**\n  - Policy varies based on occupancy and loan amount\n  - Gift funds and liquid assets can be used for reserves\n\n### Documentation Requirements\n- **WAVE VOE (Wage Earner):**\n  - WVOE with 2 years' history\n- **WAVE P&L (Self-Employed):**\n  - 3rd party prepared P&L, business license, and letter from CPA\n\n### Property and Loan Requirements\n- **Eligible Properties:**\n  - Maximum 20 acres, not meeting rural definitions\n- **Appraisal Requirements:**\n  - Completed appraisal and supporting documentation for rental income verification\n\nThese points encapsulate the primary elements of the mortgage program offered by the New Wave Lending Group, covering the product matrix, program guidelines, borrower requirements, and special conditions[0][1][2][3][4][5][6][7][8][9].",
        "QuoteLocations": [
            "2",
            "4",
            "6",
            "1",
            "5"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewWaveLendingEPDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "### Key Features of the A-QM Expanded Portfolio Product\n\n#### Matrix\n**Loan Amounts, LTV, and FICO:**\n- Maximum Loan Amount: Up to $4,000,000\n- Minimum FICO: 660\n- Maximum LTV/CLTV: Up to 80% depending on the loan amount[0].\n\n**Eligible Borrowers:**\n- US Citizens and Permanent Residents\n- Non-permanent resident aliens with specific documentation and conditions\n- LLCs, Partnerships, Corporations\n- First Time Home Buyers under certain conditions[1][0].\n\n#### Program Guidelines\n**Loan Terms and Products:**\n- Fixed: 30-year, 15-year\n- ARM: 5/6, 7/6, 10/6 (with margin & caps per rate sheet)\n- Interest Only options available[0][4].\n\n**Income Documentation Types:**\n- 24 or 12 months bank statements\n- 2 or 1-year 1099 with YTD bank statements/checks\n- Asset utilization\n- 2 or 1-year full documentation[4].\n\n**DTI Ratios:**\n- Maximum DTI: 50%, with exceptions up to 55% or lower restrictions for certain situations (e.g., rent-free living)[4].\n\n#### Special Conditions\n- **Interest-Only Loans:** Qualified at higher of note rate or fully indexed rate[4].\n- **Declining Market:** 5% LTV reduction[8].\n\n#### Credit Requirements\n- Derogatory Credit Event: Requires 4 years seasoning from the note date[9].\n- Minimum FICO score requirements and tradeline requirements based on borrower profiles (e.g., 2 credit scores needed, additional requirements for fewer tradelines)[9][8].\n\n#### Loan Types\n- **Purchase**\n  - Up to 80% LTV for primary residences and specific conditions for other properties.\n  - Minimum borrower contribution: 5% for primary, 10% for second home/investment[12].\n- **Cash-Out Refinance**\n  - Defined as loans with specific requirements, including seasoning requirements and restrictions on previously listed properties[13].\n- **Rate & Term Refinance**\n  - Cash back limitation to borrower: $5,000 or 2% of the loan amount[12].\n\n#### Borrower Experience and Reserves\n- **Reserves:**\n  - Requirements range from 6 to 12 months based on LTV and loan amounts.\n  - Certain proceeds (e.g., cash-out) can be used to satisfy reserve requirements[15].\n\n#### Property and Loan Requirements\n- **Eligible Properties:**\n  - Single family, PUD, Condo (with HOA cert), Condo Hotel, 2-4 units, and 1 unit property with ADU.\n- **Ineligible Properties:**\n  - C5/C6 or Q6, Mixed Use, Manufactured, Rural property under specified criteria, and several others[1][12].\n  \n- **Appraisal Requirements:**\n  - Two appraisals for loans > $2MM or flip transactions.\n  - Specific review and age criteria for appraisals[8].\n\nThese summarized guidelines provide a comprehensive overview for potential borrowers considering the A-QM Expanded Portfolio product.",
        "QuoteLocations": [
            "9",
            "2",
            "4",
            "8",
            "1",
            "7",
            "3"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiNQMEPDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "The key features of the Newfi mortgage product offerings are detailed below:\n\n1. **Product Terms**:\n   - Fixed-term options: 15, 30, and 40 years.\n   - Interest-Only options: 30-year fixed (120 months I.O.), 40-year fixed (120 months I.O.)[0].\n\n2. **Buydown Option**:\n   - Available on owner-occupied purchase transactions.\n   - Year 1: Payments at a rate 2% below the locked rate.\n   - Year 2: Payments at a rate 1% below the locked rate.\n   - Funded by seller, builder, realtor contributions, or lender credit[0].\n\n3. **Prepayment Penalty**:\n   - Applicable to non-owner occupied properties.\n   - Equal to 6 months interest on 80% of the unpaid principal balance.\n   - Not allowed in several states; specific conditions apply for some states like Iowa and North Carolina[0].\n\n4. **CPA Gross Receipts Program**:\n   - For self-employed borrowers.\n   - Requires a CPA letter detailing gross receipts and borrower’s ownership.\n   - Business bank statements must support the CPA letter[3].\n\n5. **Income Documentation Options**:\n   - Flexible documentation types including bank statements, 1099s, and CPA-prepared P&L statements[4][5].\n\n6. **Debt to Income Ratios (DTI)**:\n   - Maximum DTI ratio of 50% unless otherwise specified[5].\n\n7. **Secondary Financing**:\n   - Permitted according to specific LTV/CLTV thresholds and other conditions.\n   - Both lender and seller financing are accommodated[7].\n\n8. **Property Types and Cash-Out**:\n   - Applicable to single-family homes, PUDs, and both warrantable and non-warrantable condos.\n   - Cash-out limits vary with LTV ratios and ownership seasoning[7].\n\n9. **Reserve Requirements**:\n   - Ranges from 3 to 9 months PITI based on the loan amount.\n   - Crypto currency and other non-cash holdings are acceptable provided adequate documentation[9].\n\nThese features are designed to provide flexibility and accommodate a variety of borrower profiles, particularly self-employed individuals.",
        "QuoteLocations": [
            "22",
            "4",
            "16",
            "3",
            "15",
            "11"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiNQMIEPDocPromptExamples = [
    {
        question: "Summarize the key features of this product",
        "Answer": "The Newfi Sequoia NQM - ITIN Expanded product is designed for borrowers without traditional US residency status but with US credit, income, and stable housing history. Key features of this product include:\n\n1. **Loan Amounts and Terms:**\n   - Available up to $1,500,000 with a minimum loan amount of $100,000 ($250,000 for Texas 50(a)(6) and $159,500 for Missouri).\n   - Options include 30-year and 40-year fixed terms, with interest-only (I.O.) options.\n   \n2. **Prepayment Penalty:**\n   - Allowed on non-owner occupied properties (equal to 6 months of interest on 80% of the unpaid principal).\n   - Restrictions apply in several states.\n\n3. **Documentation:**\n   - Caters to various income documentation options: full documentation, bank statements, 1099s, and CPA-verified gross receipts.\n   - Specific guidelines for bank statement loans, co-mingled accounts, and non-sufficient funds tolerance.\n\n4. **Credit and Income Requirements:**\n   - Multiple options for qualifying, including tradeline and AUS requirements.\n   - Collections and charge-offs have specified thresholds for impact on title and payment requirements.\n   - Specific instructions for trust income, RSU income, and evaluating large deposits.\n\n5. **Special Programs:**\n   - **1099 Program:** Designed for contractors, with options to use a 10% expense ratio or a third-party prepared business expense statement.\n   - **CPA Gross Receipts Program:** For self-employed borrowers, requires CPA documentation of business income and ownership.\n   - **Bank Statement Income:** Multiple methods for calculating income, including fixed expense ratio and third-party prepared statements.\n   - **P&L Program:** Requires a recent P&L from a CPA and business bank statements supporting the P&L income.\n\n6. **Eligibility:**\n   - Allows for non-occupant co-borrowers and multiple properties ownership with exposures specified.\n   - Non-arm’s length transactions allowed under specific conditions (purchase and rate/term only).\n\nThese features present flexibility in documentation and substantial leeway in qualifying non-traditional income sources, making the product suitable for various borrower profiles including those with significant self-employment income or non-traditional US residency status[0][1][2][3][4][5].",
        "QuoteLocations": [
            "9",
            "4",
            "8",
            "1",
            "12",
            "11"
        ],
        "InitialChatTitle": "Document Summary"
    }
]


export const NewFiDSCRDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "The key features of the Newfi DSCR Plus 0.8 product are as follows:\n\n### Loan Terms:\n- **Product Terms**: \n  - 15, 30, and 40-year fixed terms.\n  - Interest-Only options available with 30-year (120-month I.O. term) and 40-year fixed terms (120-month I.O. term)[0].\n\n### Loan Amount and Credit Score:\n- Loan amounts up to $2,000,000 with varying credit score requirements, typically starting at 660.\n- Different LTV/CLTV matrices based on DSCR (Debt Service Coverage Ratio):\n  - DSCR ≥ 0.80 < 1.00\n  - DSCR ≥ 1.00[0].\n\n### Reserves:\n- Reserve requirements vary based on loan amount and investor experience. For example:\n  - 4 months PITI for general loans.\n  - 6 to 12 months PITI for larger loan amounts.\n  - Specialized reserve requirements for novice investors[2].\n\n### Borrower Requirements:\n- Eligible borrowers include U.S. Citizens, Permanent Resident Aliens, and Non-Permanent Resident Aliens.\n- Ineligible individuals include those under irrevocable trust, land trust, or blind trust, among others[3][4].\n\n### Rental Income:\n- Income determination varies for long-term and short-term rentals. For example:\n  - Long-term rents use the lower of the estimated market rent or the lease agreement.\n  - Short-term rents calculated with 80% of gross rents, allowed only for DSCR ≥ 1.0[5].\n\n### Credit Requirements:\n- Credit scoring relies on the lowest middle score when multiple borrowers are involved.\n- Major credit events require a 3-year seasoning.\n- Specific requirements exist for managing credit reports, housing payment history, and managing forbearances[6][7].\n\n### Loan Features:\n- Prepayment penalties and other conditions vary by state.\n- Multiple loans allowed for a single borrower, but with limits on DSCR score and the number of loans or total UPB (Unpaid Principal Balance).\n- Junior financing allowed based on Fannie Mae requirements[8][9].\n\nThese features outline the structure and conditions under which the Newfi DSCR Plus 0.8 product operates.",
        "QuoteLocations": [
            "10",
            "2",
            "4",
            "6",
            "1",
            "7",
            "8",
            "3",
            "12"
        ],
        "InitialChatTitle": "Document Summary"
    }
]


export const NewFiFNDSCRDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "The Newfi DSCR product matrix has several key features, including loan terms, property types, and borrower eligibility criteria.\n\n### Loan Terms:\n1. **Product Terms**:\n   - 15, 30, and 40-year fixed options\n   - 30 and 40-year fixed with interest-only options[0]\n\n2. **Prepayment Penalties (PPP)**:\n   - 5% PPP charge\n   - Restrictions apply in specific states (e.g., not allowed in Alaska, Illinois, Michigan)[0]\n\n3. **Minimum Loan Amount**:\n   - $100,000, with a specific minimum of $159,500 in Missouri[0]\n\n### Property Types:\n1. **Eligible Properties**:\n   - Single Family (attached and detached)\n   - PUDs (Planned Unit Developments)\n   - Warrantable and non-warrantable condos (case-by-case basis for non-warrantable)[3]\n\n2. **Refinance Options**:\n   - Properties purchased with cash or short-term financing within past six months are eligible for cash-out refinance[3]\n\n### Borrower Eligibility:\n1. **Credit History Requirements**:\n   - U.S. credit: Minimum three tradelines for 12 months or two tradelines for 24 months[5]\n   - Non-U.S. credit: Requires documentation such as housing history or financial statements[5]\n\n2. **Experience Requirement**:\n   - Borrowers must have owned two or more properties for at least 12 months within the last 36 months, with one being income-producing[7]\n\n3. **Ineligible Borrowers**:\n   - First-time investors and foreign nationals residing in the U.S.[7]\n\n### Additional Features:\n1. **Interest Only Loans**:\n   - Allowed at all LTVs with a minimum FICO score of 660[3]\n\n2. **Economic Incentives**:\n   - Automatic Payment Authorization (ACH): A reduced lender fee for enrolling in ACH payment[0]\n\nThese features provide a comprehensive outline for potential investors and borrowers interested in the product offered by Newfi.",
        "QuoteLocations": [
            "2",
            "3",
            "1",
            "6"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiNQMPDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "The Newfi NQM Product offers several specialized programs designed to address diverse borrower profiles and income scenarios. Here are the key features:\n\n1. **1099 Documented No Expenses (Full Doc)**\n    - For contractors transitioning from W2 roles.\n    - Requires proof from employer that the borrower has no job-related expenses and documentation of income through paystubs, bank statements, or employment contracts[0].\n\n2. **Real Estate Flipper Program**\n    - For self-employed real estate professionals who buy, rehab, and sell properties.\n    - Income is derived from the capital gains associated with these activities.\n    - Borrower must have evidence of two or more transactions over at least 12 months[0].\n\n3. **Short Term Rental Income**\n    - For properties rented through services like Airbnb.\n    - Income verification through host reports and PITI application to determine net income[2][3].\n\n4. **CPA Gross Receipts Program**\n    - For self-employed borrowers.\n    - Income is verified through CPA-documented gross receipts and business bank statements[4].\n\n5. **Bank Statement Rental Income**\n    - Uses 12 to 24 months of bank statements verifying rental income.\n    - Short-term and long-term rental income calculations based on lease agreements and average net deposits[0].\n\n6. **CPA P&L Program**\n    - For self-employed borrowers.\n    - Requires a 12-month CPA-prepared P&L and 2 months of supporting business bank statements to verify income[3].\n\nEach of these programs is designed with specific documentation and eligibility requirements to cater to varying financial backgrounds and employment scenarios. They provide flexible solutions for verifying income and deriving qualifying amounts for mortgage approvals. The detailed guidelines ensure compliance and clarity for both lenders and borrowers.",
        "QuoteLocations": [
            "17",
            "20",
            "15",
            "16"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiNQMIPDocPromptExamples = [
    {
        question: "Summarize the guideline.",
        "Answer": "The Sequoia NQM - ITIN product offered by Newfi includes several notable features tailored to borrowers without traditional U.S. residency status. Here’s a summary of the key features:\n\n1. **Loan & Credit Details:**\n   - Available for loan amounts up to $1,500,000 with a credit score of 660 .\n   - Supports various documentation options, including Full Doc (1-2 years), Bank Statement (12-24 Months), and 1099 (1-2 Years) .\n   - LTV/CLTV is set at 80% for Purchase and Rate & Term, and at 70% for Cash-Out transactions.\n\n2. **Product Types and Terms:**\n   - Includes 30-year and 40-year fixed rate options, both with and without Interest Only (I.O.) periods. For example, a 40-year fixed I.O. has a 120-month I.O. term .\n   - The qualifying rate is based on the note rate (fixed rate).\n\n3. **Prepayment Penalties:**\n   - Applicable only on Non-Owner Occupied properties.\n   - Penalty equals six months' interest on 80% of the unpaid principal balance.\n   - Certain states have restrictions or do not allow prepayment penalties .\n\n4. **Eligibility and Documentation:**\n   - Designed to cater to borrowers with and without traditional U.S. residency status, including those without an SSN.\n   - Requires stable housing history in the U.S. and income documentation from wages or self-employment  .\n\n5. **Income Calculation Methods:**\n   - Various income documentation options, such as bank statements, CPA Gross Receipts, and 1099 programs for self-employed borrowers .\n   - Asset depletion and rental income from both long-term and short-term rentals can be used  .\n\n6. **Borrower and Property Restrictions:**\n   - Entity vesting is allowed (LLC or Corporation), but only for non-owner occupied properties .\n   - First-time homebuyers are defined specifically and subject to particular conditions such as a maximum loan amount of $2,000,000 and a max DTI of 50% .\n\n7. **Credit and Reserve Requirements:**\n   - Detailed requirements for tradelines and collections/charge-offs that do not impact title .\n   - Various ways to meet the credit history criteria, including satisfactory housing history documentation .\n\nThese features outline a specialized loan product that accommodates diverse financial profiles (including those without traditional U.S. residency) while maintaining structured loan and documentation requirements.\n\nFor further details, you can refer to the documentation directly   .",
        "QuoteLocations": {},
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiPINNDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "The Pinnacles GPM mortgage product from Newfi features several notable elements designed for diverse borrower profiles:\n\n1. **Loan Amount and Credit Score Requirements**:\n   - Maximum loan amounts up to $3,000,000.\n   - Minimum credit scores range from 660 for loans up to $2,000,000 to 700 for loans up to $3,000,000.\n\n2. **Occupancy and State Eligibility**:\n   - Loans are limited to primary residences.\n   - Available in multiple states including AZ, CA, CO, CT, DC, FL, GA, HI, IL, KY, MD, MI, NJ, NC, NV, OH, OR, PA, SC, TN, UT, VA, and TX (excluding TX cash-out refinance under Section 50(a)(6)).\n\n3. **Eligible Property Types**:\n   - Covers single-family homes, PUDs, warrantable and non-warrantable condos on a case-by-case basis, and 2-4 unit properties.\n\n4. **Income Documentation Options**:\n   - Full documentation for 1-2 years.\n   - Various alternative documentation options including bank statements (12-24 months), 1099s, CPA gross receipts, and asset depletion.\n\n5. **Asset Depletion**:\n   - Allows the use of asset depletion to qualify with stipulations, including minimum required assets and detailed asset eligibility criteria.\n\n6. **Non-Traditional Income Sources**:\n   - Includes provisions for borrowers with rental income, business income, and other documented non-traditional income forms like Restricted Stock Units (RSUs).\n\n7. **Underwriting Requirements**:\n   - A strict verification of borrower credentials and asset seasoning periods.\n   - Exclusion rules for non-qualifying assets and limitations on equity in real estate as qualifying assets.\n\nUnderstanding these features can help mortgage professionals match appropriate borrowers with the Pinnacles GPM product, ensuring compliance with Newfi’s guidelines and optimizing loan approval processes[0][1][2][3].",
        "QuoteLocations": [
            "16",
            "2",
            "1",
            "9"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewFiRAINERDocPromptExamples = [
    {
        question: "Summarize the key features of this product.",
        "Answer": "The Newfi lending programs offer several key features across different products, structured to accommodate various borrower needs and scenarios. Here are the essential features based on the product matrix:\n\n1. **Loan Terms & Products**:\n   - Available in 15-year fixed and 30-year fixed rate terms.\n   - 30-year fixed with Interest-Only (I.O.) options available.\n   - Suitable for Purchase, Rate & Term, and Cash-Out transactions[0].\n\n2. **Documentation Requirements**:\n   - Verification of mortgage or rent payment history through credit reports, canceled checks, or Verification of Mortgage/Rent forms.\n   - Housing payment history with a maximum of 0x30 in past 24 months[1].\n\n3. **Credit and Liabilities**:\n   - Major credit events such as bankruptcy, foreclosure, and short sales require four years of seasoning.\n   - Non-mortgage debt can be excluded if paid by others with 12 months of timely payments provided as evidence[1][3].\n\n4. **Debt-to-Income Ratios (DTI)**:\n   - Maximum allowable DTI is 45%, with exceptions noted for specific conditions such as the involvement of non-occupant co-borrowers[4][3].\n\n5. **Income Verification**:\n   - 1099 income can be documented using either a 10% expense ratio or a third-party prepared Business Expense Statement with a minimum 5% expense factor.\n   - Requirements for documenting trust income, restricted stock units (RSUs), and business funds usage[6][7][8][9].\n\n6. **Assets**:\n   - Minimum borrower contributions and conditions for gift funds are specified.\n   - Business funds can be used for down payments and reserves, provided they are verified and do not negatively impact the business[7][11][8].\n\n7. **Property Types and Appraisals**:\n   - Ineligible properties include non-warrantable condos, condotels, unique homes like earth or dome homes, and properties in poor condition.\n   - Additional appraisal requirements and processes for declining property values and multiple-owner scenarios[13][13].\n\nThese guidelines ensure that loan products are tailored to meet specific borrower needs while maintaining financial risk controls and regulatory compliance.",
        "QuoteLocations": [
            "9",
            "17",
            "4",
            "7",
            "1",
            "8",
            "14",
            "12",
            "5",
            "11"
        ],
        "InitialChatTitle": "Document Summary"
    }
]

export const NewfiDocPromptExamples = [
    {
        question: "Are manufactured homes eligible?",
        "answer": "Manufactured homes are not eligible under the TETON JUMBO AUS loan product.",
        "reference": "[{'page_label': '2'}]",
        "reference file name": "Selling Guide - PDF Version 09-06-23.pdf",
        "reference page number": "325"
    },
    {
        question: "Summarize this loan product",
        "answer": "The TETON JUMBO AUS loan product is a 30-year fixed mortgage with a qualifying rate at the note rate. The loan must meet DU (Desktop Underwriter) or LP (Loan Prospector) requirements and is available for properties such as single-family residences (detached & attached), PUDs (Planned Unit Developments), condos (must meet FNMA warrantable condo requirements), and 1-4 Unit properties (not allowed on 2nd homes). There are no equity withdrawal restrictions for this product, and properties purchased with cash within the past six months are eligible for cash-out refinancing.\n\nHere are some basic requirements for the TETON JUMBO AUS loan product:\n\n- The minimum loan amount is $400,000.\n- The Debt-to-Income Ratio (DTI) is capped at 50%.\n- Borrowers can include U.S. Citizens, Permanent Resident Aliens, and Non-Permanent Resident Aliens with evidence of lawful residency and work eligibility in the U.S. \n- The maximum number of financed 1-4 unit residential properties for a borrower is four (properties owned free and clear are not included in this limit). \n- The maximum exposure to Newfi for any one borrower is five loans or $5,000,000 in unpaid principal balance (UPB).\n- Reserves: Various requirements depending on loan amounts and LTV/CLTV ratios, for instance:\n  - Loan Amount > $1MM = 3 months PITI or an amount determined by AUS, whichever is greater.\n  - For LTV/CLTV > 80%, the greater of 6 months PITI or an amount determined by AUS.\n\nAdditional important criteria include:\n\n- Credit score requirements vary depending on property type and purpose (i.e., primary residence, second home, or investment property) but typically start at 680.\n- Secondary financing is allowed subject to certain LTV/CLTV ratios.\n- Collections and charge-offs must be paid under certain circumstances.\n- Business liabilities can be excluded following FNMA guidance if certain conditions are met.\n- A maximum DTI of 50% is allowed.\n- Non-Permanent Resident Aliens are eligible with evidence of lawful residency and the right to work in the U.S.\n- Properties with solar panels must follow FNMA guidance.\n- Non-Occupant Co-Borrowers are allowed per AUS with blended ratios being acceptable.\n- Appraisal requirements must be adhered to, with one appraisal needed up to $2,000,000 loan amounts and two appraisals required for loan amounts over $2,000,000. Appraisal age must be within 120 days of the note date.\n- Ineligible properties include non-warrantable condos, manufactured homes, condotels, and certain unique property types like earth dome homes.\n\nThis summary is based on the information provided up to the point where the document confirms that it is for mortgage professionals and subject to change without notice, effective January 24, 2023. Please note that the specific details and requirements may vary depending on individual borrower circumstances and further updates to the loan product.",
        "reference": "[{'page_label': '3'}]",
        "reference file name": "None",
        "reference page number": "None"
    }
]

/**
 * Check if quote locations array is not empty
 * @param {Array} quoteLocations - Array of [page, coords] pairs
 * @returns {boolean} True if quote locations array is not empty, false otherwise
 */
export const isNonEmptyQuoteLocations = (quoteLocations) => {
    return Array.isArray(quoteLocations) && quoteLocations.length > 0
}

/**
 * Parse reference indexes from answer string
 * @param {string} answer - Answer string that may end with "Referenced context: [1, 2, 3, 6, 9]"
 * @returns {Array} Array of reference numbers
 */
export function parseRefsIndex(answer) {
    // Match "Referenced context: [numbers]" pattern at the end of the string
    const match = answer.match(/Referenced context:\s*\[([^\]]+)\]\s*$/)

    if (match && match[1]) {
        // Parse the numbers from the matched string
        const numbersString = match[1]
        const refs = numbersString
            .split(',')
            .map((num) => parseInt(num.trim()))
            .filter((num) => !isNaN(num))

        return refs
    }

    // Return empty array if no match found
    return []
}

/**
 * Check if the message is an explain answer
 * @param {Array} messages - Array of messages
 * @param {number} index - Index of the message
 * @returns {boolean} True if the message is an explain answer, false otherwise
 */
export function isExplainAnswer(messages, index) {
    if (messages[index].sender !== 'bot') return false

    // Check the immediately previous message
    const question = messages[index - 1]
    return (
        question &&
        question.sender === 'user' &&
        question.text.startsWith('Please explain: "') &&
        question.text.endsWith('"')
    )
}
